<!--
  Note 1: <defs> element need to be outside of <symbol> element.
  FireFox failed to draw SVG image which references (via <use xlink:href="...">) internal SVG element
  which also references another internal SVG element in <defs> element.
  The solution was to put <defs> element outside <symbol> element.
  * Another solution: the page http://sketchmaster.com/svg-optimizer can remove all <use></use> tags.
  * Then <defs></defs> can be placed inside <symbol></symbol>.

  Note 2: When xlink:href reference only contains a fragment identifier (e.g. #<elementId>),
  while Chrome browser resolves it within the same document, Safari/FireFox try to resolve
  using base url set in <base href="..."> and fails.
  Chrome browser's behavior is correct according to this spec.
  https://www.w3.org/TR/SVG/linking.html#IRIforms
  As a work around, location path is prepend to a fragment identifier (e.g. <absolutePath>#<elementId>).

  Note 3: Avoid using clip-path="url(#elementId)" when base url is set.
  Safari requires location path in url() function. i.e. clip-path="url(<locationPath>#<elementId>)"
  Chrome fails to resolve if location path is present in url() function.
 -->
<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  version="1.1"
  style="position: fixed; width: 0; height: 0"
>
  <style>
    use {
      fill-opacity: 1;
      fill: currentColor;
    }
  </style>

  <symbol id="checkmark-sharp-icon" viewBox="0 0 26 26">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M11.47 20c.535 0 .942-.212 1.229-.65l7.015-11.117c.203-.321.286-.627.286-.909C20 6.564 19.442 6 18.689 6c-.512 0-.836.196-1.145.705l-6.104 9.997-3.09-3.94c-.285-.361-.602-.518-1.039-.518-.753 0-1.311.564-1.311 1.332 0 .345.098.642.384.98l3.888 4.856c.324.4.701.588 1.198.588z"
        fill="currentColor"
        fill-rule="nonzero"
      />
    </g>
  </symbol>

  <symbol id="invoice2go-logo-icon" viewBox="0 0 1323.32 215.69">
    <path
      fill="#00de8c"
      fill-rule="evenodd"
      d="M270.16.2,1.72,107a2.73,2.73,0,0,0,.08,5.1c13.49,4.89,45.4,16.44,79.7,28.88a2.73,2.73,0,0,0,2.56-.38L235.16,30.46a.36.36,0,0,1,.45.57L101.82,147.39a2.72,2.72,0,0,0-.95,2.08v62.06a2.72,2.72,0,0,0,4.84,1.72l38.61-47.61a2.73,2.73,0,0,1,3.05-.84l49.25,17.85a2.74,2.74,0,0,0,3.45-1.52L273.69,3.79A2.74,2.74,0,0,0,270.16.2"
    ></path>
    <rect
      fill="#fff"
      x="330.79"
      y="21.75"
      width="24.32"
      height="147.83"
      transform="translate(-0.23 0.84) rotate(-0.14)"
    ></rect>
    <path
      fill="#fff"
      d="M431.32,63.16c-12.26,0-23.48,4.42-30.53,13.21V65.32l-22.87.06.26,104.11,22.86-.06-.16-68.92A27.28,27.28,0,0,1,426.4,84c14.55,0,22.89,10.36,22.93,26.81l.15,58.56,22.86-.06-.15-62.26c-.09-26.91-15.93-43.95-40.87-43.89"
    ></path>
    <polygon
      fill="#fff"
      points="566.77 64.91 535.15 137.87 503.38 65.07 478.01 65.13 525.25 169.12 545.42 169.08 592.34 64.86 566.77 64.91"
    ></polygon>
    <path
      fill="#fff"
      d="M649.12,62.62c-30.76.08-54.4,24.08-54.32,54.27s23.82,54.08,54.58,54,54.4-24.08,54.33-54.28-23.83-54.08-54.59-54m.21,87c-18.5,0-31.42-14.29-31.47-32.82s12.77-32.94,31.31-33c18.3,0,31.22,14.3,31.26,32.83s-12.8,32.92-31,33Z"
    ></path>
    <rect
      fill="#fff"
      x="719.81"
      y="20.55"
      width="22.87"
      height="21.25"
      transform="translate(-0.08 1.87) rotate(-0.15)"
    ></rect>
    <rect
      fill="#fff"
      x="720.02"
      y="64.52"
      width="22.87"
      height="104.11"
      transform="translate(-0.3 1.87) rotate(-0.15)"
    ></rect>
    <path
      fill="#fff"
      d="M815.77,83.45c13.3,0,23.51,7.65,28.52,18.25l19.94-10.88c-9-17.26-27.09-28.67-48.54-28.62-31.18.08-54.81,23.46-54.74,54.28s23.83,54.07,55,54c21.41,0,39.46-11.54,48.37-28.85l-20-10.78c-5,10.63-15.13,18.37-28.44,18.4-18.49,0-31.63-14.29-31.67-32.82s13-32.93,31.54-33"
    ></path>
    <path
      fill="#fff"
      d="M930.52,61.93c-31.59.08-54.19,23.66-54.12,54.27.08,31.64,22.79,54.08,54.39,54,21.83,0,38-9.47,47.33-24.31l-17.49-12.45c-5.38,9.17-15.14,15.86-29.68,15.9-17.25,0-31-11.17-32.09-28.24l81.69-.2c.2-3.32.2-5.21.19-7.49-.08-33.49-23-51.56-50.22-51.49m-30.67,42.56C902.93,89,916.4,81.28,929.73,81.28s25.37,8.06,27.91,23Z"
    ></path>
    <path
      fill="#fff"
      d="M1269.27,61.09h-.81c-30.54.21-54,24-54.06,54v.29c.07,30.1,23.67,53.92,54.3,54h.3c30.64-.08,54.2-23.88,54.32-53.9V115c-.12-30-23.57-53.71-54-53.92m-.34,87c-18.5,0-31.43-14.29-31.47-32.82s12.8-32.93,31.3-33c18.3,0,31.21,14.29,31.26,32.82s-12.79,32.93-31.08,33Z"
    ></path>
    <path
      fill="#fff"
      d="M1174.8,63.41V73c-7.29-7.48-18.12-11.62-30.59-11.59-30.13.07-51.9,23.2-52,52.39s22.16,52.42,52.31,52.35c12.47,0,23.27-4.42,30.53-12.15v12.35c0,16.2-8.83,24.86-20.78,27.5-29.79,5.36-48.28-3.64-48.28-3.64l-7.29,18.71c10.63,6.63,43.59,8.53,58.91,5.13,22.06-3.88,40.38-18.3,40.32-47.51l-.26-103.15Zm.16,67c-5.38,8.34-14.34,14.61-27.81,14.64-18.08,0-31.22-13.46-31.46-31.36,0-17.9,13.23-31.47,31.3-31.52,13.51,0,22.47,6.19,27.89,14.3Z"
    ></path>
    <path
      fill="#fff"
      d="M1023.24,148.22l31.2-42.44c6.3-8.23,16.31-21.94,18.2-25.07,8.64-14.36,9.75-29.47,2.2-44.5-6.14-12.28-17-18.26-30.4-20-18.76-2.38-38.29,6.3-47.1,24.09a36,36,0,0,0-4,12.49l20,4.34c.3-.87.59-1.57.81-2.29,2.27-7.57,6.71-13.26,14-16.57s17.78-2,23.42,2.85c9.47,8.21,9.34,22.1,2.48,30.94C1053,73.61,993.76,149,993.76,149a3.7,3.7,0,0,0-.86,2.38v16.88l87.83-.22V148.16Z"
    ></path>
  </symbol>

  <symbol id="mini-chevron-down-icon" viewBox="0 0 10 10">
    <path d="M0 0h10v10H0z" fill="none"></path>
    <path
      d="M5 8a.997.997 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L5 5.586l2.293-2.293a.999.999 0 1 1 1.414 1.414l-3 3A.997.997 0 0 1 5 8"
    ></path>
  </symbol>

  <symbol id="error-icon" viewBox="0 0 16 16">
    <g
      id="icon/Message/Alert16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
      <g id="iconAlert">
        <circle id="Background" fill="#E80E51" cx="8" cy="8" r="8"></circle>
        <rect
          id="Stroke"
          fill="#FFFFFF"
          x="7"
          y="3"
          width="2"
          height="6"
        ></rect>
        <polygon id="Dot" fill="#FFFFFF" points="7 11 9 11 9 13 7 13"></polygon>
      </g>
    </g>
  </symbol>

  <symbol id="chevron-down-icon" viewBox="0 0 15 15">
    <path d="M0 0h15v15H0z" fill="none"></path>
    <path
      d="M7.5 10.5a.997.997 0 0 1-.707-.293l-4.5-4.5a.999.999 0 1 1 1.414-1.414L7.5 8.086l3.793-3.793a.999.999 0 1 1 1.414 1.414l-4.5 4.5a.997.997 0 0 1-.707.293"
    ></path>
  </symbol>

  <symbol id="chevron-right-icon" viewBox="0 0 15 15">
    <path d="M0 0h15v15H0z" fill="none"></path>
    <path
      d="M5.5 13a.999.999 0 0 1-.707-1.707L8.586 7.5 4.793 3.707a.999.999 0 1 1 1.414-1.414l4.5 4.5a.999.999 0 0 1 0 1.414l-4.5 4.5A.997.997 0 0 1 5.5 13"
    ></path>
  </symbol>

  <symbol id="close-icon" viewBox="0 0 15 15">
    <path d="M0 0h15v15H0z" fill="none"></path>
    <path
      d="M12.707 11.293a.999.999 0 1 1-1.414 1.414L7.5 8.914l-3.793 3.793a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L6.086 7.5 2.293 3.707a.999.999 0 1 1 1.414-1.414L7.5 6.086l3.793-3.793a.999.999 0 1 1 1.414 1.414L8.914 7.5l3.793 3.793z"
      fill="currentColor"
    ></path>
  </symbol>

  <symbol id="checkmark-icon" viewBox="0 0 15 15">
    <path d="M0 0h15v15H0z" fill="none"></path>
    <path
      d="M5.829 11.364a.997.997 0 0 1-.707-.293l-2.83-2.828A1 1 0 0 1 3.708 6.83l2.121 2.12 5.657-5.657a.999.999 0 1 1 1.413 1.414l-6.363 6.364a.997.997 0 0 1-.707.293z"
    ></path>
  </symbol>

  <symbol id="megaphone-icon" viewBox="0 0 50 47">
    <g id="Screens-for-JIRA" stroke="none" stroke-width="1" fill="none">
      <g
        id="Reports/Appointments-feedback-bar"
        transform="translate(-57.000000, -61.000000)"
      >
        <g id="Icon" transform="translate(57.000000, 61.000000)">
          <path
            d="M48.278011,23.1991713 C48.278011,36.0118785 37.8912707,46.3980663 25.0788398,46.3980663 C12.2661326,46.3980663 1.87966851,36.0118785 1.87966851,23.1991713 C1.87966851,10.3867403 12.2661326,-2.84217094e-14 25.0788398,-2.84217094e-14 C37.8912707,-2.84217094e-14 48.278011,10.3867403 48.278011,23.1991713"
            id="Fill-1"
            fill="#EDF3FD"
          ></path>
          <path
            d="M9.18665746,31.0303039 L11.3048895,39.7352762 C11.5391436,40.6974309 12.4858287,41.2932873 13.4206354,41.0659392 C14.3551657,40.8383149 14.9228453,39.8739503 14.6885912,38.9117956 L14.6902486,38.9112431 L12.6181492,30.396326 C11.4753315,30.5477072 10.3300276,30.7601381 9.18665746,31.0303039"
            id="Fill-3"
            fill="#FFFFFF"
          ></path>
          <path
            d="M9.18665746,31.0303039 C9.41179558,32.0001934 9.37008287,32.7059945 9.53002762,33.8935635 C9.54356354,33.994116 9.56124309,34.1264365 9.58720994,34.3184254 C9.60516575,34.5120718 9.6971547,34.7501934 9.77146409,35.0833425 C9.9369337,35.7631768 10.1587569,36.675884 10.3985359,37.6623481 C10.5184254,38.155442 10.643011,38.6673204 10.7675967,39.1775414 L10.8606906,39.5595856 C10.8943923,39.6916298 10.9142818,39.7990884 10.9648343,39.9609669 C11.0570994,40.2606906 11.2129006,40.5383149 11.4140055,40.7678729 C11.816768,41.2297514 12.3968785,41.4822376 12.9347238,41.4996409 C13.4772652,41.5250552 13.9504696,41.3250552 14.2756077,41.0816851 C14.6004696,40.8308564 14.7863812,40.5479834 14.8880387,40.3468785 C14.9899724,40.1432873 15.0222928,40.0209116 15.0222928,40.0209116 C15.0222928,40.0209116 15.025884,40.0090331 15.0385912,39.9678729 C15.0526796,39.926989 15.0717403,39.855442 15.0938398,39.733895 C15.115663,39.6126243 15.1369337,39.4388674 15.1225691,39.1985359 C15.1170442,39.0808564 15.0899724,38.936105 15.0617956,38.7966022 C15.0311326,38.6706354 14.9968785,38.5291989 14.9582044,38.3706354 L14.9582044,38.3706354 C14.9582044,38.3706354 14.9582044,38.3703591 14.9579282,38.3687017 L14.9576519,38.3687017 C14.8093094,37.7587569 13.8413536,33.7742265 13.2675967,31.4137293 C13.2137293,31.1924586 13.1648343,30.9921823 13.1209116,30.8117956 C13.053232,30.5206354 12.993011,30.2620718 12.9399724,30.0333425 C12.935,30.0164917 12.9333425,29.9949448 12.9256077,29.9825138 L12.8733978,29.9866575 C12.8388674,29.9891436 12.8048895,29.9919061 12.7714641,29.9943923 C12.7048895,29.9996409 12.6402486,30.004337 12.5783702,30.0093094 C12.5175967,30.0090331 12.4537845,30.0272652 12.3927348,30.0443923 C12.3314088,30.0620718 12.276989,30.0687017 12.2222928,30.0805801 C12.1123481,30.1082044 12.0206354,30.1314088 11.9460497,30.1501934 C10.7750552,30.4615193 10.1535083,30.7968785 9.18665746,31.0303039 C10.1595856,30.815663 10.8637293,30.8761602 12.0474309,30.8189779 C12.1187017,30.8162155 12.2059945,30.8129006 12.3109669,30.8084807 C12.3109669,30.7985359 12.3098619,30.8093094 12.3098619,30.8093094 L12.3093094,30.8093094 C12.3093094,30.8093094 12.3109669,30.8068232 12.3140055,30.806547 L12.3162155,30.8062707 L12.3308564,30.864558 C12.3410773,30.9073757 12.3518508,30.9512983 12.3629006,30.996326 C12.406547,31.1767127 12.4551657,31.376989 12.5087569,31.5985359 C13.083895,33.9584807 14.0548895,37.9424586 14.2035083,38.5524033 C14.2040608,38.5537845 14.2040608,38.5540608 14.2040608,38.5540608 C14.2427348,38.7131768 14.276989,38.854337 14.3076519,38.9800276 C14.3278177,39.0880387 14.3446685,39.1711878 14.3485359,39.2512983 C14.3573757,39.4076519 14.3443923,39.5198066 14.3300276,39.5982597 C14.3024033,39.7559945 14.2797514,39.7827901 14.283895,39.7836188 C14.283895,39.7836188 14.2629006,39.8631768 14.1968785,39.9935635 C14.1316851,40.1233978 14.0112431,40.3029558 13.8079282,40.4615193 C13.6037845,40.6120718 13.3057182,40.7394199 12.9662155,40.7222928 C12.6311326,40.7112431 12.2601381,40.5524033 11.9999171,40.2537845 C11.8706354,40.1051657 11.7703591,39.9261602 11.7101381,39.7300276 C11.6814088,39.6449448 11.6493646,39.4960497 11.6189779,39.3750552 L11.525884,38.9927348 C11.4021271,38.4827901 11.2775414,37.9709116 11.1576519,37.4775414 C10.9173204,36.4913536 10.6949448,35.5786464 10.5294751,34.8988122 C10.4424586,34.5689779 10.4148343,34.3153867 10.3416298,34.1347238 C10.2764365,33.9524033 10.2314088,33.8267127 10.1971547,33.7311326 C9.79356354,32.6029558 9.43223757,31.995221 9.18665746,31.0303039"
            id="Fill-5"
            fill="#202020"
          ></path>
          <path
            d="M36.6035083,20.9164088 C36.6035083,23.12 34.8170442,24.9061878 32.6137293,24.9061878 C30.4098619,24.9061878 28.6233978,23.12 28.6233978,20.9164088 C28.6233978,18.7128177 30.4098619,16.9266298 32.6137293,16.9266298 C34.8170442,16.9266298 36.6035083,18.7128177 36.6035083,20.9164088"
            id="Fill-7"
            fill="#00E58C"
          ></path>
          <path
            d="M36.6035083,20.9164088 C36.586105,21.4144751 36.4990884,21.8274586 36.3471547,22.239337 C36.1916298,22.6481768 35.964558,23.0644751 35.5623481,23.4912707 C35.4902486,23.5592265 35.4090331,23.6622652 35.2590331,23.7782873 C35.1847238,23.8368508 35.1073757,23.9139227 34.9990884,23.981326 C34.894116,24.0523204 34.7786464,24.1390608 34.6297514,24.2139227 C34.0985359,24.5161326 33.286105,24.7713812 32.4098619,24.6959669 C31.536105,24.641547 30.6402486,24.2307735 30.0446685,23.6194475 C29.7421823,23.3197238 29.5087569,22.9832597 29.3377624,22.6572928 C29.1733978,22.3269061 29.0717403,22.008674 29.014558,21.7360221 C28.9604144,21.4628177 28.9394199,21.2371271 28.9396961,21.0804972 C28.9303039,20.9244199 28.9394199,20.8379558 28.9394199,20.8379558 C28.9394199,20.8379558 28.9443923,20.7658564 28.9537845,20.6343646 C28.9551657,20.5683425 28.9675967,20.4885083 28.9855525,20.3965193 C29.0051657,20.3050829 29.0123481,20.1973481 29.0501934,20.0851934 C29.1695304,19.6329834 29.4316851,19.0075691 29.9485359,18.4896133 C30.4449448,17.9561878 31.1722928,17.5553591 31.9305801,17.3965193 C32.6943923,17.2407182 33.4695304,17.3371271 34.0731215,17.5509392 C34.1709116,17.5898895 34.2642818,17.6266298 34.353232,17.6617127 C34.4396961,17.701768 34.5195304,17.7451381 34.5977072,17.7832597 C34.7548895,17.8578453 34.8780939,17.9523204 34.9982597,18.0213812 C35.1082044,18.1050829 35.2037845,18.1777348 35.2855525,18.2401657 C35.3612431,18.3106077 35.4242265,18.3694475 35.4756077,18.4172376 C35.8877624,18.8128177 36.1385912,19.2075691 36.3129006,19.6059116 C36.483895,20.0064641 36.586105,20.4183425 36.6035083,20.9164088 C36.6098619,20.4180663 36.5460497,19.9987293 36.4291989,19.5644751 C36.3068232,19.1335359 36.1278177,18.6760773 35.756547,18.1719337 C35.7087569,18.110884 35.6499171,18.0357459 35.5797514,17.9456906 C35.5007459,17.861989 35.4087569,17.7647514 35.3024033,17.6525967 C35.1836188,17.5548066 35.0601381,17.4249724 34.8954972,17.3136464 C34.8137293,17.2572928 34.7297514,17.1932044 34.6355525,17.1340884 C34.5383149,17.0796685 34.436105,17.0222099 34.3289227,16.9622652 C33.9896961,16.801768 33.5946685,16.6462431 33.1551657,16.5865746 C32.7184254,16.5244199 32.246326,16.5164088 31.7778177,16.6048066 C30.8396961,16.7744199 29.9496409,17.3012155 29.3852762,17.9760773 C28.7946685,18.6354696 28.5275414,19.3979006 28.4112431,19.9365746 C28.3739503,20.071105 28.3681492,20.1979006 28.3504696,20.3064641 C28.3347238,20.4153039 28.323674,20.5089503 28.3242265,20.5862983 C28.3192541,20.740442 28.3162155,20.8249724 28.3162155,20.8249724 C28.3162155,20.8249724 28.3095856,20.9260773 28.3253315,21.1075691 C28.3314088,21.2896133 28.3631768,21.551768 28.4363812,21.8669613 C28.5129006,22.1816022 28.6410773,22.5467956 28.8438398,22.9202762 C29.0524033,23.2896133 29.3341713,23.6647514 29.6902486,23.9926519 C30.0454972,24.3197238 30.4720166,24.6025967 30.9399724,24.7896133 C31.406547,24.9796685 31.9068232,25.0804972 32.3885912,25.0951381 C33.3606906,25.1401657 34.2245028,24.7885083 34.7562707,24.4202762 C34.9062707,24.328011 35.0211878,24.2260773 35.1250552,24.1429282 C35.2316851,24.0628177 35.3070994,23.9749724 35.3786464,23.9078453 C35.5233978,23.7741436 35.6010221,23.6614365 35.6698066,23.5851934 C36.0510221,23.1125414 36.2537845,22.6766298 36.3949448,22.2561878 C36.5308564,21.8335359 36.6098619,21.4153039 36.6035083,20.9164088"
            id="Fill-9"
            fill="#20E89B"
          ></path>
          <path
            d="M29.728453,17.5952762 C30.0914365,17.2546685 30.4486188,17.026768 30.8516575,16.8532873 C31.2549724,16.6842265 31.7143646,16.5673757 32.2994475,16.5726243 C32.3980663,16.5659945 32.5279006,16.5867127 32.7149171,16.6019061 C32.8077348,16.613232 32.9140884,16.6383702 33.0381215,16.6604696 C33.1616022,16.6861602 33.2991713,16.7314641 33.4560773,16.7798066 C33.7171271,16.8820166 34.0201657,17.0099171 34.3118785,17.216547 C34.6027624,17.4206906 34.8969613,17.6748343 35.1444751,17.9889227 C35.6414365,18.6148895 35.9256906,19.4604696 35.9077348,20.2389227 C35.9,20.6278729 35.8270718,20.993895 35.7234807,21.3129558 C35.6176796,21.6328453 35.4712707,21.9002486 35.3342541,22.1137845 C35.1917127,22.3242818 35.0616022,22.484779 34.9599448,22.5850552 C34.9116022,22.6372652 34.8737569,22.6775967 34.8480663,22.705221 C34.8201657,22.7300829 34.8055249,22.7433425 34.8055249,22.7433425 C34.8055249,22.7433425 34.7552486,22.7864365 34.6646409,22.8651657 C34.5781768,22.9488674 34.4312155,23.0447238 34.2522099,23.1629558 C33.8872928,23.386989 33.3160221,23.6148895 32.6519337,23.643895 C31.9917127,23.6726243 31.2527624,23.5101934 30.6513812,23.1383702 C30.3508287,22.956326 30.071547,22.7403039 29.8494475,22.4914088 C29.620442,22.2499724 29.4337017,21.9900276 29.2955801,21.7342265 C29.1889503,21.555221 29.120442,21.3784254 29.0538674,21.2201381 C28.9997238,21.0577072 28.9464088,20.9121271 28.9207182,20.7781492 C28.8845304,20.6458287 28.8654696,20.5284254 28.8544199,20.4264917 C28.8392265,20.3248343 28.8270718,20.2391989 28.8273481,20.1695856 C28.7939227,19.6032873 28.8745856,19.1433425 29.0212707,18.7345028 C29.1718232,18.3262155 29.3875691,17.9588122 29.728453,17.5952762 C29.3701657,17.9419613 29.121547,18.2872652 28.9035912,18.6811878 C28.691989,19.0770442 28.5038674,19.5331215 28.4290055,20.1590884 C28.4157459,20.2364365 28.4121547,20.3317403 28.4096685,20.4469337 C28.4027624,20.5624033 28.4013812,20.6972099 28.4160221,20.8527348 C28.419337,21.0099171 28.4524862,21.183674 28.4867403,21.3820166 C28.5345304,21.5759392 28.5872928,21.7952762 28.6867403,22.0231768 C28.9375691,22.6726243 29.4812155,23.3720718 30.230663,23.8306354 C30.9720994,24.3077072 31.9074586,24.4820166 32.7085635,24.3983149 C33.5174033,24.3176519 34.1839779,23.9994199 34.6052486,23.713232 C34.8129834,23.5637845 34.9792818,23.4408564 35.0787293,23.3394751 C35.1823204,23.2427901 35.2389503,23.1894751 35.2389503,23.1894751 C35.2389503,23.1894751 35.2558011,23.173453 35.2875691,23.1430663 C35.3168508,23.1096409 35.3599448,23.0607459 35.4151934,22.9980387 C35.529558,22.875663 35.6776243,22.6828453 35.8356354,22.4306354 C35.9883978,22.1751105 36.148895,21.8568785 36.2585635,21.4814641 C36.3662983,21.1066022 36.4337017,20.6809116 36.4251381,20.2356077 C36.4116022,19.3425138 36.0425414,18.3994199 35.4577348,17.7292541 C35.1674033,17.3922376 34.8276243,17.1275967 34.4941989,16.9270442 C34.1596685,16.7248343 33.8201657,16.6118508 33.5323204,16.5292541 C33.3596685,16.4919613 33.2099448,16.4577072 33.0767956,16.4419613 C32.9436464,16.4298066 32.8301105,16.4137845 32.7312155,16.4104696 C32.5331492,16.4112983 32.3980663,16.4032873 32.2953039,16.4176519 C31.6881215,16.464337 31.2314917,16.616547 30.8301105,16.8057735 C30.4309392,17.0002486 30.0754144,17.236989 29.728453,17.5952762"
            id="Fill-11"
            fill="#202020"
          ></path>
          <path
            d="M28.7780663,5.94734807 C28.5987845,5.21060773 27.6374586,5.04430939 27.2079006,5.66917127 C22.069779,13.1445856 14.5150829,18.091547 6.2479558,20.1031492 L4.98027624,20.4117127 C1.9421547,21.1509392 -0.103977901,24.1216575 0.491325967,27.1909945 C1.12668508,30.4677901 4.35928177,32.5139227 7.56480663,31.7340884 L9.0081768,31.3827072 C17.8841436,29.2227624 26.7938122,30.5923757 34.2612155,34.588232 C34.920884,34.9412707 35.6863536,34.3357459 35.5092818,33.608674 L28.7780663,5.94734807 Z"
            id="Fill-13"
            fill="#FFFFFF"
          ></path>
          <path
            d="M34.0720166,28.1907182 C26.6524033,25.3854696 19.2570994,26.8429282 10.9687017,28.8600552 L9.3189779,29.2614365 C5.78941989,30.1202762 2.23969613,27.9774586 1.33417127,24.471105 C0.870911602,25.5045304 0.703232044,26.6738674 0.933066298,27.859779 C1.56842541,31.1365746 4.8010221,33.1827072 8.00654696,32.4025967 L9.45019337,32.0514917 C18.3261602,29.891547 27.2358287,31.2611602 34.7029558,35.2567403 C35.3626243,35.609779 36.1278177,35.0045304 35.9510221,34.2774586 L34.0720166,28.1907182 Z"
            id="Fill-26"
            fill="#C9F9EA"
          ></path>
          <g id="Group-17" transform="translate(0.000000, 5.238122)">
            <mask id="megaphone-mask-2" fill="white">
              <polygon
                points="0 0.0434033636 35.9228065 0.0434033636 35.9228065 29.8421967 0 29.8421967"
              ></polygon>
            </mask>
            <g id="Clip-16"></g>
            <path
              d="M28.7780663,0.709226519 C28.6565193,0.213922652 28.1650829,-0.0333149171 27.7346961,0.0644751381 C27.518674,0.113646409 27.311768,0.247900552 27.1736464,0.456187845 C27.0255801,0.653149171 26.8659116,0.86558011 26.6871823,1.10370166 C26.5899448,1.2321547 26.4438122,1.42497238 26.2625967,1.6641989 C26.1741989,1.78546961 26.0642541,1.90812155 25.951547,2.04348066 C25.7565193,2.27276243 25.558453,2.50563536 25.3570718,2.74237569 C25.1333149,3.01337017 24.8858011,3.27110497 24.6358011,3.53243094 C24.3855249,3.79348066 24.1377348,4.06281768 23.8747514,4.3238674 C23.6062431,4.57939227 23.3346961,4.83823204 23.0601105,5.09983425 C21.9440884,6.12497238 20.7407735,7.15121547 19.4239227,8.09872928 C19.2620442,8.22055249 19.0996133,8.34292818 18.9369061,8.46558011 C18.770884,8.58436464 18.6045856,8.70370166 18.4377348,8.82331492 C18.1023757,9.05977901 17.7805525,9.32110497 17.4264088,9.53878453 C17.0777901,9.76447514 16.7269613,9.99127072 16.3750276,10.2191713 C16.0131492,10.431326 15.6498895,10.6445856 15.2849724,10.8583978 C13.8123204,11.6896133 12.2623204,12.4324309 10.6645304,13.0647514 C9.05983425,13.6862983 7.41480663,14.1763536 5.75375691,14.5838122 C5.33220994,14.690442 4.93055249,14.7719337 4.48469613,14.9128177 C4.04906077,15.0437569 3.63552486,15.2340884 3.23911602,15.4481768 C2.45099448,15.8885083 1.7741989,16.5009392 1.24546961,17.2067403 C0.716740331,17.9136464 0.340773481,18.7222099 0.14878453,19.5622652 C-0.0470718232,20.401768 -0.0432044199,21.2708287 0.12281768,22.0832597 C0.440497238,23.7175138 1.44022099,25.1067403 2.67475138,25.9462431 C3.9101105,26.7990055 5.36121547,27.1385083 6.64740331,27.0258011 C6.97143646,27.0117127 7.28110497,26.9462431 7.58359116,26.8874033 C7.87530387,26.8241436 8.14160221,26.7537017 8.41093923,26.6896133 C8.94574586,26.5548066 9.44850829,26.4437569 9.91895028,26.3429282 C10.8576243,26.1183425 11.6882873,26.0106077 12.3634254,25.8871271 C13.0446409,25.8031492 13.5772376,25.7379558 13.9393923,25.6934807 C14.3026519,25.6572928 14.4957459,25.6473481 14.4957459,25.6473481 C14.4957459,25.6473481 14.6885635,25.6329834 15.0523757,25.6056354 C15.2344199,25.5929282 15.4592818,25.5769061 15.7241989,25.5583978 C15.9896685,25.550663 16.2951934,25.5423757 16.638011,25.5329834 C18.0081768,25.5012155 19.9885635,25.5213812 22.3628729,25.8639227 C22.9537569,25.9644751 23.5766851,26.0351934 24.2109392,26.179116 C24.5291713,26.2440331 24.8532044,26.3100552 25.1827624,26.3771823 C25.509558,26.4583978 25.841326,26.5409945 26.1786188,26.6249724 C26.8562431,26.7796685 27.5352486,27.009779 28.2404972,27.2141989 C28.5874586,27.3346409 28.9385635,27.4564641 29.2938122,27.5796685 C29.4711602,27.6423757 29.649337,27.7053591 29.8286188,27.768895 C30.0048619,27.839337 30.1824862,27.9103315 30.360663,27.9818785 C30.7161878,28.1285635 31.0819337,28.2600552 31.438011,28.4230387 C31.7949171,28.5846409 32.1551381,28.7476243 32.5181215,28.9117127 C32.8805525,29.0782873 33.2338674,29.27 33.5962983,29.4501105 L33.8678453,29.5876796 L34.0037569,29.6564641 L34.0717127,29.6909945 L34.169779,29.7360221 C34.4388398,29.8581215 34.7689503,29.8785635 35.0532044,29.7782873 C35.340221,29.6846409 35.5838674,29.4885083 35.7404972,29.2310497 C35.9032044,28.9766298 35.9567956,28.649558 35.9020994,28.3561878 C35.8888398,28.2724862 35.8761326,28.2316022 35.8639779,28.179116 L35.8269613,28.0260773 L35.7520994,27.7191713 C35.7020994,27.5141989 35.6523757,27.3089503 35.6020994,27.1028729 C35.4020994,26.2793923 35.1996133,25.4487293 34.9965746,24.6130939 C34.1855249,21.27 33.3565193,17.8514917 32.5501657,14.5277348 C32.359558,13.6943094 32.1222652,12.8782873 31.9018232,12.0675138 C31.6728177,11.258674 31.4462983,10.4583978 31.2230939,9.66944751 C30.9957459,8.88132597 30.771989,8.10425414 30.5520994,7.34099448 C30.3440884,6.60701657 30.140221,5.8860221 29.940221,5.18077348 C29.7344199,4.42055249 29.5659116,3.79651934 29.4813812,3.48491713 C29.1761326,2.33270718 29.0131492,1.67662983 28.7780663,0.709226519 C29.0139779,1.67635359 29.1703315,2.3340884 29.428895,3.49790055 C29.4974033,3.81337017 29.6338674,4.44486188 29.800442,5.21502762 C29.9468508,5.93298343 30.0968508,6.66696133 30.2496133,7.41447514 C30.4051381,8.19348066 30.5631492,8.98657459 30.7233702,9.79099448 C30.8877348,10.5943094 31.0543094,11.4092265 31.2228177,12.2327072 C31.3990608,13.0542541 31.5634254,13.888232 31.7766851,14.7161326 C32.588011,18.0385083 33.4222652,21.4559116 34.2382873,24.7976243 C34.4416022,25.6332597 34.6435359,26.4639227 34.8440884,27.2874033 C34.8943646,27.4932044 34.9440884,27.6987293 34.9940884,27.9034254 L35.068674,28.2103315 L35.1059669,28.3636464 C35.1181215,28.4133702 35.1338674,28.4735912 35.1346961,28.4945856 C35.1852486,28.7227624 35.0322099,28.9686188 34.8073481,29.038232 C34.699337,29.0766298 34.5882873,29.068895 34.4822099,29.0216575 L34.4393923,29.0034254 L34.369779,28.9680663 L34.2308287,28.8976243 L33.9537569,28.7572928 C33.5835912,28.5733149 33.221989,28.3777348 32.8518232,28.2072928 C32.4805525,28.0396133 32.1125967,27.8730387 31.7476796,27.7081215 C31.3835912,27.541547 31.0098343,27.4070166 30.6468508,27.2572928 C30.4645304,27.1843646 30.2830387,27.111989 30.1029282,27.0398895 C29.9195028,26.9749724 29.7374586,26.9103315 29.5562431,26.8465193 C29.1932597,26.7205525 28.8341436,26.5959669 28.4797238,26.4733149 C27.7590055,26.2641989 27.0648066,26.0299448 26.371989,25.871105 C26.0275138,25.7857459 25.688011,25.7012155 25.3543094,25.6183425 C25.0172928,25.549558 24.6860773,25.4821547 24.360663,25.4158564 C23.7123204,25.2694475 23.0755801,25.1965193 22.4717127,25.0940331 C20.0446409,24.7443094 18.0203315,24.7241436 16.619779,24.7567403 C16.2692265,24.7666851 15.9567956,24.7758011 15.6855249,24.7832597 C15.4148066,24.8023204 15.1849724,24.818895 14.9990608,24.8321547 C14.6272376,24.859779 14.4302762,24.8746961 14.4302762,24.8746961 C14.4302762,24.8746961 14.2327624,24.8849171 13.8614917,24.9216575 C13.491326,24.9669613 12.9471271,25.0338122 12.2509945,25.1191713 C11.5609392,25.2448619 10.7123204,25.3550829 9.75320442,25.5840884 C9.27033149,25.6874033 8.75790055,25.8012155 8.22723757,25.9349171 C7.96176796,25.9976243 7.68248619,26.0708287 7.40900552,26.130221 C7.14353591,26.1804972 6.87281768,26.239337 6.58939227,26.2503867 C5.4659116,26.3503867 4.19823204,26.051768 3.11674033,25.3059116 C2.03635359,24.5697238 1.16453039,23.360884 0.886077348,21.928011 C0.741878453,21.2191713 0.737734807,20.4655801 0.909005525,19.7340884 C1.07668508,19.0023204 1.40569061,18.2945856 1.86977901,17.6735912 C2.33441989,17.0539779 2.92944751,16.5139227 3.62281768,16.1274586 C3.97198895,15.9401657 4.33469613,15.7716575 4.71812155,15.6575691 C5.08690608,15.5387845 5.5261326,15.4456906 5.93828729,15.3420994 C7.61812155,14.9307735 9.3120442,14.4263536 10.9485083,13.7923757 C12.5813812,13.1465193 14.1659116,12.3874033 15.6711602,11.5376796 C16.0438122,11.318895 16.4153591,11.1012155 16.7852486,10.8840884 C17.1451934,10.6512155 17.5037569,10.4194475 17.8601105,10.1887845 C18.2211602,9.96475138 18.5567956,9.70729282 18.9043094,9.4719337 C19.0755801,9.35038674 19.2462983,9.22911602 19.4161878,9.10812155 C19.5824862,8.9821547 19.7421547,8.84845304 19.9023757,8.71723757 C21.198232,7.68270718 22.3418785,6.54320442 23.3761326,5.41116022 C23.6302762,5.1238674 23.881105,4.8398895 24.1291713,4.55922652 C24.3711602,4.27359116 24.5974033,3.98104972 24.8280663,3.69955801 C25.0567956,3.4161326 25.2869061,3.14127072 25.4916022,2.85232044 C25.6780663,2.60232044 25.8614917,2.35618785 26.0424309,2.11392265 C26.1471271,1.97165746 26.2512707,1.84375691 26.3330387,1.71723757 C26.5037569,1.46944751 26.641326,1.26972376 26.7327624,1.13657459 C26.9029282,0.891823204 27.0545856,0.67359116 27.1954696,0.471104972 C27.3244751,0.262265193 27.5233702,0.126077348 27.7363536,0.073038674 C28.161768,-0.0324861878 28.6573481,0.213370166 28.7780663,0.709226519"
              id="Fill-15"
              fill="#202020"
              attr.mask="url({{ locationPath }}#megaphone-mask-2)"
            ></path>
          </g>
          <path
            d="M36.1114365,12.586768 C36.2896133,12.413011 36.4832597,12.2831768 36.6827072,12.1693646 C36.7829834,12.1127348 36.8857459,12.0613536 36.9907182,12.0124586 C37.0423757,11.9870442 37.0987293,11.9666022 37.1470718,11.9375967 C37.1948619,11.9080387 37.2321547,11.8674309 37.2782873,11.8353867 C37.6387845,11.5710221 37.9956906,11.2679834 38.4219337,10.8516851 C38.5661326,10.7102486 38.8001105,10.4798619 39.2868508,10.0011326 C39.3490055,9.94367403 39.4885083,9.79947514 39.4885083,9.79947514 C39.4885083,9.79947514 39.539337,9.75085635 39.5951381,9.69726519 C40.1407182,9.15776243 40.7354696,8.56936464 40.9338122,8.37323204 C41.3559116,7.95251381 41.6639227,7.59975138 41.9327072,7.24256906 C41.9644751,7.19588398 42.0067403,7.16052486 42.0354696,7.11190608 C42.0636464,7.06218232 42.0854696,7.00665746 42.1117127,6.95555249 C42.161989,6.8511326 42.2155801,6.74975138 42.2735912,6.65030387 C42.3901657,6.45279006 42.5235912,6.26190608 42.6998343,6.08593923 C42.5216575,6.25997238 42.3288398,6.39035912 42.1296685,6.50472376 C42.0299448,6.56135359 41.9274586,6.61328729 41.8227624,6.66245856 C41.7708287,6.68787293 41.7150276,6.70914365 41.6650276,6.73649171 C41.6161326,6.76466851 41.580221,6.80638122 41.5332597,6.83759669 C41.1722099,7.10168508 40.8153039,7.40472376 40.3890608,7.82129834 C40.190442,8.01660221 39.5940331,8.60361878 39.0473481,9.14174033 C38.9929282,9.19726519 38.9437569,9.24726519 38.9437569,9.24726519 C38.9437569,9.24726519 38.7979006,9.38483425 38.739337,9.44616022 C38.2542541,9.92654696 38.0208287,10.1574862 37.8774586,10.2997514 C37.4550829,10.7201934 37.1473481,11.073232 36.8782873,11.4301381 C36.8454144,11.4757182 36.8045304,11.5124586 36.7744199,11.5599724 C36.7448619,11.6077624 36.7235912,11.6638398 36.6973481,11.715221 C36.6470718,11.8196409 36.5943094,11.9215746 36.5365746,12.0210221 C36.42,12.2190884 36.2876796,12.4108011 36.1114365,12.586768"
            id="Fill-18"
            fill="#202020"
          ></path>
          <path
            d="M49.7693094,16.5569337 C49.2828453,16.6638398 48.8414088,16.6052762 48.3800829,16.5726796 C47.9375414,16.6224033 47.4723481,16.6804144 46.8911326,16.813011 C46.6941713,16.8572099 46.3737293,16.9295856 45.7077072,17.0795856 C45.4640608,17.135663 44.8867127,17.2682597 44.8867127,17.2682597 C44.8867127,17.2682597 44.4027348,17.3762707 44.134779,17.4364917 C43.2463812,17.6395304 42.6963812,17.765221 42.4090884,17.8309669 C41.8281492,17.9627348 41.3828453,18.1099724 40.9626796,18.2583149 C40.5621271,18.4920166 40.1872652,18.7293094 39.703011,18.8431215 C40.1891989,18.736768 40.6295304,18.7889779 41.0919613,18.826547 C41.5345028,18.7787569 41.9999724,18.7193646 42.5811878,18.5873204 C42.8687569,18.5224033 43.4187569,18.3983702 44.3077072,18.1978177 C44.5753867,18.1359392 45.0585359,18.024337 45.0585359,18.024337 C45.0585359,18.024337 45.6364365,17.894779 45.8806354,17.8400829 C46.5458287,17.6875967 46.8659945,17.6143923 47.0629558,17.5693646 C47.6441713,17.4378729 48.0891989,17.2889779 48.5096409,17.1431215 C48.9115746,16.914116 49.2845028,16.6707459 49.7693094,16.5569337"
            id="Fill-20"
            fill="#202020"
          ></path>
          <path
            d="M39.2914917,25.9017127 C39.5271271,25.9820994 39.7298895,26.0975691 39.9207735,26.2268508 C40.1130387,26.3525414 40.2798895,26.5307182 40.489558,26.601989 C40.8881768,26.8041989 41.320221,26.9854144 41.8843094,27.1768508 C42.0757459,27.2414917 42.3870718,27.3461878 43.0340331,27.5635912 C43.048674,27.5710497 43.0862431,27.5787845 43.0862431,27.5787845 C43.0862431,27.5787845 43.098674,27.5840331 43.1122099,27.5898343 C43.8050276,27.820221 44.5602762,28.0716022 44.8119337,28.1553039 C45.378232,28.3414917 45.8320994,28.4564088 46.2724309,28.5345856 C46.4829282,28.6025414 46.7249171,28.5569613 46.9530939,28.5749171 C47.1829282,28.5870718 47.4141436,28.6177348 47.650884,28.6950829 C47.4149724,28.6149724 47.2119337,28.5006077 47.0207735,28.3718785 C46.8276796,28.2492265 46.6619337,28.0674586 46.4528177,27.9948066 C46.0536464,27.7928729 45.6221547,27.6113812 45.0577901,27.4199448 C44.8064088,27.3354144 44.0517127,27.0820994 43.3597238,26.849779 C43.3453591,26.8461878 43.3320994,26.8431492 43.3320994,26.8431492 C43.3320994,26.8431492 43.2972928,26.8268508 43.2812707,26.8238122 C42.6334807,26.6086188 42.3218785,26.5053039 42.1298895,26.4414917 C41.5641436,26.2553039 41.11,26.140663 40.6696685,26.0622099 C40.4597238,25.9934254 40.2185635,26.0354144 39.989558,26.020221 C39.7594475,26.008895 39.5279558,25.9790608 39.2914917,25.9017127"
            id="Fill-22"
            fill="#202020"
          ></path>
          <path
            d="M7.39660221,19.8875138 C7.29770718,20.3756354 7.22477901,20.7894475 7.16096685,21.2311602 C7.09853591,21.6728729 7.04770718,22.1438674 7.04135359,22.748011 C7.04301105,22.9527072 7.03334254,23.2864088 7.08969613,23.9795028 C7.11096685,24.251326 7.16538674,24.708232 7.24024862,25.0946961 C7.27588398,25.2877901 7.31151934,25.4640331 7.34439227,25.5905525 C7.37450276,25.7173481 7.39356354,25.7966298 7.39356354,25.7966298 C7.39356354,25.7966298 7.40737569,25.8634807 7.43859116,25.970663 C7.4689779,26.078674 7.51124309,26.2283978 7.55820442,26.3966298 C7.61372928,26.5623757 7.66372928,26.7507735 7.73030387,26.9275691 C7.79632597,27.1049171 7.85406077,27.2800552 7.9189779,27.4190055 C8.01096685,27.6383425 8.10185083,27.8339227 8.19825967,28.0027072 C8.28776243,28.1753591 8.38085635,28.3212155 8.46732044,28.4477348 C8.63168508,28.7057459 8.78527624,28.8731492 8.88002762,28.9944199 C8.97588398,29.1173481 9.0869337,29.2173481 9.18472376,29.3181768 C9.2830663,29.4190055 9.38361878,29.5076796 9.48582873,29.5872376 C9.58444751,29.6640331 9.68168508,29.7391713 9.78030387,29.8156906 C9.87781768,29.8781215 9.97616022,29.941105 10.0778177,30.0060221 C10.4662155,30.2527072 10.8612431,30.4250829 11.283895,30.6855801 C10.8778177,30.3952486 10.5935635,30.0764641 10.3280939,29.7261878 C10.0535083,29.3841989 9.80765193,28.9985635 9.4830663,28.5339227 C9.40903315,28.4137569 9.28720994,28.2496685 9.14687845,28.0096133 C9.07256906,27.8924862 8.9888674,27.7596133 8.90267956,27.6049171 C8.80986188,27.4543646 8.71455801,27.281989 8.61013812,27.09 C8.53748619,26.9687293 8.46842541,26.8134807 8.38831492,26.6571271 C8.30737569,26.5007735 8.24301105,26.330884 8.17643646,26.1811602 C8.11455801,26.0292265 8.06842541,25.89 8.03168508,25.791105 C7.99494475,25.6922099 7.97754144,25.6300552 7.97754144,25.6300552 C7.97754144,25.6300552 7.9548895,25.5562983 7.9189779,25.4380663 C7.88030387,25.3201105 7.83720994,25.1549171 7.79052486,24.9737017 C7.69466851,24.6118232 7.60958564,24.1778453 7.5651105,23.9190055 C7.45433702,23.2568508 7.43334254,22.9317127 7.41262431,22.7333702 C7.36234807,22.1466298 7.3369337,21.6828177 7.32698895,21.2413812 C7.32035912,20.8004972 7.32339779,20.3803315 7.39660221,19.8875138"
            id="Fill-24"
            fill="#202020"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="notification-bell-icon" viewBox="0 0 24 24">
    <path
      transform="translate(2.5, 1.5)"
      fill="currentColor"
      d="M11.38 17.46c-.08 1.32-.92 2.16-2.1 2.16-1.17 0-2.02-.84-2.1-2.16h4.2zM16.59 16H1.96v-.12c.18-.3.77-.86 1.27-1.43.7-.79 1.04-2.04 1.13-3.95.08-4.26 1.35-5.62 3.01-6.07.25-.06.39-.19.4-.43.02-1.03.61-1.74 1.5-1.74.92 0 1.5.71 1.53 1.74.01.24.14.37.38.43 1.68.45 2.95 1.81 3.03 6.07.09 1.91.42 3.16 1.11 3.95.52.57 1.1 1.14 1.27 1.43V16zm-7.31 5a3.62 3.62 0 003.62-3.53h4.12c.92 0 1.48-.48 1.48-1.18 0-.98-1-1.85-1.84-2.72-.64-.68-.82-2.06-.9-3.19-.06-3.84-1.06-6.33-3.66-7.27A2.92 2.92 0 009.28.8 2.91 2.91 0 006.47 3.1c-2.6.94-3.6 3.43-3.67 7.27-.07 1.13-.25 2.51-.9 3.19-.84.87-1.83 1.74-1.83 2.72 0 .7.55 1.18 1.47 1.18h4.13A3.63 3.63 0 009.27 21z"
    />
  </symbol>

  <symbol id="profile-icon" viewBox="0 0 24 24">
    <path
      transform="translate(2, 2)"
      fill="currentColor"
      d="M10.12 19.76c5.18 0 9.47-4.3 9.47-9.46 0-5.18-4.3-9.46-9.48-9.46A9.53 9.53 0 00.66 10.3c0 5.17 4.3 9.46 9.46 9.46zm0-1.57a7.85 7.85 0 01-7.87-7.89 7.84 7.84 0 017.86-7.88c4.38 0 7.89 3.5 7.9 7.88 0 4.38-3.5 7.89-7.89 7.89zm0-8.18c1.31.01 2.38-1.1 2.38-2.6 0-1.39-1.07-2.54-2.39-2.54-1.31 0-2.38 1.15-2.38 2.55 0 1.48 1.07 2.58 2.38 2.6zm4.23 5c.38 0 .55-.25.55-.59 0-1.01-1.53-3.65-4.79-3.65-3.25 0-4.78 2.64-4.78 3.65 0 .34.17.59.54.59h8.48z"
    />
  </symbol>

  <symbol id="search-v2-icon" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M16.13 10.07a6.07 6.07 0 10-12.13 0 6.07 6.07 0 0012.13 0zM10.07 2a8.07 8.07 0 016.36 13.02l5.04 5.04a1 1 0 01-1.41 1.41l-5.04-5.04A8.07 8.07 0 1110.07 2z"
    />
  </symbol>

  <symbol id="search-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M4.24 9.537a5.302 5.302 0 0 1 5.297-5.296 5.302 5.302 0 0 1 5.296 5.296 5.302 5.302 0 0 1-5.296 5.296 5.302 5.302 0 0 1-5.296-5.296zm9.595 5.565a7 7 0 0 1-4.298 1.472A7.045 7.045 0 0 1 2.5 9.537 7.045 7.045 0 0 1 9.537 2.5a7.045 7.045 0 0 1 7.037 7.037 6.996 6.996 0 0 1-1.372 4.166l6.49 6.419a.999.999 0 1 1-1.413 1.414l-6.444-6.434z"
      fill-rule="evenodd"
    ></path>
  </symbol>

  <symbol id="add-attachment-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M14.531 22.953H10.47c-2.65 0-4.5-1.626-4.5-3.953V5.5c0-1.93 1.57-3.5 3.5-3.5h3.03C14.43 2 16 3.57 16 5.5v10c0 1.38-1.122 2.5-2.5 2.5h-1.969a2.503 2.503 0 0 1-2.5-2.5V8.812a1 1 0 0 1 2 0V15.5a.5.5 0 0 0 .5.5h1.97a.5.5 0 0 0 .5-.5v-10c0-.827-.674-1.5-1.5-1.5H9.468c-.828 0-1.5.673-1.5 1.5V19c0 1.812 1.913 1.953 2.5 1.953h4.062c.586 0 2.5-.14 2.5-1.953V8.812a1 1 0 0 1 2 0V19c0 2.327-1.85 3.953-4.5 3.953"
    ></path>
  </symbol>

  <symbol id="add-photo-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M10 13.5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.122 2.5-2.5 2.5a2.503 2.503 0 0 1-2.5-2.5zm-2 0c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5S14.981 9 12.5 9A4.505 4.505 0 0 0 8 13.5zM21 19H4V8h4c.265 0 .52-.105.707-.293L10.414 6h4.171l1.708 1.707A.997.997 0 0 0 17 8h4v11zm1-13h-4.586l-1.707-1.707A1 1 0 0 0 15 4h-5a.997.997 0 0 0-.707.293L7.586 6H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
    ></path>
  </symbol>

  <symbol id="back-navigation-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M21.999 12.5a1 1 0 0 1-1 1H6.413l6.793 6.793a.999.999 0 1 1-1.414 1.414l-8.5-8.499a1.001 1.001 0 0 1 0-1.416l8.5-8.499a.999.999 0 1 1 1.414 1.414L6.413 11.5h14.586a1 1 0 0 1 1 1"
    ></path>
  </symbol>

  <symbol id="back-navigation2-icon" viewBox="0 0 12 12">
    <path
      fill="currentColor"
      d="M.32 6.73l4.95 4.95a1 1 0 101.41-1.41L3.41 7H11a1 1 0 000-2H3.41l3.27-3.27A1 1 0 005.27.32L.32 5.27a1 1 0 00-.3.65v.16a1 1 0 00.3.65z"
    />
  </symbol>

  <!-- TODO: shouldn't we just use a bigger version of the `close-icon`? -->
  <symbol id="close-navigation-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M20.707 19.293a.999.999 0 1 1-1.414 1.414L12.5 13.914l-6.793 6.793a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l6.793-6.793-6.793-6.793a.999.999 0 1 1 1.414-1.414l6.793 6.793 6.793-6.793a.999.999 0 1 1 1.414 1.414L13.914 12.5l6.793 6.793z"
    ></path>
  </symbol>

  <symbol id="get-help-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M16 10c0 2.279-1.435 2.972-2.291 3.386C13 13.729 13 13.78 13 14a1 1 0 1 1-2 0c0-1.526 1.106-2.061 1.839-2.415C13.611 11.212 14 11.024 14 10c0-1.439-.561-2-2-2-1.299 0-2 .516-2 1a1 1 0 1 1-2 0c0-1.491 1.374-3 4-3 2.542 0 4 1.458 4 4m-3.29 6.29c.18.189.29.45.29.71 0 .27-.1.52-.29.71-.101.09-.21.16-.33.21a.995.995 0 0 1-1.09-.21.99.99 0 0 1-.21-1.09c.05-.13.119-.23.21-.33.1-.09.21-.16.329-.21.361-.16.811-.07 1.091.21M12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9m0-20C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1"
    ></path>
  </symbol>

  <symbol id="more-menu-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M21 15c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-7 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m-9 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
    ></path>
  </symbol>

  <symbol id="add-items-icon" viewBox="0 0 25 25">
    <path d="M0 0h25v25H0z" fill="none"></path>
    <path
      d="M18.005 12.005a1 1 0 0 1-1 1h-4v4a1 1 0 1 1-2 0v-4h-4a1 1 0 1 1 0-2h4v-4a1 1 0 1 1 2 0v4h4a1 1 0 0 1 1 1m.333 6.396c-3.527 3.49-9.237 3.46-12.73-.064-3.49-3.526-3.461-9.235.065-12.728a8.97 8.97 0 0 1 6.377-2.6 8.976 8.976 0 0 1 6.35 2.664c3.493 3.526 3.464 9.235-.062 12.728m1.484-14.135C15.555-.045 8.576-.08 4.266 4.188-.044 8.455-.08 15.434 4.189 19.744A10.965 10.965 0 0 0 11.949 23a10.965 10.965 0 0 0 7.796-3.178c4.31-4.267 4.345-11.246.077-15.556"
    ></path>
  </symbol>

  <symbol id="start-icon" viewBox="0 0 32 32">
    <circle fill="#FFF" cx="16" cy="16" r="16" />
    <path
      d="M11 9.667v12.667a1 1 0 0 0 1.471.882l11.875-6.333a1 1 0 0 0 0-1.765L12.471 8.784A1 1 0 0 0 11 9.667z"
    />
  </symbol>

  <symbol id="stop-icon" viewBox="0 0 32 32">
    <circle fill="#FFF" cx="16" cy="16" r="16" />
    <path
      d="M22 23H10a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1z"
    />
  </symbol>

  <symbol id="info-icon" viewBox="0 0 28 28">
    <g fill="none" stroke="none" stroke-width="1">
      <g transform="translate(4.000000, 4.000000)">
        <mask fill="white" id="mask-2">
          <path
            d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 Z M9,7.80598218 L9,15.1940178 C9,15.6391495 9.44771525,16 10,16 C10.5522847,16 11,15.6391495 11,15.1940178 L11,7.80598218 C11,7.36085051 10.5522847,7 10,7 C9.44771525,7 9,7.36085051 9,7.80598218 Z M10,4 C9.44771525,4 9,4.44771525 9,5 C9,5.55228475 9.44771525,6 10,6 C10.5522847,6 11,5.55228475 11,5 C11,4.44771525 10.5522847,4 10,4 Z"
          ></path>
        </mask>
        <path
          d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 Z M9,7.80598218 L9,15.1940178 C9,15.6391495 9.44771525,16 10,16 C10.5522847,16 11,15.6391495 11,15.1940178 L11,7.80598218 C11,7.36085051 10.5522847,7 10,7 C9.44771525,7 9,7.36085051 9,7.80598218 Z M10,4 C9.44771525,4 9,4.44771525 9,5 C9,5.55228475 9.44771525,6 10,6 C10.5522847,6 11,5.55228475 11,5 C11,4.44771525 10.5522847,4 10,4 Z"
          fill="currentColor"
        ></path>
        <g mask="url(#mask-2)">
          <g transform="translate(-4.000000, -4.000000)">
            <rect height="28" width="28" x="0" y="0"></rect>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="refer-plane-icon" viewBox="0 0 165 135">
    <defs>
      <linearGradient x1="17.477%" y1="37.056%" x2="50%" y2="98.632%" id="a">
        <stop stop-color="#F5FFFB" offset="0%"></stop>
        <stop stop-color="#2EBA81" offset="100%"></stop>
      </linearGradient>
      <filter
        x="-54.6%"
        y="-57.6%"
        width="208.7%"
        height="246.3%"
        filterUnits="objectBoundingBox"
        id="b"
      >
        <feOffset
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.145098039 0 0 0 0 0.756862745 0 0 0 0 0.505882353 0 0 0 0.42430933 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        x="-19%"
        y="-19.9%"
        width="138.1%"
        height="149.7%"
        filterUnits="objectBoundingBox"
        id="d"
      >
        <feOffset
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.196078431 0 0 0 0 0.741176471 0 0 0 0 0.545098039 0 0 0 0.255066803 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        x="-16.1%"
        y="-63.1%"
        width="130.9%"
        height="198.2%"
        filterUnits="objectBoundingBox"
        id="f"
      >
        <feOffset
          dy="-6"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.149019608 0 0 0 0 0.760784314 0 0 0 0 0.505882353 0 0 0 0.209578804 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
    <g fill="none">
      <g fill="#E9F8F2">
        <path
          d="M30.867 33.416L83.78 2.791c9.647-5.583 21.994-2.289 27.577 7.358l.022.038.004.006c5.576 9.682 2.262 22.051-7.408 27.648L51.062 68.466c-9.647 5.584-21.994 2.29-27.578-7.358a20.181 20.181 0 0 1-.021-.037l-.004-.007c-5.576-9.682-2.262-22.05 7.408-27.648z"
        ></path>
        <path
          d="M30.082 80.609l73.886-42.764c9.647-5.584 21.994-2.29 27.577 7.357l.022.038c5.578 9.686 2.263 22.06-7.411 27.658L50.27 115.662c-9.647 5.584-21.994 2.29-27.578-7.357a20.181 20.181 0 0 1-.021-.038c-5.578-9.686-2.263-22.06 7.41-27.658z"
        ></path>
        <path
          d="M79.07 97.169l33.308-19.278c9.647-5.584 21.994-2.29 27.578 7.357l.021.038.01.017c5.573 9.676 2.26 22.038-7.403 27.631l-33.308 19.278c-9.647 5.584-21.994 2.29-27.578-7.357a20.182 20.182 0 0 1-.021-.038l-.01-.017c-5.573-9.676-2.26-22.038 7.403-27.631z"
        ></path>
      </g>
      <g stroke="#26C281" stroke-linecap="square">
        <path d="M91.5 21.5v3M91.5 26.5v3M88.5 24.5h3M93.5 24.5h3"></path>
      </g>
      <g stroke="#26C281" stroke-linecap="square">
        <path
          d="M108.5 26.25v1.5M108.5 28.25v1.5M107.222 27.5h1.334M110.222 27.5h1.334"
        ></path>
      </g>
      <g stroke="#26C281" stroke-linecap="square">
        <path
          d="M132.5 49.25v1.5M132.5 51.25v1.5M131.222 50.5h1.334M134.222 50.5h1.334"
        ></path>
      </g>
      <g stroke="#26C281" stroke-linecap="square">
        <path
          d="M114.5 68.25v1.5M114.5 70.25v1.5M114.222 68.5h1.334M117.222 68.5h1.334"
        ></path>
      </g>
      <g transform="rotate(-180 59.5 57)" stroke="#26C281">
        <circle cx="84" cy="3" r="2"></circle>
        <circle cx="86" cy="59" r="2"></circle>
        <circle cx="4" cy="103" r="2"></circle>
        <circle cx="88" cy="11" r="1"></circle>
        <circle cx="37" cy="1" r="1"></circle>
        <circle cx="14" cy="97" r="1"></circle>
        <circle cx="77.5" cy="62.5" r="1"></circle>
        <circle cx=".5" cy="90.5" r="1"></circle>
        <circle cx="77.5" cy="23.5" r="1"></circle>
        <circle cx="83.5" cy="38.5" r="1"></circle>
        <circle cx="43.5" cy="7.5" r="1"></circle>
        <circle cx="103.5" cy="23.5" r="1"></circle>
      </g>
      <path
        d="M24.226 42.739l10.4 31.084a1 1 0 0 0 1.523.5L141.893 0 24.226 42.739z"
        fill="url(#a)"
        transform="translate(13.154 16.946)"
      ></path>
      <g transform="translate(13.154 16.946)">
        <path
          d="M36.933 47.415l-2.461 27.281a1 1 0 0 0 1.443.984l35.608-17.803-34.59-10.462z"
          fill="#000"
          filter="url(#b)"
        ></path>
        <path
          d="M36.933 47.415l-2.461 27.281a1 1 0 0 0 1.443.984l35.608-17.803-34.59-10.462z"
          fill="#26C281"
        ></path>
      </g>
      <g transform="translate(13.154 16.946)">
        <path
          d="M76.898 79.767L141.893 0 36.8 47.125l37.223 32.877a2 2 0 0 0 2.874-.235z"
          fill="#000"
          filter="url(#d)"
        ></path>
        <path
          d="M76.898 79.767L141.893 0 36.8 47.125l37.223 32.877a2 2 0 0 0 2.874-.235z"
          fill="#FFF"
        ></path>
      </g>
      <g transform="translate(13.154 16.946)">
        <path
          d="M24.867 42.79L-1.09 35.834a1 1 0 0 1 .028-1.939L141.893 0 24.867 42.79z"
          fill="#000"
          filter="url(#f)"
        ></path>
        <path
          d="M24.867 42.79L-1.09 35.834a1 1 0 0 1 .028-1.939L141.893 0 24.867 42.79z"
          fill="#FFF"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="share-link-icon" viewBox="0 0 50 50">
    <g fill="none">
      <g transform="translate(2)">
        <rect width="48" height="48" rx="24" fill="currentColor"></rect>
      </g>
      <g transform="translate(12.5 10.793)">
        <path
          d="M13.196 8.263A1.425 1.425 0 1 1 11.18 6.25l3.68-3.681a6.767 6.767 0 1 1 9.571 9.57l-4.185 4.184a6.766 6.766 0 0 1-9.57 0 1.425 1.425 0 1 1 2.015-2.014 3.917 3.917 0 0 0 5.54 0l4.185-4.185a3.918 3.918 0 0 0-5.54-5.54l-3.681 3.68zm-.392 11.033a1.425 1.425 0 0 1 2.015 2.015l-2.974 2.973a6.767 6.767 0 0 1-9.57-9.57l3.477-3.477c2.672-2.672 7.203-2.871 9.823-.252A1.425 1.425 0 1 1 13.56 13c-1.465-1.465-4.196-1.345-5.793.252L4.29 16.729a3.918 3.918 0 0 0 5.54 5.54l2.974-2.973z"
          fill="#FFF"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-medal-icon" viewBox="0 0 138 187">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M97.715 130.087l-6.877 7.943a1.418 1.418 0 0 1-1.482.428l-10.15-3.024-7.768 5.004L87.374 187l12.886-18.43a1.42 1.42 0 0 1 1.601-.532l21.592 7.01-15.358-44.875-10.38-.086zM48.643 138.458a1.421 1.421 0 0 1-1.48-.428l-6.88-7.943-10.377.085-15.36 44.875 21.593-7.009a1.428 1.428 0 0 1 1.602.531L50.625 187l15.937-46.562-7.768-5.004-10.15 3.024z"
        fill="#3F4154"
      />
      <path
        d="M69 124.015a55.54 55.54 0 0 1-25.012-5.927l31.298-27.15-1.323-.7-31.318 27.167a55.2 55.2 0 0 1-4.285-2.563L56.957 98.71a2.034 2.034 0 0 1-.257-.67l-.423-2.435-20.284 17.595a56.094 56.094 0 0 1-2.897-2.298L55.554 91.42l-.278-1.606-23.251 20.169a55.841 55.841 0 0 1-6.217-6.495l27.68-24.01-.042-.242v-.004a2.114 2.114 0 0 1-.715-.228l-1.836-.973L24.1 101.274a54.802 54.802 0 0 1-3.709-5.774l24.066-20.876-1.324-.7-23.414 20.31a54.414 54.414 0 0 1-3.28-7.663L35.614 69.94l-2.645-1.4-17.429 15.117a54.238 54.238 0 0 1-1.99-14.548c0-30.275 24.876-54.907 55.451-54.907s55.451 24.632 55.451 54.907c0 30.275-24.876 54.907-55.451 54.907zm69.082-45.071l-4.36-9.248a1.38 1.38 0 0 1 0-1.176l4.36-9.247-6.814-7.656a1.381 1.381 0 0 1-.334-1.129l1.553-10.089-8.718-5.445a1.39 1.39 0 0 1-.642-.99l-1.381-10.112-9.912-2.793a1.401 1.401 0 0 1-.897-.771l-4.203-9.318-10.307.087c-.367-.023-.812-.176-1.08-.49L88.662 2.8l-9.863 2.956c-.398.121-.829.059-1.175-.167L69 0l-8.624 5.59a1.414 1.414 0 0 1-1.175.166L49.338 2.8l-6.685 7.767c-.268.314-.649.481-1.08.49l-10.307-.087-4.203 9.318a1.401 1.401 0 0 1-.897.771l-9.912 2.793-1.381 10.113a1.39 1.39 0 0 1-.642.99l-8.718 5.444 1.553 10.09c.063.406-.06.82-.334 1.128l-6.814 7.656 4.36 9.247a1.38 1.38 0 0 1 0 1.176l-4.36 9.248 6.814 7.655c.274.31.397.723.334 1.13L5.513 97.817l8.718 5.445c.351.22.585.582.642.99l1.381 10.113 9.912 2.792c.4.112.729.394.897.771l4.203 9.318 10.307-.085a1.42 1.42 0 0 1 1.08.488l6.685 7.769 9.863-2.958a1.401 1.401 0 0 1 1.175.168l8.624 5.59 8.624-5.59c.346-.227.777-.29 1.175-.168l9.863 2.958 6.685-7.77c.27-.312.658-.472 1.08-.487l10.307.085 4.203-9.318c.168-.377.498-.659.897-.771l9.912-2.792 1.381-10.114c.057-.407.291-.77.642-.99l8.718-5.444-1.553-10.088c-.063-.407.06-.82.334-1.13l6.814-7.655z"
        fill="#3F4154"
      />
      <path
        d="M102.322 50.409l-69.895 16.72 20.348 11.123S83.231 61.28 99.848 52.017L54.551 80.005l3.216 19.186 44.555-48.782zm0 0L75.635 90.74l-4.26-2.329 30.947-38.003z"
        fill="#00DD8C"
      />
    </g>
  </symbol>

  <symbol id="lock-green-icon" viewBox="0 0 267 115">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M228.653 42.084c2.68.314 8.825 1.563 11.721 6.495.304.516 1.04.533 1.341.016l3.946-6.78a.766.766 0 0 0-.009-.793c-.963-1.545-4.889-7.014-12.334-7.183a.785.785 0 0 0-.66.344l-4.555 6.7a.771.771 0 0 0 .55 1.201M224.29 16.88c2.375-1.287 8.115-3.801 13.32-1.44.545.249 1.156-.161 1.104-.757l-.678-7.816a.765.765 0 0 0-.465-.643c-1.675-.71-8.035-2.918-14.219 1.232a.781.781 0 0 0-.341.66l.135 8.1a.773.773 0 0 0 1.145.664"
        fill="#00DD8D"
      />
      <path
        d="M195.954 43.276c.747-2.593 2.98-8.453 8.317-10.506.559-.216.697-.938.235-1.32l-6.047-5a.765.765 0 0 0-.784-.118c-1.681.697-7.716 3.68-9.096 10.999a.785.785 0 0 0 .23.706l5.87 5.586a.77.77 0 0 0 1.275-.347"
        fill="#FFF"
      />
      <path
        d="M261.4 42.964c-1.413 2.3-5.132 7.345-10.821 7.896-.596.058-.922.717-.58 1.208l4.49 6.435c.164.234.439.36.724.325 1.806-.223 8.419-1.483 11.706-8.166a.782.782 0 0 0-.034-.742l-4.161-6.953a.773.773 0 0 0-1.323-.003"
        fill="#00DD8D"
      />
      <path
        d="M210.42 77.863c-1.904-1.204-8.011-4.89-13.35-6.17a.769.769 0 0 0-.865.418l-3.58 7.35a.77.77 0 0 0 .415 1.058c2.27.87 8.9 3.532 12.482 6.23a.767.767 0 0 0 1.143-.255l4.024-7.62a.77.77 0 0 0-.268-1.011"
        fill="#FFF"
      />
      <path
        d="M202.948 47.753c.776 1.688 3.02 6.273 5.744 9.222a.766.766 0 0 0 .955.128l5.04-3.002a.768.768 0 0 0 .235-1.108c-1.147-1.602-3.989-5.727-5.153-8.81a.769.769 0 0 0-1.094-.407l-5.397 2.98a.769.769 0 0 0-.33.997"
        fill="#00DD8D"
      />
      <path
        d="M249.96 25.19c1.504.64 5.323 2.147 8.588 2.466a.766.766 0 0 0 .798-.545l1.385-4.497a.772.772 0 0 0-.569-.98c-1.673-.37-5.53-1.3-7.944-2.509a.748.748 0 0 0-1.075.436l-1.607 4.67a.769.769 0 0 0 .424.96"
        fill="#FFF"
      />
      <path
        d="M186.986 67.1c1.542-.54 5.38-1.997 8.01-3.96a.764.764 0 0 0 .222-.94l-2.004-4.258a.771.771 0 0 0-1.082-.342c-1.485.854-4.964 2.763-7.561 3.496-.47.132-.695.597-.502 1.046l1.957 4.534c.16.371.578.558.96.424"
        fill="#00DD8D"
      />
      <path
        d="M83.56 53.855c-.5-1.556-1.855-5.431-3.75-8.111a.767.767 0 0 0-.933-.248l-4.31 1.892a.77.77 0 0 0-.368 1.073c.814 1.508 2.632 5.035 3.295 7.65.12.474.58.71 1.033.53l4.584-1.837a.77.77 0 0 0 .449-.95"
        fill="#FFF"
      />
      <path
        d="M17.802 36.474c1.692 1.5 4.935 4.959 4.757 9.337-.023.575.586.96 1.104.71l5.428-2.612a.77.77 0 0 0 .438-.672c.044-1.595-.199-6.856-4.955-10.282a.78.78 0 0 0-.74-.086l-5.806 2.31a.77.77 0 0 0-.226 1.295M20.608 20.519c2.247.25 6.89 1.212 9.267 4.894.312.483 1.03.447 1.312-.055l2.932-5.263a.768.768 0 0 0-.03-.801c-.882-1.33-4.11-5.491-9.971-5.552a.782.782 0 0 0-.656.356l-3.415 5.232a.77.77 0 0 0 .56 1.189M59.145 44.374c-2.073.904-6.576 2.39-10.473.385-.51-.263-1.116.128-1.108.703l.086 6.023c.005.29.166.551.425.68 1.427.711 6.302 2.706 11.412-.167a.778.778 0 0 0 .39-.636l.348-6.238a.771.771 0 0 0-1.08-.75"
        fill="#00DD8D"
      />
      <path
        d="M9.089 47.279c.32-1.921 1.104-7.39.446-11.66a.767.767 0 0 0-.72-.64l-6.338-.37a.77.77 0 0 0-.817.789c.055 2.074.105 7.524-.733 10.967a.768.768 0 0 0 .678.95l6.652.606a.773.773 0 0 0 .832-.642"
        fill="#FFF"
      />
      <path
        d="M73.047 37.633c1.524.428 5.281 1.375 8.391 1.287a.763.763 0 0 0 .721-.64l.758-4.377a.77.77 0 0 0-.688-.9c-1.642-.149-5.353-.56-7.775-1.399a.77.77 0 0 0-1.01.57l-.945 4.56a.772.772 0 0 0 .548.9"
        fill="#00DD8D"
      />
      <path
        d="M42.122 22.675c.505 1.289 1.725 4.157 3.293 6.164.224.286.625.36.948.195l3.151-1.608a.77.77 0 0 0 .308-1.09c-.745-1.214-2.233-3.76-2.897-5.75a.771.771 0 0 0-1.062-.461l-3.348 1.574a.768.768 0 0 0-.393.976"
        fill="#FFF"
      />
      <path
        d="M118.163 60.35V26.931c0-9.56 7.777-17.337 17.337-17.337 9.56 0 17.338 7.777 17.338 17.337v9.386a4.563 4.563 0 0 0 9.125 0v-9.386C161.963 12.341 150.092.47 135.5.47c-14.591 0-26.462 11.871-26.462 26.462v33.42h9.125z"
        fill="#3F4154"
      />
      <path
        d="M149.063 79.822l-17.355 17.354a.918.918 0 0 1-1.298 0l-8.472-8.472a.919.919 0 0 1 0-1.298l2.254-2.254a.919.919 0 0 1 1.299 0l5.568 5.567 14.45-14.45a.918.918 0 0 1 1.3 0l2.254 2.255a.919.919 0 0 1 0 1.298zm13.81-19.472H103.04c-2.231 0-4.041 1.895-4.041 4.234v45.63c0 2.384 1.844 4.317 4.12 4.317h64.909c2.192 0 3.97-1.863 3.97-4.162V69.373l-9.126-9.023z"
        fill="#00DD8C"
      />
    </g>
  </symbol>

  <symbol id="pdf-icon" viewBox="0 0 50 50">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h35v35H0z"></path>
      <path
        d="M37.282 7.528H8.564v39.277c0 1.105.89 2 1.99 2H40.45c1.099 0 1.99-.895 1.99-2V12.556l-5.158-5.028z"
        fill="#767687"
        opacity=".35"
      ></path>
      <path
        d="M42.004 43.19V5c0-1.105-.914-2-2.042-2H10.17c-1.128 0-2.043.895-2.043 2v38.19c0 1.104.915 2 2.043 2h29.79c1.129 0 2.043-.896 2.043-2"
        fill="#FFF"
      ></path>
      <path
        d="M42.004 43.19V5c0-1.105-.914-2-2.042-2H10.17c-1.128 0-2.043.895-2.043 2v38.19c0 1.104.915 2 2.043 2h29.79c1.129 0 2.043-.896 2.043-2z"
        stroke="#0E1123"
        stroke-width="2"
        stroke-linejoin="round"
      ></path>
      <path
        d="M20.735 36.215c.326 0 .562-.078.705-.234.144-.156.216-.374.216-.654a.978.978 0 0 0-.056-.338.688.688 0 0 0-.17-.262.76.76 0 0 0-.285-.169 1.265 1.265 0 0 0-.41-.06h-.654v1.717h.654zm0-2.656c.38 0 .708.045.982.136.274.09.499.214.676.373.177.158.308.345.392.56.084.216.126.449.126.699 0 .27-.043.517-.13.743a1.49 1.49 0 0 1-.397.58c-.179.16-.405.286-.678.376-.274.09-.598.136-.971.136h-.654v1.808h-1.256V33.56h1.91zm7.725 2.704c0 .391-.068.752-.203 1.082-.135.331-.325.617-.57.858-.245.242-.54.43-.885.565a3.135 3.135 0 0 1-1.15.202H23.55V33.56h2.102c.42 0 .804.068 1.15.204a2.513 2.513 0 0 1 1.456 1.42c.134.331.202.691.202 1.08zm-1.285 0c0-.268-.035-.509-.104-.724a1.547 1.547 0 0 0-.3-.548c-.13-.15-.288-.265-.476-.346a1.62 1.62 0 0 0-.643-.12h-.84v3.48h.84c.24 0 .454-.04.643-.121.188-.08.347-.196.477-.345.13-.15.23-.333.299-.548a2.37 2.37 0 0 0 .104-.728zm3.29-1.738v1.37h1.85v.97h-1.85v2.105h-1.262V33.56h3.484v.966h-2.222z"
        fill="#0E1123"
      ></path>
      <path
        d="M31.922 22.094c-11.11-.216-15.694 3.989-15.694 3.989-1.818 1.409-.63 2.534-.63 2.534 1.116 1.019 2.01 0 2.01 0 4.137-4.66 7.435-14.806 7.435-14.806.834-2.638-.459-3.76-.459-3.76-1.305-1.1-1.969.84-1.969.84-.969 2.764.584 6.556 5.144 11.04 1.461 1.438 2.63 2.266 3.541 2.727 0 0 2.604 1.332 3.401-.74 0 0 .83-1.754-2.779-1.824z"
        stroke="#EB004E"
        stroke-width="2"
      ></path>
    </g>
  </symbol>

  <symbol id="select-logo-icon" viewBox="0 0 50 50">
    <path id="a" d="M0 50h50V0H0z" fill="none"></path>
    <path
      d="M30 26h-4v4a1 1 0 1 1-2 0v-4h-4a1 1 0 1 1 0-2h4v-4a1 1 0 1 1 2 0v4h4a1 1 0 1 1 0 2zM11 2h6V-.001h-6zm0 48h6v-2h-6zM22 2h6V-.001h-6zm0 48h6v-2h-6zM44 2h.826A3.178 3.178 0 0 1 48 5.174V6h2v-.826A5.18 5.18 0 0 0 44.826 0H44v2z"
    ></path>
    <mask id="b" fill="none">
      <use attr.xlink:href="{{ locationPath }}#a"></use>
    </mask>
    <path
      mask="url(#b)"
      d="M0 39h2v-6H0zm0-22h2v-6H0zm0 11h2v-6H0zM2 6v-.826A3.178 3.178 0 0 1 5.174 2H6V0h-.826A5.18 5.18 0 0 0 0 5.174V6h2zm4 42h-.826A3.178 3.178 0 0 1 2 44.826V44H0v.826A5.18 5.18 0 0 0 5.174 50H6v-2zm42-31h2v-6h-2zM33 50h6v-2h-6zm15-6v.826A3.178 3.178 0 0 1 44.826 48H44v2h.826A5.18 5.18 0 0 0 50 44.826V44h-2zM33 2h6V0h-6zm15 26h2v-6h-2zm0 11h2v-6h-2z"
    ></path>
  </symbol>

  <symbol id="document-link-icon" viewBox="0 0 16 14">
    <path
      d="M6.091 11.139l-.114.12a2.3 2.3 0 0 1-3.372 0 2.6 2.6 0 0 1 0-3.549L4.87 5.325a2.321 2.321 0 0 1 .789-.547 2.275 2.275 0 0 1 2.212.228 2.549 2.549 0 0 1 .371.319 2.693 2.693 0 0 1 .3.391 2.631 2.631 0 0 1 .162 2.471 1.354 1.354 0 0 0 1.747-.221l.364-.384a4.641 4.641 0 0 0-.91-3.3 4.224 4.224 0 0 0-.318-.376 4.155 4.155 0 0 0-6.07 0L1.255 6.291a4.693 4.693 0 0 0 0 6.389 4.148 4.148 0 0 0 6.07 0l.507-.532a4.9 4.9 0 0 1-1.741-1.008m8.654-3.43l-2.267 2.39a4.138 4.138 0 0 1-5.712.333 3.866 3.866 0 0 1-.358-.333 4.383 4.383 0 0 1-.318-.377 4.645 4.645 0 0 1-.91-3.3l.364-.384a1.354 1.354 0 0 1 1.747-.221 2.631 2.631 0 0 0 .162 2.471 2.693 2.693 0 0 0 .3.391 2.6 2.6 0 0 0 .371.319 2.273 2.273 0 0 0 2.212.228 2.307 2.307 0 0 0 .789-.547L13.4 6.291a2.605 2.605 0 0 0 0-3.55 2.3 2.3 0 0 0-3.372 0l-.114.12a4.9 4.9 0 0 0-1.74-1.008l.506-.532a4.148 4.148 0 0 1 6.07 0 4.694 4.694 0 0 1 0 6.39"
    ></path>
  </symbol>

  <symbol id="clients-empty-state-icon" viewBox="0 0 176 176">
    <g id="pictogram/clients" stroke="none" stroke-width="1" fill="none">
      <rect id="Bounding-box" x="0" y="0" width="176" height="176"></rect>
      <rect
        id="Rectangle"
        fill="#A4EBD5"
        x="28"
        y="61"
        width="128"
        height="78"
        rx="8"
      ></rect>
      <rect
        id="Rectangle"
        fill="#FFFFFF"
        x="21"
        y="53"
        width="123"
        height="76"
        rx="8"
      ></rect>
      <g id="Oval-7-Copy" transform="translate(89.000000, 77.000000)">
        <mask id="clients-empty-state-mask-2" fill="white">
          <ellipse cx="17.5" cy="17" rx="17.5" ry="17"></ellipse>
        </mask>
        <ellipse cx="17.5" cy="17" rx="17.5" ry="17" fill="#00E591"></ellipse>
        <circle
          fill="#FFFFFF"
          mask="url(#clients-empty-state-mask-2)"
          cx="18"
          cy="35.5"
          r="11.5"
        ></circle>
        <circle
          id="Oval-7"
          fill="#FFFFFF"
          mask="url(#clients-empty-state-mask-2)"
          cx="18"
          cy="14"
          r="7"
        ></circle>
      </g>
      <path
        d="M30,60 L130,60 C131.104569,60 132,60.8954305 132,62 L132,71 L132,71 L28,71 L28,62 C28,60.8954305 28.8954305,60 30,60 Z"
        id="Rectangle"
        fill="#A4EBD5"
      ></path>
      <rect
        id="Rectangle-Copy"
        fill="#384D57"
        x="35"
        y="82"
        width="42"
        height="3"
      ></rect>
      <rect
        id="Rectangle-Copy-2"
        fill="#384D57"
        x="35"
        y="91"
        width="35"
        height="3"
      ></rect>
      <rect
        id="Rectangle-Copy-3"
        fill="#384D57"
        x="35"
        y="100"
        width="24"
        height="3"
      ></rect>
      <rect
        id="Rectangle"
        stroke="#162D3D"
        stroke-width="3"
        x="22.5"
        y="54.5"
        width="116"
        height="69"
        rx="6"
      ></rect>
    </g>
  </symbol>

  <defs>
    <filter
      x="-108.8%"
      y="-47.5%"
      width="317.6%"
      height="227.9%"
      filterUnits="objectBoundingBox"
      id="expense-filter-1"
    >
      <feOffset
        dx="4"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-79.4%"
      y="-31.1%"
      width="258.8%"
      height="195.1%"
      filterUnits="objectBoundingBox"
      id="expense-filter-4"
    >
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.033740942 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="7"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 0.5 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-90.2%"
      y="-34.9%"
      width="280.5%"
      height="194.0%"
      filterUnits="objectBoundingBox"
      id="expense-filter-5"
    >
      <feOffset
        dx="4"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.192156863   0 0 0 0 0.415686275   0 0 0 0 0.690196078  0 0 0 0.0780966938 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-65.9%"
      y="-22.9%"
      width="231.7%"
      height="169.9%"
      filterUnits="objectBoundingBox"
      id="expense-filter-8"
    >
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.033740942 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="7"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 0.5 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-65.9%"
      y="-22.9%"
      width="231.7%"
      height="169.9%"
      filterUnits="objectBoundingBox"
      id="expense-filter-10"
    >
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feComposite
        in="shadowBlurOuter1"
        in2="SourceAlpha"
        operator="out"
        result="shadowBlurOuter1"
      ></feComposite>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.033740942 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="7"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feComposite
        in="shadowBlurOuter2"
        in2="SourceAlpha"
        operator="out"
        result="shadowBlurOuter2"
      ></feComposite>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 0.5 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-77.1%"
      y="-29.9%"
      width="254.2%"
      height="180.4%"
      filterUnits="objectBoundingBox"
      id="expense-filter-11"
    >
      <feOffset
        dx="4"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.192156863   0 0 0 0 0.415686275   0 0 0 0 0.690196078  0 0 0 0.0780966938 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-56.3%"
      y="-19.6%"
      width="212.5%"
      height="159.8%"
      filterUnits="objectBoundingBox"
      id="expense-filter-13"
    >
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="4"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.033740942 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="7"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 0.5 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <mask id="expense-mask-3" fill="white">
      <polygon
        points="0 0 34 0 34 61 30.0083618 58.8694548 25.0802917 61 20.8634949 58.8694548 16.7535706 61 12.3251038 58.8694548 8.30078125 61 4.58825684 58.8694548 0 61"
      ></polygon>
    </mask>
    <mask id="expense-mask-7" fill="white">
      <polygon
        points="0 0 41 0 41 83 36.186554 80.4371702 30.2438812 83 25.1589203 80.4371702 20.2028351 83 14.8626251 80.4371702 10.0097656 83 5.53289795 80.4371702 0 83"
      ></polygon>
    </mask>
  </defs>
  <symbol id="expenses-empty-state-icon" viewBox="0 0 141 148">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Design/Illustration/Medium/Expense"
        transform="translate(-24.000000, -27.000000)"
      >
        <g id="Expenses" transform="translate(0.000000, 11.000000)">
          <g id="Group-6">
            <g
              id="Group"
              transform="translate(86.000000, 79.500000) rotate(-30.000000) translate(-86.000000, -79.500000) translate(18.000000, 27.000000)"
            >
              <rect
                id="Rectangle-9"
                fill="#ECF3FF"
                x="21"
                y="0"
                width="88"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy"
                fill="#ECF3FF"
                x="0"
                y="35"
                width="102"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-3"
                fill="#FFFFFF"
                x="68"
                y="35"
                width="45"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-2"
                fill="#ECF3FF"
                x="30"
                y="70"
                width="106"
                height="35"
                rx="17.5"
              ></rect>
            </g>
          </g>
          <g id="Group-Copy-5" transform="translate(38.000000, 34.000000)">
            <g
              id="Group"
              attr.filter="url({{ locationPath }}#expense-filter-1)"
            >
              <g id="Rectangle">
                <g id="Mask">
                  <polygon
                    points="0 0 34 0 34 61 30.0083618 58.8694548 25.0802917 61 20.8634949 58.8694548 16.7535706 61 12.3251038 58.8694548 8.30078125 61 4.58825684 58.8694548 0 61"
                    fill="black"
                    fill-opacity="1"
                    attr.filter="url({{ locationPath }}#expense-filter-4)"
                  ></polygon>
                  <polygon
                    points="0 0 34 0 34 61 30.0083618 58.8694548 25.0802917 61 20.8634949 58.8694548 16.7535706 61 12.3251038 58.8694548 8.30078125 61 4.58825684 58.8694548 0 61"
                    fill="#ECF3FF"
                  ></polygon>
                </g>
                <polygon
                  fill="#9DB1CF"
                  opacity="0.320814732"
                  attr.mask="url({{ locationPath }}#expense-mask-3)"
                  points="17 24 51 24 51 85 47.0083618 82.8694548 42.0802917 85 37.8634949 82.8694548 33.7535706 85 29.3251038 82.8694548 25.3007812 85 21.5882568 82.8694548 17 85"
                ></polygon>
              </g>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="3.1875 39.6945476 5.3125 39.6945476 5.3125 49.2820012 3.1875 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="6.375 39.6945476 10.625 39.6945476 10.625 49.2820012 6.375 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="11.6875 39.6945476 13.8125 39.6945476 13.8125 49.2820012 11.6875 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="14.875 39.6945476 15.9375 39.6945476 15.9375 49.2820012 14.875 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="17 39.6945476 19.125 39.6945476 19.125 49.2820012 17 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="20.1875 39.6945476 21.25 39.6945476 21.25 49.2820012 20.1875 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="25.5 39.6945476 26.5625 39.6945476 26.5625 49.2820012 25.5 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="27.625 39.6945476 28.6875 39.6945476 28.6875 49.2820012 27.625 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="29.75 39.6945476 30.8125 39.6945476 30.8125 49.2820012 29.75 49.2820012"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#4E87E3"
                points="22.3125 39.6945476 24.4375 39.6945476 24.4375 49.2820012 22.3125 49.2820012"
              ></polygon>
              <path
                d="M4.61729098,32.0084034 L13.3186892,32.0084034 C13.9591539,32.0084034 14.4783531,32.5276026 14.4783531,33.1680672 C14.4783531,33.8085319 13.9591539,34.3277311 13.3186892,34.3277311 L4.61729098,34.3277311 C3.97682632,34.3277311 3.45762712,33.8085319 3.45762712,33.1680672 C3.45762712,32.5276026 3.97682632,32.0084034 4.61729098,32.0084034 Z"
                id="Rectangle-2-Copy-2"
                fill="#9DBAE9"
              ></path>
              <path
                d="M26.9377625,32.0084034 L30.0305537,32.0084034 C30.6710183,32.0084034 31.1902175,32.5276026 31.1902175,33.1680672 C31.1902175,33.8085319 30.6710183,34.3277311 30.0305537,34.3277311 L26.9377625,34.3277311 C26.2972978,34.3277311 25.7780986,33.8085319 25.7780986,33.1680672 C25.7780986,32.5276026 26.2972978,32.0084034 26.9377625,32.0084034 Z"
                id="Rectangle-2-Copy-7"
                fill="#4E87E3"
              ></path>
              <path
                d="M4.61729098,17.512605 L13.3186892,17.512605 C13.9591539,17.512605 14.4783531,18.0318042 14.4783531,18.6722689 C14.4783531,19.3127336 13.9591539,19.8319328 13.3186892,19.8319328 L4.61729098,19.8319328 C3.97682632,19.8319328 3.45762712,19.3127336 3.45762712,18.6722689 C3.45762712,18.0318042 3.97682632,17.512605 4.61729098,17.512605 Z"
                id="Rectangle-2-Copy-4"
                fill="#9DBAE9"
              ></path>
              <path
                d="M26.9377625,17.512605 L30.0305537,17.512605 C30.6710183,17.512605 31.1902175,18.0318042 31.1902175,18.6722689 C31.1902175,19.3127336 30.6710183,19.8319328 30.0305537,19.8319328 L26.9377625,19.8319328 C26.2972978,19.8319328 25.7780986,19.3127336 25.7780986,18.6722689 C25.7780986,18.0318042 26.2972978,17.512605 26.9377625,17.512605 Z"
                id="Rectangle-2-Copy-8"
                fill="#4E87E3"
              ></path>
              <path
                d="M4.61729098,22.7310924 L13.3186892,22.7310924 C13.9591539,22.7310924 14.4783531,23.2502916 14.4783531,23.8907563 C14.4783531,24.531221 13.9591539,25.0504202 13.3186892,25.0504202 L4.61729098,25.0504202 C3.97682632,25.0504202 3.45762712,24.531221 3.45762712,23.8907563 C3.45762712,23.2502916 3.97682632,22.7310924 4.61729098,22.7310924 Z"
                id="Rectangle-2-Copy-2"
                fill="#9DBAE9"
              ></path>
              <path
                d="M26.9377625,22.7310924 L30.0305537,22.7310924 C30.6710183,22.7310924 31.1902175,23.2502916 31.1902175,23.8907563 C31.1902175,24.531221 30.6710183,25.0504202 30.0305537,25.0504202 L26.9377625,25.0504202 C26.2972978,25.0504202 25.7780986,24.531221 25.7780986,23.8907563 C25.7780986,23.2502916 26.2972978,22.7310924 26.9377625,22.7310924 Z"
                id="Rectangle-2-Copy-9"
                fill="#4E87E3"
              ></path>
              <path
                d="M4.61729098,7.69921164 L23.2778361,7.69921164 C23.9183008,7.69921164 24.4375,8.21841084 24.4375,8.85887551 C24.4375,9.49934018 23.9183008,10.0185394 23.2778361,10.0185394 L4.61729098,10.0185394 C3.97682632,10.0185394 3.45762712,9.49934018 3.45762712,8.85887551 C3.45762712,8.21841084 3.97682632,7.69921164 4.61729098,7.69921164 Z"
                id="Rectangle-2-Copy-5"
                fill="#9DBAE9"
              ></path>
              <path
                d="M4.61729098,26.789916 L10.2357376,26.789916 C10.8762023,26.789916 11.3954015,27.3091152 11.3954015,27.9495798 C11.3954015,28.5900445 10.8762023,29.1092437 10.2357376,29.1092437 L4.61729098,29.1092437 C3.97682632,29.1092437 3.45762712,28.5900445 3.45762712,27.9495798 C3.45762712,27.3091152 3.97682632,26.789916 4.61729098,26.789916 Z"
                id="Rectangle-2-Copy-3"
                fill="#9DBAE9"
              ></path>
              <path
                d="M24.3907766,26.789916 L30.0092233,26.789916 C30.6496879,26.789916 31.1688871,27.3091152 31.1688871,27.9495798 C31.1688871,28.5900445 30.6496879,29.1092437 30.0092233,29.1092437 L24.3907766,29.1092437 C23.750312,29.1092437 23.2311128,28.5900445 23.2311128,27.9495798 C23.2311128,27.3091152 23.750312,26.789916 24.3907766,26.789916 Z"
                id="Rectangle-2-Copy-11"
                fill="#4E87E3"
              ></path>
            </g>
          </g>
          <g id="Group" transform="translate(62.000000, 48.000000)">
            <g attr.filter="url({{ locationPath }}#expense-filter-5)">
              <g id="Rectangle">
                <g id="Mask">
                  <polygon
                    points="0 0 41 0 41 83 36.186554 80.4371702 30.2438812 83 25.1589203 80.4371702 20.2028351 83 14.8626251 80.4371702 10.0097656 83 5.53289795 80.4371702 0 83"
                    fill="black"
                    fill-opacity="1"
                    attr.filter="url({{ locationPath }}#expense-filter-8)"
                  ></polygon>
                  <polygon
                    points="0 0 41 0 41 83 36.186554 80.4371702 30.2438812 83 25.1589203 80.4371702 20.2028351 83 14.8626251 80.4371702 10.0097656 83 5.53289795 80.4371702 0 83"
                    fill="#26C281"
                  ></polygon>
                </g>
                <g
                  opacity="0.351785714"
                  style="mix-blend-mode: multiply"
                  attr.mask="url({{ locationPath }}#expense-mask-7)"
                >
                  <polygon
                    points="17 -5 58 -5 58 78 53.186554 75.4371702 47.2438812 78 42.1589203 75.4371702 37.2028351 78 31.8626251 75.4371702 27.0097656 78 22.5328979 75.4371702 17 78"
                    fill="black"
                    fill-opacity="1"
                    attr.filter="url({{ locationPath }}#expense-filter-10)"
                  ></polygon>
                  <polygon
                    points="17 -5 58 -5 58 78 53.186554 75.4371702 47.2438812 78 42.1589203 75.4371702 37.2028351 78 31.8626251 75.4371702 27.0097656 78 22.5328979 75.4371702 17 78"
                    fill-opacity="0.428640172"
                    fill="#30A371"
                    style="mix-blend-mode: multiply"
                  ></polygon>
                </g>
              </g>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="3.84375 57.3717022 6.40625 57.3717022 6.40625 68.9044362 3.84375 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="7.6875 57.3717022 12.8125 57.3717022 12.8125 68.9044362 7.6875 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="14.09375 57.3717022 16.65625 57.3717022 16.65625 68.9044362 14.09375 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="17.9375 57.3717022 19.21875 57.3717022 19.21875 68.9044362 17.9375 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="20.5 57.3717022 23.0625 57.3717022 23.0625 68.9044362 20.5 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="24.34375 57.3717022 25.625 57.3717022 25.625 68.9044362 24.34375 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#94D4B8"
                points="30.75 57.3717022 32.03125 57.3717022 32.03125 68.9044362 30.75 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#94D4B8"
                points="33.3125 57.3717022 34.59375 57.3717022 34.59375 68.9044362 33.3125 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#94D4B8"
                points="35.875 57.3717022 37.15625 57.3717022 37.15625 68.9044362 35.875 68.9044362"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#FFFFFF"
                points="26.90625 57.3717022 29.46875 57.3717022 29.46875 68.9044362 26.90625 68.9044362"
              ></polygon>
              <path
                d="M5.56444951,48.1260504 L16.0642325,48.1260504 C16.8346466,48.1260504 17.4591905,48.7505944 17.4591905,49.5210084 C17.4591905,50.2914224 16.8346466,50.9159664 16.0642325,50.9159664 L5.56444951,50.9159664 C4.79403549,50.9159664 4.16949153,50.2914224 4.16949153,49.5210084 C4.16949153,48.7505944 4.79403549,48.1260504 5.56444951,48.1260504 Z"
                id="Rectangle-2-Copy-2"
                fill="#FFFFFF"
              ></path>
              <path
                d="M32.4803122,48.1260504 L36.2167749,48.1260504 C36.9871889,48.1260504 37.6117329,48.7505944 37.6117329,49.5210084 C37.6117329,50.2914224 36.9871889,50.9159664 36.2167749,50.9159664 L32.4803122,50.9159664 C31.7098982,50.9159664 31.0853542,50.2914224 31.0853542,49.5210084 C31.0853542,48.7505944 31.7098982,48.1260504 32.4803122,48.1260504 Z"
                id="Rectangle-2-Copy-7"
                fill="#B2E7D0"
              ></path>
              <path
                d="M5.56444951,30.6890756 L16.0642325,30.6890756 C16.8346466,30.6890756 17.4591905,31.3136196 17.4591905,32.0840336 C17.4591905,32.8544476 16.8346466,33.4789916 16.0642325,33.4789916 L5.56444951,33.4789916 C4.79403549,33.4789916 4.16949153,32.8544476 4.16949153,32.0840336 C4.16949153,31.3136196 4.79403549,30.6890756 5.56444951,30.6890756 Z"
                id="Rectangle-2-Copy-4"
                fill="#FFFFFF"
              ></path>
              <path
                d="M32.4803122,30.6890756 L36.2167749,30.6890756 C36.9871889,30.6890756 37.6117329,31.3136196 37.6117329,32.0840336 C37.6117329,32.8544476 36.9871889,33.4789916 36.2167749,33.4789916 L32.4803122,33.4789916 C31.7098982,33.4789916 31.0853542,32.8544476 31.0853542,32.0840336 C31.0853542,31.3136196 31.7098982,30.6890756 32.4803122,30.6890756 Z"
                id="Rectangle-2-Copy-8"
                fill="#B2E7D0"
              ></path>
              <path
                d="M5.56444951,36.9663866 L16.0642325,36.9663866 C16.8346466,36.9663866 17.4591905,37.5909305 17.4591905,38.3613445 C17.4591905,39.1317586 16.8346466,39.7563025 16.0642325,39.7563025 L5.56444951,39.7563025 C4.79403549,39.7563025 4.16949153,39.1317586 4.16949153,38.3613445 C4.16949153,37.5909305 4.79403549,36.9663866 5.56444951,36.9663866 Z"
                id="Rectangle-2-Copy-2"
                fill="#FFFFFF"
              ></path>
              <path
                d="M32.4803122,36.9663866 L36.2167749,36.9663866 C36.9871889,36.9663866 37.6117329,37.5909305 37.6117329,38.3613445 C37.6117329,39.1317586 36.9871889,39.7563025 36.2167749,39.7563025 L32.4803122,39.7563025 C31.7098982,39.7563025 31.0853542,39.1317586 31.0853542,38.3613445 C31.0853542,37.5909305 31.7098982,36.9663866 32.4803122,36.9663866 Z"
                id="Rectangle-2-Copy-9"
                fill="#B2E7D0"
              ></path>
              <path
                d="M5.56444951,19.5294118 L16.0642325,19.5294118 C16.8346466,19.5294118 17.4591905,20.1539557 17.4591905,20.9243697 C17.4591905,21.6947838 16.8346466,22.3193277 16.0642325,22.3193277 L5.56444951,22.3193277 C4.79403549,22.3193277 4.16949153,21.6947838 4.16949153,20.9243697 C4.16949153,20.1539557 4.79403549,19.5294118 5.56444951,19.5294118 Z"
                id="Rectangle-2-Copy-5"
                fill="#FFFFFF"
              ></path>
              <path
                d="M5.56444951,9.26137053 L28.073792,9.26137053 C28.844206,9.26137053 29.46875,9.88591449 29.46875,10.6563285 C29.46875,11.4267425 28.844206,12.0512865 28.073792,12.0512865 L5.56444951,12.0512865 C4.79403549,12.0512865 4.16949153,11.4267425 4.16949153,10.6563285 C4.16949153,9.88591449 4.79403549,9.26137053 5.56444951,9.26137053 Z"
                id="Rectangle-2-Copy-5"
                fill="#FFFFFF"
              ></path>
              <path
                d="M32.4803122,19.5294118 L36.2167749,19.5294118 C36.9871889,19.5294118 37.6117329,20.1539557 37.6117329,20.9243697 C37.6117329,21.6947838 36.9871889,22.3193277 36.2167749,22.3193277 L32.4803122,22.3193277 C31.7098982,22.3193277 31.0853542,21.6947838 31.0853542,20.9243697 C31.0853542,20.1539557 31.7098982,19.5294118 32.4803122,19.5294118 Z"
                id="Rectangle-2-Copy-10"
                fill="#B2E7D0"
              ></path>
              <path
                d="M5.56444951,41.8487395 L12.3465556,41.8487395 C13.1169696,41.8487395 13.7415136,42.4732835 13.7415136,43.2436975 C13.7415136,44.0141115 13.1169696,44.6386555 12.3465556,44.6386555 L5.56444951,44.6386555 C4.79403549,44.6386555 4.16949153,44.0141115 4.16949153,43.2436975 C4.16949153,42.4732835 4.79403549,41.8487395 5.56444951,41.8487395 Z"
                id="Rectangle-2-Copy-3"
                fill="#FFFFFF"
              ></path>
              <path
                d="M29.4089469,41.8487395 L36.191053,41.8487395 C36.961467,41.8487395 37.5860109,42.4732835 37.5860109,43.2436975 C37.5860109,44.0141115 36.961467,44.6386555 36.191053,44.6386555 L29.4089469,44.6386555 C28.6385329,44.6386555 28.0139889,44.0141115 28.0139889,43.2436975 C28.0139889,42.4732835 28.6385329,41.8487395 29.4089469,41.8487395 Z"
                id="Rectangle-2-Copy-11"
                fill="#B2E7D0"
              ></path>
              <path
                d="M5.56444951,24.4117647 L22.2660921,24.4117647 C23.0365061,24.4117647 23.6610501,25.0363087 23.6610501,25.8067227 C23.6610501,26.5771367 23.0365061,27.2016807 22.2660921,27.2016807 L5.56444951,27.2016807 C4.79403549,27.2016807 4.16949153,26.5771367 4.16949153,25.8067227 C4.16949153,25.0363087 4.79403549,24.4117647 5.56444951,24.4117647 Z"
                id="Rectangle-2-Copy-6"
                fill="#FFFFFF"
              ></path>
              <path
                d="M33.8559689,24.4117647 L36.191053,24.4117647 C36.961467,24.4117647 37.5860109,25.0363087 37.5860109,25.8067227 C37.5860109,26.5771367 36.961467,27.2016807 36.191053,27.2016807 L33.8559689,27.2016807 C33.0855549,27.2016807 32.4610109,26.5771367 32.4610109,25.8067227 C32.4610109,25.0363087 33.0855549,24.4117647 33.8559689,24.4117647 Z"
                id="Rectangle-2-Copy-12"
                fill="#B2E7D0"
              ></path>
            </g>
          </g>
          <g id="Group" transform="translate(91.000000, 22.000000)">
            <g attr.filter="url({{ locationPath }}#expense-filter-11)">
              <g id="Rectangle">
                <polygon
                  points="0 0 48 0 48 97 42.3647461 94.0048857 35.4074707 97 29.4543457 94.0048857 23.6520996 97 17.4001465 94.0048857 11.71875 97 6.47753906 94.0048857 0 97"
                  fill="black"
                  fill-opacity="1"
                  attr.filter="url({{ locationPath }}#expense-filter-13)"
                ></polygon>
                <polygon
                  points="0 0 48 0 48 97 42.3647461 94.0048857 35.4074707 97 29.4543457 94.0048857 23.6520996 97 17.4001465 94.0048857 11.71875 97 6.47753906 94.0048857 0 97"
                  fill="#FFFFFF"
                ></polygon>
              </g>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="4.5 67.0488568 7.5 67.0488568 7.5 80.5268712 4.5 80.5268712"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="9 67.0488568 15 67.0488568 15 80.5268712 9 80.5268712"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="16.5 67.0488568 19.5 67.0488568 19.5 80.5268712 16.5 80.5268712"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="21 67.0488568 22.5 67.0488568 22.5 80.5268712 21 80.5268712"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="24 67.0488568 27 67.0488568 27 80.5268712 24 80.5268712"
              ></polygon>
              <rect
                id="Rectangle-2-Copy"
                fill="#93949F"
                x="28.5"
                y="67.0488568"
                width="1.5"
                height="13.4780145"
              ></rect>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="36 67.0488568 37.5 67.0488568 37.5 80.5268712 36 80.5268712"
              ></polygon>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="39 67.0488568 40.5 67.0488568 40.5 80.5268712 39 80.5268712"
              ></polygon>
              <rect
                id="Rectangle-2-Copy"
                fill="#93949F"
                x="42"
                y="67.0488568"
                width="1.5"
                height="13.4780145"
              ></rect>
              <polygon
                id="Rectangle-2-Copy"
                fill="#93949F"
                points="31.5 67.0488568 34.5 67.0488568 34.5 80.5268712 31.5 80.5268712"
              ></polygon>
              <path
                d="M6.51160803,56.2436975 L18.8097758,56.2436975 C19.7101392,56.2436975 20.4400279,56.9735862 20.4400279,57.8739496 C20.4400279,58.774313 19.7101392,59.5042017 18.8097758,59.5042017 L6.51160803,59.5042017 C5.61124466,59.5042017 4.88135593,58.774313 4.88135593,57.8739496 C4.88135593,56.9735862 5.61124466,56.2436975 6.51160803,56.2436975 Z"
                id="Rectangle-2-Copy-2"
                fill="#CECFD5"
              ></path>
              <path
                d="M38.0228619,56.2436975 L42.4029962,56.2436975 C43.3033595,56.2436975 44.0332483,56.9735862 44.0332483,57.8739496 C44.0332483,58.774313 43.3033595,59.5042017 42.4029962,59.5042017 L38.0228619,59.5042017 C37.1224986,59.5042017 36.3926098,58.774313 36.3926098,57.8739496 C36.3926098,56.9735862 37.1224986,56.2436975 38.0228619,56.2436975 Z"
                id="Rectangle-2-Copy-7"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,35.8655462 L18.8097758,35.8655462 C19.7101392,35.8655462 20.4400279,36.5954349 20.4400279,37.4957983 C20.4400279,38.3961617 19.7101392,39.1260504 18.8097758,39.1260504 L6.51160803,39.1260504 C5.61124466,39.1260504 4.88135593,38.3961617 4.88135593,37.4957983 C4.88135593,36.5954349 5.61124466,35.8655462 6.51160803,35.8655462 Z"
                id="Rectangle-2-Copy-4"
                fill="#CECFD5"
              ></path>
              <path
                d="M38.0228619,35.8655462 L42.4029962,35.8655462 C43.3033595,35.8655462 44.0332483,36.5954349 44.0332483,37.4957983 C44.0332483,38.3961617 43.3033595,39.1260504 42.4029962,39.1260504 L38.0228619,39.1260504 C37.1224986,39.1260504 36.3926098,38.3961617 36.3926098,37.4957983 C36.3926098,36.5954349 37.1224986,35.8655462 38.0228619,35.8655462 Z"
                id="Rectangle-2-Copy-8"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,43.2016807 L18.8097758,43.2016807 C19.7101392,43.2016807 20.4400279,43.9315694 20.4400279,44.8319328 C20.4400279,45.7322961 19.7101392,46.4621849 18.8097758,46.4621849 L6.51160803,46.4621849 C5.61124466,46.4621849 4.88135593,45.7322961 4.88135593,44.8319328 C4.88135593,43.9315694 5.61124466,43.2016807 6.51160803,43.2016807 Z"
                id="Rectangle-2-Copy-2"
                fill="#CECFD5"
              ></path>
              <path
                d="M38.0228619,43.2016807 L42.4029962,43.2016807 C43.3033595,43.2016807 44.0332483,43.9315694 44.0332483,44.8319328 C44.0332483,45.7322961 43.3033595,46.4621849 42.4029962,46.4621849 L38.0228619,46.4621849 C37.1224986,46.4621849 36.3926098,45.7322961 36.3926098,44.8319328 C36.3926098,43.9315694 37.1224986,43.2016807 38.0228619,43.2016807 Z"
                id="Rectangle-2-Copy-9"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,22.8235294 L18.8097758,22.8235294 C19.7101392,22.8235294 20.4400279,23.5534181 20.4400279,24.4537815 C20.4400279,25.3541449 19.7101392,26.0840336 18.8097758,26.0840336 L6.51160803,26.0840336 C5.61124466,26.0840336 4.88135593,25.3541449 4.88135593,24.4537815 C4.88135593,23.5534181 5.61124466,22.8235294 6.51160803,22.8235294 Z"
                id="Rectangle-2-Copy-5"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,10.8235294 L32.8697479,10.8235294 C33.7701113,10.8235294 34.5,11.5534181 34.5,12.4537815 C34.5,13.3541449 33.7701113,14.0840336 32.8697479,14.0840336 L6.51160803,14.0840336 C5.61124466,14.0840336 4.88135593,13.3541449 4.88135593,12.4537815 C4.88135593,11.5534181 5.61124466,10.8235294 6.51160803,10.8235294 Z"
                id="Rectangle-2-Copy-5"
                fill="#CECFD5"
              ></path>
              <path
                d="M38.0228619,22.8235294 L42.4029962,22.8235294 C43.3033595,22.8235294 44.0332483,23.5534181 44.0332483,24.4537815 C44.0332483,25.3541449 43.3033595,26.0840336 42.4029962,26.0840336 L38.0228619,26.0840336 C37.1224986,26.0840336 36.3926098,25.3541449 36.3926098,24.4537815 C36.3926098,23.5534181 37.1224986,22.8235294 38.0228619,22.8235294 Z"
                id="Rectangle-2-Copy-10"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,48.907563 L14.4573735,48.907563 C15.3577369,48.907563 16.0876256,49.6374518 16.0876256,50.5378151 C16.0876256,51.4381785 15.3577369,52.1680672 14.4573735,52.1680672 L6.51160803,52.1680672 C5.61124466,52.1680672 4.88135593,51.4381785 4.88135593,50.5378151 C4.88135593,49.6374518 5.61124466,48.907563 6.51160803,48.907563 Z"
                id="Rectangle-2-Copy-3"
                fill="#CECFD5"
              ></path>
              <path
                d="M34.4271172,48.907563 L42.3728827,48.907563 C43.273246,48.907563 44.0031348,49.6374518 44.0031348,50.5378151 C44.0031348,51.4381785 43.273246,52.1680672 42.3728827,52.1680672 L34.4271172,52.1680672 C33.5267538,52.1680672 32.7968651,51.4381785 32.7968651,50.5378151 C32.7968651,49.6374518 33.5267538,48.907563 34.4271172,48.907563 Z"
                id="Rectangle-2-Copy-11"
                fill="#CECFD5"
              ></path>
              <path
                d="M6.51160803,28.5294118 L26.0704894,28.5294118 C26.9708528,28.5294118 27.7007415,29.2593005 27.7007415,30.1596639 C27.7007415,31.0600272 26.9708528,31.789916 26.0704894,31.789916 L6.51160803,31.789916 C5.61124466,31.789916 4.88135593,31.0600272 4.88135593,30.1596639 C4.88135593,29.2593005 5.61124466,28.5294118 6.51160803,28.5294118 Z"
                id="Rectangle-2-Copy-6"
                fill="#CECFD5"
              ></path>
              <path
                d="M39.6333869,28.5294118 L42.3728827,28.5294118 C43.273246,28.5294118 44.0031348,29.2593005 44.0031348,30.1596639 C44.0031348,31.0600272 43.273246,31.789916 42.3728827,31.789916 L39.6333869,31.789916 C38.7330235,31.789916 38.0031348,31.0600272 38.0031348,30.1596639 C38.0031348,29.2593005 38.7330235,28.5294118 39.6333869,28.5294118 Z"
                id="Rectangle-2-Copy-12"
                fill="#CECFD5"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <filter
      x="-62.5%"
      y="-38.1%"
      width="225.0%"
      height="195.2%"
      filterUnits="objectBoundingBox"
      id="create-invoice-filter-2"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-42.6%"
      y="-25.8%"
      width="185.1%"
      height="164.5%"
      filterUnits="objectBoundingBox"
      id="create-invoice-filter-5"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-35.1%"
      y="-21.3%"
      width="170.2%"
      height="153.3%"
      filterUnits="objectBoundingBox"
      id="create-invoice-filter-8"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <mask id="create-invoice-mask-4" fill="white">
      <rect x="12" y="0" width="47" height="62" rx="4"></rect>
    </mask>
    <mask id="create-invoice-mask-7" fill="white">
      <rect x="0" y="0" width="57" height="75" rx="4"></rect>
    </mask>
  </defs>
  <symbol id="documents-empty-state-icon" viewBox="0 0 140 128">
    <g id="Empty-States" stroke="none" stroke-width="1" fill="none">
      <g
        id="Empty-State-/-Invoice-/-No-unpaid"
        transform="translate(-330.000000, -141.000000)"
      >
        <g
          id="illustration-invoices"
          transform="translate(306.000000, 130.000000)"
        >
          <g id="Create-invoice">
            <g
              id="Group"
              transform="translate(85.277568, 80.000000) rotate(-30.000000) translate(-85.277568, -80.000000) translate(17.277568, 27.500000)"
            >
              <rect
                id="Rectangle-9"
                fill="#ECF3FF"
                x="21"
                y="0"
                width="88"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy"
                fill="#ECF3FF"
                x="0"
                y="35"
                width="102"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-3"
                fill="#FFFFFF"
                x="68"
                y="35"
                width="45"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-2"
                fill="#ECF3FF"
                x="30"
                y="70"
                width="106"
                height="35"
                rx="17.5"
              ></rect>
            </g>
            <g id="Oval-4-Copy" transform="translate(41.000000, 53.000000)">
              <g id="Mask" opacity="0.776506696">
                <rect
                  x="0"
                  y="10"
                  width="32"
                  height="42"
                  rx="4"
                  fill="black"
                  fill-opacity="1"
                  attr.filter="url({{ locationPath }}#create-invoice-filter-2)"
                ></rect>
                <rect
                  x="0"
                  y="10"
                  width="32"
                  height="42"
                  rx="4"
                  fill="#FFFFFF"
                ></rect>
              </g>
              <g id="Mask" opacity="0.776506696">
                <rect
                  x="12"
                  y="0"
                  width="47"
                  height="62"
                  rx="4"
                  fill="black"
                  fill-opacity="1"
                  attr.filter="url({{ locationPath }}#create-invoice-filter-5)"
                ></rect>
                <rect
                  x="12"
                  y="0"
                  width="47"
                  height="62"
                  rx="4"
                  fill="#FFFFFF"
                ></rect>
              </g>
            </g>
            <g id="Oval-4" transform="translate(70.000000, 45.000000)">
              <g id="Mask">
                <rect
                  x="0"
                  y="0"
                  width="57"
                  height="75"
                  rx="4"
                  fill="black"
                  fill-opacity="1"
                  attr.filter="url({{ locationPath }}#create-invoice-filter-8)"
                ></rect>
                <rect
                  x="0"
                  y="0"
                  width="57"
                  height="75"
                  rx="4"
                  fill="#FFFFFF"
                ></rect>
              </g>
            </g>
            <rect
              id="Rectangle"
              fill="#93949F"
              x="76"
              y="71"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy"
              fill="#93949F"
              x="76"
              y="78"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-2"
              fill="#93949F"
              x="76"
              y="85"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-3"
              fill="#93949F"
              x="76"
              y="92"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <path
              d="M102,81 L122,81 C122.552285,81 123,81.4477153 123,82 C123,82.5522847 122.552285,83 122,83 L102,83 C101.447715,83 101,82.5522847 101,82 C101,81.4477153 101.447715,81 102,81 Z"
              id="Rectangle-Copy-3"
              fill="#93949F"
              transform="translate(112.000000, 82.000000) rotate(-90.000000) translate(-112.000000, -82.000000) "
            ></path>
            <path
              d="M109.5,81.5 L130.5,81.5 C131.052285,81.5 131.5,81.9477153 131.5,82.5 C131.5,83.0522847 131.052285,83.5 130.5,83.5 L109.5,83.5 C108.947715,83.5 108.5,83.0522847 108.5,82.5 C108.5,81.9477153 108.947715,81.5 109.5,81.5 Z"
              id="Rectangle-Copy-6"
              fill="#93949F"
              transform="translate(120.000000, 82.500000) rotate(-90.000000) translate(-120.000000, -82.500000) "
            ></path>
            <path
              d="M66.5,81.5 L87.5,81.5 C88.0522847,81.5 88.5,81.9477153 88.5,82.5 C88.5,83.0522847 88.0522847,83.5 87.5,83.5 L66.5,83.5 C65.9477153,83.5 65.5,83.0522847 65.5,82.5 C65.5,81.9477153 65.9477153,81.5 66.5,81.5 Z"
              id="Rectangle-Copy-7"
              fill="#93949F"
              transform="translate(77.000000, 82.500000) rotate(-90.000000) translate(-77.000000, -82.500000) "
            ></path>
            <rect
              id="Rectangle-Copy-4"
              fill="#4E87E3"
              x="102"
              y="104"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-5"
              fill="#CECFD5"
              x="102"
              y="53"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-8"
              fill="#CECFD5"
              x="102"
              y="57"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-9"
              fill="#CECFD5"
              x="102"
              y="61"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <circle
              id="Oval-2"
              fill="#BAD3FB"
              cx="140.5"
              cy="69.5"
              r="6.5"
            ></circle>
            <circle id="Oval-2" fill="#BAD3FB" cx="147" cy="55" r="4"></circle>
            <circle id="Oval-2" fill="#BAD3FB" cx="115" cy="28" r="4"></circle>
            <circle
              id="Oval-2"
              fill="#ECF3FF"
              cx="128.5"
              cy="13.5"
              r="2.5"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="items-empty-state-icon" viewBox="0 0 170 170">
    <circle fill="#0e1123" cx="85" cy="85" r="85"></circle>
    <rect
      fill="#fff"
      x="58.926"
      y="26.907"
      width="51.129"
      height="102.702"
      rx="7.792"
      ry="7.792"
    ></rect>
    <circle fill="#00dd8d" cx="84.441" cy="108.058" r="10.667"></circle>
    <path
      fill="#00dd8d"
      d="M98.745 109.558a1.5 1.5 0 0 1-1.5-1.5 12.8 12.8 0 1 0-25.608 0 1.5 1.5 0 1 1-3 0 15.8 15.8 0 1 1 31.608 0 1.5 1.5 0 0 1-1.5 1.5z"
    ></path>
    <path
      fill="#0e1123"
      d="M98.745 79.808a1.5 1.5 0 0 1-1.5-1.5 12.8 12.8 0 1 0-25.608 0 1.5 1.5 0 0 1-3 0 15.8 15.8 0 1 1 31.608 0 1.5 1.5 0 0 1-1.5 1.5zm0-29.75a1.5 1.5 0 0 1-1.5-1.5 12.8 12.8 0 1 0-25.608 0 1.5 1.5 0 1 1-3 0 15.8 15.8 0 1 1 31.608 0 1.5 1.5 0 0 1-1.5 1.5z"
    ></path>
    <circle fill="#0e1123" cx="84.441" cy="78.308" r="10.667"></circle>
    <circle fill="#0e1123" cx="84.441" cy="48.558" r="10.667"></circle>
    <path
      fill="#00dd8d"
      d="M117.639 76.636a1.5 1.5 0 0 1-1.061-2.561l6.245-6.245a1.5 1.5 0 1 1 2.121 2.121L118.7 76.2a1.5 1.5 0 0 1-1.061.436zm13.294 32.922H122.1a1.5 1.5 0 0 1 0-3h8.831a1.5 1.5 0 0 1 0 3zm-11.781 34.791a1.5 1.5 0 0 1-1.061-.439l-6.245-6.245a1.5 1.5 0 0 1 2.121-2.121l6.245 6.245a1.5 1.5 0 0 1-1.061 2.561zM50.7 77.157a1.5 1.5 0 0 1-1.061-.439L43.4 70.474a1.5 1.5 0 0 1 2.121-2.121l6.242 6.247a1.5 1.5 0 0 1-1.063 2.557zm-4.02 32.401h-8.832a1.5 1.5 0 1 1 0-3h8.832a1.5 1.5 0 0 1 0 3zm3.12 33.555a1.5 1.5 0 0 1-1.061-2.561l6.245-6.245a1.5 1.5 0 1 1 2.121 2.121l-6.245 6.245a1.5 1.5 0 0 1-1.06.44z"
    ></path>
  </symbol>

  <symbol id="notifications-empty-state-icon" viewBox="0 0 173 173">
    <g fill="none">
      <circle fill="#EAEAED" cx="86.5" cy="86.5" r="86.5"></circle>
      <path
        d="M112.694 41.099H60.027a7.637 7.637 0 0 0-7.453 7.81v77.189a7.923 7.923 0 0 0 7.734 8.101h52.667a7.637 7.637 0 0 0 7.453-7.81V49.2a7.923 7.923 0 0 0-7.734-8.101z"
        fill="#FFF"
      ></path>
      <circle fill="#B9B9C4" cx="65.943" cy="47.976" r="4.091"></circle>
      <ellipse
        fill="#B9B9C4"
        cx="86.5"
        cy="47.976"
        rx="4.091"
        ry="4.091"
      ></ellipse>
      <ellipse
        fill="#B9B9C4"
        cx="107.057"
        cy="47.976"
        rx="4.091"
        ry="4.091"
      ></ellipse>
      <path
        d="M65.944 49.502a1.526 1.526 0 0 1-1.527-1.526V34.221a1.526 1.526 0 0 1 3.053 0v13.755c0 .843-.683 1.526-1.526 1.526zm20.556 0a1.526 1.526 0 0 1-1.526-1.526V34.221a1.526 1.526 0 0 1 3.052 0v13.755c0 .843-.683 1.526-1.526 1.526zm20.556 0a1.526 1.526 0 0 1-1.526-1.526V34.221a1.526 1.526 0 0 1 3.053 0v13.755c0 .843-.683 1.526-1.527 1.526zm-1.284 29.188l-5.658-5.659a1.337 1.337 0 0 0-1.886 0l-15.086 15.09-5.658-5.659a1.337 1.337 0 0 0-1.886 0L69.94 88.12a1.337 1.337 0 0 0 0 1.886l12.26 12.26a1.337 1.337 0 0 0 1.886 0l21.691-21.69a1.337 1.337 0 0 0-.005-1.886z"
        fill="#00DD8D"
      ></path>
    </g>
  </symbol>

  <defs>
    <filter
      x="-41.7%"
      y="-41.9%"
      width="183.3%"
      height="191.9%"
      filterUnits="objectBoundingBox"
      id="cal-filter-1"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.685933045   0 0 0 0 0.813760025   0 0 0 0 0.959848002  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-8.5%"
      y="-7.5%"
      width="116.9%"
      height="121.0%"
      filterUnits="objectBoundingBox"
      id="cal-filter-3"
    >
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
        type="matrix"
        in="shadowBlurOuter1"
      ></feColorMatrix>
    </filter>
  </defs>
  <symbol id="appointments-empty-state-icon" viewBox="0 0 140 119">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Design/Illustration/Medium/Appointments"
        transform="translate(-28.000000, -35.000000)"
      >
        <g id="Group-3" transform="translate(4.000000, 15.000000)">
          <g
            id="Group"
            transform="translate(85.277568, 80.000000) rotate(-30.000000) translate(-85.277568, -80.000000) translate(17.277568, 27.500000)"
          >
            <rect
              id="Rectangle-9"
              fill="#ECF3FF"
              x="21"
              y="0"
              width="88"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy"
              fill="#ECF3FF"
              x="0"
              y="35"
              width="102"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy-2"
              fill="#ECF3FF"
              x="30"
              y="70"
              width="106"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy-3"
              fill="#F3F9FE"
              x="68"
              y="35"
              width="45"
              height="35"
              rx="17.5"
            ></rect>
          </g>
          <g
            id="Group-33"
            attr.filter="url({{ locationPath }}#cal-filter-1)"
            transform="translate(44.000000, 27.000000)"
          >
            <g id="Fill-3">
              <path
                d="M58.1807,13.8359 C58.1807,11.6159 59.9807,9.8159 62.2017,9.8159 C64.4207,9.8159 66.2207,11.6159 66.2207,13.8359 C66.2207,16.0569 64.4207,17.8569 62.2017,17.8569 C59.9807,17.8569 58.1807,16.0569 58.1807,13.8359 M37.9797,13.8359 C37.9797,11.6159 39.7797,9.8159 41.9997,9.8159 C44.2197,9.8159 46.0197,11.6159 46.0197,13.8359 C46.0197,16.0569 44.2197,17.8569 41.9997,17.8569 C39.7797,17.8569 37.9797,16.0569 37.9797,13.8359 M17.7787,13.8359 C17.7787,11.6159 19.5787,9.8159 21.7987,9.8159 C24.0187,9.8159 25.8187,11.6159 25.8187,13.8359 C25.8187,16.0569 24.0187,17.8569 21.7987,17.8569 C19.5787,17.8569 17.7787,16.0569 17.7787,13.8359 M83.3337,65.3189 L83.3337,14.7319 C83.3337,10.3149 79.7517,6.7319 75.3337,6.7319 L8.6667,6.7319 C4.2477,6.7319 0.6667,10.3149 0.6667,14.7319 L0.6667,65.3189 C0.6667,69.7379 4.2477,73.3189 8.6667,73.3189 L75.3337,73.3189 C79.7517,73.3189 83.3337,69.7379 83.3337,65.3189"
                fill="black"
                fill-opacity="1"
                attr.filter="url({{ locationPath }}#cal-filter-3)"
              ></path>
              <path
                d="M58.1807,13.8359 C58.1807,11.6159 59.9807,9.8159 62.2017,9.8159 C64.4207,9.8159 66.2207,11.6159 66.2207,13.8359 C66.2207,16.0569 64.4207,17.8569 62.2017,17.8569 C59.9807,17.8569 58.1807,16.0569 58.1807,13.8359 M37.9797,13.8359 C37.9797,11.6159 39.7797,9.8159 41.9997,9.8159 C44.2197,9.8159 46.0197,11.6159 46.0197,13.8359 C46.0197,16.0569 44.2197,17.8569 41.9997,17.8569 C39.7797,17.8569 37.9797,16.0569 37.9797,13.8359 M17.7787,13.8359 C17.7787,11.6159 19.5787,9.8159 21.7987,9.8159 C24.0187,9.8159 25.8187,11.6159 25.8187,13.8359 C25.8187,16.0569 24.0187,17.8569 21.7987,17.8569 C19.5787,17.8569 17.7787,16.0569 17.7787,13.8359 M83.3337,65.3189 L83.3337,14.7319 C83.3337,10.3149 79.7517,6.7319 75.3337,6.7319 L8.6667,6.7319 C4.2477,6.7319 0.6667,10.3149 0.6667,14.7319 L0.6667,65.3189 C0.6667,69.7379 4.2477,73.3189 8.6667,73.3189 L75.3337,73.3189 C79.7517,73.3189 83.3337,69.7379 83.3337,65.3189"
                fill="#FFFFFF"
              ></path>
            </g>
            <path
              d="M20.2988,13.8359 L20.2988,2.1809 C20.2988,1.3519 20.9708,0.6809 21.7988,0.6809 C22.6278,0.6809 23.2988,1.3519 23.2988,2.1809 L23.2988,13.8359 C23.2988,14.6649 22.6278,15.3359 21.7988,15.3359 C20.9708,15.3359 20.2988,14.6649 20.2988,13.8359"
              id="Fill-5"
              fill="#0775E2"
            ></path>
            <path
              d="M40.5,13.8359 L40.5,2.1809 C40.5,1.3519 41.171,0.6809 42,0.6809 C42.829,0.6809 43.5,1.3519 43.5,2.1809 L43.5,13.8359 C43.5,14.6649 42.829,15.3359 42,15.3359 C41.171,15.3359 40.5,14.6649 40.5,13.8359"
              id="Fill-7"
              fill="#0775E2"
            ></path>
            <path
              d="M60.7002,13.8359 L60.7002,2.1809 C60.7002,1.3519 61.3712,0.6809 62.2002,0.6809 C63.0282,0.6809 63.7002,1.3519 63.7002,2.1809 L63.7002,13.8359 C63.7002,14.6649 63.0282,15.3359 62.2002,15.3359 C61.3712,15.3359 60.7002,14.6649 60.7002,13.8359"
              id="Fill-9"
              fill="#0775E2"
            ></path>
            <path
              d="M20.5889,40.957 L12.1019,40.957 C10.8049,40.957 9.7539,39.905 9.7539,38.608 L9.7539,30.121 C9.7539,28.824 10.8049,27.773 12.1019,27.773 L20.5889,27.773 C21.8859,27.773 22.9379,28.824 22.9379,30.121 L22.9379,38.608 C22.9379,39.905 21.8859,40.957 20.5889,40.957"
              id="Fill-11"
              fill="#F5F5F6"
            ></path>
            <path
              d="M37.9224,40.957 L29.4354,40.957 C28.1384,40.957 27.0874,39.905 27.0874,38.608 L27.0874,30.121 C27.0874,28.824 28.1384,27.773 29.4354,27.773 L37.9224,27.773 C39.2194,27.773 40.2704,28.824 40.2704,30.121 L40.2704,38.608 C40.2704,39.905 39.2194,40.957 37.9224,40.957"
              id="Fill-13"
              fill="#F5F5F6"
            ></path>
            <path
              d="M55.2559,40.957 L46.7689,40.957 C45.4719,40.957 44.4199,39.905 44.4199,38.608 L44.4199,30.121 C44.4199,28.824 45.4719,27.773 46.7689,27.773 L55.2559,27.773 C56.5529,27.773 57.6039,28.824 57.6039,30.121 L57.6039,38.608 C57.6039,39.905 56.5529,40.957 55.2559,40.957"
              id="Fill-15"
              fill="#0775E2"
            ></path>
            <path
              d="M72.5889,40.957 L64.1019,40.957 C62.8049,40.957 61.7539,39.905 61.7539,38.608 L61.7539,30.121 C61.7539,28.824 62.8049,27.773 64.1019,27.773 L72.5889,27.773 C73.8859,27.773 74.9379,28.824 74.9379,30.121 L74.9379,38.608 C74.9379,39.905 73.8859,40.957 72.5889,40.957"
              id="Fill-17"
              fill="#F5F5F6"
            ></path>
            <path
              d="M20.5889,58.8154 L12.1019,58.8154 C10.8049,58.8154 9.7539,57.7644 9.7539,56.4674 L9.7539,47.9804 C9.7539,46.6834 10.8049,45.6324 12.1019,45.6324 L20.5889,45.6324 C21.8859,45.6324 22.9379,46.6834 22.9379,47.9804 L22.9379,56.4674 C22.9379,57.7644 21.8859,58.8154 20.5889,58.8154"
              id="Fill-19"
              fill="#F5F5F6"
            ></path>
            <path
              d="M37.9224,58.8154 L29.4354,58.8154 C28.1384,58.8154 27.0874,57.7644 27.0874,56.4674 L27.0874,47.9804 C27.0874,46.6834 28.1384,45.6324 29.4354,45.6324 L37.9224,45.6324 C39.2194,45.6324 40.2704,46.6834 40.2704,47.9804 L40.2704,56.4674 C40.2704,57.7644 39.2194,58.8154 37.9224,58.8154"
              id="Fill-21"
              fill="#F5F5F6"
            ></path>
            <path
              d="M55.2559,58.8154 L46.7689,58.8154 C45.4719,58.8154 44.4199,57.7644 44.4199,56.4674 L44.4199,47.9804 C44.4199,46.6834 45.4719,45.6324 46.7689,45.6324 L55.2559,45.6324 C56.5529,45.6324 57.6039,46.6834 57.6039,47.9804 L57.6039,56.4674 C57.6039,57.7644 56.5529,58.8154 55.2559,58.8154"
              id="Fill-23"
              fill="#F5F5F6"
            ></path>
            <path
              d="M72.5889,58.8154 L64.1019,58.8154 C62.8049,58.8154 61.7539,57.7644 61.7539,56.4674 L61.7539,47.9804 C61.7539,46.6834 62.8049,45.6324 64.1019,45.6324 L72.5889,45.6324 C73.8859,45.6324 74.9379,46.6834 74.9379,47.9804 L74.9379,56.4674 C74.9379,57.7644 73.8859,58.8154 72.5889,58.8154"
              id="Fill-25"
              fill="#F5F5F6"
            ></path>
            <path
              d="M51.2314,30.6318 L51.9204,32.7538 L54.1514,32.7538 C54.6414,32.7538 54.8454,33.3808 54.4494,33.6688 L52.6444,34.9808 L53.3344,37.1018 C53.4854,37.5688 52.9514,37.9558 52.5544,37.6678 L50.7504,36.3568 L48.9454,37.6678 C48.5484,37.9558 48.0144,37.5688 48.1664,37.1018 L48.8554,34.9808 L47.0504,33.6688 C46.6544,33.3808 46.8584,32.7538 47.3484,32.7538 L49.5794,32.7538 L50.2684,30.6318 C50.4194,30.1658 51.0804,30.1658 51.2314,30.6318"
              id="Fill-27"
              fill="#FFFFFF"
            ></path>
            <path
              d="M68.5645,48.6611 L69.2535,50.7831 L71.4845,50.7831 C71.9755,50.7831 72.1785,51.4101 71.7825,51.6991 L69.9775,53.0101 L70.6675,55.1311 C70.8185,55.5981 70.2845,55.9851 69.8875,55.6971 L68.0835,54.3861 L66.2785,55.6971 C65.8815,55.9851 65.3475,55.5981 65.5005,55.1311 L66.1885,53.0101 L64.3845,51.6991 C63.9875,51.4101 64.1915,50.7831 64.6815,50.7831 L66.9125,50.7831 L67.6015,48.6611 C67.7525,48.1951 68.4135,48.1951 68.5645,48.6611"
              id="Fill-29"
              fill="#0775E2"
            ></path>
            <path
              d="M16.8271,48.6611 L17.5161,50.7831 L19.7461,50.7831 C20.2371,50.7831 20.4411,51.4101 20.0441,51.6991 L18.2401,53.0101 L18.9291,55.1311 C19.0801,55.5981 18.5471,55.9851 18.1501,55.6971 L16.3461,54.3861 L14.5411,55.6971 C14.1441,55.9851 13.6101,55.5981 13.7621,55.1311 L14.4511,53.0101 L12.6461,51.6991 C12.2501,51.4101 12.4531,50.7831 12.9441,50.7831 L15.1751,50.7831 L15.8641,48.6611 C16.0151,48.1951 16.6751,48.1951 16.8271,48.6611"
              id="Fill-31"
              fill="#0775E2"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <filter
      x="-27.4%"
      y="-27.4%"
      width="154.9%"
      height="154.9%"
      filterUnits="objectBoundingBox"
      id="time-filter-1"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <mask id="time-mask-5" fill="white">
      <circle cx="56" cy="56" r="42"></circle>
    </mask>
    <mask id="time-mask-3" fill="white">
      <circle cx="56.5" cy="56.5" r="56.5"></circle>
    </mask>
  </defs>
  <symbol id="tracked-time-empty-state-icon" viewBox="0 0 121 128">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Design/Illustration/Medium/Watch"
        transform="translate(-27.000000, -28.000000)"
      >
        <g id="time-entry" transform="translate(9.000000, 24.000000)">
          <g
            id="Group"
            transform="translate(69.870835, 65.651924) rotate(-30.000000) translate(-69.870835, -65.651924) translate(15.370835, 21.651924)"
          >
            <path
              d="M34.5,0 L82.5,0 C91.0604136,-1.57252247e-15 98,6.93958638 98,15.5 C98,24.0604136 91.0604136,31 82.5,31 L34.5,31 C25.9395864,31 19,24.0604136 19,15.5 C19,6.93958638 25.9395864,1.57252247e-15 34.5,0 Z"
              id="Rectangle-9"
              fill="#ECF3FF"
            ></path>
            <rect
              id="Rectangle-9-Copy"
              fill="#ECF3FF"
              x="0"
              y="31"
              width="92"
              height="31"
              rx="15.5"
            ></rect>
            <path
              d="M76.5,31 L85.5,31 C94.0604136,31 101,37.9395864 101,46.5 C101,55.0604136 94.0604136,62 85.5,62 L76.5,62 C67.9395864,62 61,55.0604136 61,46.5 C61,37.9395864 67.9395864,31 76.5,31 Z"
              id="Rectangle-9-Copy-3"
              fill="#FFFFFF"
            ></path>
            <rect
              id="Rectangle-9-Copy-2"
              fill="#ECF3FF"
              x="27"
              y="57"
              width="82"
              height="31"
              rx="15.5"
            ></rect>
          </g>
          <g
            id="Group"
            attr.filter="url({{ locationPath }}#time-filter-1)"
            transform="translate(22.000000, 11.000000)"
          >
            <g id="Group-10">
              <circle
                cx="56.5"
                cy="56.5"
                r="56.5"
                fill-opacity="0.5"
                fill="#ECF3FF"
                opacity="0"
              ></circle>
              <path
                d="M56.8761543,-35.3406204 C65.9888527,-35.3406204 73.3761543,-27.9533188 73.3761543,-18.8406204 L73.3761543,130.592929 C73.3761543,139.705627 65.9888527,147.092929 56.8761543,147.092929 C47.763456,147.092929 40.3761543,139.705627 40.3761543,130.592929 L40.3761543,-18.8406204 C40.3761543,-27.9533188 47.763456,-35.3406204 56.8761543,-35.3406204 Z"
                id="Rectangle-11"
                fill="#0E5DDB"
                attr.mask="url({{ locationPath }}#time-mask-3)"
                transform="translate(56.876154, 55.876154) rotate(-315.000000) translate(-56.876154, -55.876154) "
              ></path>
            </g>
            <circle
              cx="56"
              cy="56"
              r="42"
              fill-opacity="0"
              fill="#ECF3FF"
            ></circle>
            <polygon
              id="Rectangle-11"
              fill="#4E87E3"
              attr.mask="url({{ locationPath }}#time-mask-5)"
              transform="translate(56.500000, 56.500000) rotate(-315.000000) translate(-56.500000, -56.500000) "
              points="40 6 73 6 73 107 40 107"
            ></polygon>
            <circle
              id="Oval-4"
              fill="#BAD3FB"
              attr.mask="url({{ locationPath }}#time-mask-5)"
              cx="55.5"
              cy="55.5"
              r="22.5"
            ></circle>
            <circle
              id="Oval-4"
              fill="#FFFFFF"
              attr.mask="url({{ locationPath }}#time-mask-5)"
              cx="55.5"
              cy="55.5"
              r="19.5"
            ></circle>
            <polyline
              id="Path-4"
              stroke="#26C281"
              stroke-width="2"
              attr.mask="url({{ locationPath }}#time-mask-5)"
              points="56 49 56 57.6123315 63 65"
            ></polyline>
          </g>
          <g
            id="Group-11"
            transform="translate(76.000000, 83.000000)"
            stroke="#0E5DDB"
          >
            <g
              id="Group-9"
              transform="translate(15.000000, 11.000000)"
              stroke-linecap="square"
            >
              <line
                x1="5.51737625"
                y1="1.5085739"
                x2="5.51737625"
                y2="4.5085739"
                id="Line"
                transform="translate(5.517376, 3.008574) rotate(-1.000000) translate(-5.517376, -3.008574) "
              ></line>
              <line
                x1="5.51737625"
                y1="6.5085739"
                x2="5.51737625"
                y2="9.5085739"
                id="Line-Copy"
                transform="translate(5.517376, 8.008574) rotate(-1.000000) translate(-5.517376, -8.008574) "
              ></line>
              <line
                x1="3.0085739"
                y1="4.01737625"
                x2="3.0085739"
                y2="7.01737625"
                id="Line"
                transform="translate(3.008574, 5.517376) rotate(-91.000000) translate(-3.008574, -5.517376) "
              ></line>
              <line
                x1="8.0085739"
                y1="4.01737625"
                x2="8.0085739"
                y2="7.01737625"
                id="Line-Copy"
                transform="translate(8.008574, 5.517376) rotate(-91.000000) translate(-8.008574, -5.517376) "
              ></line>
            </g>
            <g
              id="Group-7"
              transform="translate(18.000000, 28.000000)"
              stroke-linecap="square"
            >
              <line
                x1="2.6161508"
                y1="0.484541353"
                x2="2.6161508"
                y2="1.98454135"
                id="Line"
                transform="translate(2.616151, 1.234541) rotate(-1.000000) translate(-2.616151, -1.234541) "
              ></line>
              <line
                x1="2.65105562"
                y1="2.48423674"
                x2="2.65105562"
                y2="3.98423674"
                id="Line-Copy"
                transform="translate(2.651056, 3.234237) rotate(-1.000000) translate(-2.651056, -3.234237) "
              ></line>
              <line
                x1="1.52266133"
                y1="1.58711394"
                x2="1.52266133"
                y2="2.92044728"
                id="Line"
                transform="translate(1.522661, 2.253781) rotate(-91.000000) translate(-1.522661, -2.253781) "
              ></line>
              <line
                x1="3.74454509"
                y1="1.54833082"
                x2="3.74454509"
                y2="2.88166415"
                id="Line-Copy"
                transform="translate(3.744545, 2.214997) rotate(-91.000000) translate(-3.744545, -2.214997) "
              ></line>
            </g>
            <circle
              id="Oval-3"
              transform="translate(28.008574, 3.000000) rotate(-1.000000) translate(-28.008574, -3.000000) "
              cx="28.0085739"
              cy="3"
              r="2"
            ></circle>
            <circle
              id="Oval-3-Copy"
              transform="translate(32.991274, 9.982700) rotate(-1.000000) translate(-32.991274, -9.982700) "
              cx="32.9912738"
              cy="9.9826999"
              r="1"
            ></circle>
            <circle
              id="Oval-3-Copy-9"
              transform="translate(2.000000, 25.000000) rotate(-1.000000) translate(-2.000000, -25.000000) "
              cx="2"
              cy="25"
              r="1"
            ></circle>
            <circle
              id="Oval-3-Copy-10"
              transform="translate(8.491350, 31.491350) rotate(-1.000000) translate(-8.491350, -31.491350) "
              cx="8.49134995"
              cy="31.4913499"
              r="1"
            ></circle>
          </g>
          <g
            id="Group-12"
            transform="translate(56.000000, 5.000000)"
            stroke="#0E5DDB"
          >
            <line
              x1="23.5173763"
              y1="17.5085739"
              x2="23.5173763"
              y2="20.5085739"
              id="Line"
              stroke-linecap="square"
              transform="translate(23.517376, 19.008574) rotate(-1.000000) translate(-23.517376, -19.008574) "
            ></line>
            <line
              x1="23.5173763"
              y1="22.5085739"
              x2="23.5173763"
              y2="25.5085739"
              id="Line-Copy"
              stroke-linecap="square"
              transform="translate(23.517376, 24.008574) rotate(-1.000000) translate(-23.517376, -24.008574) "
            ></line>
            <line
              x1="21.0085739"
              y1="20.0173763"
              x2="21.0085739"
              y2="23.0173763"
              id="Line"
              stroke-linecap="square"
              transform="translate(21.008574, 21.517376) rotate(-91.000000) translate(-21.008574, -21.517376) "
            ></line>
            <line
              x1="26.0085739"
              y1="20.0173763"
              x2="26.0085739"
              y2="23.0173763"
              id="Line-Copy"
              stroke-linecap="square"
              transform="translate(26.008574, 21.517376) rotate(-91.000000) translate(-26.008574, -21.517376) "
            ></line>
            <line
              x1="22.6161508"
              y1="5.48454135"
              x2="22.6161508"
              y2="6.98454135"
              id="Line"
              stroke-linecap="square"
              transform="translate(22.616151, 6.234541) rotate(-1.000000) translate(-22.616151, -6.234541) "
            ></line>
            <line
              x1="22.6510556"
              y1="7.48423674"
              x2="22.6510556"
              y2="8.98423674"
              id="Line-Copy"
              stroke-linecap="square"
              transform="translate(22.651056, 8.234237) rotate(-1.000000) translate(-22.651056, -8.234237) "
            ></line>
            <line
              x1="21.5226613"
              y1="6.58711394"
              x2="21.5226613"
              y2="7.92044728"
              id="Line"
              stroke-linecap="square"
              transform="translate(21.522661, 7.253781) rotate(-91.000000) translate(-21.522661, -7.253781) "
            ></line>
            <line
              x1="23.7445451"
              y1="6.54833082"
              x2="23.7445451"
              y2="7.88166415"
              id="Line-Copy"
              stroke-linecap="square"
              transform="translate(23.744545, 7.214997) rotate(-91.000000) translate(-23.744545, -7.214997) "
            ></line>
            <circle
              id="Oval-3"
              transform="translate(31.045047, 2.086805) rotate(-1.000000) translate(-31.045047, -2.086805) "
              cx="31.0450466"
              cy="2.08680512"
              r="2"
            ></circle>
            <circle
              id="Oval-3-Copy"
              transform="translate(35.184057, 10.015777) rotate(-1.000000) translate(-35.184057, -10.015777) "
              cx="35.1840566"
              cy="10.0157771"
              r="1"
            ></circle>
            <circle
              id="Oval-3-Copy-9"
              transform="translate(2.000000, 17.000000) rotate(-1.000000) translate(-2.000000, -17.000000) "
              cx="2"
              cy="17"
              r="1"
            ></circle>
            <circle
              id="Oval-3-Copy-10"
              transform="translate(8.491350, 23.491350) rotate(-1.000000) translate(-8.491350, -23.491350) "
              cx="8.49134995"
              cy="23.4913499"
              r="1"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <filter
      x="-72.5%"
      y="-92.6%"
      width="255.0%"
      height="297.9%"
      filterUnits="objectBoundingBox"
      id="underwriting-stripe-canvas-filter-2"
    >
      <feOffset
        dx="3"
        dy="3"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="15"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.811764706   0 0 0 0 0.831372549   0 0 0 0 0.870588235  0 0 0 0.5 0"
        type="matrix"
        in="shadowBlurOuter1"
      ></feColorMatrix>
    </filter>
  </defs>
  <symbol id="underwriting-stripe-canvas-icon" viewBox="0 0 400 200">
    <g
      id="stripe-canvas-web"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect fill="#F6F6F6" x="0" y="0" width="400" height="200"></rect>
      <rect
        id="Rectangle"
        fill="#F6F6F6"
        x="0"
        y="0"
        width="400"
        height="200"
      ></rect>
      <g id="Group" transform="translate(56.000000, 64.000000)">
        <g id="Path">
          <path
            d="M59.1751814,14.0474955 L0.375574472,37.4626266 C0.145718344,37.555324 -0.00350748031,37.7800793 0,38.0282007 C0.00363283945,38.2763221 0.159263269,38.4966784 0.391691018,38.5827052 L17.8491338,44.9126021 C18.0377221,44.982049 18.2485546,44.9517139 18.4099896,44.8319048 L51.5069287,20.6840422 C51.5417847,20.6608398 51.5885759,20.6682225 51.6146194,20.7010334 C51.6406628,20.7338443 51.6372876,20.7811595 51.6068513,20.80993 L22.3005238,46.3328747 C22.1674174,46.4464778 22.0908209,46.6128695 22.0910087,46.7880076 L22.0910087,60.4000296 C22.0898307,60.6537095 22.2488314,60.8804472 22.4875104,60.9654476 C22.7261895,61.0504481 22.9924462,60.9751569 23.1514775,60.777693 L31.6094409,50.3354613 C31.7699274,50.1379418 32.0378331,50.0640658 32.2766659,50.1514714 L43.0650819,54.0669048 C43.3622066,54.1770521 43.6934708,54.0352849 43.8193362,53.7441156 L59.9519989,14.8318733 C60.0470408,14.6091909 59.9983758,14.3510758 59.8287981,14.1784267 C59.6592204,14.0057776 59.4023114,13.952784 59.1784047,14.0442676"
            fill="black"
            fill-opacity="1"
            attr.filter="url({{
              locationPath
            }}#underwriting-stripe-canvas-filter-2)"
          ></path>
          <path
            d="M59.1751814,14.0474955 L0.375574472,37.4626266 C0.145718344,37.555324 -0.00350748031,37.7800793 0,38.0282007 C0.00363283945,38.2763221 0.159263269,38.4966784 0.391691018,38.5827052 L17.8491338,44.9126021 C18.0377221,44.982049 18.2485546,44.9517139 18.4099896,44.8319048 L51.5069287,20.6840422 C51.5417847,20.6608398 51.5885759,20.6682225 51.6146194,20.7010334 C51.6406628,20.7338443 51.6372876,20.7811595 51.6068513,20.80993 L22.3005238,46.3328747 C22.1674174,46.4464778 22.0908209,46.6128695 22.0910087,46.7880076 L22.0910087,60.4000296 C22.0898307,60.6537095 22.2488314,60.8804472 22.4875104,60.9654476 C22.7261895,61.0504481 22.9924462,60.9751569 23.1514775,60.777693 L31.6094409,50.3354613 C31.7699274,50.1379418 32.0378331,50.0640658 32.2766659,50.1514714 L43.0650819,54.0669048 C43.3622066,54.1770521 43.6934708,54.0352849 43.8193362,53.7441156 L59.9519989,14.8318733 C60.0470408,14.6091909 59.9983758,14.3510758 59.8287981,14.1784267 C59.6592204,14.0057776 59.4023114,13.952784 59.1784047,14.0442676"
            fill="#00DE8C"
            fill-rule="evenodd"
          ></path>
        </g>
        <rect
          id="Linebreak"
          fill="#9B9EB2"
          opacity="0.200000003"
          x="79"
          y="0"
          width="1"
          height="72"
        ></rect>
        <g
          id="Payment-Icon-/-Visa"
          transform="translate(100.000000, 14.000000)"
        >
          <path
            d="M53.2420523,0.459183673 L2.75794766,0.459183673 C2.12309529,0.459183673 1.54825862,0.715953305 1.13216555,1.13120895 C0.716425943,1.54611185 0.459183673,2.11926345 0.459183673,2.75239706 L0.459183673,41.2476029 C0.459183673,41.8801271 0.716672536,42.4534211 1.13264939,42.8685608 C1.54867327,43.2837474 2.12327875,43.5408163 2.75794766,43.5408163 L53.2420523,43.5408163 C53.8769047,43.5408163 54.4517414,43.2840467 54.8678345,42.868791 C55.2835741,42.4538882 55.5408163,41.8807366 55.5408163,41.2476029 L55.5408163,2.75239706 C55.5408163,2.11987295 55.2833275,1.5465789 54.8673506,1.13143923 C54.4513267,0.716252633 53.8767212,0.459183673 53.2420523,0.459183673 Z"
            id="Rectangle-Copy-4"
            stroke-opacity="0.5"
            stroke="#EAEAEA"
            stroke-width="0.918367347"
            fill="#FFFFFF"
          ></path>
          <g
            id="Visa_Inc._logo"
            stroke-width="1"
            transform="translate(5.086111, 15.570370)"
            fill="#0742A6"
          >
            <polygon
              id="polygon9"
              points="18.717321 13.5236071 15.2343854 13.5236071 17.4128628 0.405272064 20.8956079 0.405272064"
            ></polygon>
            <path
              d="M31.3432718,0.725977925 C30.6562838,0.460546989 29.5666642,0.167478591 28.2193527,0.167478591 C24.7798419,0.167478591 22.3577666,1.95371193 22.3429108,4.50748769 C22.3143418,6.39165781 24.0770458,7.43817167 25.3954175,8.06641387 C26.7429095,8.70838205 27.200965,9.12739566 27.200965,9.69962098 C27.1872519,10.5784552 26.1121072,10.9835573 25.1093371,10.9835573 C23.7187913,10.9835573 22.9737131,10.7746997 21.8414305,10.2857578 L21.3828037,10.0761582 L20.8954175,13.0209392 C21.7122989,13.3833795 23.217311,13.7050127 24.7798419,13.7191097 C28.4343816,13.7191097 30.8136035,11.9605138 30.8417915,9.23905843 C30.8556951,7.745708 29.9249188,6.60144285 27.918236,5.66640627 C26.7000561,5.06617251 25.9540257,4.66144134 25.9540257,4.04729611 C25.9683101,3.48898227 26.5850185,2.91712792 27.9601371,2.91712792 C29.0924197,2.88911948 29.9243474,3.15417944 30.5545784,3.41942489 L30.8695986,3.55872512 L31.3432718,0.725977925 L31.3432718,0.725977925 L31.3432718,0.725977925 Z"
              id="path11"
            ></path>
            <path
              d="M35.9723935,8.87624717 C36.2592257,8.12261622 37.3629393,5.20584372 37.3629393,5.20584372 C37.3484644,5.23385215 37.6492002,4.43830129 37.8211852,3.94991579 L38.0645927,5.08026947 C38.0645927,5.08026947 38.7241544,8.22036752 38.8673801,8.87624717 C38.3230464,8.87624717 36.6603337,8.87624717 35.9723935,8.87624717 L35.9723935,8.87624717 Z M40.271639,0.405272064 L37.5775874,0.405272064 C36.7468024,0.405272064 36.1156191,0.642323591 35.7571741,1.49370584 L30.5837187,13.5234216 L34.2382584,13.5234216 C34.2382584,13.5234216 34.8399204,11.9043115 34.9692425,11.5555972 C35.3701601,11.5555972 38.9252798,11.5555972 39.4410445,11.5555972 C39.5410358,12.0161597 39.8566275,13.5234216 39.8566275,13.5234216 L43.0814902,13.5234216 L40.271639,0.405272064 L40.271639,0.405272064 L40.271639,0.405272064 Z"
              id="path13"
              fill-rule="nonzero"
            ></path>
            <path
              d="M12.3253048,0.405272064 L8.914363,9.3507212 L8.54163348,7.53647943 C7.91102159,5.44308073 5.93328863,3.16864738 3.72624226,2.03773724 L6.85054228,13.5096956 L10.5336509,13.5096956 L16.008223,0.405272064 L12.3253048,0.405272064 L12.3253048,0.405272064 L12.3253048,0.405272064 Z"
              id="path15"
            ></path>
            <path
              d="M5.7470191,0.405272064 L0.143315405,0.405272064 L0.0859870517,0.670332026 C4.45722638,1.75895128 7.35221299,4.38302637 8.54163348,7.53703589 L7.32345358,1.50798828 C7.12289958,0.67014654 6.50657216,0.432909526 5.7470191,0.405272064 L5.7470191,0.405272064 Z"
              id="path17"
            ></path>
          </g>
        </g>
        <g
          id="Payment-Icon-/-Mastercard"
          transform="translate(166.000000, 14.000000)"
        >
          <path
            d="M53.2420523,0.459183673 L2.75794766,0.459183673 C2.12309529,0.459183673 1.54825862,0.715953305 1.13216555,1.13120895 C0.716425943,1.54611185 0.459183673,2.11926345 0.459183673,2.75239706 L0.459183673,41.2476029 C0.459183673,41.8801271 0.716672536,42.4534211 1.13264939,42.8685608 C1.54867327,43.2837474 2.12327875,43.5408163 2.75794766,43.5408163 L53.2420523,43.5408163 C53.8769047,43.5408163 54.4517414,43.2840467 54.8678345,42.868791 C55.2835741,42.4538882 55.5408163,41.8807366 55.5408163,41.2476029 L55.5408163,2.75239706 C55.5408163,2.11987295 55.2833275,1.5465789 54.8673506,1.13143923 C54.4513267,0.716252633 53.8767212,0.459183673 53.2420523,0.459183673 Z"
            id="Rectangle-Copy-4"
            stroke-opacity="0.5"
            stroke="#EAEAEA"
            stroke-width="0.918367347"
            fill="#FFFFFF"
          ></path>
          <g
            id="mc_symbol"
            stroke-width="1"
            transform="translate(8.680556, 9.142593)"
          >
            <g id="Group" opacity="0" fill="#FFFFFF">
              <rect
                id="Rectangle"
                x="0"
                y="0"
                width="39.3776224"
                height="25.6847291"
              ></rect>
            </g>
            <rect
              id="Rectangle"
              fill="#FF5F00"
              x="14.4965035"
              y="4.47487685"
              width="10.3876124"
              height="16.7320197"
            ></rect>
            <path
              d="M15.5664336,12.8423645 C15.5638254,9.57783295 17.0833992,6.49341242 19.6873127,4.47783251 C15.2636734,1.04927639 8.91115004,1.54867524 5.09412524,5.62506497 C1.27710044,9.7014547 1.27710044,15.98623 5.09412524,20.0626198 C8.91115004,24.1390095 15.2636734,24.6384083 19.6873127,21.2098522 C17.0825706,19.1936322 15.5629039,16.1079333 15.5664336,12.8423645 Z"
              id="Path"
              fill="#EB001B"
            ></path>
            <path
              d="M36.1345654,19.8618209 L36.1345654,19.1665162 L36.2994006,19.1665162 L36.2994006,19.0226601 L35.9070929,19.0226601 L35.9070929,19.1665162 L36.062038,19.1665162 L36.062038,19.8618209 L36.1345654,19.8618209 Z M36.8961039,19.8618209 L36.8961039,19.0226601 L36.7774226,19.0226601 L36.638961,19.6220607 L36.5004995,19.0226601 L36.3818182,19.0226601 L36.3818182,19.8618209 L36.4675325,19.8618209 L36.4675325,19.2264563 L36.5961039,19.7719108 L36.6851149,19.7719108 L36.8136863,19.2264563 L36.8136863,19.8618209 L36.8961039,19.8618209 Z"
              id="Shape"
              fill="#F79E1B"
              fill-rule="nonzero"
            ></path>
            <path
              d="M37.1448551,12.8423645 C37.1448551,16.9162701 34.7860402,20.6325075 31.0704561,22.4127765 C27.354872,24.1930455 22.9347422,23.7247965 19.6873127,21.2068966 C22.29009,19.1896055 23.8097782,16.105595 23.8097782,12.8408867 C23.8097782,9.57617837 22.29009,6.49216793 19.6873127,4.47487685 C22.9347422,1.9569769 27.354872,1.48872786 31.0704561,3.26899688 C34.7860402,5.04926591 37.1448551,8.76550334 37.1448551,12.8394089 L37.1448551,12.8423645 Z"
              id="Path"
              fill="#F79E1B"
            ></path>
          </g>
        </g>
        <g
          id="Payment-Icon-/-Apple-Pay"
          transform="translate(232.000000, 14.000000)"
        >
          <path
            d="M53.2420523,0.459183673 L2.75794766,0.459183673 C2.12309529,0.459183673 1.54825862,0.715953305 1.13216555,1.13120895 C0.716425943,1.54611185 0.459183673,2.11926345 0.459183673,2.75239706 L0.459183673,41.2476029 C0.459183673,41.8801271 0.716672536,42.4534211 1.13264939,42.8685608 C1.54867327,43.2837474 2.12327875,43.5408163 2.75794766,43.5408163 L53.2420523,43.5408163 C53.8769047,43.5408163 54.4517414,43.2840467 54.8678345,42.868791 C55.2835741,42.4538882 55.5408163,41.8807366 55.5408163,41.2476029 L55.5408163,2.75239706 C55.5408163,2.11987295 55.2833275,1.5465789 54.8673506,1.13143923 C54.4513267,0.716252633 53.8767212,0.459183673 53.2420523,0.459183673 Z"
            id="Rectangle-Copy-21"
            stroke-opacity="0.5"
            stroke="#EAEAEA"
            stroke-width="0.918367347"
            fill="#FFFFFF"
          ></path>
          <g
            id="Apple_Pay_logo-Copy"
            stroke-width="1"
            transform="translate(9.602778, 14.651852)"
            fill="#000000"
          >
            <path
              d="M6.84987245,2.00517458 C6.41077806,2.53051552 5.70822704,2.94486894 5.00567602,2.8856756 C4.91785714,2.17535545 5.26181441,1.42064029 5.6643176,0.954492698 C6.10341199,0.414353419 6.87182717,0.0295966728 7.49387755,0 C7.56705995,0.73991682 7.2816486,1.4650353 6.84987245,2.00517458 L6.84987245,2.00517458 Z M7.48655931,3.02625979 C6.46932398,2.96706645 5.59845344,3.61079408 5.11544962,3.61079408 C4.62512755,3.61079408 3.88598533,3.05585647 3.08097895,3.0706548 C2.03447066,3.08545314 1.06114477,3.68478576 0.526913265,4.63927846 C-0.570822704,6.54826386 0.241501913,9.37474611 1.30264668,10.9285714 C1.82224171,11.6980849 2.44429209,12.5415901 3.26393495,12.5119934 C4.03966837,12.4823968 4.34703444,12.0014508 5.28376913,12.0014508 C6.22782207,12.0014508 6.49859694,12.5119934 7.3182398,12.4971951 C8.16715561,12.4823968 8.70138712,11.7276816 9.22098214,10.9581681 C9.81375957,10.0850663 10.0552615,9.23416191 10.069898,9.1897669 C10.0552615,9.17496857 8.43061224,8.54603927 8.41597577,6.65185221 C8.40133929,5.06843022 9.69666773,4.31371506 9.75521365,4.26932005 C9.02338967,3.17424316 7.88174426,3.05585647 7.48655931,3.02625979 L7.48655931,3.02625979 Z M13.3631059,0.880501016 L13.3631059,12.4158042 L15.1341199,12.4158042 L15.1341199,8.47204759 L17.5857302,8.47204759 C19.8251116,8.47204759 21.3985332,6.91822227 21.3985332,4.66887513 C21.3985332,2.419528 19.8543846,0.880501016 17.6442761,0.880501016 L13.3631059,0.880501016 Z M15.1341199,2.38993133 L17.1759088,2.38993133 C18.7127392,2.38993133 19.5909279,3.21863817 19.5909279,4.6762743 C19.5909279,6.13391044 18.7127392,6.97001644 17.1685906,6.97001644 L15.1341199,6.97001644 L15.1341199,2.38993133 L15.1341199,2.38993133 Z M24.6331952,12.5045943 C25.7455676,12.5045943 26.7774394,11.9348583 27.2458068,11.0321598 L27.282398,11.0321598 L27.282398,12.4158042 L28.9216837,12.4158042 L28.9216837,6.67404971 C28.9216837,5.00923687 27.6044005,3.93635748 25.5772481,3.93635748 C23.6964605,3.93635748 22.3059949,5.02403521 22.2547672,6.51866718 L23.8501435,6.51866718 C23.9818718,5.80834704 24.6331952,5.34219944 25.5260204,5.34219944 C26.6091199,5.34219944 27.2165338,5.85274204 27.2165338,6.79243641 L27.2165338,7.42876487 L25.0064254,7.5619499 C22.95,7.68773576 21.8376276,8.5386401 21.8376276,10.0184737 C21.8376276,11.5131057 22.9865912,12.5045943 24.6331952,12.5045943 Z M25.1088807,11.1357481 C24.1648278,11.1357481 23.5647321,10.6769997 23.5647321,9.97407873 C23.5647321,9.24896025 24.1428731,8.82720766 25.2479273,8.76061515 L27.2165338,8.63482929 L27.2165338,9.28595609 C27.2165338,10.3662346 26.3090721,11.1357481 25.1088807,11.1357481 Z M31.1098374,15.5530516 C32.836942,15.5530516 33.6492666,14.8871264 34.3591358,12.8671535 L37.4693878,4.047345 L35.6691008,4.047345 L33.5834024,10.8619789 L33.5468112,10.8619789 L31.4611129,4.047345 L29.6095982,4.047345 L32.6100765,12.4454009 L32.4490753,12.9559435 C32.1783004,13.8216462 31.739206,14.1546088 30.9561543,14.1546088 C30.8171078,14.1546088 30.5463329,14.1398104 30.4365593,14.1250121 L30.4365593,15.5086565 C30.5390147,15.5382532 30.9781091,15.5530516 31.1098374,15.5530516 Z"
              id="XMLID_34_"
              fill-rule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="best-egg-logo-icon" viewBox="0 0 1010 440">
    <defs>
      <style>
        .cls-1 {
          fill: #4d4d4c;
        }

        .cls-2 {
          fill: #238f93;
        }
      </style>
    </defs>
    <g id="Page-1">
      <g id="Artboard">
        <g id="Group">
          <path
            id="Fill-1"
            class="cls-1"
            d="M580.58 90.41h18.58C566.7 32.56 525.56.71 483.2.71s-83.5 31.84-116 89.7h18.57a245.31 245.31 0 0 1 16-23.39c25-32.31 53.63-50.24 81.43-50.24 33.92-.01 69.05 26.69 97.38 73.63z"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-2"
            class="cls-1"
            d="M483.2 425.35c-59.84 0-104-24.75-127.56-69h-18.06A141.84 141.84 0 0 0 368 399.62c28.52 27.34 68.35 41.79 115.2 41.79s86.68-14.41 115.19-41.79a142 142 0 0 0 30.43-43.24h-18.06c-23.58 44.23-67.73 69-127.56 69"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-3"
            class="cls-2"
            d="M149.36 235a107 107 0 0 1-4.36 31.08 73.89 73.89 0 0 1-12.84 25 61 61 0 0 1-20.8 16.73Q99 314 83 314q-20.61 0-60.86-8.55V112.56l-7.45-.29-4.63-.18-2.31-.09-1.62-.07q-6.06-.31-6.06-5.4v-6.08h36.57l.15 86.12a79.38 79.38 0 0 1 23.37-21.22 58.1 58.1 0 0 1 29.94-7.8q27.95 0 43.61 19.32T149.36 235m-15 0q0-33.92-12.54-49.87t-36-16a49.89 49.89 0 0 0-27.3 7.87q-12.24 7.79-21.88 21.69V296q31.77 6.54 43.6 6.55 13.46 0 23.55-4.89a46.43 46.43 0 0 0 16.91-13.82 62.15 62.15 0 0 0 10.24-21.39A102.42 102.42 0 0 0 134.4 235"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-4"
            class="cls-2"
            d="M257.07 163A53.36 53.36 0 0 1 276 175.9a59.36 59.36 0 0 1 12.52 20.85q4.52 12.37 4.51 28.4c0 2.25-.34 3.77-1 4.59a3.8 3.8 0 0 1-3.13 1.26H179.09v2.9q0 17.1 4 30.08a61.7 61.7 0 0 0 11.3 21.77 46.63 46.63 0 0 0 17.72 13.22 58.68 58.68 0 0 0 23.22 4.43 69.49 69.49 0 0 0 19.85-2.52 73.63 73.63 0 0 0 14.13-5.65 76.44 76.44 0 0 0 9.09-5.65c2.25-1.68 3.87-2.52 4.89-2.52a3.49 3.49 0 0 1 3.05 1.53l4 4.88a41.28 41.28 0 0 1-9.71 8.55 68.54 68.54 0 0 1-13.44 6.8 97.68 97.68 0 0 1-15.89 4.5 87.11 87.11 0 0 1-17 1.69 72.23 72.23 0 0 1-28.4-5.43 60.2 60.2 0 0 1-22-15.8 72 72 0 0 1-14.13-25.44q-5-15-5-34.44a93.85 93.85 0 0 1 4.66-30.17 68.89 68.89 0 0 1 13.44-23.83 61.19 61.19 0 0 1 21.53-15.65q12.75-5.66 29-5.65a62.68 62.68 0 0 1 23.67 4.4m-44.68 10.08a46 46 0 0 0-16.11 10.54 53.66 53.66 0 0 0-11 16.5 75.16 75.16 0 0 0-5.58 21.53h100.2a66.67 66.67 0 0 0-3.36-21.92 46.93 46.93 0 0 0-9.47-16.42A41 41 0 0 0 252.4 173a48.43 48.43 0 0 0-18.94-3.58 57.16 57.16 0 0 0-21.08 3.66"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-5"
            class="cls-2"
            d="M411 268.53a47.15 47.15 0 0 1-3.6 18.48 42 42 0 0 1-10.4 14.82 49.8 49.8 0 0 1-16.72 9.92 64.87 64.87 0 0 1-22.61 3.67 125.42 125.42 0 0 1-44.94-8.4v-37.1h7.43q6.21 0 6.58 7.4c0 .43.13 1.63.34 3.57s.44 4.63.74 8 .55 7 .76 10.86q12.34 4.93 29.7 4.94a49.21 49.21 0 0 0 16.95-2.67 35.37 35.37 0 0 0 12.22-7.25 30.27 30.27 0 0 0 7.39-10.77 34.48 34.48 0 0 0 2.52-13q0-7.64-3.67-12.68a31.44 31.44 0 0 0-9.62-8.56 67.45 67.45 0 0 0-13.52-6Q363 241.34 355 238.9t-15.58-5.35a55.88 55.88 0 0 1-13.51-7.33 35.27 35.27 0 0 1-9.63-10.76q-3.66-6.34-3.66-15.81a36.24 36.24 0 0 1 3.52-15.58 39.6 39.6 0 0 1 10-13.14 49.26 49.26 0 0 1 15.8-9 61.35 61.35 0 0 1 20.92-3.36q16.36 0 40.33 8.1V203h-7.42q-6.21 0-6.59-7.4c0-.44-.13-1.61-.33-3.5s-.44-4.51-.73-7.84-.54-6.85-.75-10.56a78.12 78.12 0 0 0-24.21-4 45.55 45.55 0 0 0-15 2.36 37.34 37.34 0 0 0-11.61 6.32 28.85 28.85 0 0 0-7.55 9.22 24 24 0 0 0-2.67 11 18.89 18.89 0 0 0 3.67 11.94 31.71 31.71 0 0 0 9.63 8.07 73.71 73.71 0 0 0 13.52 5.79q7.66 2.47 15.5 4.88t15.5 5.43a58.21 58.21 0 0 1 13.52 7.41 35.08 35.08 0 0 1 9.63 10.84 31 31 0 0 1 3.7 15.57"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-6"
            class="cls-2"
            d="M453.11 305.88q-8.63-8.56-8.63-26.43V175.59h-21.83a4.08 4.08 0 0 1-2.76-.92 3.25 3.25 0 0 1-1.07-2.6v-5.65l26-1.83 3.67-43.66a4.14 4.14 0 0 1 1.14-2.44 3.48 3.48 0 0 1 2.67-1.07h6.88v47.33H507v10.85h-47.85v103.1a32.2 32.2 0 0 0 1.6 10.77 20.09 20.09 0 0 0 4.43 7.41 17.24 17.24 0 0 0 6.64 4.27 24.13 24.13 0 0 0 8.25 1.38 25.29 25.29 0 0 0 9.47-1.6 39.79 39.79 0 0 0 6.87-3.52 43.52 43.52 0 0 0 4.73-3.51 5.26 5.26 0 0 1 2.9-1.61 3.34 3.34 0 0 1 2.45 1.54l4 6.41a42.51 42.51 0 0 1-14.73 10.31 46.12 46.12 0 0 1-18.56 3.9q-15.43 0-24.06-8.55"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-7"
            class="cls-2"
            d="M651.4 162a53.25 53.25 0 0 1 18.94 12.91 59.43 59.43 0 0 1 12.53 20.85q4.49 12.37 4.49 28.4c0 2.25-.33 3.77-1 4.59a3.79 3.79 0 0 1-3.13 1.22h-109.8v2.9q0 17.1 4 30.08a61.62 61.62 0 0 0 11.31 21.77 46.62 46.62 0 0 0 17.71 13.22 58.7 58.7 0 0 0 23.22 4.43 69.5 69.5 0 0 0 19.86-2.52 73.62 73.62 0 0 0 14.12-5.65 76.31 76.31 0 0 0 9.09-5.65q3.36-2.52 4.89-2.52a3.48 3.48 0 0 1 3 1.53l4 4.88a41.37 41.37 0 0 1-9.71 8.55 68.34 68.34 0 0 1-13.45 6.8 97.25 97.25 0 0 1-15.88 4.5 87.07 87.07 0 0 1-17 1.69 72.26 72.26 0 0 1-28.41-5.43 60.2 60.2 0 0 1-22-15.8A72 72 0 0 1 564 267.31q-5-15-5-34.44a93.85 93.85 0 0 1 4.66-30.17 69 69 0 0 1 13.44-23.83 61.3 61.3 0 0 1 21.54-15.65q12.75-5.65 28.95-5.65A62.59 62.59 0 0 1 651.4 162m-44.68 10.08a46 46 0 0 0-16.11 10.54 53.81 53.81 0 0 0-11 16.5 75.2 75.2 0 0 0-5.61 21.52h100.2a67 67 0 0 0-3.36-21.92 47 47 0 0 0-9.47-16.42 41 41 0 0 0-14.63-10.3 48.53 48.53 0 0 0-18.94-3.58 57.17 57.17 0 0 0-21.09 3.66"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-8"
            class="cls-2"
            d="M778 159.85a55.14 55.14 0 0 1 15.2 6.88h38.95v5c0 2.54-1.42 3.91-4.29 4.12l-23.06 1.68a44.23 44.23 0 0 1 6.56 13.06 51 51 0 0 1 2.3 15.5 48.61 48.61 0 0 1-4 19.93 44.24 44.24 0 0 1-11.07 15.28 50.61 50.61 0 0 1-17 9.85 65.54 65.54 0 0 1-22 3.51 67.87 67.87 0 0 1-23.82-4 31.61 31.61 0 0 0-10.09 8.7q-3.66 5-3.67 9.78 0 6.56 4.59 10.08a29.91 29.91 0 0 0 12.14 5.12 109.12 109.12 0 0 0 17.26 2.14q9.7.46 19.71 1t19.7 1.9a63.07 63.07 0 0 1 17.26 4.81 30.6 30.6 0 0 1 12.15 9.63q4.57 6.19 4.57 16.42a37.41 37.41 0 0 1-4.74 18.18A48.13 48.13 0 0 1 811 353.84a71.85 71.85 0 0 1-21.6 10.76 93.06 93.06 0 0 1-28.4 4.05 107.62 107.62 0 0 1-28.1-3.28 66.85 66.85 0 0 1-20.24-8.86 39 39 0 0 1-12.3-12.9 31.39 31.39 0 0 1-4.13-15.61 29.78 29.78 0 0 1 7.94-20.77q8-8.7 21.84-13.44a28.54 28.54 0 0 1-12.13-7.48c-3-3.26-4.51-7.79-4.51-13.6a20.37 20.37 0 0 1 1.22-6.72 27.85 27.85 0 0 1 3.67-6.95 38.69 38.69 0 0 1 5.87-6.5 41.82 41.82 0 0 1 8-5.5 45.23 45.23 0 0 1-16.88-16.64q-6-10.39-6-24.29a49.45 49.45 0 0 1 3.9-19.93 44.1 44.1 0 0 1 11-15.35 49.65 49.65 0 0 1 17.17-9.93 67.44 67.44 0 0 1 22.3-3.51 66.29 66.29 0 0 1 18.38 2.46m34.21 150.84a24.81 24.81 0 0 0-10-6.8 59.48 59.48 0 0 0-14.43-3.44q-8.17-1-17.11-1.45t-17.94-.91a137.68 137.68 0 0 1-16.81-1.84 72.41 72.41 0 0 0-10.76 5.27 39 39 0 0 0-8.47 6.72 29.13 29.13 0 0 0-5.5 8.24 24.15 24.15 0 0 0-2 9.86 23.75 23.75 0 0 0 3.45 12.45 30.26 30.26 0 0 0 10.08 9.93 56.29 56.29 0 0 0 16.28 6.65 90.6 90.6 0 0 0 22.15 2.44 85.91 85.91 0 0 0 21.62-2.6 60.31 60.31 0 0 0 17.41-7.33 37.43 37.43 0 0 0 11.61-11.3 26.1 26.1 0 0 0 4.2-14.36c0-4.79-1.26-8.64-3.74-11.54M777 242a36.41 36.41 0 0 0 12.83-7.87 32.55 32.55 0 0 0 7.89-12.13 46.26 46.26 0 0 0-.07-31.23 33.17 33.17 0 0 0-8-12.14 36.25 36.25 0 0 0-12.83-7.79 50.12 50.12 0 0 0-17.18-2.75 50.78 50.78 0 0 0-17.26 2.75 36.18 36.18 0 0 0-12.92 7.79 33.23 33.23 0 0 0-8 12.14 43 43 0 0 0-2.75 15.66 42.3 42.3 0 0 0 2.72 15.57 33.41 33.41 0 0 0 8 12.07 37.18 37.18 0 0 0 12.93 7.93 49.62 49.62 0 0 0 17.26 2.82A50.14 50.14 0 0 0 777 242"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            id="Fill-9"
            class="cls-2"
            d="M923.6 159.85a55 55 0 0 1 15.19 6.88h39v5q0 3.81-4.28 4.12l-23.06 1.68a44.23 44.23 0 0 1 6.55 13.1 50.84 50.84 0 0 1 2.29 15.5 48.49 48.49 0 0 1-4 19.93 44.14 44.14 0 0 1-11.07 15.28 50.47 50.47 0 0 1-17 9.85 65.53 65.53 0 0 1-22 3.51 67.88 67.88 0 0 1-23.82-4 31.8 31.8 0 0 0-10.09 8.7q-3.66 5-3.66 9.78c0 4.37 1.54 7.74 4.58 10.08a30 30 0 0 0 12.15 5.12 109 109 0 0 0 17.25 2.06q9.71.46 19.71 1t19.71 1.9a63.1 63.1 0 0 1 17.26 4.81 30.57 30.57 0 0 1 12.14 9.63Q975 310 975 320.24a37.61 37.61 0 0 1-4.74 18.18 48 48 0 0 1-13.66 15.43A71.87 71.87 0 0 1 935 364.6a93.06 93.06 0 0 1-28.41 4.05 107.72 107.72 0 0 1-28.1-3.28 66.93 66.93 0 0 1-20.24-8.86 38.89 38.89 0 0 1-12.29-12.9A31.33 31.33 0 0 1 841.8 328a29.78 29.78 0 0 1 7.93-20.77q8-8.7 21.85-13.44a28.61 28.61 0 0 1-12.14-7.48q-4.51-4.89-4.51-13.6a20.4 20.4 0 0 1 1.23-6.72 28 28 0 0 1 3.67-6.95 39.19 39.19 0 0 1 5.88-6.5 41.83 41.83 0 0 1 8-5.5 45.22 45.22 0 0 1-16.88-16.64q-6-10.39-6-24.29a49.17 49.17 0 0 1 3.9-19.93 44.2 44.2 0 0 1 11-15.35 49.81 49.81 0 0 1 17.18-9.93 67.55 67.55 0 0 1 22.3-3.51 66.35 66.35 0 0 1 18.41 2.44m34.21 150.84a24.81 24.81 0 0 0-10-6.8 59.55 59.55 0 0 0-14.44-3.44q-8.17-1-17.1-1.45c-6-.31-11.94-.62-18-.91a137.68 137.68 0 0 1-16.8-1.84 72.71 72.71 0 0 0-10.77 5.27 39.26 39.26 0 0 0-8.48 6.72 29.11 29.11 0 0 0-5.5 8.24 24.25 24.25 0 0 0-2 9.86 23.75 23.75 0 0 0 3.45 12.45 30.24 30.24 0 0 0 10.08 9.93 56.33 56.33 0 0 0 16.26 6.64 90.67 90.67 0 0 0 22.15 2.44 85.86 85.86 0 0 0 21.62-2.6 60.19 60.19 0 0 0 17.41-7.33 37.4 37.4 0 0 0 11.61-11.3 26.13 26.13 0 0 0 4.2-14.36q0-7.19-3.74-11.54M922.6 242a36.37 36.37 0 0 0 12.84-7.87 32.63 32.63 0 0 0 7.85-12.13 46.27 46.27 0 0 0-.07-31.23 33.1 33.1 0 0 0-8-12.14 36.15 36.15 0 0 0-12.83-7.79 50.1 50.1 0 0 0-17.18-2.75 50.78 50.78 0 0 0-17.26 2.75 36.1 36.1 0 0 0-12.95 7.8 33.17 33.17 0 0 0-8 12.14 43.21 43.21 0 0 0-2.74 15.66A42.54 42.54 0 0 0 867 222a33.35 33.35 0 0 0 8 12.07 37.09 37.09 0 0 0 12.93 7.93 54.73 54.73 0 0 0 34.67 0"
            transform="translate(-.07 -.71)"
          ></path>
          <path
            class="cls-2"
            d="M1011.65 350.4a12.54 12.54 0 1 1-12.5-12.2 12.26 12.26 0 0 1 12.5 12.2zm-21.94 0a9.45 9.45 0 0 0 9.52 9.74 9.34 9.34 0 0 0 9.3-9.67c0-5.43-3.94-9.82-9.37-9.82a9.48 9.48 0 0 0-9.46 9.75zm7.51 6.4h-2.83v-12.2a24.67 24.67 0 0 1 4.69-.37 7.6 7.6 0 0 1 4.24.89 3.38 3.38 0 0 1 1.19 2.68 3.12 3.12 0 0 1-2.53 2.83v.15a3.6 3.6 0 0 1 2.23 3 9.37 9.37 0 0 0 .89 3.05h-3a10.52 10.52 0 0 1-1-3c-.22-1.34-1-1.93-2.53-1.93h-1.34zm.08-6.92h1.34c1.56 0 2.83-.52 2.83-1.79 0-1.11-.82-1.86-2.6-1.86a6.67 6.67 0 0 0-1.56.15z"
            transform="translate(-.07 -.71)"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="kabbage-logo-icon" viewBox="0 0 470 95">
    <defs>
      <style>
        .cls-1 {
          fill: #5dbd71;
        }

        .cls-2 {
          fill: #7a7a7a;
        }
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M55.72 73.06s-17.61-25.12-3.7-50 42.61-24.7 52.07-21.68 5.76 19.21 5.72 23.24.43 5.08.43 5.08 1 2.63 3.47 2.29a46.15 46.15 0 0 0 4.76-1s.2 16.66-11 28.42-18.75 5.88-28.66 14.38S60.46 93 63.55 77c9.88-51.17 37.11-70.11 28.16-63.85-26.56 18.57-36 60-36 60zM31.9 41.37c-5.17-15.31-16.27-24.78-16.28-24.53C15.52 16.6 28.51 23.58 37 39c.73 1.21 1.39 2.48 2 3.76a52.67 52.67 0 0 1 6.2-21.23A49.91 49.91 0 0 0 5 9.07a12 12 0 0 1 2.3 9.45c-1.15 5.3-15 21.68-1.15 38.29 9.51 11.41 22.17 21.51 29.17 26.71 1.29-10.35 2.11-27.83-3.38-42.15zm17.18-25.03s-7.75-6-16.88-7.77c6.8-4.1 19.17-6.84 22.36-5.92-.45 2.73.38 4.21 4.67 5.61a87.86 87.86 0 0 0-10.15 8.08zm-13.8 72.04S6.2 70.65 0 57c3.29 11.63 2.69 24.74 35.28 31.38zm39.83-3.16s8.67-9.09 12.31-9.54 13.7-3 13.7-3-5.49 11.6-26 12.55z"
        />
        <path
          class="cls-2"
          d="M186.02 76.25l-16.68-26.84-6.66 9.59v17.25h-10.64V13.22h10.64v30.16l20.35-30.16h12.1l-18.76 27.54 22.35 35.49h-12.7zm39.77-4.6a10.08 10.08 0 0 1-4.85 3.94 17.82 17.82 0 0 1-7.21 1.53c-4.72 0-8.42-1.25-11.13-3.73s-4-6-4-10.56q0-8 5.7-12.52t16.21-4.51a17 17 0 0 1 4.25.64c0-5.43-3.25-8.13-9.76-8.13a20.68 20.68 0 0 0-9.65 2L203.09 32a27.53 27.53 0 0 1 12.55-2.67q10 0 14.69 4.8T235 52.29v9.85c0 6.13 1.17 10 3.52 11.58a5.68 5.68 0 0 1-2.83 2.86 10.79 10.79 0 0 1-3.56.54 5.48 5.48 0 0 1-4-1.73 8.55 8.55 0 0 1-2.37-3.74zm-1-17.08a20.27 20.27 0 0 0-3.92-.57q-12.09 0-12.1 8.36 0 6.18 6.82 6.19 9.21 0 9.2-9.67v-4.31zm26.78 19.15l-2.29 3.4h-5.75V13l10.21-2.58v21.52a16.18 16.18 0 0 1 8.92-2.63q9.58 0 15.48 6.39T284 52.07q0 11.58-5.93 18.31T262 77.12a16.67 16.67 0 0 1-10.47-3.4zm2.17-32.57V65.2a7.41 7.41 0 0 0 6.09 2.8c4.94 0 8.42-1.23 10.49-3.7s3.08-6.41 3.08-11.83q0-14-12.75-14c-3 0-5.32.91-6.91 2.72zm44.85 32.57l-2.3 3.4h-5.76V13l10.22-2.58v21.52a16.16 16.16 0 0 1 8.9-2.63q9.62 0 15.5 6.39T331 52.07q0 11.58-5.92 18.31T309 77.12a16.61 16.61 0 0 1-10.45-3.4zm2.16-32.57V65.2a7.41 7.41 0 0 0 6.09 2.8q7.4 0 10.48-3.7c2.07-2.47 3.09-6.41 3.09-11.83q0-14-12.75-14-4.55 0-6.91 2.72zm61.97 30.5a10 10 0 0 1-4.85 3.94 17.75 17.75 0 0 1-7.21 1.53q-7.08 0-11.12-3.73t-4.05-10.56q0-8 5.71-12.52t16.2-4.51a17.19 17.19 0 0 1 4.26.64c0-5.43-3.26-8.13-9.78-8.13a20.66 20.66 0 0 0-9.64 2L340 32a27.47 27.47 0 0 1 12.55-2.67q10 0 14.67 4.8t4.67 18.18v9.85c0 6.13 1.17 10 3.51 11.58a5.72 5.72 0 0 1-2.83 2.86 10.72 10.72 0 0 1-3.55.54 5.52 5.52 0 0 1-4-1.73 8.64 8.64 0 0 1-2.37-3.74zm-1-17.08a20.17 20.17 0 0 0-3.92-.57q-12.09 0-12.1 8.36 0 6.18 6.83 6.19 9.18 0 9.19-9.67v-4.31zM378 88.09l6.46-8.4a17.42 17.42 0 0 0 19.2 3.79c1.92-.92 2.87-2.17 2.87-3.79 0-2.73-2.11-4.08-6.33-4.08a44 44 0 0 0-5.12.43 43.59 43.59 0 0 1-5.1.43q-10.55 0-10.55-8a7.06 7.06 0 0 1 1.76-4.47 11 11 0 0 1 4.09-3.23 16.54 16.54 0 0 1-7.48-14.5 16 16 0 0 1 5.2-12.2 17.8 17.8 0 0 1 12.67-4.85 19.14 19.14 0 0 1 9.84 2.33l4-4.9 7.07 6.75-4.87 3.75a17.6 17.6 0 0 1 2.54 9.55c0 5.24-1.53 9.44-4.56 12.58A15.33 15.33 0 0 1 398.15 64a24.8 24.8 0 0 1-2.93-.22l-1.7-.25a11.51 11.51 0 0 0-2.17.92c-1.27.62-1.91 1.26-1.91 1.92 0 1.15.95 1.72 2.83 1.72a23.31 23.31 0 0 0 4.24-.65 25.59 25.59 0 0 1 5.12-.64q14.92 0 14.92 12.61a12.51 12.51 0 0 1-6 10.95 25.37 25.37 0 0 1-14.39 4A29.14 29.14 0 0 1 378 88.09zm10.22-41.74a9.64 9.64 0 0 0 2.15 6.56 7.22 7.22 0 0 0 5.78 2.48 6.83 6.83 0 0 0 5.6-2.42 10.17 10.17 0 0 0 2-6.62 8.65 8.65 0 0 0-2.11-5.89 6.89 6.89 0 0 0-5.46-2.41 7.53 7.53 0 0 0-5.72 2.32 8.31 8.31 0 0 0-2.21 6zm72.47 10.15h-31.27a12 12 0 0 0 3.6 8.57c2.2 2 5.18 3.05 8.91 3.05q7 0 10.63-3.83l4 8.22c-3.6 3.07-8.95 4.61-16.1 4.61q-10 0-15.84-6.17c-3.88-4.13-5.82-9.86-5.82-17.24s2.13-13.14 6.4-17.64a20.39 20.39 0 0 1 15.33-6.76q9.54 0 15.3 6t5.76 15.23a30.84 30.84 0 0 1-.86 6zm-30.91-8.08h21.51q-1.07-10.11-10.63-10.11c-5.84 0-9.44 3.37-10.88 10.11zm33-15.68a5.08 5.08 0 0 1 .43-2.09 5.38 5.38 0 0 1 1.16-1.72 5.62 5.62 0 0 1 1.71-1.16 5.33 5.33 0 0 1 2.1-.43 5.26 5.26 0 0 1 2.1.43 5.53 5.53 0 0 1 2.88 2.88 5.44 5.44 0 0 1 0 4.19 5.53 5.53 0 0 1-2.88 2.88 5.26 5.26 0 0 1-2.1.43 5.33 5.33 0 0 1-2.1-.43 5.62 5.62 0 0 1-1.71-1.16 5.38 5.38 0 0 1-1.16-1.72 5.09 5.09 0 0 1-.43-2.1zm1 0a4.22 4.22 0 0 0 .35 1.73 4.37 4.37 0 0 0 1 1.42 4.43 4.43 0 0 0 3.14 1.3 4.38 4.38 0 0 0 1.73-.35 4.6 4.6 0 0 0 1.42-1 4.54 4.54 0 0 0 .95-1.42 4.38 4.38 0 0 0 .35-1.73 4.34 4.34 0 0 0-.35-1.72 4.54 4.54 0 0 0-.95-1.42 4.6 4.6 0 0 0-1.42-1 4.45 4.45 0 0 0-3.46 0 4.44 4.44 0 0 0-1.41 1 4.37 4.37 0 0 0-1 1.42 4.17 4.17 0 0 0-.39 1.77zm2.36-3.12h2.39a2.43 2.43 0 0 1 1.65.48 1.77 1.77 0 0 1 .52 1.38 1.62 1.62 0 0 1-.41 1.22 1.77 1.77 0 0 1-1.05.48l1.6 2.61h-1.2l-1.54-2.52h-.82v2.52h-1.18zm1.14 2.69h1.35a1.7 1.7 0 0 0 .47-.11.88.88 0 0 0 .34-.26.78.78 0 0 0 .13-.48.74.74 0 0 0-.13-.48.8.8 0 0 0-.34-.26 1.4 1.4 0 0 0-.47-.1h-1.35z"
        />
      </g>
    </g>
  </symbol>

  <symbol id="card-visa-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Visa24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="Visa" fill="#0742A6">
        <g id="Visa_Inc._logo" transform="translate(3.500000, 8.000000)">
          <polygon
            id="polygon9"
            points="10.8699109 7.8537096 8.84722825 7.8537096 10.1123588 0.235357998 12.1349308 0.235357998"
          ></polygon>
          <path
            d="M18.2023149,0.421604957 C17.803353,0.267458399 17.1705664,0.097261641 16.3881278,0.097261641 C14.3906637,0.097261641 12.9840659,1.13460012 12.9754385,2.61768174 C12.9588474,3.71189609 13.9825215,4.31964932 14.7481477,4.68449516 C15.5306971,5.05731225 15.7967085,5.3006505 15.7967085,5.63296505 C15.7887448,6.1433399 15.1643645,6.37859925 14.5820151,6.37859925 C13.7744684,6.37859925 13.3417711,6.2573071 12.6842085,5.9733586 L12.4178653,5.8516356 L12.1348202,7.56178985 C12.6092165,7.7722737 13.4832384,7.95905925 14.3906637,7.96724595 C16.5130039,7.96724595 17.894715,6.94595765 17.9110849,5.36549765 C17.9191592,4.49824821 17.3786195,3.83372681 16.213257,3.29071297 C15.5058104,2.94213277 15.0725601,2.7070889 15.0725601,2.35042974 C15.0808557,2.02619414 15.4390033,1.69409502 16.2375907,1.69409502 C16.8951534,1.67782938 17.3782877,1.8317605 17.7442885,1.98579934 L17.9272336,2.06669666 L18.2023149,0.421604957 L18.2023149,0.421604957 L18.2023149,0.421604957 Z"
            id="path11"
          ></path>
          <path
            d="M20.8906345,5.15479835 C21.0572096,4.71713416 21.698181,3.02324554 21.698181,3.02324554 C21.6897749,3.03951117 21.8644244,2.57750238 21.9643031,2.29387702 L22.1056598,2.95031945 C22.1056598,2.95031945 22.4886942,4.77390232 22.5718711,5.15479835 C22.2557544,5.15479835 21.2901494,5.15479835 20.8906345,5.15479835 L20.8906345,5.15479835 Z M23.3873815,0.235357998 L21.8228359,0.235357998 C21.3403653,0.235357998 20.9738114,0.373023478 20.7656477,0.867455835 L17.7612115,7.8536019 L19.8835515,7.8536019 C19.8835515,7.8536019 20.2329612,6.91331865 20.3080638,6.71080605 C20.5408929,6.71080605 22.6054959,6.71080605 22.9050214,6.71080605 C22.9630904,6.9782735 23.1463673,7.8536019 23.1463673,7.8536019 L25.0191766,7.8536019 L23.3873815,0.235357998 L23.3873815,0.235357998 L23.3873815,0.235357998 Z"
            id="path13"
          ></path>
          <path
            d="M7.15780665,0.235357998 L5.17693375,5.43034475 L4.96047455,4.37674064 C4.59425254,3.16101873 3.44570243,1.84016263 2.16398069,1.18339703 L3.978389,7.84563065 L6.11732025,7.84563065 L9.29662725,0.235357998 L7.15780665,0.235357998 L7.15780665,0.235357998 L7.15780665,0.235357998 Z"
            id="path15"
          ></path>
          <path
            d="M3.33752812,0.235357998 L0.0832290945,0.235357998 L0.0499361841,0.389289118 C2.58849295,1.02149467 4.26972962,2.54540198 4.96047455,4.3770638 L4.25302786,0.875750235 C4.13655797,0.389181398 3.77863154,0.251408199 3.33752812,0.235357998 L3.33752812,0.235357998 Z"
            id="path17"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="card-master-card-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Mastercard24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="Mastercard">
        <g id="mc_symbol" transform="translate(5.000000, 5.000000)">
          <g id="Group" opacity="0" fill="#FFFFFF">
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="21.4389278"
              height="13.9839081"
            ></rect>
          </g>
          <rect
            id="Rectangle"
            fill="#FF5F00"
            x="7.8925408"
            y="2.43632184"
            width="5.65547785"
            height="9.10965515"
          ></rect>
          <path
            d="M8.4750583,6.991954 C8.47363825,5.21459795 9.3009618,3.53530232 10.718648,2.43793103 C8.3102222,0.5712727 4.85162614,0.84316763 2.77346819,3.06253537 C0.69531024,5.2819031 0.69531024,8.70361415 2.77346819,10.9229818 C4.85162614,13.1423496 8.3102222,13.4142445 10.718648,11.5475862 C9.30051065,10.4498664 8.47313655,8.7698748 8.4750583,6.991954 Z"
            id="Path"
            fill="#EB001B"
          ></path>
          <path
            d="M19.7794172,11.2705345 L19.7794172,10.513425 L19.9460839,10.513425 L19.9460839,10.3567816 L19.5494173,10.3567816 L19.5494173,10.513425 L19.7060839,10.513425 L19.7060839,11.2705345 L19.7794172,11.2705345 Z M20.5494173,11.2705345 L20.5494173,10.3567816 L20.4294172,10.3567816 L20.2894173,11.0094623 L20.1494172,10.3567816 L20.0294173,10.3567816 L20.0294173,11.2705345 L20.1160839,11.2705345 L20.1160839,10.578693 L20.2460839,11.1726324 L20.3360839,11.1726324 L20.4660839,10.578693 L20.4660839,11.2705345 L20.5494173,11.2705345 Z"
            id="Shape"
            fill="#F79E1B"
          ></path>
          <path
            d="M20.22331,6.991954 C20.22331,9.20996925 18.9390664,11.2332541 16.9161372,12.2025116 C14.8932081,13.1717693 12.486693,12.9168336 10.718648,11.545977 C12.1357156,10.4476741 12.9631015,8.76860175 12.9631015,6.99114945 C12.9631015,5.2136971 12.1357156,3.53462476 10.718648,2.43632184 C12.486693,1.0654652 14.8932081,0.81052961 16.9161372,1.77978719 C18.9390664,2.74904477 20.22331,4.77232959 20.22331,6.99034485 L20.22331,6.991954 Z"
            id="Path"
            fill="#F79E1B"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="card-amex-icon" viewBox="0 0 32 24">
    <g id="logo*/PaymentCards/AmX24" stroke="none" stroke-width="1" fill="none">
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <g id="AMEX" transform="translate(3.000000, 8.000000)" fill="#016FD0">
        <g id="American_Express_logo_(2018)">
          <g id="Group" transform="translate(0.000000, 0.382775)">
            <path
              d="M1.30869679,0.000529678004 L-8.04743477e-15,3.1375102 L0.852029133,3.1375102 L1.09349996,2.50934419 L2.49728368,2.50934419 L2.73750344,3.1375102 L3.60829975,3.1375102 L2.30085394,0.000529678004 L1.30869679,0.000529678004 Z M1.79288945,0.730599853 L2.22078094,1.82828796 L1.36374699,1.82828796 L1.79288945,0.730599853 L1.79288945,0.730599853 Z"
              id="path3046"
            ></path>
            <polygon
              id="path3048"
              points="3.69838196 3.1369832 3.69838196 1.37719958e-13 4.90916278 0.00463602008 5.61339407 2.02716332 6.30076192 1.31637391e-13 7.50186019 1.31637391e-13 7.50186019 3.1369832 6.74116454 3.1369832 6.74116454 0.825521895 5.93481115 3.1369832 5.26767942 3.1369832 4.45907759 0.825521895 4.45907759 3.1369832"
            ></polygon>
            <polygon
              id="path3050"
              points="8.02233608 3.1369832 8.02233608 1.33994534e-13 10.5046062 1.33994534e-13 10.5046062 0.701694947 8.79103908 0.701694947 8.79103908 1.23828284 10.4645695 1.23828284 10.4645695 1.89870036 8.79103908 1.89870036 8.79103908 2.45592697 10.5046062 2.45592697 10.5046062 3.1369832"
            ></polygon>
            <path
              d="M10.9450088,0.000529678004 L10.9450088,3.1375102 L11.7057044,3.1375102 L11.7057044,2.02305698 L12.0259972,2.02305698 L12.9380814,3.1375102 L13.8676815,3.1375102 L12.8667661,1.98178222 C13.277548,1.94604501 13.7012792,1.58256284 13.7012792,1.01824443 C13.7012792,0.358113158 13.1987093,0.000529678004 12.6378068,0.000529678004 L10.9450088,0.000529678004 L10.9450088,0.000529678004 Z M11.7057044,0.702221949 L12.5752495,0.702221949 C12.7838414,0.702221949 12.9355792,0.870440194 12.9355792,1.03243071 C12.9355792,1.2408376 12.7389774,1.36263947 12.58651,1.36263947 L11.7057044,1.36263947 L11.7057044,0.702221949 L11.7057044,0.702221949 Z"
              id="path3052"
            ></path>
            <polygon
              id="path3054"
              points="14.7885237 3.1369832 14.0118134 3.1369832 14.0118134 1.33994534e-13 14.7885237 1.33994534e-13"
            ></polygon>
            <path
              d="M16.6302078,3.1369832 L16.4625544,3.1369832 C15.6513721,3.1369832 15.1588623,2.47811726 15.1588623,1.58139113 C15.1588623,0.662512152 15.6458579,1.33994534e-13 16.6702443,1.33994534e-13 L17.5110132,1.33994534e-13 L17.5110132,0.742969705 L16.6395055,0.742969705 C16.2236611,0.742969705 15.9295669,1.07754162 15.9295669,1.58913032 C15.9295669,2.19664423 16.2658509,2.45179923 16.7503176,2.45179923 L16.9505005,2.45179923 L16.6302078,3.1369832 Z"
              id="path3056"
            ></path>
            <path
              d="M18.2854713,0.000529678004 L16.9767748,3.1375102 L17.8288038,3.1375102 L18.0702745,2.50934419 L19.4740584,2.50934419 L19.7142779,3.1375102 L20.5850742,3.1375102 L19.2776287,0.000529678004 L18.2854713,0.000529678004 Z M18.7696642,0.730599853 L19.1975554,1.82828796 L18.3405217,1.82828796 L18.7696642,0.730599853 Z"
              id="path3058"
            ></path>
            <polygon
              id="path3060"
              points="20.6739055 3.1369832 20.6739055 1.33994534e-13 21.6410398 1.33994534e-13 22.8759192 1.97093453 22.8759192 1.33994534e-13 23.6366148 1.33994534e-13 23.6366148 3.1369832 22.7007591 3.1369832 21.4346011 1.11445589 21.4346011 3.1369832"
            ></polygon>
            <polygon
              id="path3062"
              points="5.54006627 7.40182206 5.54006627 4.26483886 8.02233608 4.26483886 8.02233608 4.96653381 6.30876923 4.96653381 6.30876923 5.50312173 7.98229945 5.50312173 7.98229945 6.16353924 6.30876923 6.16353924 6.30876923 6.72076585 8.02233608 6.72076585 8.02233608 7.40182206"
            ></polygon>
            <polygon
              id="path3064"
              points="17.7031888 7.40182206 17.7031888 4.26483886 20.1854589 4.26483886 20.1854589 4.96653381 18.4718918 4.96653381 18.4718918 5.50312173 20.1374149 5.50312173 20.1374149 6.16353924 18.4718918 6.16353924 18.4718918 6.72076585 20.1854589 6.72076585 20.1854589 7.40182206"
            ></polygon>
            <polygon
              id="path3066"
              points="8.11867412 7.40182206 9.32727945 5.85267709 8.08989797 4.26483886 9.0482743 4.26483886 9.78519811 5.24643385 10.5246243 4.26483886 11.4454665 4.26483886 10.2243498 5.83333048 11.4351799 7.40182206 10.4769551 7.40182206 9.76142655 6.43570008 9.06328812 7.40182206"
            ></polygon>
            <path
              d="M11.5255398,4.26536855 L11.5255398,7.40234909 L12.3062536,7.40234909 L12.3062536,6.41172282 L13.1069859,6.41172282 C13.7845186,6.41172282 14.2980749,6.04115149 14.2980749,5.32048716 C14.2980749,4.72349187 13.8952901,4.26536855 13.2058264,4.26536855 L11.5255398,4.26536855 L11.5255398,4.26536855 Z M12.3062536,4.9748 L13.1495247,4.9748 C13.3684089,4.9748 13.5248679,5.11310749 13.5248679,5.33596552 C13.5248679,5.54532741 13.3691987,5.69713099 13.1470225,5.69713099 L12.3062536,5.69713099 L12.3062536,4.9748 Z"
              id="path3068"
            ></path>
            <path
              d="M14.6283772,4.26483886 L14.6283772,7.40182206 L15.3890728,7.40182206 L15.3890728,6.28736619 L15.7093656,6.28736619 L16.6214497,7.40182206 L17.5510499,7.40182206 L16.5501345,6.24609141 C16.960916,6.21034884 17.3846476,5.84687204 17.3846476,5.28255095 C17.3846476,4.62242236 16.8820777,4.26483886 16.3211752,4.26483886 L14.6283772,4.26483886 L14.6283772,4.26483886 Z M15.3890728,4.96653381 L16.2586179,4.96653381 C16.4672098,4.96653381 16.6189473,5.13474939 16.6189473,5.29673992 C16.6189473,5.50514947 16.4223455,5.62694867 16.2698781,5.62694867 L15.3890728,5.62694867 L15.3890728,4.96653381 L15.3890728,4.96653381 Z"
              id="path3072"
            ></path>
            <path
              d="M20.5377809,7.40182206 L20.5377809,6.72076585 L22.0601733,6.72076585 C22.2854327,6.72076585 22.3829685,6.5952696 22.3829685,6.45763091 C22.3829685,6.32575714 22.2857402,6.19243343 22.0601733,6.19243343 L21.3722216,6.19243343 C20.7742292,6.19243343 20.4411928,5.81681949 20.4411928,5.25288632 C20.4411928,4.74989819 20.7461733,4.26483886 21.6347843,4.26483886 L23.1161389,4.26483886 L22.7958459,4.97065891 L21.5146744,4.97065891 C21.2697707,4.97065891 21.1943814,5.10314796 21.1943814,5.22966876 C21.1943814,5.35971272 21.2875444,5.50312173 21.4746378,5.50312173 L22.1952968,5.50312173 C22.8619111,5.50312173 23.1511709,5.89295402 23.1511709,6.40345663 C23.1511709,6.95229667 22.8288405,7.40182206 22.1590073,7.40182206 L20.5377809,7.40182206 Z"
              id="path3074"
            ></path>
            <path
              d="M23.3297094,7.40182206 L23.3297094,6.72076585 L24.8521008,6.72076585 C25.0773615,6.72076585 25.1748978,6.5952696 25.1748978,6.45763091 C25.1748978,6.32575714 25.0776677,6.19243343 24.8521008,6.19243343 L24.1641502,6.19243343 C23.5661577,6.19243343 23.233121,5.81681949 23.233121,5.25288632 C23.233121,4.74989819 23.5381016,4.26483886 24.4267125,4.26483886 L25.9080667,4.26483886 L25.5877737,4.97065891 L24.3066027,4.97065891 C24.0616992,4.97065891 23.9863099,5.10314796 23.9863099,5.22966876 C23.9863099,5.35971272 24.0794727,5.50312173 24.266566,5.50312173 L24.9872256,5.50312173 C25.6538401,5.50312173 25.9430992,5.89295402 25.9430992,6.40345663 C25.9430992,6.95229667 25.6207693,7.40182206 24.9509345,7.40182206 L23.3297094,7.40182206 Z"
              id="path3076"
            ></path>
          </g>
        </g>
      </g>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
    </g>
  </symbol>

  <defs>
    <linearGradient
      x1="70.7519601%"
      y1="81.9569836%"
      x2="32.4763686%"
      y2="18.0430164%"
      id="card-diners-linear-gradient"
    >
      <stop stop-color="#009BE0" offset="0%"></stop>
      <stop stop-color="#006BA8" offset="100%"></stop>
    </linearGradient>
  </defs>
  <symbol id="card-diners-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Diners-Club"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="Diners-Club" fill-rule="nonzero">
        <g id="Shape-+-Shape" transform="translate(8.500000, 6.000000)">
          <path
            d="M8.77605965,11.9763064 C12.0197802,11.9918974 14.9804553,9.30674895 14.9804553,6.04015885 C14.9804553,2.46796082 12.0197802,-0.00118769022 8.77605965,1.77635684e-15 L5.9844584,1.77635684e-15 C2.70188383,-0.00118769022 0,2.46869746 0,6.04015885 C0,9.3074618 2.70188383,11.9919212 5.9844584,11.9763064 L8.77605965,11.9763064 L8.77605965,11.9763064 Z"
            id="Shape"
            attr.fill="url({{ locationPath }}#card-diners-linear-gradient)"
          ></path>
          <path
            d="M5.99599685,0.499009901 C2.99646782,0.499960396 0.565855575,2.95342575 0.565149135,5.9814891 C0.565855575,9.0090297 2.99644427,11.4622574 5.99599685,11.4632079 C8.99623235,11.4622574 11.4273391,9.0090297 11.4277629,5.9814891 C11.4273155,2.95342575 8.99623235,0.499960396 5.99599685,0.499009901 L5.99599685,0.499009901 Z M2.55353218,5.9814891 L2.55353218,5.9814891 C2.55635793,4.50180594 3.47213501,3.24002376 4.76350078,2.73861386 L4.76350078,9.22360395 C3.47213501,8.7224792 2.55633438,7.46138615 2.55353218,5.9814891 L2.55353218,5.9814891 Z M7.228022,9.2250297 L7.228022,9.2250297 L7.228022,2.7384 C8.5198587,3.23859802 9.43704865,4.50109307 9.43940345,5.9814891 C9.43704865,7.46233665 8.5198587,8.7238812 7.228022,9.2250297 L7.228022,9.2250297 Z"
            id="Shape"
            fill="#F4F6F7"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <linearGradient
      x1="75.6237785%"
      y1="90.1192182%"
      x2="40.9749186%"
      y2="35.8693811%"
      id="card-discover-linear-gradient-1"
    >
      <stop stop-color="#F89F20" offset="0%"></stop>
      <stop stop-color="#F79A20" offset="25.02%"></stop>
      <stop stop-color="#F68D20" offset="53.31%"></stop>
      <stop stop-color="#F58720" offset="61.96%"></stop>
      <stop stop-color="#F48120" offset="72.32%"></stop>
      <stop stop-color="#F37521" offset="100%"></stop>
    </linearGradient>
    <linearGradient
      x1="70.1473941%"
      y1="89.3791531%"
      x2="19.5068404%"
      y2="-9.60032573%"
      id="card-discover-linear-gradient-2"
    >
      <stop stop-color="#F58720" offset="0%"></stop>
      <stop stop-color="#E16F27" offset="35.87%"></stop>
      <stop stop-color="#D4602C" offset="70.3%"></stop>
      <stop stop-color="#D05B2E" offset="98.16%"></stop>
    </linearGradient>
  </defs>
  <symbol id="card-discover-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Discover24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="Discover">
        <path
          d="M30.4994941,0.25 L1.50050592,0.25 C1.15414942,0.25 0.841757025,0.389597644 0.61586532,0.61561002 C0.389440966,0.84215533 0.25,1.15537774 0.25,1.50130749 L0.25,22.4986925 C0.25,22.8458467 0.389299177,23.1583697 0.615036535,23.3842277 C0.841459335,23.6107715 1.15463517,23.75 1.50050592,23.75 L30.4994941,23.75 C30.8458506,23.75 31.158243,23.6104024 31.3841347,23.38439 C31.610559,23.1578447 31.75,22.8446223 31.75,22.4986925 L31.75,1.50130749 C31.75,1.15415328 31.6107008,0.841630245 31.3849635,0.6157723 C31.1585406,0.389228544 30.8453648,0.25 30.4994941,0.25 Z"
          id="Rectangle-Copy-10"
          stroke="#EEF3F5"
          fill="#FFFFFF"
        ></path>
        <g
          id="Discover-logo-vector-02"
          transform="translate(2.300000, 10.000000)"
        >
          <path
            d="M1.9092437,0 L0.8,0 L0.8,4 L1.9092437,4 C2.49411765,4 2.92436975,3.85467128 3.29411765,3.53633218 C3.73781513,3.15570934 4,2.58823529 4,2 C3.99327731,0.823529412 3.1394958,0 1.9092437,0 Z M2.79663866,3.00346021 C2.56134454,3.22491349 2.25210084,3.32179931 1.76134454,3.32179931 L1.55966387,3.32179931 L1.55966387,0.678200692 L1.76134454,0.678200692 C2.25210084,0.678200692 2.54789916,0.76816609 2.79663866,1.00346021 C3.05882353,1.24567474 3.21344538,1.61245675 3.21344538,2 C3.21344538,2.38062284 3.05882353,2.76124567 2.79663866,3.00346021 Z"
            id="Shape"
            fill="#231F20"
          ></path>
          <rect
            id="XMLID_422_"
            fill="#231F20"
            x="4.6"
            y="0"
            width="1"
            height="4"
          ></rect>
          <path
            d="M7.39548872,1.54 C6.98646617,1.37333333 6.87218045,1.26 6.87218045,1.05333333 C6.87218045,0.813333333 7.08270677,0.626666667 7.37744361,0.626666667 C7.58195489,0.626666667 7.7443609,0.72 7.92481203,0.94 L8.27969925,0.426666667 C7.99097744,0.146666667 7.64210526,0 7.25714286,0 C6.64360902,0 6.17443609,0.473333333 6.17443609,1.1 C6.17443609,1.63333333 6.39097744,1.9 7.02857143,2.15333333 C7.29323308,2.26 7.43157895,2.32666667 7.49774436,2.37333333 C7.63609023,2.47333333 7.70225564,2.61333333 7.70225564,2.77333333 C7.70225564,3.08666667 7.47969925,3.31333333 7.17894737,3.31333333 C6.85413534,3.31333333 6.59548872,3.13333333 6.43909774,2.8 L6,3.26666667 C6.31278195,3.77333333 6.68571429,4 7.20300752,4 C7.90676692,4 8.4,3.48 8.4,2.73333333 C8.4,2.12666667 8.17142857,1.85333333 7.39548872,1.54 Z"
            id="XMLID_421_"
            fill="#231F20"
          ></path>
          <path
            d="M8.9,2.00662252 C8.9,3.13245033 9.85426009,4 11.0883408,4 C11.4327354,4 11.7340807,3.93377483 12.1,3.77483444 L12.1,2.89403974 C11.77713,3.19205298 11.4901345,3.31125828 11.1242152,3.31125828 C10.3134529,3.31125828 9.732287,2.76821192 9.732287,1.99337748 C9.732287,1.25827815 10.3278027,0.682119205 11.0883408,0.682119205 C11.4757848,0.682119205 11.7627803,0.80794702 12.1,1.11258278 L12.1,0.231788079 C11.7484305,0.0662251656 11.4542601,0 11.1026906,0 C9.88295964,0.00662251656 8.9,0.894039735 8.9,2.00662252 Z"
            id="XMLID_420_"
            fill="#231F20"
          ></path>
          <polygon
            id="XMLID_419_"
            fill="#231F20"
            points="18.3928058 2.61720067 17.2848921 0 16.4 0 18.1697842 4 18.6014388 4 20.4 0 19.5223022 0"
          ></polygon>
          <polygon
            id="XMLID_418_"
            fill="#231F20"
            points="20.8 4 23.2 4 23.2 3.32179931 21.6426332 3.32179931 21.6426332 2.24221453 23.1398119 2.24221453 23.1398119 1.56401384 21.6426332 1.56401384 21.6426332 0.678200692 23.2 0.678200692 23.2 0 20.8 0"
          ></polygon>
          <path
            d="M25.9049645,1.183391 C25.9049645,0.435986159 25.4851064,0 24.7475177,0 L23.8,0 L23.8,4 L24.4411348,4 L24.4411348,2.39446367 L24.5262411,2.39446367 L25.4113475,4 L26.2,4 L25.1673759,2.3183391 C25.6382979,2.19377163 25.9049645,1.79238754 25.9049645,1.183391 Z M24.622695,1.84083045 L24.435461,1.84083045 L24.435461,0.629757785 L24.6340426,0.629757785 C25.0312057,0.629757785 25.2468085,0.830449827 25.2468085,1.22491349 C25.2468085,1.62629758 25.0312057,1.84083045 24.622695,1.84083045 Z"
            id="Shape"
            fill="#231F20"
          ></path>
          <circle
            id="XMLID_415_"
            attr.fill="url({{ locationPath }}#card-discover-linear-gradient-1)"
            cx="14.4"
            cy="2"
            r="2"
          ></circle>
          <circle
            id="XMLID_414_"
            attr.fill="url({{ locationPath }}#card-discover-linear-gradient-2)"
            opacity="0.65"
            cx="14.4"
            cy="2"
            r="2"
          ></circle>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="card-jcb-icon" viewBox="0 0 29 20">
    <g fill="none">
      <polygon points="0 0 28.9 0 28.9 19.9 0 19.9" fill="#F8F8F8" />
      <path
        d="M21.8 13.6C21.8 14.9 20.8 16.1 19.5 16.1L7.1 16.1 7.1 6.3C7.1 4.9 8.2 3.8 9.4 3.8L21.8 3.8 21.8 13.6 21.8 13.6 21.8 13.6Z"
        fill="#FFF"
      />
      <path
        d="M17.8 10.2L17.8 10.2 17.8 10.2 17.8 10.2 17.9 10.2 17.9 10.2 17.9 10.2 17.9 10.2 17.9 10.2 17.9 10.2 18 10.2 18 10.2 18 10.2 18 10.2 18 10.2 18 10.2 18 10.2 18.1 10.2 18.1 10.2 18.1 10.2 18.1 10.2 18.1 10.2 18.1 10.2 18.2 10.2 18.2 10.2 18.2 10.2 18.2 10.2 18.2 10.2 18.2 10.2 18.3 10.2 18.3 10.2 18.3 10.2 18.3 10.2 18.3 10.2 18.3 10.2 18.3 10.2 18.4 10.2 18.4 10.2 18.4 10.2 18.4 10.2 18.4 10.2 18.4 10.2 18.5 10.2 18.5 10.2 18.5 10.2 18.5 10.2 18.5 10.2 18.5 10.2 18.6 10.2 18.6 10.2 18.6 10.2 18.6 10.2 18.6 10.2 18.6 10.2 18.6 10.2 18.7 10.2 18.7 10.2 18.7 10.2 18.7 10.2 18.7 10.2 18.7 10.2 18.8 10.2 18.8 10.2C18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.8 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2L18.9 10.2C18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 18.9 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.2 19 10.3 19 10.3 19 10.3 19 10.3 19 10.3 19 10.3 19 10.3 19 10.3 19 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.3 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.1 10.4 19.2 10.4 19.2 10.4 19.2 10.5 19.2 10.5 19.2 10.5 19.2 10.5 19.2 10.5 19.2 10.6 19.2 10.6 19.2 10.6 19.2 10.7 19.2 10.7 19.2 10.7 19.2 10.8 19.2 10.8 19.2 10.8 19.2 10.8 19.2 10.8 19.2 10.8 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 10.9 19.1 11 19.1 11 19.1 11 19.1 11 19.1 11 19.1 11 19.1 11 19.1 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11 19 11.1 19 11.1 19 11.1 19 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1 18.9 11.1L18.9 11.1C18.9 11.1 18.9 11.1 18.9 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1 18.8 11.1L18.7 11.1 18.7 11.1 18.7 11.1 18.7 11.1 18.7 11.1 18.7 11.1 18.7 11.1 18.6 11.1 18.6 11.1 18.6 11.1 18.6 11.1 18.6 11.1 18.6 11.1 18.6 11.1 18.5 11.1 18.5 11.1 18.5 11.1 18.5 11.1 18.5 11.1 18.5 11.1 18.4 11.1 18.4 11.1 18.4 11.1 18.4 11.1 18.4 11.1 18.4 11.1 18.3 11.1 18.3 11.1 18.3 11.1 18.3 11.1 18.3 11.1 18.3 11.1 18.3 11.1 18.2 11.1 18.2 11.1 18.2 11.1 18.2 11.1 18.2 11.1 18.2 11.1 18.1 11.1 18.1 11.1 18.1 11.1 18.1 11.1 18.1 11.1 18.1 11.1 18 11.1 18 11.1 18 11.1 18 11.1 18 11.1 18 11.1 18 11.1 17.9 11.1 17.9 11.1 17.9 11.1 17.9 11.1 17.9 11.1 17.9 11.1 17.8 11.1 17.8 11.1 17.8 11.1 17.8 11.1 17.8 10.2 17.8 10.2ZM19.1 9.1C19.1 9.2 19.1 9.2 19.1 9.2 19.1 9.3 19.1 9.3 19.1 9.3 19.1 9.3 19.1 9.4 19.1 9.4 19.1 9.4 19 9.4 19 9.4 19 9.4 19 9.4 19 9.4 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 19 9.5 18.9 9.5 18.9 9.5 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.9 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6 18.8 9.6L18.8 9.6C18.8 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6 18.7 9.6L18.7 9.6 18.6 9.6 18.6 9.6 18.6 9.6 18.6 9.6 18.6 9.6 18.6 9.6 18.6 9.6 18.5 9.6 18.5 9.6 18.5 9.6 18.5 9.6 18.5 9.6 18.5 9.6 18.4 9.6 18.4 9.6 18.4 9.6 18.4 9.6 18.4 9.6 18.4 9.6 18.3 9.6 18.3 9.6 18.3 9.6 18.3 9.6 18.3 9.6 18.3 9.6 18.3 9.6 18.2 9.6 18.2 9.6 18.2 9.6 18.2 9.6 18.2 9.6 18.2 9.6 18.1 9.6 18.1 9.6 18.1 9.6 18.1 9.6 18.1 9.6 18.1 9.6 18.1 9.6 18 9.6 18 9.6 18 9.6 18 9.6 18 9.6 18 9.6 17.9 9.6 17.9 9.6 17.9 9.6 17.9 9.6 17.9 9.6 17.9 9.6 17.8 9.6 17.8 9.6 17.8 9.6 17.8 9.6 17.8 8.8 17.8 8.8 17.8 8.8 17.8 8.8 17.9 8.8 17.9 8.8 17.9 8.8 17.9 8.8 17.9 8.8 17.9 8.8 18 8.8 18 8.8 18 8.8 18 8.8 18 8.8 18 8.8 18.1 8.8 18.1 8.8 18.1 8.8 18.1 8.8 18.1 8.8 18.1 8.8 18.1 8.8 18.2 8.8 18.2 8.8 18.2 8.8 18.2 8.8 18.2 8.8 18.2 8.8 18.3 8.8 18.3 8.8 18.3 8.8 18.3 8.8 18.3 8.8 18.3 8.8 18.3 8.8 18.4 8.8 18.4 8.8 18.4 8.8 18.4 8.8 18.4 8.8 18.4 8.8 18.5 8.8 18.5 8.8 18.5 8.8 18.5 8.8 18.5 8.8 18.5 8.8 18.6 8.8 18.6 8.8 18.6 8.8 18.6 8.8 18.6 8.8 18.6 8.8 18.6 8.8 18.7 8.8 18.7 8.8 18.7 8.8C18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.7 8.8 18.8 8.8 18.8 8.8L18.8 8.8C18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.8 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.8 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 18.9 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 8.9 19 9 19 9 19 9 19 9 19 9 19 9 19 9 19 9 19 9 19 9 19.1 9 19.1 9.1 19.1 9.1 19.1 9.1 19.1 9.1L19.1 9.1ZM21 4.7L21 4.7 21 13.5C21 13.5 21 13.6 21 13.6 21 13.7 21 13.7 21 13.8 21 13.8 21 13.8 21 13.9 21 13.9 21 13.9 21 13.9 21 14 21 14 21 14 21 14 21 14 20.9 14.1 20.9 14.1 20.9 14.1 20.9 14.1 20.9 14.1 20.9 14.1 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.2 20.9 14.3 20.9 14.3 20.9 14.3 20.9 14.3 20.9 14.3 20.8 14.3 20.8 14.3 20.8 14.3 20.8 14.3 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.4 20.8 14.5 20.8 14.5 20.8 14.5 20.8 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.5 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.7 14.6 20.6 14.6 20.6 14.6 20.6 14.6 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.6 14.7 20.5 14.7 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.5 14.8 20.4 14.8 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.4 14.9 20.3 14.9 20.3 14.9 20.3 14.9 20.3 14.9 20.3 14.9 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.3 15 20.2 15 20.2 15 20.2 15L20.2 15C20.2 15 20.2 15 20.2 15 20.2 15 20.2 15 20.2 15 20.2 15 20.2 15 20.2 15 20.2 15.1 20.2 15.1 20.2 15.1 20.2 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1 20.1 15.1L20.1 15.1 20.1 15.1C20.1 15.1 20.1 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1 20 15.1L20 15.2C19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2 19.9 15.2L19.9 15.2C19.9 15.2 19.9 15.2 19.9 15.2L19.9 15.2C19.9 15.2 19.8 15.2 19.8 15.2 19.8 15.2 19.8 15.2 19.8 15.2 19.8 15.2 19.8 15.2 19.8 15.2L19.8 15.2 19.8 15.2 19.8 15.2C19.8 15.2 19.8 15.2 19.7 15.2 19.7 15.2 19.7 15.2 19.7 15.2L19.7 15.2 19.7 15.2C19.7 15.2 19.7 15.2 19.7 15.2 19.7 15.2 19.7 15.2 19.7 15.2L19.7 15.2 19.6 15.2 19.6 15.2C19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.2 19.6 15.3 19.6 15.3 19.6 15.3 19.6 15.3 19.6 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3L19.5 15.3C19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3 19.5 15.3L19.5 15.3 19.4 15.3C19.4 15.3 19.4 15.3 19.4 15.3L19.4 15.3 19.4 15.3 19.4 15.3 19.4 15.3 19.4 15.3 19.3 15.3 19.3 15.3 19.3 15.3 19.3 15.3 19.3 15.3 19.3 15.3 19.2 15.3 19.2 15.3 19.2 15.3 19.2 15.3 19.2 15.3 19.2 15.3 19.2 15.3 19.1 15.3 19.1 15.3 19.1 15.3 19.1 15.3 19.1 15.3 19.1 15.3 19 15.3 19 15.3 19 15.3 19 15.3 19 15.3 19 15.3 18.9 15.3 18.9 15.3 18.9 15.3 18.9 15.3 18.9 15.3 18.9 15.3 18.9 15.3 18.8 15.3 18.8 15.3 18.8 15.3 18.8 15.3 18.8 15.3 18.8 15.3 18.7 15.3 18.7 15.3 18.7 15.3 18.7 15.3 18.7 15.3 18.7 15.3 18.6 15.3 18.6 15.3 18.6 15.3 18.6 15.3 18.6 15.3 18.6 15.3 18.6 15.3 18.5 15.3 18.5 15.3 18.5 15.3 18.5 15.3 18.5 15.3 18.5 15.3 18.4 15.3 18.4 15.3 18.4 15.3 18.4 15.3 18.4 15.3 18.4 15.3 18.3 15.3 18.3 15.3 18.3 15.3 18.3 15.3 18.3 15.3 18.3 15.3 18.3 15.3 18.2 15.3 18.2 15.3 18.2 15.3 18.2 15.3 18.2 15.3 18.2 15.3 18.1 15.3 18.1 15.3 18.1 15.3 18.1 15.3 18.1 15.3 18.1 15.3 18 15.3 18 15.3 18 15.3 18 15.3 18 15.3 18 15.3 18 15.3 17.9 15.3 17.9 15.3 17.9 15.3 17.9 15.3 17.9 15.3 17.9 15.3 17.8 15.3 17.8 15.3 17.8 15.3 17.8 15.3 17.8 15.3 17.8 15.3 17.8 15.3 17.7 15.3 17.7 15.3 17.7 15.3 17.7 15.3 17.7 15.3 17.7 15.3 17.6 15.3 17.6 15.3 17.6 15.3 17.6 15.3 17.6 15.3 17.6 15.3 17.5 15.3 17.5 15.3 17.5 15.3 17.5 15.3 17.5 15.3 17.5 15.3 17.5 15.3 17.4 15.3 17.4 15.3 17.4 15.3 17.4 15.3 17.4 15.3 17.4 15.3 17.3 15.3 17.3 15.3 17.3 15.3 17.3 15.3 17.3 15.3 17.3 15.3 17.2 15.3 17.2 15.3 17.2 15.3 17.2 15.3 17.2 15.3 17.2 15.3 17.2 15.3 17.1 15.3 17.1 15.3 17.1 15.3 17.1 15.3 17.1 15.3 17.1 15.3 17 15.3 17 15.3 17 11.7 17 11.7 17.1 11.7 17.1 11.7 17.1 11.7 17.1 11.7 17.1 11.7 17.1 11.7 17.2 11.7 17.2 11.7 17.2 11.7 17.2 11.7 17.2 11.7 17.2 11.7 17.2 11.7 17.3 11.7 17.3 11.7 17.3 11.7 17.3 11.7 17.3 11.7 17.3 11.7 17.4 11.7 17.4 11.7 17.4 11.7 17.4 11.7 17.4 11.7 17.4 11.7 17.5 11.7 17.5 11.7 17.5 11.7 17.5 11.7 17.5 11.7 17.5 11.7 17.5 11.7 17.6 11.7 17.6 11.7 17.6 11.7 17.6 11.7 17.6 11.7 17.6 11.7 17.7 11.7 17.7 11.7 17.7 11.7 17.7 11.7 17.7 11.7 17.7 11.7 17.8 11.7 17.8 11.7 17.8 11.7 17.8 11.7 17.8 11.7 17.8 11.7 17.8 11.7 17.9 11.7 17.9 11.7 17.9 11.7 17.9 11.7 17.9 11.7 17.9 11.7 18 11.7 18 11.7 18 11.7 18 11.7 18 11.7 18 11.7 18 11.7 18.1 11.7 18.1 11.7 18.1 11.7 18.1 11.7 18.1 11.7 18.1 11.7 18.2 11.7 18.2 11.7 18.2 11.7 18.2 11.7 18.2 11.7 18.2 11.7 18.3 11.7 18.3 11.7 18.3 11.7 18.3 11.7 18.3 11.7 18.3 11.7 18.3 11.7 18.4 11.7 18.4 11.7 18.4 11.7 18.4 11.7 18.4 11.7 18.4 11.7 18.5 11.7 18.5 11.7 18.5 11.7 18.5 11.7 18.5 11.7 18.5 11.7 18.6 11.7 18.6 11.7 18.6 11.7 18.6 11.7 18.6 11.7 18.6 11.7 18.6 11.7 18.7 11.7 18.7 11.7 18.7 11.7 18.7 11.7 18.7 11.7 18.7 11.7 18.8 11.7 18.8 11.7 18.8 11.7 18.8 11.7 18.8 11.7 18.8 11.7 18.9 11.7 18.9 11.7 18.9 11.7 18.9 11.7 18.9 11.7 18.9 11.7 18.9 11.7 19 11.7 19 11.7 19 11.7 19 11.7 19 11.7 19 11.7 19.1 11.7 19.1 11.7 19.1 11.7 19.1 11.7 19.1 11.7 19.1 11.7 19.2 11.7 19.2 11.7 19.2 11.7 19.2 11.7 19.2 11.7 19.2 11.7 19.2 11.7 19.3 11.7 19.3 11.7 19.3 11.7 19.3 11.7 19.3 11.7 19.3 11.7 19.4 11.7 19.4 11.7 19.4 11.7 19.4 11.7 19.4 11.7 19.4 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.5 11.7 19.6 11.7 19.6 11.7C19.6 11.7 19.6 11.7 19.6 11.7 19.6 11.7 19.6 11.7 19.6 11.7L19.6 11.7 19.6 11.7 19.7 11.7 19.7 11.7 19.7 11.7C19.7 11.6 19.7 11.6 19.7 11.6 19.7 11.6 19.7 11.6 19.7 11.6L19.7 11.6C19.7 11.6 19.7 11.6 19.7 11.6 19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6L19.8 11.6 19.8 11.6C19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6 19.8 11.6L19.9 11.6C19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 19.9 11.6 20 11.6L20 11.6C20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20 11.6 20.1 11.6 20.1 11.6 20.1 11.6 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.1 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.5 20.2 11.4 20.2 11.4 20.2 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.3 11.4 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.3 20.4 11.2 20.4 11.2 20.4 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.2 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11.1 20.5 11 20.5 11 20.5 11 20.6 11 20.6 10.9 20.6 10.9 20.6 10.9 20.6 10.9 20.6 10.8 20.6 10.8 20.6 10.7 20.6 10.7 20.6 10.7 20.6 10.6 20.6 10.6 20.6 10.6 20.5 10.6 20.5 10.5 20.5 10.5 20.5 10.5 20.5 10.5 20.5 10.5 20.5 10.5 20.5 10.5 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.4 20.5 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.3 20.4 10.2 20.4 10.2 20.4 10.2 20.4 10.2 20.4 10.2 20.4 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.2 20.3 10.1 20.3 10.1 20.3 10.1 20.3 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.2 10.1 20.1 10.1 20.1 10.1 20.1 10.1 20.1 10.1 20.1 10.1 20.1 10.1 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20.1 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10 20 10L19.9 10C19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.9 10 19.8 10 19.8 10 19.8 10 19.8 9.9 19.8 9.9L19.8 9.9 19.8 9.9C19.8 9.9 19.8 9.9 19.8 9.9L19.8 9.9C19.8 9.9 19.8 9.9 19.7 9.9L19.7 9.9 19.7 9.9 19.7 9.9 19.7 9.9 19.7 9.9 19.7 9.9 19.6 9.9 19.6 9.9 19.7 9.9 19.7 9.9C19.7 9.9 19.7 9.9 19.7 9.9L19.7 9.9C19.7 9.9 19.7 9.9 19.7 9.9L19.7 9.9C19.7 9.9 19.7 9.9 19.7 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.9 19.8 9.8 19.8 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 19.9 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.8 20 9.7 20 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.1 9.7 20.2 9.7 20.2 9.7 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.6 20.2 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.5 20.3 9.4 20.3 9.4 20.3 9.4 20.3 9.4 20.3 9.4 20.3 9.4 20.3 9.4 20.3 9.3 20.3 9.3 20.4 9.3 20.4 9.3 20.4 9.3 20.4 9.2 20.4 9.2 20.4 9.2 20.4 9.1 20.4 9.1 20.4 9.1 20.4 9.1 20.4 9 20.4 9 20.4 9 20.4 8.9 20.4 8.9 20.4 8.9 20.4 8.9 20.3 8.8 20.3 8.8 20.3 8.8 20.3 8.8 20.3 8.8 20.3 8.8 20.3 8.8 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.7 20.3 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.6 20.2 8.5 20.2 8.5 20.2 8.5 20.2 8.5 20.2 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.5 20.1 8.4 20.1 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 20 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.4 19.9 8.3 19.9 8.3 19.9 8.3 19.9 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3 19.8 8.3L19.7 8.3C19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3L19.7 8.3C19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3 19.7 8.3L19.7 8.3C19.7 8.3 19.6 8.3 19.6 8.3L19.6 8.3 19.6 8.3 19.6 8.3 19.6 8.3 19.6 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.5 8.3 19.4 8.3 19.4 8.3 19.4 8.3 19.4 8.3 19.4 8.3 19.4 8.3 19.3 8.3 19.3 8.3 19.3 8.3 19.3 8.3 19.3 8.3 19.3 8.3 19.3 8.3 19.2 8.3 19.2 8.3 19.2 8.3 19.2 8.3 19.2 8.3 19.2 8.3 19.2 8.3 19.1 8.3 19.1 8.3 19.1 8.3 19.1 8.3 19.1 8.3 19.1 8.3 19 8.3 19 8.3 19 8.3 19 8.3 19 8.3 19 8.3 18.9 8.3 18.9 8.3 18.9 8.3 18.9 8.3 18.9 8.3 18.9 8.3 18.9 8.3 18.8 8.3 18.8 8.3 18.8 8.3 18.8 8.3 18.8 8.3 18.8 8.3 18.7 8.3 18.7 8.3 18.7 8.3 18.7 8.3 18.7 8.3 18.7 8.3 18.6 8.3 18.6 8.3 18.6 8.3 18.6 8.3 18.6 8.3 18.6 8.3 18.6 8.3 18.5 8.3 18.5 8.3 18.5 8.3 18.5 8.3 18.5 8.3 18.5 8.3 18.4 8.3 18.4 8.3 18.4 8.3 18.4 8.3 18.4 8.3 18.4 8.3 18.3 8.3 18.3 8.3 18.3 8.3 18.3 8.3 18.3 8.3 18.3 8.3 18.3 8.3 18.2 8.3 18.2 8.3 18.2 8.3 18.2 8.3 18.2 8.3 18.2 8.3 18.1 8.3 18.1 8.3 18.1 8.3 18.1 8.3 18.1 8.3 18.1 8.3 18 8.3 18 8.3 18 8.3 18 8.3 18 8.3 18 8.3 18 8.3 17.9 8.3 17.9 8.3 17.9 8.3 17.9 8.3 17.9 8.3 17.9 8.3 17.8 8.3 17.8 8.3 17.8 8.3 17.8 8.3 17.8 8.3 17.8 8.3 17.8 8.3 17.7 8.3 17.7 8.3 17.7 8.3 17.7 8.3 17.7 8.3 17.7 8.3 17.6 8.3 17.6 8.3 17.6 8.3 17.6 8.3 17.6 8.3 17.6 8.3 17.5 8.3 17.5 8.3 17.5 8.3 17.5 8.3 17.5 8.3 17.5 8.3 17.5 8.3 17.4 8.3 17.4 8.3 17.4 8.3 17.4 8.3 17.4 8.3 17.4 8.3 17.3 8.3 17.3 8.3 17.3 8.3 17.3 8.3 17.3 8.3 17.3 8.3 17.2 8.3 17.2 8.3 17.2 8.3 17.2 8.3 17.2 8.3 17.2 8.3 17.2 8.3 17.1 8.3 17.1 8.3 17.1 8.3 17.1 8.3 17.1 8.3 17.1 8.3 17 8.3 17 8.3 17 6.4C17 6.3 17 6.2 17 6.1 17 6 17.1 6 17.1 6 17.1 6 17.1 5.9 17.1 5.9 17.1 5.9 17.1 5.9 17.1 5.9 17.1 5.9 17.1 5.8 17.1 5.8 17.1 5.8 17.1 5.8 17.1 5.8 17.1 5.8 17.1 5.8 17.1 5.7 17.1 5.7 17.1 5.7 17.2 5.7 17.2 5.7 17.2 5.7 17.2 5.7 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.6 17.2 5.5 17.2 5.5 17.2 5.5 17.2 5.5 17.2 5.5 17.3 5.5 17.3 5.5 17.3 5.5 17.3 5.5 17.3 5.5 17.3 5.5 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.4 17.3 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.3 17.4 5.2 17.4 5.2 17.4 5.2 17.4 5.2 17.4 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.2 17.5 5.1 17.5 5.1 17.5 5.1 17.5 5.1 17.5 5.1 17.5 5.1 17.5 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5.1 17.6 5 17.6 5L17.6 5 17.7 5C17.7 5 17.7 5 17.7 5 17.7 5 17.7 5 17.7 5L17.7 5C17.7 5 17.7 5 17.7 5L17.7 5 17.8 4.9C17.8 4.9 17.8 4.9 17.8 4.9L17.8 4.9C17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.8 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.9 17.9 4.8 17.9 4.8 17.9 4.8 17.9 4.8 17.9 4.8L17.9 4.8C17.9 4.8 17.9 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8 18 4.8L18 4.8 18.1 4.8C18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.8 18.1 4.7 18.1 4.7L18.1 4.7C18.1 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7 18.2 4.7L18.2 4.7C18.2 4.7 18.2 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7L18.3 4.7 18.3 4.7C18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.3 4.7 18.4 4.7 18.4 4.7 18.4 4.7L18.4 4.7C18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7 18.4 4.7L18.5 4.7C18.5 4.7 18.5 4.7 18.5 4.7 18.5 4.7 18.5 4.7 18.5 4.7L18.5 4.7 18.5 4.7C18.5 4.7 18.5 4.7 18.5 4.7 18.5 4.7 18.5 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7L18.6 4.7C18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7 18.6 4.7L18.6 4.7 18.6 4.7 18.7 4.7 18.7 4.7 18.7 4.7 18.7 4.7 18.7 4.7 18.7 4.7 18.8 4.7 18.8 4.7 18.8 4.7 18.8 4.7 18.8 4.7 18.8 4.7 18.9 4.7 18.9 4.7 18.9 4.7 18.9 4.7 18.9 4.7 18.9 4.7 18.9 4.7 19 4.7 19 4.7 19 4.7 19 4.7 19 4.7 19 4.7 19.1 4.7 19.1 4.7 19.1 4.7 19.1 4.7 19.1 4.7 19.1 4.7 19.2 4.7 19.2 4.7 19.2 4.7 19.2 4.7 19.2 4.7 19.2 4.7 19.2 4.7 19.3 4.7 19.3 4.7 19.3 4.7 19.3 4.7 19.3 4.7 19.3 4.7 19.4 4.7 19.4 4.7 19.4 4.7 19.4 4.7 19.4 4.7 19.4 4.7 19.5 4.7 19.5 4.7 19.5 4.7 19.5 4.7 19.5 4.7 19.5 4.7 19.5 4.7 19.6 4.7 19.6 4.7 19.6 4.7 19.6 4.7 19.6 4.7 19.6 4.7 19.7 4.7 19.7 4.7 19.7 4.7 19.7 4.7 19.7 4.7 19.7 4.7 19.7 4.7 19.8 4.7 19.8 4.7 19.8 4.7 19.8 4.7 19.8 4.7 19.8 4.7 19.9 4.7 19.9 4.7 19.9 4.7 19.9 4.7 19.9 4.7 19.9 4.7 20 4.7 20 4.7 20 4.7 20 4.7 20 4.7 20 4.7 20 4.7 20.1 4.7 20.1 4.7 20.1 4.7 20.1 4.7 20.1 4.7 20.1 4.7 20.2 4.7 20.2 4.7 20.2 4.7 20.2 4.7 20.2 4.7 20.2 4.7 20.3 4.7 20.3 4.7 20.3 4.7 20.3 4.7 20.3 4.7 20.3 4.7 20.3 4.7 20.4 4.7 20.4 4.7 20.4 4.7 20.4 4.7 20.4 4.7 20.4 4.7 20.5 4.7 20.5 4.7 20.5 4.7 20.5 4.7 20.5 4.7 20.5 4.7 20.6 4.7 20.6 4.7 20.6 4.7 20.6 4.7 20.6 4.7 20.6 4.7 20.6 4.7 20.7 4.7 20.7 4.7 20.7 4.7 20.7 4.7 20.7 4.7 20.7 4.7 20.8 4.7 20.8 4.7 20.8 4.7 20.8 4.7 20.8 4.7 20.8 4.7 20.9 4.7 20.9 4.7 20.9 4.7 20.9 4.7 20.9 4.7 20.9 4.7 20.9 4.7 21 4.7 21 4.7 21 4.7 21 4.7 21 4.7 21 4.7 21 4.7Z"
        fill="#55B330"
      ></path>
      <path
        d="M8 10.8C8 10.8 8 10.8 8 10.8L8 6.4C8 6.3 8 6.2 8 6.1 8 6 8 6 8 6 8 6 8 6 8 5.9 8.1 5.9 8.1 5.9 8.1 5.9 8.1 5.9 8.1 5.8 8.1 5.8 8.1 5.8 8.1 5.8 8.1 5.8 8.1 5.8 8.1 5.8 8.1 5.7 8.1 5.7 8.1 5.7 8.1 5.7 8.1 5.7 8.1 5.7 8.1 5.7 8.1 5.7 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.6 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.2 5.5 8.3 5.5 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.4 8.3 5.3 8.3 5.3 8.3 5.3 8.3 5.3 8.3 5.3 8.3 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.3 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.4 5.2 8.5 5.2 8.5 5.2 8.5 5.2 8.5 5.2 8.5 5.2 8.5 5.2 8.5 5.2 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.5 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5.1 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5 8.6 5L8.7 5C8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 5 8.7 4.9 8.7 4.9 8.7 4.9 8.7 4.9 8.7 4.9 8.7 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.8 4.9 8.9 4.9 8.9 4.9 8.9 4.9 8.9 4.9 8.9 4.9 8.9 4.8 8.9 4.8L8.9 4.8C8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 8.9 4.8 9 4.8 9 4.8 9 4.8 9 4.8 9 4.8 9 4.8 9 4.8 9 4.8L9 4.8 9 4.8 9 4.8C9 4.8 9 4.8 9.1 4.8 9.1 4.8 9.1 4.8 9.1 4.8 9.1 4.8 9.1 4.8 9.1 4.8L9.1 4.7 9.1 4.7C9.1 4.7 9.1 4.7 9.1 4.7 9.1 4.7 9.1 4.7 9.1 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7L9.2 4.7C9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.2 4.7 9.3 4.7 9.3 4.7L9.3 4.7C9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7 9.3 4.7L9.4 4.7C9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7 9.4 4.7L9.4 4.7 9.4 4.7C9.4 4.7 9.4 4.7 9.4 4.7 9.5 4.7 9.5 4.7 9.5 4.7L9.5 4.7C9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7 9.5 4.7L9.6 4.7C9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7 9.6 4.7L9.6 4.7 9.6 4.7 9.6 4.7 9.7 4.7 9.7 4.7 9.7 4.7 9.7 4.7 9.7 4.7 9.7 4.7 9.7 4.7 9.8 4.7 9.8 4.7 9.8 4.7 9.8 4.7 9.8 4.7 9.8 4.7 9.9 4.7 9.9 4.7 9.9 4.7 9.9 4.7 9.9 4.7 9.9 4.7 10 4.7 10 4.7 10 4.7 10 4.7 10 4.7 10 4.7 10 4.7 10.1 4.7 10.1 4.7 10.1 4.7 10.1 4.7 10.1 4.7 10.1 4.7 10.2 4.7 10.2 4.7 10.2 4.7 10.2 4.7 10.2 4.7 10.2 4.7 10.2 4.7 10.3 4.7 10.3 4.7 10.3 4.7 10.3 4.7 10.3 4.7 10.3 4.7 10.4 4.7 10.4 4.7 10.4 4.7 10.4 4.7 10.4 4.7 10.4 4.7 10.5 4.7 10.5 4.7 10.5 4.7 10.5 4.7 10.5 4.7 10.5 4.7 10.5 4.7 10.6 4.7 10.6 4.7 10.6 4.7 10.6 4.7 10.6 4.7 10.6 4.7 10.7 4.7 10.7 4.7 10.7 4.7 10.7 4.7 10.7 4.7 10.7 4.7 10.8 4.7 10.8 4.7 10.8 4.7 10.8 4.7 10.8 4.7 10.8 4.7 10.8 4.7 10.9 4.7 10.9 4.7 10.9 4.7 10.9 4.7 10.9 4.7 10.9 4.7 11 4.7 11 4.7 11 4.7 11 4.7 11 4.7 11 4.7 11.1 4.7 11.1 4.7 11.1 4.7 11.1 4.7 11.1 4.7 11.1 4.7 11.1 4.7 11.2 4.7 11.2 4.7 11.2 4.7 11.2 4.7 11.2 4.7 11.2 4.7 11.3 4.7 11.3 4.7 11.3 4.7 11.3 4.7 11.3 4.7 11.3 4.7 11.3 4.7 11.4 4.7 11.4 4.7 11.4 4.7 11.4 4.7 11.4 4.7 11.4 4.7 11.5 4.7 11.5 4.7 11.5 4.7 11.5 4.7 11.5 4.7 11.5 4.7 11.6 4.7 11.6 4.7 11.6 4.7 11.6 4.7 11.6 4.7 11.6 4.7 11.6 4.7 11.7 4.7 11.7 4.7 11.7 4.7 11.7 4.7 11.7 4.7 11.7 4.7 11.8 4.7 11.8 4.7 11.8 4.7 11.8 4.7 11.8 4.7 11.8 4.7 11.9 4.7 11.9 4.7 11.9 4.7 11.9 4.7 11.9 4.7 11.9 4.7 11.9 4.7 12 4.7 12 4.7 12 4.7 12 4.7 12 13.5C12 13.6 12 13.6 12 13.7 12 13.8 12 13.8 12 13.8 12 13.9 12 13.9 12 13.9 12 13.9 12 13.9 11.9 14 11.9 14 11.9 14 11.9 14 11.9 14 11.9 14.1 11.9 14.1 11.9 14.1 11.9 14.1 11.9 14.1 11.9 14.1 11.9 14.2 11.9 14.2 11.9 14.2 11.9 14.2 11.9 14.2 11.9 14.2 11.9 14.2 11.9 14.2 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.7 14.4 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.5 11.7 14.6 11.7 14.6 11.7 14.6 11.7 14.6 11.7 14.6 11.7 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.6 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.6 14.7 11.5 14.7 11.5 14.7 11.5 14.7 11.5 14.7 11.5 14.7 11.5 14.7 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.5 14.8 11.4 14.8 11.4 14.8 11.4 14.8 11.4 14.8 11.4 14.8 11.4 14.8 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.4 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 14.9 11.3 15 11.3 15 11.3 15 11.3 15 11.3 15 11.3 15 11.3 15 11.3 15 11.3 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.1 15.1L11.1 15.1C11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11 15.1 11 15.1 11 15.1L11 15.1 11 15.1C11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 11 15.1 10.9 15.1 10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2L10.9 15.2 10.9 15.2C10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2 10.9 15.2 10.8 15.2L10.8 15.2 10.8 15.2C10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2 10.8 15.2L10.7 15.2 10.7 15.2C10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2 10.7 15.2L10.7 15.2C10.7 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2L10.6 15.2C10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.6 15.2 10.5 15.3 10.5 15.3 10.5 15.3 10.5 15.3L10.5 15.3C10.5 15.3 10.5 15.3 10.5 15.3 10.5 15.3 10.5 15.3 10.5 15.3L10.5 15.3 10.5 15.3C10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3 10.4 15.3L10.4 15.3C10.4 15.3 10.4 15.3 10.4 15.3L10.4 15.3 10.4 15.3 10.3 15.3 10.3 15.3 10.3 15.3 10.3 15.3 10.3 15.3 10.3 15.3 10.2 15.3 10.2 15.3 10.2 15.3 10.2 15.3 10.2 15.3 10.2 15.3 10.2 15.3 10.1 15.3 10.1 15.3 10.1 15.3 10.1 15.3 10.1 15.3 10.1 15.3 10 15.3 10 15.3 10 15.3 10 15.3 10 15.3 10 15.3 10 15.3 9.9 15.3 9.9 15.3 9.9 15.3 9.9 15.3 9.9 15.3 9.9 15.3 9.8 15.3 9.8 15.3 9.8 15.3 9.8 15.3 9.8 15.3 9.8 15.3 9.7 15.3 9.7 15.3 9.7 15.3 9.7 15.3 9.7 15.3 9.7 15.3 9.7 15.3 9.6 15.3 9.6 15.3 9.6 15.3 9.6 15.3 9.6 15.3 9.6 15.3 9.5 15.3 9.5 15.3 9.5 15.3 9.5 15.3 9.5 15.3 9.5 15.3 9.4 15.3 9.4 15.3 9.4 15.3 9.4 15.3 9.4 15.3 9.4 15.3 9.4 15.3 9.3 15.3 9.3 15.3 9.3 15.3 9.3 15.3 9.3 15.3 9.3 15.3 9.2 15.3 9.2 15.3 9.2 15.3 9.2 15.3 9.2 15.3 9.2 15.3 9.1 15.3 9.1 15.3 9.1 15.3 9.1 15.3 9.1 15.3 9.1 15.3 9.1 15.3 9 15.3 9 15.3 9 15.3 9 15.3 9 15.3 9 15.3 8.9 15.3 8.9 15.3 8.9 15.3 8.9 15.3 8.9 15.3 8.9 15.3 8.9 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.7 15.3 8.7 15.3 8.7 15.3 8.7 15.3 8.7 15.3 8.7 15.3 8.6 15.3 8.6 15.3 8.6 15.3 8.6 15.3 8.6 15.3 8.6 15.3 8.6 15.3 8.5 15.3 8.5 15.3 8.5 15.3 8.5 15.3 8.5 15.3 8.5 15.3 8.4 15.3 8.4 15.3 8.4 15.3 8.4 15.3 8.4 15.3 8.4 15.3 8.3 15.3 8.3 15.3 8.3 15.3 8.3 15.3 8.3 15.3 8.3 15.3 8.3 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.1 15.3 8.1 15.3 8.1 15.3 8.1 15.3 8.1 15.3 8.1 15.3 8 15.3 8 15.3 8 15.3 8 15.3 8 11.5C8 11.5 8 11.5 8 11.5L8 11.5 8 11.6 8.1 11.6 8.1 11.6 8.1 11.6 8.1 11.6 8.1 11.6 8.1 11.6 8.2 11.6 8.2 11.6 8.2 11.6 8.2 11.6 8.2 11.6 8.2 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.4 11.6 8.4 11.6 8.4 11.6 8.4 11.6 8.4 11.6 8.4 11.6 8.5 11.6 8.5 11.6 8.5 11.6 8.5 11.7 8.5 11.7 8.5 11.7 8.6 11.7 8.6 11.7 8.6 11.7 8.6 11.7 8.6 11.7 8.6 11.7 8.6 11.7 8.7 11.7 8.7 11.7 8.7 11.7 8.7 11.7 8.7 11.7 8.7 11.7 8.8 11.7 8.8 11.7 8.8 11.7 8.8 11.7 8.8 11.7 8.8 11.7 8.9 11.7 8.9 11.7 8.9 11.7 8.9 11.7 8.9 11.7 8.9 11.7 8.9 11.7 9 11.7 9 11.7 9 11.7 9 11.7 9 11.7 9 11.7 9.1 11.7 9.1 11.7 9.1 11.7 9.1 11.7 9.1 11.7 9.1 11.7 9.1 11.7 9.2 11.7 9.2 11.7 9.2 11.7 9.2 11.7 9.2 11.7 9.2 11.7 9.3 11.7 9.3 11.7 9.3 11.7 9.3 11.7 9.3 11.7 9.3 11.7 9.4 11.7 9.4 11.7 9.4 11.7 9.4 11.8 9.4 11.8 9.4 11.8 9.4 11.8 9.5 11.8 9.5 11.8 9.5 11.8 9.5 11.8 9.5 11.8 9.5 11.8 9.6 11.8 9.6 11.8 9.6 11.8 9.6 11.8 9.6 11.8 9.6 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.7 11.8 9.8 11.8 9.8 11.8 9.8 11.8 9.8 11.8 9.8 11.8 9.8 11.8 9.9 11.8 9.9 11.8 9.9 11.8 9.9 11.7 9.9 11.7 9.9 11.7 10 11.7 10 11.7 10 11.7 10 11.7 10 11.7 10 11.7 10 11.7 10.1 11.7 10.1 11.7 10.1 11.7 10.1 11.7 10.1 11.7 10.1 11.7 10.2 11.7 10.2 11.7 10.2 11.7 10.2 11.7 10.2 11.7 10.2 11.7 10.2 11.7 10.3 11.7 10.3 11.7 10.3 11.7 10.3 11.7C10.3 11.7 10.3 11.7 10.3 11.7L10.3 11.7 10.4 11.7 10.4 11.7C10.4 11.7 10.4 11.7 10.4 11.7L10.4 11.7C10.4 11.7 10.4 11.7 10.4 11.7 10.4 11.7 10.4 11.7 10.4 11.7L10.5 11.7 10.5 11.7 10.5 11.7C10.5 11.7 10.5 11.7 10.5 11.7L10.5 11.7 10.5 11.7C10.5 11.7 10.5 11.7 10.5 11.7L10.6 11.7C10.6 11.7 10.6 11.7 10.6 11.7 10.6 11.7 10.6 11.7 10.6 11.7L10.6 11.6C10.6 11.6 10.6 11.6 10.6 11.6 10.6 11.6 10.6 11.6 10.6 11.6L10.7 11.6C10.7 11.6 10.7 11.6 10.7 11.6 10.7 11.6 10.7 11.6 10.7 11.6L10.7 11.6C10.7 11.6 10.7 11.6 10.7 11.6L10.7 11.6 10.8 11.6C10.8 11.6 10.8 11.6 10.8 11.6L10.8 11.6 10.8 11.6C10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6L10.8 11.6C10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6L10.9 11.5 10.9 11.5C10.9 11.5 10.9 11.5 10.9 11.5 10.9 11.5 11 11.5 11 11.5L11 11.5 11 11.5C11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.3 11.2 11.3 11.2 11.3 11.2 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.3 11.2 11.3 11.2 11.3 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.2 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.4 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11.1 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 11 11.5 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.9 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.8 11.6 10.7 11.6 10.7 11.6 10.7 11.6 10.7 11.6 10.6 11.6 10.6 11.7 10.6 11.7 10.5 11.7 10.5 11.7 10.4 11.7 10.4 11.7 10.3L11.7 8.3 11.7 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.6 8.3 11.5 8.3 11.5 8.3 11.5 8.3 11.5 8.3 11.5 8.3 11.5 8.3 11.4 8.3 11.4 8.3 11.4 8.3 11.4 8.3 11.4 8.3 11.4 8.3 11.3 8.3 11.3 8.3 11.3 8.3 11.3 8.3 11.3 8.3 11.3 8.3 11.3 8.3 11.2 8.3 11.2 8.3 11.2 8.3 11.2 8.3 11.2 8.3 11.2 8.3 11.1 8.3 11.1 8.3 11.1 8.3 11.1 8.3 11.1 8.3 11.1 8.3 11.1 8.3 11 8.3 11 8.3 11 8.3 11 8.3 11 8.3 11 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.8 8.3 10.8 8.3 10.8 8.3 10.8 8.3 10.8 8.3 10.8 8.3 10.8 8.3 10.7 8.3 10.7 8.3 10.7 8.3 10.7 8.3 10.7 8.3 10.7 8.3 10.6 8.3 10.6 8.3 10.6 8.3 10.6 8.3 10.6 8.3 10.6 8.3 10.5 8.3 10.5 8.3 10.5 8.3 10.5 8.3 10.5 8.3 10.5 8.3 10.5 8.3 10.4 8.3 10.4 8.3 10.4 8.3 10.4 8.3 10.4 8.3 10.4 8.3 10.3 8.3 10.3 8.3 10.3 8.3 10.3 8.3 10.3 8.3 10.3 8.3 10.3 10.3C10.3 10.3 10.3 10.4 10.3 10.4 10.3 10.4 10.3 10.5 10.2 10.5 10.2 10.5 10.2 10.6 10.2 10.6 10.2 10.6 10.2 10.6 10.2 10.6 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.7 10.2 10.8 10.2 10.8 10.2 10.8 10.2 10.8 10.1 10.8 10.1 10.8 10.1 10.8 10.1 10.8 10.1 10.8 10.1 10.8 10.1 10.8 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10.1 10.9 10 10.9 10 10.9 10 10.9 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 10 11 9.9 11 9.9 11 9.9 11 9.9 11 9.9 11 9.9 11 9.9 11 9.9 11 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.9 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.8 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.1 9.7 11.2 9.7 11.2 9.7 11.2 9.7 11.2 9.7 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2L9.6 11.2C9.6 11.2 9.6 11.2 9.6 11.2 9.6 11.2 9.5 11.2 9.5 11.2L9.5 11.2C9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.5 11.2 9.4 11.2 9.4 11.2 9.4 11.2 9.4 11.2L9.4 11.2C9.4 11.2 9.4 11.2 9.4 11.2L9.4 11.2 9.4 11.2 9.4 11.2 9.4 11.2 9.3 11.2 9.3 11.2 9.3 11.2 9.3 11.2 9.3 11.2 9.3 11.2 9.2 11.2 9.2 11.2 9.2 11.2 9.2 11.2 9.2 11.2 9.2 11.2 9.1 11.2 9.1 11.2 9.1 11.2 9.1 11.2 9.1 11.2 9.1 11.2 9.1 11.2 9 11.2 9 11.2 9 11.2 9 11.2 9 11.1 9 11.1 8.9 11.1 8.9 11.1 8.9 11.1 8.9 11.1 8.9 11.1 8.9 11.1 8.9 11.1 8.8 11.1 8.8 11.1 8.8 11.1 8.8 11.1 8.8 11.1 8.8 11.1 8.7 11.1 8.7 11.1 8.7 11.1 8.7 11.1 8.7 11.1 8.7 11.1 8.6 11.1 8.6 11.1 8.6 11.1 8.6 11.1 8.6 11 8.6 11 8.6 11 8.5 11 8.5 11 8.5 11 8.5 11 8.5 11 8.5 11 8.4 11 8.4 11 8.4 11 8.4 11 8.4 11 8.4 11 8.3 11 8.3 11 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.9 8.3 10.9 8.2 10.9 8.2 10.9 8.2 10.9 8.2 10.9 8.2 10.9 8.2 10.9 8.1 10.9 8.1 10.9 8.1 10.9 8.1 10.8 8.1 10.8 8.1 10.8 8 10.8 8 10.8 8 10.8 8 10.8 8 10.8Z"
        fill="#006DBA"
      ></path>
      <path
        d="M12.5 8.7C12.5 8.7 12.5 8.7 12.5 8.7L12.5 6.4C12.5 6.3 12.5 6.2 12.5 6.1 12.5 6 12.5 6 12.5 6 12.6 6 12.6 6 12.6 5.9 12.6 5.9 12.6 5.9 12.6 5.9 12.6 5.9 12.6 5.8 12.6 5.8 12.6 5.8 12.6 5.8 12.6 5.8 12.6 5.8 12.6 5.8 12.6 5.7 12.6 5.7 12.6 5.7 12.6 5.7 12.6 5.7 12.7 5.7 12.7 5.7 12.7 5.7 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.6 12.7 5.5 12.7 5.5 12.7 5.5 12.7 5.5 12.7 5.5 12.7 5.5 12.7 5.5 12.7 5.5 12.8 5.5 12.8 5.5 12.8 5.5 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.4 12.8 5.3 12.8 5.3 12.8 5.3 12.8 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.3 12.9 5.2 12.9 5.2 12.9 5.2 12.9 5.2 12.9 5.2 12.9 5.2 12.9 5.2 12.9 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.2 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5.1 13.1 5 13.1 5 13.1 5 13.1 5 13.1 5 13.1 5 13.1 5 13.1 5 13.1 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 5 13.2 4.9 13.2 4.9 13.2 4.9 13.2 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.3 4.9 13.4 4.9 13.4 4.9 13.4 4.9 13.4 4.9 13.4 4.9 13.4 4.9L13.4 4.8 13.4 4.8C13.4 4.8 13.4 4.8 13.4 4.8 13.4 4.8 13.4 4.8 13.4 4.8 13.4 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8L13.5 4.8C13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.5 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.8 13.6 4.7 13.6 4.7L13.6 4.7C13.6 4.7 13.6 4.7 13.6 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7L13.7 4.7C13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.7 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7L13.8 4.7C13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7 13.8 4.7L13.8 4.7 13.9 4.7C13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7 13.9 4.7L13.9 4.7 13.9 4.7C13.9 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7L14 4.7C14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14 4.7 14.1 4.7L14.1 4.7C14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7 14.1 4.7L14.1 4.7 14.1 4.7 14.1 4.7 14.2 4.7 14.2 4.7 14.2 4.7 14.2 4.7 14.2 4.7 14.2 4.7 14.3 4.7 14.3 4.7 14.3 4.7 14.3 4.7 14.3 4.7 14.3 4.7 14.4 4.7 14.4 4.7 14.4 4.7 14.4 4.7 14.4 4.7 14.4 4.7 14.4 4.7 14.5 4.7 14.5 4.7 14.5 4.7 14.5 4.7 14.5 4.7 14.5 4.7 14.6 4.7 14.6 4.7 14.6 4.7 14.6 4.7 14.6 4.7 14.6 4.7 14.7 4.7 14.7 4.7 14.7 4.7 14.7 4.7 14.7 4.7 14.7 4.7 14.7 4.7 14.8 4.7 14.8 4.7 14.8 4.7 14.8 4.7 14.8 4.7 14.8 4.7 14.9 4.7 14.9 4.7 14.9 4.7 14.9 4.7 14.9 4.7 14.9 4.7 15 4.7 15 4.7 15 4.7 15 4.7 15 4.7 15 4.7 15 4.7 15.1 4.7 15.1 4.7 15.1 4.7 15.1 4.7 15.1 4.7 15.1 4.7 15.2 4.7 15.2 4.7 15.2 4.7 15.2 4.7 15.2 4.7 15.2 4.7 15.2 4.7 15.3 4.7 15.3 4.7 15.3 4.7 15.3 4.7 15.3 4.7 15.3 4.7 15.4 4.7 15.4 4.7 15.4 4.7 15.4 4.7 15.4 4.7 15.4 4.7 15.5 4.7 15.5 4.7 15.5 4.7 15.5 4.7 15.5 4.7 15.5 4.7 15.5 4.7 15.6 4.7 15.6 4.7 15.6 4.7 15.6 4.7 15.6 4.7 15.6 4.7 15.7 4.7 15.7 4.7 15.7 4.7 15.7 4.7 15.7 4.7 15.7 4.7 15.8 4.7 15.8 4.7 15.8 4.7 15.8 4.7 15.8 4.7 15.8 4.7 15.8 4.7 15.9 4.7 15.9 4.7 15.9 4.7 15.9 4.7 15.9 4.7 15.9 4.7 16 4.7 16 4.7 16 4.7 16 4.7 16 4.7 16 4.7 16.1 4.7 16.1 4.7 16.1 4.7 16.1 4.7 16.1 4.7 16.1 4.7 16.1 4.7 16.2 4.7 16.2 4.7 16.2 4.7 16.2 4.7 16.2 4.7 16.2 4.7 16.3 4.7 16.3 4.7 16.3 4.7 16.3 4.7 16.3 4.7 16.3 4.7 16.3 4.7 16.4 4.7 16.4 4.7 16.4 4.7 16.4 4.7 16.4 4.7 16.4 4.7 16.5 4.7 16.5 4.7 16.5 4.7 16.5 4.7 16.5 4.7 16.5 13.5C16.5 13.6 16.5 13.6 16.5 13.7 16.5 13.8 16.5 13.8 16.5 13.8 16.5 13.9 16.5 13.9 16.5 13.9 16.5 13.9 16.5 13.9 16.5 14 16.5 14 16.4 14 16.4 14 16.4 14 16.4 14.1 16.4 14.1 16.4 14.1 16.4 14.1 16.4 14.1 16.4 14.1 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.2 16.4 14.3 16.4 14.3 16.3 14.3 16.3 14.3 16.3 14.3 16.3 14.3 16.3 14.3 16.3 14.3 16.3 14.3 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.4 16.3 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.5 16.2 14.6 16.2 14.6 16.2 14.6 16.2 14.6 16.2 14.6 16.2 14.6 16.2 14.6 16.2 14.6 16.1 14.6 16.1 14.6 16.1 14.6 16.1 14.6 16.1 14.6 16.1 14.6 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16.1 14.7 16 14.7 16 14.7 16 14.7 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 16 14.8 15.9 14.8 15.9 14.8 15.9 14.8 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.9 14.9 15.8 14.9 15.8 14.9 15.8 14.9 15.8 14.9 15.8 14.9 15.8 14.9 15.8 14.9 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.8 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15 15.7 15L15.7 15 15.7 15.1 15.6 15.1C15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.6 15.1 15.5 15.1L15.5 15.1 15.5 15.1 15.5 15.1C15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.1 15.5 15.2 15.4 15.2 15.4 15.2 15.4 15.2L15.4 15.2 15.4 15.2C15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2 15.4 15.2L15.3 15.2 15.3 15.2C15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2 15.3 15.2L15.2 15.2 15.2 15.2C15.2 15.2 15.2 15.2 15.2 15.2 15.2 15.2 15.2 15.2 15.2 15.2L15.2 15.2 15.2 15.2C15.2 15.2 15.2 15.2 15.2 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2L15.1 15.2C15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.2 15.1 15.3 15.1 15.3 15 15.3 15 15.3L15 15.3C15 15.3 15 15.3 15 15.3 15 15.3 15 15.3 15 15.3L15 15.3 15 15.3C15 15.3 15 15.3 15 15.3 14.9 15.3 14.9 15.3 14.9 15.3 14.9 15.3 14.9 15.3 14.9 15.3L14.9 15.3C14.9 15.3 14.9 15.3 14.9 15.3L14.9 15.3 14.9 15.3 14.9 15.3 14.8 15.3 14.8 15.3 14.8 15.3 14.8 15.3 14.8 15.3 14.8 15.3 14.7 15.3 14.7 15.3 14.7 15.3 14.7 15.3 14.7 15.3 14.7 15.3 14.7 15.3 14.6 15.3 14.6 15.3 14.6 15.3 14.6 15.3 14.6 15.3 14.6 15.3 14.5 15.3 14.5 15.3 14.5 15.3 14.5 15.3 14.5 15.3 14.5 15.3 14.4 15.3 14.4 15.3 14.4 15.3 14.4 15.3 14.4 15.3 14.4 15.3 14.4 15.3 14.3 15.3 14.3 15.3 14.3 15.3 14.3 15.3 14.3 15.3 14.3 15.3 14.2 15.3 14.2 15.3 14.2 15.3 14.2 15.3 14.2 15.3 14.2 15.3 14.1 15.3 14.1 15.3 14.1 15.3 14.1 15.3 14.1 15.3 14.1 15.3 14.1 15.3 14 15.3 14 15.3 14 15.3 14 15.3 14 15.3 14 15.3 13.9 15.3 13.9 15.3 13.9 15.3 13.9 15.3 13.9 15.3 13.9 15.3 13.8 15.3 13.8 15.3 13.8 15.3 13.8 15.3 13.8 15.3 13.8 15.3 13.8 15.3 13.7 15.3 13.7 15.3 13.7 15.3 13.7 15.3 13.7 15.3 13.7 15.3 13.6 15.3 13.6 15.3 13.6 15.3 13.6 15.3 13.6 15.3 13.6 15.3 13.6 15.3 13.5 15.3 13.5 15.3 13.5 15.3 13.5 15.3 13.5 15.3 13.5 15.3 13.4 15.3 13.4 15.3 13.4 15.3 13.4 15.3 13.4 15.3 13.4 15.3 13.3 15.3 13.3 15.3 13.3 15.3 13.3 15.3 13.3 15.3 13.3 15.3 13.3 15.3 13.2 15.3 13.2 15.3 13.2 15.3 13.2 15.3 13.2 15.3 13.2 15.3 13.1 15.3 13.1 15.3 13.1 15.3 13.1 15.3 13.1 15.3 13.1 15.3 13 15.3 13 15.3 13 15.3 13 15.3 13 15.3 13 15.3 13 15.3 12.9 15.3 12.9 15.3 12.9 15.3 12.9 15.3 12.9 15.3 12.9 15.3 12.8 15.3 12.8 15.3 12.8 15.3 12.8 15.3 12.8 15.3 12.8 15.3 12.7 15.3 12.7 15.3 12.7 15.3 12.7 15.3 12.7 15.3 12.7 15.3 12.7 15.3 12.6 15.3 12.6 15.3 12.6 15.3 12.6 15.3 12.6 15.3 12.6 15.3 12.5 15.3 12.5 15.3 12.5 15.3 12.5 11.2C12.5 11.2 12.5 11.2 12.5 11.2 12.5 11.2 12.5 11.2 12.5 11.2 12.6 11.2 12.6 11.2 12.6 11.2 12.6 11.2 12.6 11.2 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3 12.6 11.3L12.6 11.3C12.6 11.3 12.7 11.3 12.7 11.3L12.7 11.3C12.7 11.3 12.7 11.3 12.7 11.3 12.7 11.3 12.7 11.3 12.7 11.3L12.7 11.4C12.7 11.4 12.7 11.4 12.7 11.4 12.7 11.4 12.7 11.4 12.7 11.4L12.8 11.4 12.8 11.4 12.8 11.4C12.8 11.4 12.8 11.4 12.8 11.4 12.8 11.4 12.8 11.4 12.8 11.4L12.8 11.4 12.9 11.4 12.9 11.4C12.9 11.4 12.9 11.4 12.9 11.5L12.9 11.5 12.9 11.5 12.9 11.5 13 11.5 13 11.5 13 11.5 13 11.5 13 11.5 13 11.5 13 11.5C13.1 11.5 13.1 11.5 13.1 11.5L13.1 11.5C13.1 11.5 13.1 11.5 13.1 11.5 13.1 11.5 13.1 11.5 13.1 11.5L13.1 11.6 13.1 11.6C13.1 11.6 13.2 11.6 13.2 11.6 13.2 11.6 13.2 11.6 13.2 11.6L13.2 11.6 13.2 11.6 13.2 11.6 13.2 11.6 13.3 11.6 13.3 11.6 13.3 11.6 13.3 11.6 13.3 11.6 13.3 11.6 13.3 11.6 13.4 11.6 13.4 11.6 13.4 11.6 13.4 11.6 13.4 11.6 13.4 11.6 13.5 11.7 13.5 11.7 13.5 11.7 13.5 11.7 13.5 11.7 13.5 11.7 13.6 11.7 13.6 11.7 13.6 11.7 13.6 11.7 13.6 11.7 13.6 11.7 13.6 11.7 13.7 11.7 13.7 11.7 13.7 11.7 13.7 11.7 13.7 11.7 13.7 11.7 13.8 11.7 13.8 11.7 13.8 11.7 13.8 11.7 13.8 11.7 13.8 11.7 13.8 11.7 13.9 11.7 13.9 11.7 13.9 11.7 13.9 11.7 13.9 11.7 13.9 11.7 14 11.7 14 11.7 14 11.7 14 11.7 14 11.7 14 11.7 14.1 11.7 14.1 11.7 14.1 11.7 14.1 11.7 14.1 11.7 14.1 11.7 14.1 11.7 14.2 11.7 14.2 11.7 14.2 11.7 14.2 11.8 14.2 11.8 14.2 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.3 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.4 11.8 14.5 11.8 14.5 11.8 14.5 11.8 14.5 11.8 14.5 11.8 14.5 11.8 14.6 11.8 14.6 11.8 14.6 11.8 14.6 11.8 14.6 11.8 14.6 11.8 14.7 11.8 14.7 11.8 14.7 11.8 14.7 11.8 14.7 11.8 14.7 11.7 14.7 11.7 14.8 11.7 14.8 11.7 14.8 11.7 14.8 11.7 14.8 11.7 14.8 11.7 14.8 11.7 14.9 11.7 14.9 11.7 14.9 11.7 14.9 11.7 14.9 11.7 14.9 11.7 15 11.7 15 11.7 15 11.7 15 11.7 15 11.7 15 11.7 15 11.7 15.1 11.7 15.1 11.7 15.1 11.7 15.1 11.7 15.1 11.7 15.1 11.7 15.2 11.7 15.2 11.7 15.2 11.7 15.2 11.7 15.2 11.7 15.2 11.7 15.2 11.7 15.3 11.7 15.3 11.7 15.3 11.7 15.3 11.7 15.3 11.7 15.3 11.7 15.4 11.7 15.4 11.7 15.4 11.7 15.4 11.7 15.4 11.7 15.4 11.7 15.5 11.7 15.5 11.7 15.5 11.7 15.5 11.7 15.5 11.7 15.5 11.7 15.5 11.7 15.6 11.6 15.6 11.6 15.6 11.6 15.6 11.6 15.6 11.6 15.6 11.6 15.7 11.6 15.7 11.6 15.7 11.6 15.7 11.6 15.7 11.6 15.7 11.6 15.8 11.6 15.8 11.6 15.8 11.6 15.8 11.6 15.8 11.6 15.8 11.6 15.8 11.6 15.9 11.6 15.9 11.6 15.9 11.6 15.9 11.6 15.9 11.6 15.9 11.6 16 11.6 16 11.6 16 11.6 16 11.6 16 11.5 16 11.5 16.1 11.5 16.1 11.5 16.1 10.8 16.1 10.8 16 10.8 16 10.8 16 10.8 16 10.8 16 10.8 16 10.8 15.9 10.9 15.9 10.9 15.9 10.9 15.9 10.9 15.9 10.9 15.9 10.9 15.8 10.9 15.8 10.9 15.8 10.9 15.8 10.9 15.8 10.9 15.8 10.9 15.8 10.9 15.7 10.9 15.7 11 15.7 11 15.7 11 15.7 11 15.7 11 15.6 11 15.6 11 15.6 11 15.6 11 15.6 11 15.6 11 15.5 11 15.5 11 15.5 11 15.5 11 15.5 11 15.5 11.1 15.5 11.1 15.4 11.1 15.4 11.1 15.4 11.1 15.4 11.1 15.4 11.1 15.4 11.1 15.3 11.1 15.3 11.1 15.3 11.1 15.3 11.1 15.3 11.1 15.3 11.1 15.2 11.1 15.2 11.1 15.2 11.1 15.2 11.1 15.2 11.1 15.2 11.1 15.2 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.1 15.1 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 15 11.2 14.9 11.2 14.9 11.2 14.9 11.2 14.9 11.2 14.9 11.2 14.9 11.2 14.8 11.2 14.8 11.2 14.8 11.2 14.8 11.2 14.8 11.2 14.8 11.2 14.8 11.2 14.7 11.2 14.7 11.2 14.7 11.2 14.7 11.2 14.7 11.2 14.7 11.2C14.7 11.2 14.7 11.2 14.7 11.2L14.6 11.2 14.6 11.2 14.6 11.2 14.6 11.2C14.6 11.2 14.6 11.2 14.6 11.2 14.6 11.2 14.6 11.2 14.6 11.2L14.5 11.2 14.5 11.2 14.5 11.2 14.5 11.2C14.5 11.2 14.5 11.2 14.5 11.2 14.5 11.2 14.5 11.2 14.5 11.2L14.4 11.2 14.4 11.2 14.4 11.2 14.4 11.2 14.4 11.2C14.4 11.2 14.4 11.2 14.4 11.2 14.4 11.2 14.4 11.2 14.4 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.2 14.3 11.1 14.3 11.1 14.3 11.1 14.3 11.1 14.3 11.1 14.3 11.1 14.3 11.1 14.3 11.1L14.2 11.1C14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.2 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14.1 11.1 14 11.1 14 11.1 14 11.1 14 11.1 14 11.1 14 11.1 14 11.1 14 11.1 14 11 14 11 14 11 14 11 14 11 14 11 14 11 14 11 14 11 14 11 14 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.9 11 13.8 11 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.8 10.9 13.7 10.9 13.7 10.9 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.7 10.8 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.7 13.6 10.6 13.6 10.6 13.6 10.6 13.6 10.6 13.6 10.6 13.6 10.6 13.6 10.6 13.5 10.6 13.5 10.6 13.5 10.6 13.5 10.5 13.5 10.5 13.5 10.5 13.5 10.5 13.5 10.5 13.5 10.5 13.5 10.5 13.5 10.4 13.5 10.4 13.5 10.4 13.5 10.4 13.5 10.4 13.5 10.4 13.5 10.3 13.5 10.3 13.5 10.3 13.4 10.3 13.4 10.2 13.4 10.2 13.4 10.2 13.4 10.1 13.4 10.1 13.4 10 13.4 10 13.4 9.9 13.4 9.9 13.4 9.8 13.4 9.8 13.4 9.7 13.4 9.7 13.4 9.7 13.5 9.6 13.5 9.6 13.5 9.6 13.5 9.6 13.5 9.5 13.5 9.5 13.5 9.5 13.5 9.5 13.5 9.5 13.5 9.5 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.4 13.5 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.3 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.6 9.2 13.7 9.2 13.7 9.2 13.7 9.2 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.7 9.1 13.8 9.1 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.8 9 13.9 9 13.9 9 13.9 9 13.9 9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 13.9 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14 8.9 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.1 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8L14.2 8.8C14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8 14.2 8.8L14.3 8.8C14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.3 8.8 14.4 8.8 14.4 8.8 14.4 8.8 14.4 8.8L14.4 8.8 14.4 8.7 14.4 8.7 14.4 8.7 14.4 8.7 14.5 8.7C14.5 8.7 14.5 8.7 14.5 8.7 14.5 8.7 14.5 8.7 14.5 8.7L14.5 8.7 14.5 8.7 14.5 8.7 14.6 8.7C14.6 8.7 14.6 8.7 14.6 8.7 14.6 8.7 14.6 8.7 14.6 8.7L14.6 8.7 14.6 8.7 14.6 8.7 14.7 8.7C14.7 8.7 14.7 8.7 14.7 8.7L14.7 8.7 14.7 8.7 14.7 8.7 14.7 8.7 14.7 8.7 14.8 8.7 14.8 8.7 14.8 8.7 14.8 8.7 14.8 8.7 14.8 8.7 14.8 8.7 14.9 8.7 14.9 8.7 14.9 8.7 14.9 8.7 14.9 8.7 14.9 8.7 15 8.8 15 8.8 15 8.8 15 8.8 15 8.8 15 8.8 15 8.8 15.1 8.8 15.1 8.8 15.1 8.8 15.1 8.8 15.1 8.8 15.1 8.8 15.2 8.8 15.2 8.8 15.2 8.8 15.2 8.8 15.2 8.8 15.2 8.8 15.2 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.3 8.8 15.4 8.8 15.4 8.8 15.4 8.8 15.4 8.8 15.4 8.9 15.4 8.9 15.5 8.9 15.5 8.9 15.5 8.9 15.5 8.9 15.5 8.9 15.5 8.9 15.5 8.9 15.6 8.9 15.6 8.9 15.6 8.9 15.6 8.9 15.6 8.9 15.6 8.9 15.7 8.9 15.7 8.9 15.7 8.9 15.7 9 15.7 9 15.7 9 15.8 9 15.8 9 15.8 9 15.8 9 15.8 9 15.8 9 15.8 9 15.9 9 15.9 9 15.9 9 15.9 9 15.9 9.1 15.9 9.1 16 9.1 16 9.1 16 9.1 16 9.1 16 9.1 16 9.1 16.1 9.1 16.1 9.1 16.1 8.4 16.1 8.4 16 8.4 16 8.4 16 8.4 16 8.4 16 8.4 16 8.4 15.9 8.3 15.9 8.3 15.9 8.3 15.9 8.3 15.9 8.3 15.9 8.3 15.8 8.3 15.8 8.3 15.8 8.3 15.8 8.3 15.8 8.3 15.8 8.3 15.8 8.3 15.7 8.3 15.7 8.3 15.7 8.3 15.7 8.3 15.7 8.3 15.7 8.3 15.6 8.3 15.6 8.3 15.6 8.3 15.6 8.3 15.6 8.3 15.6 8.3 15.5 8.3 15.5 8.3 15.5 8.3 15.5 8.3 15.5 8.3 15.5 8.3 15.5 8.2 15.4 8.2 15.4 8.2 15.4 8.2 15.4 8.2 15.4 8.2 15.4 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.3 8.2 15.2 8.2 15.2 8.2 15.2 8.2 15.2 8.2 15.2 8.2 15.2 8.2 15.2 8.2 15.1 8.2 15.1 8.2 15.1 8.2 15.1 8.2 15.1 8.2 15.1 8.2 15 8.2 15 8.2 15 8.2 15 8.2 15 8.2 15 8.2 15 8.2 14.9 8.2 14.9 8.2 14.9 8.2 14.9 8.2 14.9 8.2 14.9 8.2 14.8 8.2 14.8 8.2 14.8 8.2 14.8 8.2 14.8 8.2 14.8 8.2 14.8 8.2 14.7 8.2 14.7 8.2 14.7 8.2 14.7 8.2 14.7 8.2 14.7 8.2 14.7 8.2 14.6 8.2 14.6 8.2 14.6 8.2 14.6 8.2 14.6 8.2 14.6 8.2 14.5 8.2 14.5 8.2 14.5 8.2 14.5 8.2 14.5 8.2 14.5 8.2 14.4 8.2 14.4 8.2 14.4 8.2 14.4 8.2 14.4 8.2 14.4 8.2 14.4 8.2 14.3 8.2 14.3 8.2 14.3 8.2 14.3 8.2 14.3 8.2 14.3 8.2 14.2 8.2 14.2 8.2 14.2 8.2 14.2 8.2 14.2 8.2 14.2 8.2 14.1 8.2 14.1 8.2 14.1 8.2 14.1 8.2 14.1 8.2 14.1 8.2 14.1 8.2 14 8.2 14 8.2 14 8.2 14 8.2 14 8.2 14 8.2 13.9 8.2 13.9 8.2 13.9 8.2 13.9 8.2 13.9 8.2 13.9 8.2 13.8 8.2 13.8 8.2 13.8 8.2 13.8 8.2 13.8 8.2 13.8 8.2 13.8 8.2 13.7 8.2 13.7 8.2 13.7 8.2 13.7 8.2 13.7 8.2 13.7 8.2 13.6 8.2 13.6 8.2 13.6 8.2 13.6 8.2 13.6 8.2 13.6 8.2 13.6 8.2 13.5 8.2 13.5 8.3 13.5 8.3 13.5 8.3 13.5 8.3 13.5 8.3 13.4 8.3 13.4 8.3 13.4 8.3 13.4 8.3 13.4 8.3 13.4 8.3 13.3 8.3 13.3 8.3 13.3 8.3 13.3 8.3 13.3 8.3 13.3 8.3 13.3 8.3 13.2 8.3 13.2 8.3 13.2 8.3 13.2 8.3 13.2 8.3C13.2 8.3 13.2 8.4 13.2 8.4L13.1 8.4C13.1 8.4 13.1 8.4 13.1 8.4L13.1 8.4 13.1 8.4C13.1 8.4 13.1 8.4 13.1 8.4 13.1 8.4 13.1 8.4 13.1 8.4L13 8.4C13 8.4 13 8.4 13 8.4L13 8.4 13 8.4 13 8.4 13 8.4 13 8.4 12.9 8.4 12.9 8.5 12.9 8.5 12.9 8.5C12.9 8.5 12.9 8.5 12.9 8.5L12.9 8.5 12.8 8.5 12.8 8.5C12.8 8.5 12.8 8.5 12.8 8.5 12.8 8.5 12.8 8.5 12.8 8.5L12.8 8.5 12.8 8.5C12.8 8.5 12.8 8.5 12.7 8.5 12.7 8.5 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6 12.7 8.6L12.7 8.6C12.7 8.6 12.6 8.6 12.6 8.6L12.6 8.6C12.6 8.6 12.6 8.6 12.6 8.6 12.6 8.6 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.6 8.7 12.5 8.7 12.5 8.7 12.5 8.7 12.5 8.7L12.5 8.7 12.5 8.7Z"
        fill="#E30138"
      />
    </g>
  </symbol>

  <symbol id="card-apple-pay-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Apple24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <g id="Apple-Pay" fill="#000000">
        <g id="Apple_Pay_logo-Copy" transform="translate(6.000000, 8.000000)">
          <path
            d="M3.729375,1.09170616 C3.4903125,1.37772512 3.1078125,1.60331754 2.7253125,1.57109005 C2.6775,1.18436019 2.86476563,0.773459715 3.08390625,0.519668245 C3.32296875,0.225592417 3.74132813,0.0161137441 4.08,0 C4.11984375,0.402843602 3.96445312,0.79763033 3.729375,1.09170616 L3.729375,1.09170616 Z M4.07601563,1.64763033 C3.5221875,1.61540285 3.04804688,1.96587678 2.78507813,1.96587678 C2.518125,1.96587678 2.11570313,1.66374408 1.67742188,1.67180095 C1.10765625,1.67985782 0.577734375,2.00616114 0.286875,2.52582939 C-0.31078125,3.56516588 0.131484375,5.10402845 0.70921875,5.95 C0.992109375,6.36895735 1.33078125,6.82819905 1.77703125,6.8120853 C2.199375,6.79597155 2.36671875,6.5341232 2.87671875,6.5341232 C3.39070312,6.5341232 3.538125,6.8120853 3.984375,6.80402845 C4.4465625,6.79597155 4.73742187,6.3850711 5.0203125,5.96611375 C5.3430469,5.4907583 5.47453125,5.02748815 5.4825,5.00331755 C5.47453125,4.99526067 4.59,4.6528436 4.58203125,3.62156398 C4.5740625,2.75947868 5.2792969,2.3485782 5.3111719,2.32440759 C4.91273438,1.72819905 4.29117187,1.66374408 4.07601563,1.64763033 L4.07601563,1.64763033 Z M7.27546875,0.479383886 L7.27546875,6.75971565 L8.2396875,6.75971565 L8.2396875,4.61255924 L9.5744531,4.61255924 C10.7936719,4.61255924 11.6503125,3.76658768 11.6503125,2.54194313 C11.6503125,1.31729858 10.8096094,0.479383886 9.6063281,0.479383886 L7.27546875,0.479383886 Z M8.2396875,1.30118483 L9.3513281,1.30118483 C10.1880468,1.30118483 10.6661718,1.75236967 10.6661718,2.54597156 C10.6661718,3.33957346 10.1880468,3.79478673 9.34734375,3.79478673 L8.2396875,3.79478673 L8.2396875,1.30118483 L8.2396875,1.30118483 Z M13.4114062,6.80805685 C14.0170312,6.80805685 14.5788281,6.4978673 14.8338281,6.0063981 L14.85375,6.0063981 L14.85375,6.75971565 L15.74625,6.75971565 L15.74625,3.63364929 C15.74625,2.72725119 15.0290625,2.14312796 13.9253906,2.14312796 C12.9014062,2.14312796 12.144375,2.73530806 12.1164843,3.54905214 L12.9850781,3.54905214 C13.0567968,3.16232228 13.4114062,2.90853081 13.8975,2.90853081 C14.4871875,2.90853081 14.8178906,3.18649289 14.8178906,3.69810427 L14.8178906,4.04454977 L13.6146093,4.11706161 C12.495,4.18554502 11.889375,4.64881517 11.889375,5.45450235 C11.889375,6.26824645 12.5149218,6.80805685 13.4114062,6.80805685 Z M13.6703906,6.0627962 C13.1564062,6.0627962 12.8296875,5.8130332 12.8296875,5.43033175 C12.8296875,5.035545 13.1444531,4.80592417 13.7460937,4.76966825 L14.8178906,4.70118484 L14.8178906,5.0556872 C14.8178906,5.64383885 14.3238281,6.0627962 13.6703906,6.0627962 Z M16.9375781,8.4677725 C17.8778906,8.4677725 18.3201562,8.10521325 18.7066406,7.00545025 L20.4,2.2035545 L19.4198437,2.2035545 L18.2842968,5.9137441 L18.264375,5.9137441 L17.1288281,2.2035545 L16.1207812,2.2035545 L17.754375,6.7758294 L17.6667187,7.05379145 C17.5192968,7.5251185 17.2802343,7.7063981 16.8539062,7.7063981 C16.7782031,7.7063981 16.6307812,7.69834125 16.5710156,7.69028435 L16.5710156,8.4436019 C16.6267969,8.45971565 16.8658593,8.4677725 16.9375781,8.4677725 Z"
            id="XMLID_34_"
          ></path>
        </g>
      </g>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
    </g>
  </symbol>

  <symbol id="card-google-pay-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Google24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <g
        id="Google_Pay_(GPay)_Logo-Copy"
        transform="translate(5.000000, 8.000000)"
      >
        <path
          d="M9.7289646,3.91222857 L9.7289646,6.23222855 L8.9693316,6.23222855 L8.9693316,0.502857145 L10.9840105,0.502857145 C11.4697384,0.49302651 11.9393965,0.67158903 12.2885976,0.998857145 C12.6419089,1.30676951 12.8405996,1.74762416 12.8335517,2.208 C12.8436711,2.67094721 12.6446263,3.11509194 12.2885976,3.424 C11.9363041,3.74948572 11.5014417,3.91207619 10.9840105,3.91177143 L9.7289646,3.91177143 L9.7289646,3.91222857 Z M9.7289646,1.20822857 L9.7289646,3.20822857 L11.0028833,3.20822857 C11.2852776,3.21633876 11.5581311,3.10880057 11.7544954,2.912 C11.9496683,2.7281517 12.0597826,2.47562673 12.0597826,2.21188572 C12.0597826,1.94814471 11.9496683,1.69561974 11.7544954,1.51177143 C11.5605127,1.31074129 11.2868124,1.20003939 11.0028833,1.20777143 L9.7289646,1.20777143 L9.7289646,1.20822857 Z"
          id="Shape"
          fill="#3C4043"
        ></path>
        <path
          d="M14.5840105,2.18422857 C15.1454784,2.18422857 15.5886763,2.3296 15.9136042,2.62034286 C16.2385321,2.91108572 16.4008388,3.30971429 16.4005252,3.81622857 L16.4005252,6.23222855 L15.6739188,6.23222855 L15.6739188,5.68822855 L15.6408912,5.68822855 C15.3263434,6.13622855 14.9079948,6.36022855 14.3858454,6.36022855 C13.9401311,6.36022855 13.5672346,6.23222855 13.267156,5.97622855 C12.9755068,5.7382726 12.8101432,5.3855894 12.817038,5.01622855 C12.817038,4.61059048 12.9752556,4.288 13.2916907,4.04845715 C13.6081258,3.80891429 14.0305636,3.68883809 14.559004,3.68822857 C15.0100656,3.68822857 15.3815466,3.76822857 15.6734469,3.92822857 L15.6734469,3.76 C15.6751888,3.50821138 15.5599775,3.26901078 15.3596855,3.10857143 C15.1588056,2.93297282 14.8970102,2.83716011 14.6264745,2.84022857 C14.2021494,2.84022857 13.8663696,3.0136381 13.619135,3.36045714 L12.9500918,2.95222857 C13.3181127,2.44022857 13.8627523,2.18422857 14.5840105,2.18422857 Z M13.601189,5.03222855 C13.6001724,5.22228175 13.6940315,5.40109435 13.8531586,5.51222855 C14.0211639,5.640272 14.2296912,5.70810305 14.4434076,5.70422855 C14.7639611,5.70370955 15.0712293,5.5800889 15.2978768,5.36045715 C15.5495151,5.13097145 15.6753342,4.86171429 15.6753342,4.55268572 C15.4384797,4.36982857 15.1082045,4.2784 14.6845085,4.2784 C14.3759371,4.2784 14.118637,4.35047619 13.9126082,4.49462857 C13.7045348,4.64091429 13.601189,4.81874286 13.601189,5.03222855 L13.601189,5.03222855 Z"
          id="Shape"
          fill="#3C4043"
        ></path>
        <polygon
          id="Path"
          fill="#3C4043"
          points="20.5714286 2.31222857 18.0349148 7.96022855 17.2507471 7.96022855 18.1920315 5.984 16.5241415 2.31222857 17.3498296 2.31222857 18.5553342 5.12822855 18.5718479 5.12822855 19.7443251 2.31222857"
        ></polygon>
        <path
          d="M6.65929838,3.41211428 C6.6595787,3.18781805 6.640005,2.96391143 6.60078635,2.74285714 L3.39711665,2.74285714 L3.39711665,4.01051429 L5.23203145,4.01051429 C5.1561583,4.41963524 4.91106202,4.78096118 4.55355177,5.01074285 L4.55355177,5.8336 L5.64865005,5.8336 C6.28985585,5.2608 6.65929838,4.41371429 6.65929838,3.41211428 Z"
          id="Path"
          fill="#4285F4"
        ></path>
        <path
          d="M3.39711664,6.62857145 C4.31386631,6.62857145 5.0857667,6.3369143 5.64865005,5.83405715 L4.55355177,5.0112 C4.24875491,5.21142855 3.85619921,5.3257143 3.39711664,5.3257143 C2.51103538,5.3257143 1.7589515,4.74697143 1.4900131,3.96708572 L0.361887287,3.96708572 L0.361887287,4.81508572 C0.93852608,5.9268375 2.1129226,6.6285147 3.39711664,6.62857145 Z"
          id="Path"
          fill="#34A853"
        ></path>
        <path
          d="M1.49001311,3.96708571 C1.34783502,3.55842029 1.34783502,3.11586542 1.49001311,2.7072 L1.49001311,1.8592 L0.361887287,1.8592 C-0.120422662,2.78908704 -0.120422662,3.88519867 0.361887287,4.81508572 L1.49001311,3.96708571 Z"
          id="Path"
          fill="#FBBC04"
        ></path>
        <path
          d="M3.39711664,1.34857143 C3.88157733,1.34090286 4.34969497,1.51825199 4.70028833,1.84228572 L4.70028833,1.84228572 L5.66988205,0.902857145 C5.0550587,0.343348943 4.24055426,0.0361695723 3.39711664,0.0457142857 C2.1129226,0.0457709932 0.93852608,0.74744822 0.361887287,1.8592 L1.4900131,2.7072 C1.7589515,1.92731429 2.51103538,1.34857143 3.39711664,1.34857143 Z"
          id="Path"
          fill="#EA4335"
        ></path>
      </g>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
    </g>
  </symbol>

  <symbol id="card-paypal-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/PayPal24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="PayPal">
        <g id="Group" transform="translate(11.000000, 6.000000)">
          <path
            d="M2.2209645,-1.31450406e-13 L5.6330079,-1.31450406e-13 C6.59398955,-1.31450406e-13 7.7337421,0.0312321228 8.49624575,0.70364653 C9.0055493,1.15286123 9.2728259,1.86856072 9.21106545,2.63687094 C9.00185425,5.2422458 7.4434153,6.70153375 5.3535904,6.70153375 L3.67075083,6.70153375 C3.38438306,6.70153375 3.19452694,6.8913019 3.11376331,7.40535625 L2.64413776,10.3925548 C2.61369744,10.5863699 2.52967863,10.7005651 2.37633331,10.7143776 L0.274455435,10.7143776 C0.0412262591,10.7143776 -0.0416488384,10.5359586 0.0193197843,10.1495601 L1.53289004,0.566841035 C1.59350675,0.18281789 1.80359776,-1.31450406e-13 2.2209645,-1.31450406e-13"
            id="Fill-1"
            fill="#1B3D92"
          ></path>
          <path
            d="M4.41532042,3 L7.8239327,3 C9.65387115,3 10.3429134,3.92631837 10.2365482,5.28953455 C10.0611205,7.53675175 8.70239115,8.77935035 6.90025365,8.77935035 L5.9902992,8.77935035 C5.74334545,8.77935035 5.5771554,8.94263715 5.50985235,9.38639725 L5.1195828,11.9625635 C5.0942452,12.1298973 5.00626735,12.2281685 4.87403672,12.2401335 L2.73670379,12.2401335 C2.53558652,12.2401335 2.46406056,12.0862603 2.51667129,11.7530004 L3.82191008,3.4888927 C3.8741689,3.15765624 4.05531522,3 4.41532042,3"
            id="Fill-1"
            fill="#00A2D3"
          ></path>
          <path
            d="M3,7.2601759 L3.59578573,3.48883111 C3.64813253,3.15768263 3.82936682,3.00002639 4.18937202,3.00002639 L7.5979843,3.00002639 C8.162274,3.00002639 8.618087,3.08809218 8.9753649,3.25032327 C8.6328673,5.5691544 7.13310955,6.85750145 5.16926885,6.85750145 L3.48634134,6.85750145 C3.26490118,6.85750145 3.09941493,6.9707289 3,7.2601759"
            id="Page-1"
            fill="#1B2E7F"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="card-venmo-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Venmo24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <g id="venmo"></g>
      <path
        d="M21.3250791,6 C21.7902741,6.72040091 22,7.46241496 22,8.39973124 C22,11.3892886 19.2782212,15.272936 17.0691721,18 L12.0235683,18 L10,6.6545536 L14.4179788,6.26126151 L15.4878675,14.3342759 C16.4875291,12.8072454 17.7211617,10.4075142 17.7211617,8.77141017 C17.7211617,7.87586439 17.5575373,7.2658809 17.3018293,6.7636272 L21.3250791,6 Z"
        id="Path"
        fill="#3D95CE"
      ></path>
    </g>
  </symbol>

  <symbol id="card-bank-transfer-icon" viewBox="0 0 32 24">
    <g
      id="logo*/PaymentCards/Bank24"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="32" height="24"></rect>
      <rect
        id="Border"
        stroke="#EAEAEA"
        x="0.5"
        y="0.5"
        width="31"
        height="23"
      ></rect>
      <text
        id="Bank"
        font-family="EuclidSquare-Medium, Euclid Square"
        font-size="8"
        font-weight="400"
        fill="#000000"
      >
        <tspan x="6" y="15">Bank</tspan>
      </text>
    </g>
  </symbol>

  <symbol id="ribbon-icon" viewBox="0 0 25 32">
    <g>
      <path
        d="M21.2981932,28.9398329 L17.2492038,27.9100145 C17.2064221,27.8988097 17.1626217,27.8926981 17.1188213,27.8926981 C16.9843643,27.8926981 16.8519445,27.9477032 16.753139,28.0465087 L13.8378667,31.0320654 L11.6600707,23.2804154 L11.7160944,23.2518942 L13.7482287,24.3102338 C13.8215689,24.3479225 13.9030579,24.3682948 13.984547,24.3682948 C14.132246,24.3682948 14.2717961,24.3041221 14.3665272,24.1941118 L15.8852801,22.474692 L18.1639189,22.7232337 C18.1812354,22.7252709 18.1995704,22.7252709 18.2168868,22.7252709 C18.4297771,22.7252709 18.6222951,22.5918325 18.6976725,22.3921843 L19.1316019,21.2136482 L21.2981932,28.9398329 Z"
        fill="#0E1123"
      ></path>
      <path
        d="M11.1813222,25.3573686 L9.59024768,31.0320654 L6.67293814,28.0444715 C6.57616984,27.9477032 6.44375006,27.8926981 6.30827444,27.8926981 C6.25836237,27.8926981 6.2155806,27.8988097 6.17585467,27.9110331 L2.13399563,28.9398329 L4.29956829,21.2197599 L4.73146049,22.3932029 C4.80581928,22.5918325 4.99935588,22.7252709 5.21224614,22.7252709 C5.22956257,22.7252709 5.246879,22.7252709 5.26521405,22.7232337 L7.54487144,22.474692 L9.06056857,24.1930932 C9.15631826,24.3041221 9.29688694,24.3682948 9.44356731,24.3682948 C9.52607502,24.3682948 9.60756411,24.3479225 9.67886707,24.3102338 L10.7341508,23.7601824 L11.1813222,25.3573686 Z"
        fill="#0E1123"
      ></path>
      <path
        d="M22.205778,12.4464404 L23.3720906,10.6302522 L21.8889891,9.05954996 C21.7769416,8.94037216 21.7290668,8.7723009 21.7596252,8.60932272 L22.1945732,6.49264352 L20.2449466,5.56366785 C20.0952104,5.4923649 19.9892746,5.35179621 19.961772,5.1867808 L19.60322,3.05787823 L17.4488521,2.89693727 C17.2817995,2.88369529 17.1320633,2.79100145 17.0475183,2.64941415 L15.9423225,0.792481433 L13.8755554,1.41791023 C13.8307364,1.43217082 13.7787871,1.44031973 13.7268378,1.44031973 C13.6137717,1.44031973 13.5027428,1.40161241 13.4141234,1.33132806 L11.7160944,0.00101861366 L10.013991,1.33132806 C9.92537158,1.40161241 9.81434269,1.44031973 9.70127657,1.44031973 C9.64932727,1.44031973 9.59737798,1.43217082 9.54848452,1.415873 L7.48579184,0.792481433 L6.38059601,2.64941415 C6.29605108,2.79100145 6.14631487,2.88369529 5.98028084,2.89693727 L3.82489432,3.05787823 L3.46634231,5.1867808 C3.43883974,5.3507776 3.33392253,5.4923649 3.18316771,5.56366785 L1.23354115,6.49264352 L1.66747057,8.60626688 C1.6990476,8.7723009 1.65117276,8.94037216 1.53912525,9.05954996 L0.0560237517,10.6302522 L1.2223364,12.4444032 C1.31095579,12.5849719 1.32725361,12.7591548 1.26613679,12.9109282 L0.452264468,14.9155599 L2.19816829,16.1857712 C2.32956946,16.2805022 2.40902132,16.4363501 2.40902132,16.6044214 L2.37235123,18.7669382 L4.45439757,19.3180082 C4.61635714,19.3628272 4.74673969,19.482005 4.80378206,19.6368343 L5.55144449,21.6638755 L7.69562626,21.4295943 L7.70683101,21.4285757 L7.71803576,21.4285757 C7.7282219,21.4265385 7.74044526,21.4265385 7.75266862,21.4265385 C7.89629315,21.4265385 8.03482461,21.4886739 8.13363014,21.5976656 L9.56274511,23.2182799 L11.4807946,22.2230944 C11.551079,22.1854057 11.6335867,22.1650334 11.7160944,22.1650334 C11.7986021,22.1650334 11.8811098,22.1854057 11.9534314,22.224113 L13.8653692,23.2182799 L15.2934656,21.5997028 C15.3881967,21.4896925 15.5277467,21.4265385 15.677483,21.4265385 C15.6947994,21.4265385 15.7131344,21.4275571 15.7304509,21.4295943 L17.8766699,21.6638755 L18.6243323,19.6368343 C18.6813747,19.4789492 18.8148131,19.3587528 18.9788099,19.3169896 L19.1346577,19.2782823 L21.0557631,18.7679568 L21.019093,16.6074772 C21.019093,16.4363501 21.0985449,16.2805022 21.2309647,16.1847526 L22.9758499,14.9145413 L22.1619776,12.9119468 C22.1008607,12.7591548 22.1171586,12.5849719 22.205778,12.4464404 Z M15.964732,8.28947803 L10.9500969,15.8241633 C10.8136027,16.0278861 10.5905263,16.1623431 10.3531893,16.1867898 L10.346059,16.1867898 L10.3389287,16.1878084 L10.2778119,16.1898456 L10.2706816,16.1898456 C10.0557541,16.1898456 9.8449011,16.1012262 9.69109043,15.9474156 L7.56626232,13.8225875 C7.24947347,13.5037614 7.24947347,12.9863056 7.56524371,12.6674796 C7.71294269,12.5177434 7.92379572,12.4321798 8.14279766,12.4321798 C8.36281821,12.4321798 8.57468985,12.518762 8.72340745,12.6705354 L10.1423363,14.087427 L14.6048828,7.3859677 C14.7199861,7.20567308 14.9043552,7.08140222 15.1213199,7.03658322 C15.1732692,7.02537846 15.2303116,7.01926678 15.2873539,7.01926678 C15.4472763,7.01926678 15.6031242,7.06714163 15.7375812,7.15779824 C15.9188944,7.27697604 16.0431653,7.46236373 16.0869657,7.67729121 C16.1297474,7.89120008 16.085947,8.10918341 15.964732,8.28947803 Z"
        fill="#00DD8D"
      ></path>
    </g>
  </symbol>

  <symbol id="star-icon" viewBox="0 0 28 27">
    <polygon
      fill="#FFD22A"
      points="14.0025795 22.0909091 5.34850944 26.6418866 7.00128975 17.0027615 2.17126317e-12 10.1762952 9.67554447 8.76996577 14.0025795 0 18.3296145 8.76996577 28.005159 10.1762952 21.0038693 17.0027615 22.6566496 26.6418866"
    ></polygon>
  </symbol>

  <symbol id="post-purchase-banner-icon" viewBox="0 0 121 99">
    <defs>
      <filter
        filterUnits="objectBoundingBox"
        height="171.6%"
        id="filter-2"
        width="142.9%"
        x="-21.4%"
        y="-28.7%"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="6"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          type="matrix"
          values="0 0 0 0 0.68627451   0 0 0 0 0.815686275   0 0 0 0 0.960784314  0 0 0 0.5 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
      <g
        id="home---adoption-card"
        transform="translate(-31.000000, -369.000000)"
      >
        <g
          id="Core-Style/Illustration/Clients"
          transform="translate(12.000000, 340.000000)"
        >
          <g
            fill="#ECF3FF"
            id="Group"
            transform="translate(74.397973, 79.166667) rotate(-30.000000) translate(-74.397973, -79.166667) translate(17.731307, 35.416667)"
          >
            <rect
              height="29.1666667"
              id="Rectangle-9"
              rx="14.5833333"
              width="73.3333333"
              x="17.5"
              y="0"
            ></rect>
            <rect
              height="29.1666667"
              id="Rectangle-9-Copy"
              rx="14.5833333"
              width="85"
              x="0"
              y="29.1666667"
            ></rect>
            <rect
              height="29.1666667"
              id="Rectangle-9-Copy-2"
              rx="14.5833333"
              width="88.3333333"
              x="25"
              y="58.3333333"
            ></rect>
            <rect
              height="29.1666667"
              id="Rectangle-9-Copy-3"
              rx="14.5833333"
              width="37.5"
              x="56.6666667"
              y="29.1666667"
            ></rect>
          </g>
          <g id="Group-3" transform="translate(30.833333, 49.166667)">
            <g id="Group-2">
              <g id="Rectangle-6">
                <rect
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-2)"
                  height="55.8333333"
                  rx="4"
                  width="93.3333333"
                  x="0"
                  y="0"
                ></rect>
                <rect
                  fill="#FFFFFF"
                  height="55.8333333"
                  rx="4"
                  width="93.3333333"
                  x="0"
                  y="0"
                ></rect>
              </g>
              <rect
                fill="#B3B5BF"
                height="4.06060606"
                id="Rectangle-Copy-5"
                rx="2.03030303"
                width="19.2753623"
                x="43.6231884"
                y="19.2878788"
              ></rect>
              <path
                d="M45.6534914,26.3939394 L83.1870883,26.3939394 C84.3083937,26.3939394 85.2173913,27.302937 85.2173913,28.4242424 L85.2173913,28.4242424 C85.2173913,29.5455478 84.3083937,30.4545455 83.1870883,30.4545455 L45.6534914,30.4545455 C44.532186,30.4545455 43.6231884,29.5455478 43.6231884,28.4242424 L43.6231884,28.4242424 C43.6231884,27.302937 44.532186,26.3939394 45.6534914,26.3939394 Z"
                fill="#CECFD5"
                id="Rectangle-Copy-8"
              ></path>
              <path
                d="M45.6534914,33.5 L83.1870883,33.5 C84.3083937,33.5 85.2173913,34.4089976 85.2173913,35.530303 L85.2173913,35.530303 C85.2173913,36.6516084 84.3083937,37.5606061 83.1870883,37.5606061 L45.6534914,37.5606061 C44.532186,37.5606061 43.6231884,36.6516084 43.6231884,35.530303 L43.6231884,35.530303 C43.6231884,34.4089976 44.532186,33.5 45.6534914,33.5 Z"
                fill="#CECFD5"
                id="Rectangle-Copy-9"
              ></path>
              <g id="Oval-7-Copy" transform="translate(11.159420, 14.212121)">
                <mask fill="white" id="mask-4">
                  <ellipse
                    cx="14.2028986"
                    cy="14.2121212"
                    rx="14.2028986"
                    ry="14.2121212"
                  ></ellipse>
                </mask>
                <ellipse
                  cx="14.2028986"
                  cy="14.2121212"
                  fill="#2CBA7E"
                  rx="14.2028986"
                  ry="14.2121212"
                ></ellipse>
                <ellipse
                  cx="14.7101449"
                  cy="29.9469697"
                  fill="#79E5B8"
                  mask="url(#mask-4)"
                  rx="9.63768116"
                  ry="9.64393939"
                ></ellipse>
              </g>
            </g>
            <circle
              cx="25.4166667"
              cy="27.0833333"
              fill="#B6F7DC"
              id="Oval-7"
              r="6.25"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="premium-feature-alt-icon" viewBox="0 0 16 16">
    <g
      id="logo*/I2G/plane16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="bounding-box"
        fill="#D8D8D8"
        opacity="0"
        x="0"
        y="0"
        width="16"
        height="16"
      ></rect>
      <g
        id="I2G-plane-Slate"
        transform="translate(1.000000, 2.000000)"
        fill="#162D3D"
      >
        <path
          d="M13.8075423,0.0121265062 L0.0876340434,5.99045785 C0.0340009468,6.01412528 -0.000818412072,6.07150961 0,6.13485975 C0.000847662539,6.1982099 0.0371614294,6.25447108 0.0913945708,6.27643538 L4.16479788,7.89257926 C4.20880182,7.91031037 4.25799607,7.90256524 4.29566424,7.8719757 L12.0182834,1.70656395 C12.0264164,1.70063996 12.0373344,1.70252489 12.0434112,1.71090214 C12.049488,1.71927939 12.0487004,1.73135986 12.0415986,1.73870552 L5.20345556,8.25520206 C5.1723974,8.28420709 5.15452489,8.32669009 5.1545687,8.37140619 L5.1545687,11.8468161 C5.15429382,11.9115854 5.19139398,11.9694759 5.24708577,11.9911781 C5.30277756,12.0128804 5.3649041,11.9936571 5.40201141,11.9432408 L7.3755362,9.27713904 C7.41298306,9.22670854 7.47549439,9.20784658 7.53122204,9.23016291 L10.0485191,10.229848 C10.1178482,10.2579708 10.1951432,10.2217749 10.2245118,10.1474338 L13.9887997,0.212393189 C14.0109762,0.15553809 13.999621,0.0896363858 13.9600529,0.0455557566 C13.9204848,0.00147512744 13.8605393,-0.0120551515 13.8082944,0.0113023634"
          id="Path"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="premium-feature-icon" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
        fill="#FED86B"
      />
      <path
        d="M17.814 6.012L4.584 11.99a.155.155 0 00-.084.145c0 .063.036.12.088.141l3.928 1.617c.042.017.09.01.126-.021l7.447-6.165c.008-.006.018-.004.024.004a.023.023 0 01-.001.028l-6.594 6.516a.162.162 0 00-.048.116v3.476c0 .065.036.122.09.144a.125.125 0 00.15-.048l1.902-2.666a.124.124 0 01.15-.047l2.428 1c.066.028.141-.008.17-.083l3.63-9.935a.168.168 0 00-.029-.166.123.123 0 00-.146-.035"
        fill="#162D3D"
      />
    </g>
  </symbol>

  <symbol id="recurring-icon" viewBox="0 0 15 15">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M12 9V2a1 1 0 0 0-1-1H6l2 2h2v6H8l3 3 3-3h-2zM6 3L3 0 0 3h2v7a1 1 0 0 0 1 1h5L6 9H4V3h2z"
      />
    </g>
  </symbol>

  <symbol id="printed-icon" viewBox="0 0 15 15">
    <path
      d="M2 10h8V8H2v2zm2-4h4V2H4v4zm7-2h-1V0H2v4H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </symbol>

  <symbol id="reorder-icon" viewBox="0 0 15 15">
    <g fill="#93949F" fill-rule="evenodd">
      <circle cx="1.5" cy="1.5" r="1.5" />
      <circle cx="1.5" cy="7.5" r="1.5" />
      <circle cx="1.5" cy="13.5" r="1.5" />
      <circle cx="7.5" cy="1.5" r="1.5" />
      <circle cx="7.5" cy="7.5" r="1.5" />
      <circle cx="7.5" cy="13.5" r="1.5" />
    </g>
  </symbol>

  <defs>
    <rect id="a2" width="13" height="10" x="1.5" y="5.434" rx="1" />
    <mask id="b2" width="13" height="10" x="0" y="0" fill="#fff">
      <use attr.xlink:href="{{ locationPath }}#a2" />
    </mask>
  </defs>
  <symbol id="lock-icon" viewBox="0 0 16 20">
    <g
      id="Web---Settings--(Design-System)"
      stroke="none"
      stroke-width="1"
      fill="none"
    >
      <g
        id="Web-Settings-/--Payment-options"
        transform="translate(-321.000000, -272.000000)"
      >
        <g id="Group-3" transform="translate(278.000000, 270.000000)">
          <g id="Group" transform="translate(39.000000, 0.000000)">
            <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,2 C15.2383969,2 17.8775718,4.56557489 17.9958615,7.77506174 L18,8 L18,11 L6,11 L6,8 C6,4.6862915 8.6862915,2 12,2 Z M12,4 C9.85780461,4 8.10892112,5.68396847 8.00489531,7.80035966 L8,8 L8,9 L16,9 L16,8 C16,5.85780461 14.3160315,4.10892112 12.1996403,4.00489531 L12,4 Z"
              id="Oval"
              fill="#162D3D"
            ></path>
            <path
              d="M20,9 L20,22 L4,22 L4,9 L20,9 Z M18,11 L6,11 L6,20 L18,20 L18,11 Z"
              id="Rectangle"
              fill="#162D3D"
            ></path>
            <circle id="Oval" fill="#162D3D" cx="12" cy="15" r="2"></circle>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="add-new-item-icon" viewBox="0 0 22 22">
    <g transform="translate(2 2)" fill="none" fill-rule="evenodd">
      <circle
        stroke="#FFF"
        stroke-width="2"
        fill="#26C281"
        cx="9"
        cy="9"
        r="10"
      />
      <g fill="#FFF" fill-rule="nonzero">
        <path d="M8.071 4.488a1 1 0 1 1 2 0v9.167a1 1 0 0 1-2 0V4.488z" />
        <path d="M13.654 8.071a1 1 0 0 1 0 2H4.487a1 1 0 1 1 0-2h9.167z" />
      </g>
    </g>
  </symbol>

  <symbol id="i2g-loader-icon" viewBox="0 0 600 600">
    <ellipse
      transform="rotate(-40.002 299.986 299.998)"
      fill="none"
      cx="300"
      cy="300"
      rx="200"
      ry="200"
    ></ellipse>
    <g fill="#00DD8D">
      <path
        d="M245.5 116.3c-.2 0-.3 0-.5-.1l.5 52.2 176.7-66.3-176.6 14.1c0 .1-.1.1-.1.1zM422.2
      97L245.5 30l-.5 52.2c.2 0 .4-.1.6-.1L422.2 97zM250.7 111.9l153.9-12.3-154.1-13 11 11.7c.7.8.7
      2 0 2.8l-10.8 10.8z"
      ></path>
      <ellipse
        transform="rotate(-40.002 171.435 146.79)"
        cx="171.4"
        cy="146.8"
        rx="27"
        ry="27"
      ></ellipse>
      <ellipse
        transform="rotate(-70.001 112.057 231.594)"
        cx="112.1"
        cy="231.6"
        rx="24.3"
        ry="24.3"
      ></ellipse>
      <ellipse
        transform="rotate(-10.003 103.043 334.827)"
        cx="103"
        cy="334.7"
        rx="21.6"
        ry="21.6"
      ></ellipse>
      <ellipse
        transform="rotate(-40.002 146.78 428.549)"
        cx="146.8"
        cy="428.6"
        rx="18.9"
        ry="18.9"
      ></ellipse>
      <ellipse
        transform="rotate(-70.001 231.587 487.933)"
        cx="231.6"
        cy="487.9"
        rx="16.2"
        ry="16.2"
      ></ellipse>
      <ellipse
        transform="rotate(-10.003 334.789 497.123)"
        cx="334.7"
        cy="497"
        rx="13.5"
        ry="13.5"
      ></ellipse>
      <ellipse
        transform="rotate(-40.002 428.538 453.205)"
        cx="428.6"
        cy="453.2"
        rx="10.8"
        ry="10.8"
      ></ellipse>
      <ellipse
        transform="rotate(-70.001 487.928 368.404)"
        cx="487.9"
        cy="368.4"
        rx="8.1"
        ry="8.1"
      ></ellipse>
    </g>
  </symbol>

  <symbol id="add-client-icon" viewBox="0 0 35 35">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h35v35H0z" />
      <path
        d="M26.826 25.803c-.468-2.981-2.025-4.68-5.079-5.394A6.482 6.482 0 0 0 24 15.5c0-3.584-2.916-6.5-6.5-6.5a6.508 6.508 0 0 0-6.5 6.5c0 1.96.876 3.716 2.252 4.909-3.053.714-4.611 2.413-5.078 5.394A12.437 12.437 0 0 1 5 17.5C5 10.597 10.597 5 17.5 5S30 10.597 30 17.5c0 3.192-1.206 6.094-3.174 8.303M13 15.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m-2.985 11.995C10.121 24.037 10.952 22 17.5 22s7.379 2.037 7.484 5.495a12.517 12.517 0 0 1-3.238 1.749c-.102.038-.202.079-.306.113-.198.066-.401.123-.604.179a13.166 13.166 0 0 1-1.051.246c-.23.042-.464.077-.699.107-.14.018-.279.039-.42.053-.384.035-.773.058-1.166.058-.394 0-.782-.023-1.167-.058-.141-.014-.279-.035-.419-.053-.235-.03-.469-.065-.699-.107a12.697 12.697 0 0 1-1.051-.246 12.375 12.375 0 0 1-.605-.179c-.103-.034-.203-.075-.306-.113a12.55 12.55 0 0 1-3.238-1.749M17.5 3C9.505 3 3 9.505 3 17.5S9.505 32 17.5 32 32 25.495 32 17.5 25.495 3 17.5 3"
        fill="currentColor"
      />
    </g>
  </symbol>

  <symbol id="pdf-not-found-icon" viewBox="0 0 51 53">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M8.571 38a2.14 2.14 0 0 1 2.143-2.143H30A2.14 2.14 0 0 1 32.143 38 2.14 2.14 0 0 1 30 40.143H10.714A2.14 2.14 0 0 1 8.571 38zm0-8.571a2.14 2.14 0 0 1 2.143-2.143H30a2.14 2.14 0 0 1 2.143 2.143A2.14 2.14 0 0 1 30 31.57H10.714a2.14 2.14 0 0 1-2.143-2.142zm0-8.572a2.14 2.14 0 0 1 2.143-2.143H30a2.14 2.14 0 0 1 2.143 2.143A2.14 2.14 0 0 1 30 23H10.714a2.14 2.14 0 0 1-2.143-2.143zM4.286 48.714h32.143V12.286H4.286v36.428zM38.57 8H2.143A2.14 2.14 0 0 0 0 10.143v40.714A2.14 2.14 0 0 0 2.143 53H38.57a2.14 2.14 0 0 0 2.143-2.143V10.143A2.14 2.14 0 0 0 38.571 8z"
        fill="#3f4154"
      />
      <g transform="translate(28)">
        <circle fill="#EB004E" cx="11.5" cy="11.5" r="11.5" />
        <text
          font-family="Lato-Black, Lato"
          font-size="16"
          font-weight="700"
          fill="#FFF"
        >
          <tspan x="8.992" y="17">!</tspan>
        </text>
      </g>
    </g>
  </symbol>

  <symbol id="loading-spinner-icon" viewBox="0 0 100 100">
    <path fill="none" class="bk" d="M0 0h100v100H0z" />
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="translate(0 -30)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(30 105.98 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.08333333333333333s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(60 75.98 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.16666666666666666s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(90 65 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.25s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(120 58.66 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.3333333333333333s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(150 54.02 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.4166666666666667s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(180 50 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.5s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(-150 45.98 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.5833333333333334s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(-120 41.34 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.6666666666666666s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(-90 35 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.75s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(-60 24.02 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.8333333333333334s"
        repeatCount="indefinite"
      />
    </rect>
    <rect
      x="46.5"
      y="40"
      width="7"
      height="20"
      rx="5"
      ry="5"
      fill="#3f4154"
      transform="rotate(-30 -5.98 65)"
    >
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1s"
        begin="0.9166666666666666s"
        repeatCount="indefinite"
      />
    </rect>
  </symbol>

  <symbol id="customize-invoice-icon" viewBox="0 0 141 119">
    <defs>
      <filter
        filterUnits="objectBoundingBox"
        height="214.3%"
        id="filter-2"
        width="250.0%"
        x="-75.0%"
        y="-42.9%"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="6"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
          stdDeviation="2"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        filterUnits="objectBoundingBox"
        height="177.4%"
        id="filter-5"
        width="202.1%"
        x="-51.1%"
        y="-29.0%"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="6"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
          stdDeviation="2"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        filterUnits="objectBoundingBox"
        height="164.0%"
        id="filter-7"
        width="184.2%"
        x="-42.1%"
        y="-24.0%"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="6"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          type="matrix"
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
          stdDeviation="2"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
          type="matrix"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <mask
        fill="white"
        height="14"
        id="mask-9"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        width="14"
        x="0"
        y="0"
      >
        <path
          d="M77,50 L83,50 C85.209139,50 87,51.790861 87,54 L87,60 C87,62.209139 85.209139,64 83,64 L77,64 C74.790861,64 73,62.209139 73,60 L73,54 C73,51.790861 74.790861,50 77,50 Z"
        ></path>
      </mask>
      <filter
        filterUnits="objectBoundingBox"
        height="385.7%"
        id="filter-11"
        width="385.7%"
        x="-142.9%"
        y="-85.7%"
      >
        <feOffset
          dx="0"
          dy="12"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="8"
        ></feGaussianBlur>
        <feColorMatrix
          in="shadowBlurOuter1"
          type="matrix"
          values="0 0 0 0 0.305882353   0 0 0 0 0.529411765   0 0 0 0 0.890196078  0 0 0 0.16833673 0"
        ></feColorMatrix>
      </filter>
    </defs>
    <g
      fill="none"
      fill-rule="evenodd"
      id="Page-1"
      stroke="none"
      stroke-width="1"
    >
      <g
        id="Adoption-card-list"
        transform="translate(-498.000000, -134.000000)"
      >
        <g id="Style-invoice" transform="translate(474.000000, 115.000000)">
          <g>
            <g
              id="Group"
              transform="translate(86.000000, 79.500000) rotate(-30.000000) translate(-86.000000, -79.500000) translate(18.000000, 27.000000)"
            >
              <rect
                fill="#ECF3FF"
                height="35"
                id="Rectangle-9"
                rx="17.5"
                width="88"
                x="21"
                y="0"
              ></rect>
              <rect
                fill="#ECF3FF"
                height="35"
                id="Rectangle-9-Copy"
                rx="17.5"
                width="102"
                x="0"
                y="35"
              ></rect>
              <rect
                fill="#FFFFFF"
                height="35"
                id="Rectangle-9-Copy-3"
                rx="17.5"
                width="45"
                x="68"
                y="35"
              ></rect>
              <rect
                fill="#ECF3FF"
                height="35"
                id="Rectangle-9-Copy-2"
                rx="17.5"
                width="106"
                x="30"
                y="70"
              ></rect>
            </g>
            <g id="Oval-4-Copy" transform="translate(39.000000, 50.000000)">
              <g id="Mask" opacity="0.776506696">
                <rect
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-2)"
                  height="42"
                  rx="4"
                  width="32"
                  x="0"
                  y="10"
                ></rect>
                <rect
                  fill="#FFFFFF"
                  height="42"
                  rx="4"
                  width="32"
                  x="0"
                  y="10"
                ></rect>
              </g>
              <mask fill="white" id="mask-4">
                <rect height="62" rx="4" width="47" x="12" y="0"></rect>
              </mask>
              <g id="Mask" opacity="0.776506696">
                <rect
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-5)"
                  height="62"
                  rx="4"
                  width="47"
                  x="12"
                  y="0"
                ></rect>
                <rect
                  fill="#FFFFFF"
                  height="62"
                  rx="4"
                  width="47"
                  x="12"
                  y="0"
                ></rect>
              </g>
            </g>
            <g id="Rectangle-8">
              <rect
                fill="black"
                fill-opacity="1"
                filter="url(#filter-7)"
                height="75"
                rx="4"
                width="57"
                x="67"
                y="44"
              ></rect>
              <rect
                fill="#FFFFFF"
                height="75"
                rx="4"
                width="57"
                x="67"
                y="44"
              ></rect>
            </g>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle"
              rx="1"
              width="45"
              x="73"
              y="70"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy"
              rx="1"
              width="45"
              x="73"
              y="77"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-2"
              rx="1"
              width="45"
              x="73"
              y="84"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-3"
              rx="1"
              width="45"
              x="73"
              y="91"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-3"
              rx="1"
              transform="translate(109.000000, 81.000000) rotate(-90.000000) translate(-109.000000, -81.000000) "
              width="22"
              x="98"
              y="80"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-6"
              rx="1"
              transform="translate(117.000000, 82.000000) rotate(-90.000000) translate(-117.000000, -82.000000) "
              width="22"
              x="106"
              y="81"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-7"
              rx="1"
              transform="translate(74.000000, 81.000000) rotate(-90.000000) translate(-74.000000, -81.000000) "
              width="22"
              x="63"
              y="80"
            ></rect>
            <rect
              fill="#4E87E3"
              height="2"
              id="Rectangle-Copy-4"
              rx="1"
              width="19"
              x="99"
              y="103"
            ></rect>
            <rect
              fill="#CECFD5"
              height="2"
              id="Rectangle-Copy-5"
              rx="1"
              width="19"
              x="99"
              y="52"
            ></rect>
            <rect
              fill="#CECFD5"
              height="2"
              id="Rectangle-Copy-8"
              rx="1"
              width="19"
              x="99"
              y="56"
            ></rect>
            <rect
              fill="#CECFD5"
              height="2"
              id="Rectangle-Copy-9"
              rx="1"
              width="19"
              x="99"
              y="60"
            ></rect>
          </g>
          <path
            d="M77,50 L83,50 C85.209139,50 87,51.790861 87,54 L87,60 C87,62.209139 85.209139,64 83,64 L77,64 C74.790861,64 73,62.209139 73,60 L73,54 C73,51.790861 74.790861,50 77,50 Z"
            fill="#F1F1F1"
            mask="url(#mask-9)"
            stroke="#979797"
            stroke-dasharray="2,3"
            stroke-width="2"
          ></path>
          <g id="Rectangle-21">
            <rect
              fill="black"
              fill-opacity="1"
              filter="url(#filter-11)"
              height="21"
              rx="4"
              width="21"
              x="61"
              y="37"
            ></rect>
            <rect
              fill="#26C281"
              height="21"
              rx="4"
              width="21"
              x="61"
              y="37"
            ></rect>
          </g>
          <polygon
            fill="#FFFFFF"
            id="Path-5"
            points="66 52 78 52 73.8028208 43"
          ></polygon>
          <polygon
            fill="#FFFFFF"
            id="Path-6"
            points="66 49 69 44.8866572 66 42"
          ></polygon>
          <circle
            cx="138.5"
            cy="68.5"
            fill="#44B485"
            id="Oval-6"
            r="4.5"
          ></circle>
          <circle
            cx="138.5"
            cy="52.5"
            fill="#1E5B69"
            id="Oval-6-Copy"
            r="4.5"
          ></circle>
          <circle
            cx="138.5"
            cy="84.5"
            fill="#4E87E3"
            id="Oval-6-Copy-2"
            r="4.5"
          ></circle>
          <circle
            cx="138.5"
            cy="84.5"
            id="Oval-6-Copy-2"
            r="7.5"
            stroke="#303141"
          ></circle>
          <circle
            cx="138.5"
            cy="38.5"
            fill="#303141"
            id="Oval-6-Copy-3"
            r="4.5"
          ></circle>
          <circle
            cx="138.5"
            cy="100.5"
            fill="#BAD3FB"
            id="Oval-6-Copy-4"
            r="4.5"
          ></circle>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="invoice-payment-icon" viewBox="0 0 180 180">
    <defs>
      <filter
        x="-35.1%"
        y="-21.3%"
        width="170.2%"
        height="153.3%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
          type="matrix"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        x="-75.6%"
        y="-119.2%"
        width="251.2%"
        height="338.5%"
        filterUnits="objectBoundingBox"
        id="filter-3"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.176488904 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="SourceGraphic"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
    <g
      id="Core-Style/Illustration/Invoice&amp;Payment"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="New-home-image" transform="translate(6.000000, 11.000000)">
        <g
          id="Group"
          transform="translate(86.000000, 79.500000) rotate(-30.000000) translate(-86.000000, -79.500000) translate(18.000000, 27.000000)"
        >
          <rect
            id="Rectangle-9"
            fill="#ECF3FF"
            x="21"
            y="0"
            width="88"
            height="35"
            rx="17.5"
          ></rect>
          <rect
            id="Rectangle-9-Copy"
            fill="#ECF3FF"
            x="0"
            y="35"
            width="102"
            height="35"
            rx="17.5"
          ></rect>
          <rect
            id="Rectangle-9-Copy-3"
            fill="#FFFFFF"
            x="68"
            y="35"
            width="45"
            height="35"
            rx="17.5"
          ></rect>
          <rect
            id="Rectangle-9-Copy-2"
            fill="#ECF3FF"
            x="30"
            y="70"
            width="106"
            height="35"
            rx="17.5"
          ></rect>
        </g>
        <g id="Rectangle-8">
          <rect
            x="55"
            y="44"
            width="57"
            height="75"
            rx="4"
            fill="black"
            fill-opacity="1"
            filter="url(#filter-2)"
          ></rect>
          <rect
            x="55"
            y="44"
            width="57"
            height="75"
            rx="4"
            fill="#FFFFFF"
          ></rect>
        </g>
        <rect
          id="Rectangle"
          fill="#93949F"
          x="61"
          y="70"
          width="45"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy"
          fill="#93949F"
          x="62"
          y="77"
          width="44"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy-2"
          fill="#93949F"
          x="61"
          y="84"
          width="45"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy-3"
          fill="#93949F"
          x="61"
          y="91"
          width="45"
          height="2"
          rx="1"
        ></rect>
        <path
          d="M87,80 L107,80 C107.552285,80 108,80.4477153 108,81 L108,81 C108,81.5522847 107.552285,82 107,82 L87,82 C86.4477153,82 86,81.5522847 86,81 L86,81 C86,80.4477153 86.4477153,80 87,80 Z"
          id="Rectangle-Copy-3"
          fill="#93949F"
          transform="translate(97.000000, 81.000000) rotate(-90.000000) translate(-97.000000, -81.000000) "
        ></path>
        <rect
          id="Rectangle-Copy-6"
          fill="#93949F"
          transform="translate(105.000000, 81.500000) rotate(-90.000000) translate(-105.000000, -81.500000) "
          x="93.5"
          y="80.5"
          width="23"
          height="2"
          rx="1"
        ></rect>
        <path
          d="M52.5,79.5 L71.5,79.5 C72.0522847,79.5 72.5,79.9477153 72.5,80.5 L72.5,80.5 C72.5,81.0522847 72.0522847,81.5 71.5,81.5 L52.5,81.5 C51.9477153,81.5 51.5,81.0522847 51.5,80.5 L51.5,80.5 C51.5,79.9477153 51.9477153,79.5 52.5,79.5 Z"
          id="Rectangle-Copy-7"
          fill="#93949F"
          transform="translate(62.000000, 80.500000) rotate(-90.000000) translate(-62.000000, -80.500000) "
        ></path>
        <rect
          id="Rectangle-Copy-4"
          fill="#4E87E3"
          x="87"
          y="103"
          width="19"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy-5"
          fill="#CECFD5"
          x="87"
          y="52"
          width="19"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy-8"
          fill="#CECFD5"
          x="87"
          y="56"
          width="19"
          height="2"
          rx="1"
        ></rect>
        <rect
          id="Rectangle-Copy-9"
          fill="#CECFD5"
          x="87"
          y="60"
          width="19"
          height="2"
          rx="1"
        ></rect>
        <path
          d="M80,104.70273 L67.2740392,119 C62.2834283,118.982603 59.1302623,118.703442 57.8145412,118.162518 C56.4988202,117.621593 55.5606398,116.218703 55,113.953847 L55,94 L80,104.70273 Z"
          id="Path-3"
          fill="#000000"
          opacity="0.0352678571"
        ></path>
        <g
          id="Group-2"
          filter="url(#filter-3)"
          transform="translate(38.000000, 81.000000)"
        >
          <rect
            id="Rectangle-13-Copy"
            fill="#4E87E3"
            x="0"
            y="0"
            width="41"
            height="26"
            rx="3"
          ></rect>
          <polygon
            id="Rectangle-13-Copy"
            fill="#BAD3FB"
            points="11 -4.01501869e-15 17.8105469 -8.9e-15 40.8603516 26 34.4882813 26"
          ></polygon>
          <rect
            id="Rectangle-5"
            fill="#FDD159"
            x="6"
            y="7"
            width="7"
            height="7"
            rx="2"
          ></rect>
          <rect
            id="Rectangle-7"
            fill="#FFFFFF"
            x="6"
            y="17"
            width="13"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-7-Copy"
            fill="#FFFFFF"
            x="22"
            y="17"
            width="13"
            height="2"
            rx="1"
          ></rect>
        </g>
        <g
          id="Group-4"
          transform="translate(98.000000, 29.000000)"
          stroke="#0E5DDB"
          stroke-linecap="square"
        >
          <path d="M4.5,0.5 L4.5,3.5" id="Line"></path>
          <path d="M4.5,5.5 L4.5,8.5" id="Line-Copy"></path>
          <g
            id="Group-3"
            transform="translate(4.500000, 4.500000) rotate(-90.000000) translate(-4.500000, -4.500000) translate(3.000000, 0.000000)"
          >
            <path d="M1.5,0.5 L1.5,3.5" id="Line"></path>
            <path d="M1.5,5.5 L1.5,8.5" id="Line-Copy"></path>
          </g>
        </g>
        <g
          id="Group-4-Copy"
          transform="translate(117.000000, 34.000000)"
          stroke="#0E5DDB"
          stroke-linecap="square"
        >
          <path d="M2.5,0.25 L2.5,1.75" id="Line"></path>
          <path d="M2.5,2.25 L2.5,3.75" id="Line-Copy"></path>
          <g
            id="Group-3"
            transform="translate(2.500000, 2.000000) rotate(-90.000000) translate(-2.500000, -2.000000) translate(2.000000, 0.000000)"
          >
            <path d="M0.5,0.222222222 L0.5,1.55555556" id="Line"></path>
            <path d="M0.5,2.44444444 L0.5,3.77777778" id="Line-Copy"></path>
          </g>
        </g>
        <g
          id="Group-4-Copy-3"
          transform="translate(141.000000, 57.000000)"
          stroke="#0E5DDB"
          stroke-linecap="square"
        >
          <path d="M2.5,0.25 L2.5,1.75" id="Line"></path>
          <path d="M2.5,2.25 L2.5,3.75" id="Line-Copy"></path>
          <g
            id="Group-3"
            transform="translate(2.500000, 2.000000) rotate(-90.000000) translate(-2.500000, -2.000000) translate(2.000000, 0.000000)"
          >
            <path d="M0.5,0.222222222 L0.5,1.55555556" id="Line"></path>
            <path d="M0.5,2.44444444 L0.5,3.77777778" id="Line-Copy"></path>
          </g>
        </g>
        <g
          id="Group-4-Copy-2"
          transform="translate(123.000000, 76.000000)"
          stroke="#0E5DDB"
          stroke-linecap="square"
        >
          <path d="M2.5,0.25 L2.5,1.75" id="Line"></path>
          <path d="M2.5,2.25 L2.5,3.75" id="Line-Copy"></path>
          <g
            id="Group-3"
            transform="translate(2.500000, 2.000000) rotate(-90.000000) translate(-2.500000, -2.000000) translate(2.000000, 0.000000)"
          >
            <path d="M0.5,0.222222222 L0.5,1.55555556" id="Line"></path>
            <path d="M0.5,2.44444444 L0.5,3.77777778" id="Line-Copy"></path>
          </g>
        </g>
        <circle id="Oval-3" stroke="#0E5DDB" cx="128" cy="31" r="2"></circle>
        <circle
          id="Oval-3-Copy-2"
          stroke="#0E5DDB"
          cx="130"
          cy="87"
          r="2"
        ></circle>
        <circle
          id="Oval-3-Copy-6"
          stroke="#0E5DDB"
          cx="48"
          cy="131"
          r="2"
        ></circle>
        <circle
          id="Oval-3-Copy"
          stroke="#0E5DDB"
          cx="132"
          cy="39"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-9"
          stroke="#0E5DDB"
          cx="81"
          cy="29"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-8"
          stroke="#4E87E3"
          cx="58"
          cy="125"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-3"
          stroke="#0E5DDB"
          cx="121.5"
          cy="90.5"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-7"
          stroke="#4E87E3"
          cx="44.5"
          cy="118.5"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-4"
          stroke="#0E5DDB"
          cx="121.5"
          cy="51.5"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-4"
          stroke="#0E5DDB"
          cx="127.5"
          cy="66.5"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-10"
          stroke="#0E5DDB"
          cx="87.5"
          cy="35.5"
          r="1"
        ></circle>
        <circle
          id="Oval-3-Copy-5"
          stroke="#0E5DDB"
          cx="147.5"
          cy="51.5"
          r="1"
        ></circle>
      </g>
    </g>
  </symbol>

  <symbol id="create-invoice-icon" viewBox="0 0 140 128">
    <defs>
      <filter
        x="-62.5%"
        y="-38.1%"
        width="225.0%"
        height="195.2%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
          type="matrix"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        x="-42.6%"
        y="-25.8%"
        width="185.1%"
        height="164.5%"
        filterUnits="objectBoundingBox"
        id="filter-5"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
          type="matrix"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
      <filter
        x="-35.1%"
        y="-21.3%"
        width="170.2%"
        height="153.3%"
        filterUnits="objectBoundingBox"
        id="filter-8"
      >
        <feOffset
          dx="0"
          dy="4"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter2"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
          type="matrix"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Core-Style/Illustration/Invoice"
        transform="translate(-20.000000, -21.000000)"
      >
        <g id="Create-invoice" transform="translate(-4.000000, 10.000000)">
          <g
            id="Group"
            transform="translate(85.277568, 80.000000) rotate(-30.000000) translate(-85.277568, -80.000000) translate(17.277568, 27.500000)"
          >
            <rect
              id="Rectangle-9"
              fill="#ECF3FF"
              x="21"
              y="0"
              width="88"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy"
              fill="#ECF3FF"
              x="0"
              y="35"
              width="102"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy-3"
              fill="#FFFFFF"
              x="68"
              y="35"
              width="45"
              height="35"
              rx="17.5"
            ></rect>
            <rect
              id="Rectangle-9-Copy-2"
              fill="#ECF3FF"
              x="30"
              y="70"
              width="106"
              height="35"
              rx="17.5"
            ></rect>
          </g>
          <g id="Oval-4-Copy" transform="translate(41.000000, 53.000000)">
            <g id="Mask" opacity="0.776506696">
              <rect
                x="0"
                y="10"
                width="32"
                height="42"
                rx="4"
                fill="black"
                fill-opacity="1"
                filter="url(#filter-2)"
              ></rect>
              <rect
                x="0"
                y="10"
                width="32"
                height="42"
                rx="4"
                fill="#FFFFFF"
              ></rect>
            </g>
            <mask id="mask-4" fill="white">
              <rect x="12" y="0" width="47" height="62" rx="4"></rect>
            </mask>
            <g id="Mask" opacity="0.776506696">
              <rect
                x="12"
                y="0"
                width="47"
                height="62"
                rx="4"
                fill="black"
                fill-opacity="1"
                filter="url(#filter-5)"
              ></rect>
              <rect
                x="12"
                y="0"
                width="47"
                height="62"
                rx="4"
                fill="#FFFFFF"
              ></rect>
            </g>
          </g>
          <g id="Oval-4" transform="translate(70.000000, 45.000000)">
            <mask id="mask-7" fill="white">
              <rect x="0" y="0" width="57" height="75" rx="4"></rect>
            </mask>
            <g id="Mask">
              <rect
                x="0"
                y="0"
                width="57"
                height="75"
                rx="4"
                fill="black"
                fill-opacity="1"
                filter="url(#filter-8)"
              ></rect>
              <rect
                x="0"
                y="0"
                width="57"
                height="75"
                rx="4"
                fill="#FFFFFF"
              ></rect>
            </g>
            <circle
              fill="#0D0E1A"
              opacity="0.0473214286"
              mask="url(#mask-7)"
              cx="55"
              cy="9"
              r="13"
            ></circle>
          </g>
          <rect
            id="Rectangle"
            fill="#93949F"
            x="76"
            y="71"
            width="45"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy"
            fill="#93949F"
            x="76"
            y="78"
            width="45"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-2"
            fill="#93949F"
            x="76"
            y="85"
            width="45"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-3"
            fill="#93949F"
            x="76"
            y="92"
            width="45"
            height="2"
            rx="1"
          ></rect>
          <path
            d="M102,81 L122,81 C122.552285,81 123,81.4477153 123,82 L123,82 C123,82.5522847 122.552285,83 122,83 L102,83 C101.447715,83 101,82.5522847 101,82 L101,82 C101,81.4477153 101.447715,81 102,81 Z"
            id="Rectangle-Copy-3"
            fill="#93949F"
            transform="translate(112.000000, 82.000000) rotate(-90.000000) translate(-112.000000, -82.000000) "
          ></path>
          <path
            d="M109.5,81.5 L130.5,81.5 C131.052285,81.5 131.5,81.9477153 131.5,82.5 L131.5,82.5 C131.5,83.0522847 131.052285,83.5 130.5,83.5 L109.5,83.5 C108.947715,83.5 108.5,83.0522847 108.5,82.5 L108.5,82.5 C108.5,81.9477153 108.947715,81.5 109.5,81.5 Z"
            id="Rectangle-Copy-6"
            fill="#93949F"
            transform="translate(120.000000, 82.500000) rotate(-90.000000) translate(-120.000000, -82.500000) "
          ></path>
          <path
            d="M66.5,81.5 L87.5,81.5 C88.0522847,81.5 88.5,81.9477153 88.5,82.5 L88.5,82.5 C88.5,83.0522847 88.0522847,83.5 87.5,83.5 L66.5,83.5 C65.9477153,83.5 65.5,83.0522847 65.5,82.5 L65.5,82.5 C65.5,81.9477153 65.9477153,81.5 66.5,81.5 Z"
            id="Rectangle-Copy-7"
            fill="#93949F"
            transform="translate(77.000000, 82.500000) rotate(-90.000000) translate(-77.000000, -82.500000) "
          ></path>
          <rect
            id="Rectangle-Copy-4"
            fill="#4E87E3"
            x="102"
            y="104"
            width="19"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-5"
            fill="#CECFD5"
            x="102"
            y="53"
            width="19"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-8"
            fill="#CECFD5"
            x="102"
            y="57"
            width="19"
            height="2"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-9"
            fill="#CECFD5"
            x="102"
            y="61"
            width="19"
            height="2"
            rx="1"
          ></rect>
          <g id="Group-2-Copy-4" transform="translate(114.000000, 35.000000)">
            <circle id="Oval-2" fill="#25C081" cx="13" cy="13" r="13"></circle>
            <g
              id="Page-1"
              transform="translate(12.853553, 12.853553) rotate(-45.000000) translate(-12.853553, -12.853553) translate(7.353553, 6.853553)"
              fill="#FFFFFF"
              fill-rule="nonzero"
            >
              <path
                d="M8.78611476,0.773240938 C9.29257164,0.266784064 10.1137005,0.266784064 10.6201573,0.773240938 C11.1266142,1.27969781 11.1266142,2.10082665 10.6201573,2.60728352 L2.21388524,11.0135556 C1.70742836,11.5200125 0.88629953,11.5200125 0.379842656,11.0135556 C-0.126614219,10.5070988 -0.126614219,9.68596992 0.379842656,9.17951304 L8.78611476,0.773240938 Z"
                id="Stroke-3"
              ></path>
              <path
                d="M10.6201573,9.17951304 C11.1266142,9.68596992 11.1266142,10.5070988 10.6201573,11.0135556 C10.1137005,11.5200125 9.29257164,11.5200125 8.78611476,11.0135556 L0.379842656,2.60728352 C-0.126614219,2.10082665 -0.126614219,1.27969781 0.379842656,0.773240938 C0.88629953,0.266784064 1.70742836,0.266784064 2.21388524,0.773240938 L10.6201573,9.17951304 Z"
                id="Stroke-5"
              ></path>
            </g>
          </g>
          <circle
            id="Oval-2"
            fill="#BAD3FB"
            cx="140.5"
            cy="69.5"
            r="6.5"
          ></circle>
          <circle id="Oval-2" fill="#BAD3FB" cx="147" cy="55" r="4"></circle>
          <circle id="Oval-2" fill="#BAD3FB" cx="115" cy="28" r="4"></circle>
          <circle
            id="Oval-2"
            fill="#ECF3FF"
            cx="128.5"
            cy="13.5"
            r="2.5"
          ></circle>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <filter
      x="-35.1%"
      y="-21.3%"
      width="170.2%"
      height="153.3%"
      filterUnits="objectBoundingBox"
      id="estimates-filter-2"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.729411765   0 0 0 0 0.82745098   0 0 0 0 0.984313725  0 0 0 1 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0543195199 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-180.0%"
      y="-122.7%"
      width="460.0%"
      height="345.5%"
      filterUnits="objectBoundingBox"
      id="estimates-filter-3"
    >
      <feOffset
        dx="0"
        dy="12"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="8"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.521568627   0 0 0 0 0.654901961   0 0 0 0 0.803921569  0 0 0 0.564849411 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
  </defs>
  <symbol id="estimates-empty-state-icon" viewBox="0 0 141 119">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Design/Illustration/Medium/Estimate"
        transform="translate(-31.000000, -30.000000)"
      >
        <g id="Estimates" transform="translate(7.000000, 11.000000)">
          <g>
            <g
              id="Group"
              transform="translate(86.000000, 79.500000) rotate(-30.000000) translate(-86.000000, -79.500000) translate(18.000000, 27.000000)"
              fill="#ECF3FF"
            >
              <rect
                id="Rectangle-9"
                x="21"
                y="0"
                width="88"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy"
                x="0"
                y="35"
                width="102"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-3"
                x="68"
                y="35"
                width="45"
                height="35"
                rx="17.5"
              ></rect>
              <rect
                id="Rectangle-9-Copy-2"
                x="30"
                y="70"
                width="106"
                height="35"
                rx="17.5"
              ></rect>
            </g>
            <g id="Rectangle-8">
              <rect
                x="55"
                y="44"
                width="57"
                height="75"
                rx="4"
                fill="black"
                fill-opacity="1"
                attr.filter="url({{ locationPath }}#estimates-filter-2)"
              ></rect>
              <rect
                x="55"
                y="44"
                width="57"
                height="75"
                rx="4"
                fill="#FFFFFF"
              ></rect>
            </g>
            <rect
              id="Rectangle"
              fill="#93949F"
              x="61"
              y="70"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy"
              fill="#93949F"
              x="61"
              y="77"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-2"
              fill="#93949F"
              x="61"
              y="84"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-3"
              fill="#93949F"
              x="61"
              y="91"
              width="45"
              height="2"
              rx="1"
            ></rect>
            <path
              d="M87,80 L107,80 C107.552285,80 108,80.4477153 108,81 C108,81.5522847 107.552285,82 107,82 L87,82 C86.4477153,82 86,81.5522847 86,81 C86,80.4477153 86.4477153,80 87,80 Z"
              id="Rectangle-Copy-3"
              fill="#93949F"
              transform="translate(97.000000, 81.000000) rotate(-90.000000) translate(-97.000000, -81.000000) "
            ></path>
            <path
              d="M94.5,80.5 L115.5,80.5 C116.052285,80.5 116.5,80.9477153 116.5,81.5 C116.5,82.0522847 116.052285,82.5 115.5,82.5 L94.5,82.5 C93.9477153,82.5 93.5,82.0522847 93.5,81.5 C93.5,80.9477153 93.9477153,80.5 94.5,80.5 Z"
              id="Rectangle-Copy-6"
              fill="#93949F"
              transform="translate(105.000000, 81.500000) rotate(-90.000000) translate(-105.000000, -81.500000) "
            ></path>
            <path
              d="M53,80 L72,80 C72.5522847,80 73,80.4477153 73,81 C73,81.5522847 72.5522847,82 72,82 L53,82 C52.4477153,82 52,81.5522847 52,81 C52,80.4477153 52.4477153,80 53,80 Z"
              id="Rectangle-Copy-7"
              fill="#93949F"
              transform="translate(62.500000, 81.000000) rotate(-90.000000) translate(-62.500000, -81.000000) "
            ></path>
            <rect
              id="Rectangle-Copy-4"
              fill="#4E87E3"
              x="87"
              y="103"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <g
              id="Group-3"
              attr.filter="url({{ locationPath }}#estimates-filter-3)"
              transform="translate(41.000000, 63.000000)"
            >
              <path
                d="M2,0 L28,0 C29.1045695,-2.02906125e-16 30,0.8954305 30,2 L30,42 C30,43.1045695 29.1045695,44 28,44 L2,44 C0.8954305,44 1.3527075e-16,43.1045695 0,42 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
                id="Rectangle-3"
                fill="#26C281"
              ></path>
              <polygon
                id="Rectangle-4"
                fill="#B6F7DC"
                points="3 5 26 5 26 13 3 13"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy"
                fill="#79E5B8"
                points="3 26 9 26 9 32 3 32"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-4"
                fill="#79E5B8"
                points="3 35 9 35 9 41 3 41"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-2"
                fill="#79E5B8"
                points="12 26 18 26 18 32 12 32"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-5"
                fill="#79E5B8"
                points="12 35 18 35 18 41 12 41"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-3"
                fill="#79E5B8"
                points="21 26 27 26 27 32 21 32"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy"
                fill="#79E5B8"
                points="3 17 9 17 9 23 3 23"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-2"
                fill="#79E5B8"
                points="12 17 18 17 18 23 12 23"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-3"
                fill="#79E5B8"
                points="21 17 27 17 27 23 21 23"
              ></polygon>
              <polygon
                id="Rectangle-4-Copy-6"
                fill="#79E5B8"
                points="21 35 27 35 27 41 21 41"
              ></polygon>
            </g>
            <rect
              id="Rectangle-Copy-5"
              fill="#CECFD5"
              x="87"
              y="52"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-8"
              fill="#CECFD5"
              x="87"
              y="56"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="Rectangle-Copy-9"
              fill="#CECFD5"
              x="87"
              y="60"
              width="19"
              height="2"
              rx="1"
            ></rect>
            <path
              d="M69.1094971,107.013672 L65.2740392,119 C63.4609346,118.936727 61.4102987,118.90509 59.1221313,118.90509 C56.833964,118.90509 55.4599202,117.749308 55,115.437744 L55,107.013672 L69.1094971,107.013672 Z"
              id="Path-3"
              fill="#000000"
              opacity="0.0352678571"
            ></path>
          </g>
          <text
            id="+"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="54" y="40">+</tspan>
          </text>
          <text
            id="+"
            font-family="Helvetica"
            font-size="12"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="118" y="31">+</tspan>
          </text>
          <text
            id="+"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="117" y="78">+</tspan>
          </text>
          <text
            id="="
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="128" y="84">=</tspan>
          </text>
          <text
            id="="
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="119" y="42">=</tspan>
          </text>
          <text
            id="="
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="63" y="39">=</tspan>
          </text>
          <text
            id="x"
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="95" y="39">x</tspan>
          </text>
          <text
            id="/"
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="128" y="51">/</tspan>
          </text>
          <text
            id="/-copy"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="106" y="32">/</tspan>
          </text>
          <text
            id="x"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="118" y="61">x</tspan>
          </text>
          <text
            id="x"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="130" y="34">x</tspan>
          </text>
          <text
            id="+"
            font-family="Helvetica"
            font-size="12"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="43" y="126">+</tspan>
          </text>
          <text
            id="="
            font-family="Helvetica"
            font-size="10"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="44" y="137">=</tspan>
          </text>
          <text
            id="x"
            font-family="Helvetica"
            font-size="6"
            font-weight="normal"
            fill="#4E87E3"
          >
            <tspan x="55" y="129">x</tspan>
          </text>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="invoice2go-logo-white-icon" viewBox="0 0 899.24 146.57">
    <path
      fill="#00de8c"
      fill-rule="evenodd"
      d="M183.59.14,1.17,72.68a1.86,1.86,0,0,0,.05,3.47L55.38,95.76a1.85,1.85,0,0,0,1.74-.25L159.8,20.7a.25.25,0,0,1,.31.39L69.19,100.16a1.85,1.85,0,0,0-.65,1.41v42.17a1.85,1.85,0,0,0,3.29,1.17l26.24-32.35a1.85,1.85,0,0,1,2.07-.57l33.47,12.13a1.85,1.85,0,0,0,2.34-1L186,2.57a1.85,1.85,0,0,0-2.4-2.44"
    ></path>
    <rect
      fill="#172e3d"
      x="224.78"
      y="14.78"
      width="16.53"
      height="100.46"
      transform="translate(-0.16 0.57) rotate(-0.14)"
    ></rect>
    <path
      fill="#172e3d"
      d="M293.1,42.92c-8.33,0-16,3-20.75,9V44.39l-15.54,0,.17,70.75,15.54,0-.11-46.84a18.53,18.53,0,0,1,17.34-11.22c9.89,0,15.55,7,15.58,18.22l.1,39.79,15.54,0-.1-42.31C320.81,54.46,310,42.88,293.1,42.92"
    ></path>
    <polygon
      fill="#172e3d"
      points="385.14 44.11 363.65 93.69 342.07 44.22 324.83 44.26 356.93 114.93 370.63 114.9 402.52 44.07 385.14 44.11"
    ></polygon>
    <path
      fill="#172e3d"
      d="M441.1,42.56a36.79,36.79,0,1,0,37.09,36.7,36.48,36.48,0,0,0-37.09-36.7m.14,59.15c-12.57,0-21.35-9.71-21.39-22.3S428.54,57,441.14,57c12.44,0,21.21,9.72,21.24,22.31s-8.7,22.38-21.1,22.4Z"
    ></path>
    <rect
      fill="#172e3d"
      x="489.14"
      y="13.97"
      width="15.54"
      height="14.44"
      transform="translate(-0.05 1.27) rotate(-0.15)"
    ></rect>
    <rect
      fill="#172e3d"
      x="489.28"
      y="43.84"
      width="15.54"
      height="70.75"
      transform="translate(-0.2 1.27) rotate(-0.15)"
    ></rect>
    <path
      fill="#172e3d"
      d="M554.35,56.71a21.08,21.08,0,0,1,19.38,12.4l13.55-7.4c-6.1-11.73-18.41-19.48-33-19.44-21.19.05-37.25,15.94-37.2,36.88s16.19,36.74,37.38,36.69a36.47,36.47,0,0,0,32.87-19.6l-13.58-7.33a21,21,0,0,1-19.32,12.5c-12.57,0-21.5-9.71-21.53-22.3s8.86-22.38,21.44-22.4"
    ></path>
    <path
      fill="#172e3d"
      d="M632.32,42.08c-21.47.06-36.82,16.08-36.77,36.88.06,21.5,15.49,36.75,37,36.7,14.83,0,25.84-6.43,32.16-16.52l-11.89-8.46c-3.66,6.23-10.29,10.78-20.17,10.81-11.72,0-21.07-7.59-21.81-19.19l55.51-.13c.13-2.25.13-3.54.13-5.09-.05-22.76-15.62-35-34.13-35M611.48,71c2.09-10.51,11.24-15.77,20.3-15.77s17.24,5.47,19,15.66Z"
    ></path>
    <path
      fill="#172e3d"
      d="M862.52,41.51H862a36.47,36.47,0,0,0-36.74,36.68v.2a36.47,36.47,0,0,0,36.9,36.69h.2a36.47,36.47,0,0,0,36.91-36.63v-.3a36.47,36.47,0,0,0-36.72-36.64m-.24,59.15c-12.57,0-21.35-9.71-21.38-22.3S849.6,56,862.17,56s21.21,9.71,21.24,22.31-8.69,22.37-21.12,22.4Z"
    ></path>
    <path
      fill="#172e3d"
      d="M798.32,43.09V49.6c-5-5.08-12.31-7.9-20.79-7.88-20.48.05-35.27,15.77-35.36,35.6s15.06,35.62,35.54,35.57c8.48,0,15.81-3,20.75-8.26V113c0,11-6,16.89-14.12,18.69-20.24,3.64-32.81-2.48-32.81-2.48l-5,12.72c7.22,4.51,29.62,5.8,40,3.49,15-2.64,27.44-12.43,27.4-32.29l-.17-70.09Zm.11,45.56c-3.66,5.67-9.74,9.92-18.9,9.95-12.28,0-21.21-9.15-21.38-21.32,0-12.16,9-21.38,21.27-21.42,9.18,0,15.27,4.2,18.95,9.72Z"
    ></path>
    <path
      fill="#172e3d"
      d="M695.33,100.72l21.2-28.84c4.28-5.59,11.09-14.91,12.37-17,5.87-9.76,6.63-20,1.5-30.24-4.17-8.34-11.57-12.4-20.66-13.56-12.74-1.62-26,4.28-32,16.37A24.54,24.54,0,0,0,675,35.9l13.58,2.94c.21-.59.4-1.07.55-1.55A17,17,0,0,1,698.71,26c5-2.25,12.08-1.38,15.91,1.94,6.44,5.58,6.35,15,1.69,21-.79,1-41,52.26-41,52.26a2.51,2.51,0,0,0-.59,1.61v11.47l59.69-.15V100.68Z"
    ></path>
  </symbol>

  <symbol id="task-incomplete-icon" viewBox="0 0 20 20">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g id="Task-Cell-/-Default" transform="translate(-16.000000, -18.000000)">
        <g id="Design/Icon/Success" transform="translate(16.000000, 18.000000)">
          <g id="Page-1">
            <mask id="mask-2" fill="white">
              <path
                d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2"
              ></path>
            </mask>
            <path
              d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2"
              fill="#CFD4DE"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="task-complete-icon" viewBox="0 0 20 20">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Task-Cell-/-Complete"
        transform="translate(-16.000000, -18.000000)"
      >
        <g id="Design/Icon/Success" transform="translate(12.000000, 14.000000)">
          <g id="Page-1" transform="translate(4.000000, 4.000000)">
            <mask id="task-complete-mask-2" fill="white">
              <path
                d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 Z M14.6401844,6.23177872 C14.2159075,5.87821464 13.5853428,5.9355387 13.2317787,6.3598156 L13.2317787,6.3598156 L8.93280165,11.5185881 L7.20710678,9.79289322 C6.81658249,9.40236893 6.18341751,9.40236893 5.79289322,9.79289322 C5.40236893,10.1834175 5.40236893,10.8165825 5.79289322,11.2071068 L5.79289322,11.2071068 L8.29289322,13.7071068 C8.70869418,14.1229077 9.39177278,14.0919226 9.76822128,13.6401844 L9.76822128,13.6401844 L14.7682213,7.6401844 C15.1217854,7.2159075 15.0644613,6.5853428 14.6401844,6.23177872 Z"
              ></path>
            </mask>
            <path
              d="M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0 M10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 Z M14.6401844,6.23177872 C14.2159075,5.87821464 13.5853428,5.9355387 13.2317787,6.3598156 L13.2317787,6.3598156 L8.93280165,11.5185881 L7.20710678,9.79289322 C6.81658249,9.40236893 6.18341751,9.40236893 5.79289322,9.79289322 C5.40236893,10.1834175 5.40236893,10.8165825 5.79289322,11.2071068 L5.79289322,11.2071068 L8.29289322,13.7071068 C8.70869418,14.1229077 9.39177278,14.0919226 9.76822128,13.6401844 L9.76822128,13.6401844 L14.7682213,7.6401844 C15.1217854,7.2159075 15.0644613,6.5853428 14.6401844,6.23177872 Z"
              fill="#24CA93"
            ></path>
            <g
              id="Design/Colour/Jungle"
              attr.mask="url({{ locationPath }}#task-complete-mask-2)"
            >
              <g transform="translate(-4.000000, -4.000000)"></g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="tasks-completed-icon" viewBox="0 0 132 117">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Modal-/-Setup-Complete"
        transform="translate(-199.000000, -67.000000)"
      >
        <g id="Group-5" transform="translate(192.000000, 60.000000)">
          <g id="Group-8" fill="#26C281" fill-opacity="0.1">
            <path
              d="M20.9359315,24.2674033 L89.9434522,24.2674033 C100.196965,24.2674033 108.509079,32.5795175 108.509079,42.83303 C108.509079,53.0865425 100.196965,61.3986568 89.9434522,61.3986568 L20.9359315,61.3986568 C10.682419,61.3986568 2.37030478,53.0865425 2.37030478,42.83303 C2.37030478,32.5795175 10.682419,24.2674033 20.9359315,24.2674033 Z"
              id="Rectangle-9-Copy"
              transform="translate(55.439692, 42.833030) rotate(-30.000000) translate(-55.439692, -42.833030) "
            ></path>
            <path
              d="M19.2923097,60.9341241 L128.090906,60.9341241 C137.83539,60.9341241 145.734856,68.8335897 145.734856,78.5780743 C145.734856,88.3225589 137.83539,96.2220245 128.090906,96.2220245 L19.2923097,96.2220245 C9.54782503,96.2220245 1.64835945,88.3225589 1.64835945,78.5780743 C1.64835945,68.8335897 9.54782503,60.9341241 19.2923097,60.9341241 Z"
              id="Rectangle-9-Copy"
              transform="translate(73.691608, 78.578074) rotate(-30.000000) translate(-73.691608, -78.578074) "
            ></path>
          </g>
          <g id="Group-6" transform="translate(33.000000, 25.000000)">
            <circle id="Oval-5" fill="#24CA93" cx="40" cy="40" r="40"></circle>
            <g
              id="Group-4"
              transform="translate(25.000000, 30.000000)"
              stroke="#FFFFFF"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="6"
            >
              <line
                x1="0"
                y1="10.6551724"
                x2="9.75319698"
                y2="20.4083694"
                id="Line-6"
              ></line>
              <line
                x1="10.6551724"
                y1="0"
                x2="30.1615664"
                y2="19.506394"
                id="Line-6"
                transform="translate(20.408369, 9.753197) scale(-1, 1) translate(-20.408369, -9.753197) "
              ></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <defs>
    <filter
      x="-80.9%"
      y="-49.6%"
      width="261.7%"
      height="218.8%"
      filterUnits="objectBoundingBox"
      id="ready-filter-2"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.0274509804   0 0 0 0 0.458823529   0 0 0 0 0.88627451  0 0 0 0.42 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-25.3%"
      y="-18.7%"
      width="150.5%"
      height="146.0%"
      filterUnits="objectBoundingBox"
      id="ready-filter-4"
    >
      <feOffset
        dx="0"
        dy="4"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.0274509804   0 0 0 0 0.458823529   0 0 0 0 0.88627451  0 0 0 0.26 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="2"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
    <filter
      x="-15.2%"
      y="-40.5%"
      width="131.8%"
      height="163.0%"
      filterUnits="objectBoundingBox"
      id="ready-filter-6"
    >
      <feOffset
        dx="0"
        dy="-6"
        in="SourceAlpha"
        result="shadowOffsetOuter1"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="6"
        in="shadowOffsetOuter1"
        result="shadowBlurOuter1"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0.0274509804   0 0 0 0 0.458823529   0 0 0 0 0.88627451  0 0 0 0.21 0"
        type="matrix"
        in="shadowBlurOuter1"
        result="shadowMatrixOuter1"
      ></feColorMatrix>
      <feOffset
        dx="0"
        dy="0"
        in="SourceAlpha"
        result="shadowOffsetOuter2"
      ></feOffset>
      <feGaussianBlur
        stdDeviation="2"
        in="shadowOffsetOuter2"
        result="shadowBlurOuter2"
      ></feGaussianBlur>
      <feColorMatrix
        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
        type="matrix"
        in="shadowBlurOuter2"
        result="shadowMatrixOuter2"
      ></feColorMatrix>
      <feMerge>
        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
        <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
      </feMerge>
    </filter>
  </defs>
  <symbol id="invoice-ready-icon" viewBox="0 0 148 144">
    <g id="Registration" stroke="none" stroke-width="1" fill="none">
      <g
        id="Screen-/-Sign-up-/-Ready-to-go"
        transform="translate(-668.000000, -298.000000)"
      >
        <g
          id="Design/Illustration/Medium/Payment-Copy-10"
          transform="translate(677.000000, 299.000000)"
        >
          <g id="Group">
            <g
              id="Group-5"
              transform="translate(8.000000, 0.000000)"
              fill="#ECF3FF"
            >
              <g id="Group-3">
                <path
                  d="M24.8704839,23.4360085 L86.0068342,23.3703508 C97.1531558,23.3583801 106.198739,32.384555 106.21071,43.5308766 C106.210725,43.5453175 106.210725,43.5597584 106.21071,43.5741993 L106.210701,43.5819351 C106.198717,54.75495 97.1441958,63.809483 85.971181,63.8214823 L24.8348307,63.8871401 C13.6885091,63.8991107 4.64292599,54.8729359 4.63095533,43.7266142 C4.63093982,43.7121733 4.63093981,43.6977324 4.6309553,43.6832915 L4.6309636,43.6755558 C4.64294806,32.5025409 13.6974691,23.4480078 24.8704839,23.4360085 Z"
                  id="Rectangle-9"
                  transform="translate(55.420832, 43.628745) rotate(-30.000000) translate(-55.420832, -43.628745) "
                ></path>
                <path
                  d="M22.4559127,64.5738546 L107.82515,64.4821719 C118.971472,64.4702012 128.017055,73.4963761 128.029026,84.6426977 C128.029041,84.6571386 128.029041,84.6715795 128.029026,84.6860204 C128.017037,95.8633103 118.959051,104.921308 107.781761,104.933312 L22.4125238,105.024995 C11.2662021,105.036965 2.22061901,96.0107903 2.20864835,84.8644687 C2.20863284,84.8500278 2.20863283,84.8355869 2.20864832,84.8211459 C2.22063737,73.643856 11.2786228,64.5858586 22.4559127,64.5738546 Z"
                  id="Rectangle-9-Copy"
                  transform="translate(65.118837, 84.753583) rotate(-30.000000) translate(-65.118837, -84.753583) "
                ></path>
                <path
                  d="M74.5964196,92.846615 L113.081115,92.8052842 C124.227436,92.7933135 133.273019,101.819488 133.28499,112.96581 C133.285006,112.980251 133.285006,112.994692 133.28499,113.009133 L133.284969,113.029012 C133.272991,124.195316 124.223909,133.244411 113.057605,133.256403 L74.5729102,133.297734 C63.4265886,133.309704 54.3810055,124.283529 54.3690348,113.137208 C54.3690193,113.122767 54.3690193,113.108326 54.3690348,113.093885 L54.3690561,113.074005 C54.3810334,101.907702 63.4301158,92.8586071 74.5964196,92.846615 Z"
                  id="Rectangle-9-Copy-2"
                  transform="translate(93.827012, 113.051509) rotate(-30.000000) translate(-93.827012, -113.051509) "
                ></path>
              </g>
            </g>
            <g
              id="Group-4"
              transform="translate(74.000000, 29.000000)"
              stroke="#0775E2"
              stroke-linecap="square"
            >
              <line x1="3.5" y1="0.5" x2="3.5" y2="3.5" id="Line"></line>
              <line x1="3.5" y1="5.5" x2="3.5" y2="8.5" id="Line-Copy"></line>
              <line
                x1="2"
                y1="2"
                x2="2"
                y2="5"
                id="Line"
                transform="translate(2.000000, 3.500000) rotate(-90.000000) translate(-2.000000, -3.500000) "
              ></line>
              <line
                x1="7"
                y1="2"
                x2="7"
                y2="5"
                id="Line-Copy"
                transform="translate(7.000000, 3.500000) rotate(-90.000000) translate(-7.000000, -3.500000) "
              ></line>
            </g>
            <g
              id="Group-4-Copy"
              transform="translate(93.000000, 14.000000)"
              stroke="#0775E2"
              stroke-linecap="square"
            >
              <line x1="1.5" y1="0.25" x2="1.5" y2="1.75" id="Line"></line>
              <line x1="1.5" y1="2.25" x2="1.5" y2="3.75" id="Line-Copy"></line>
              <line
                x1="0.888888889"
                y1="0.833333333"
                x2="0.888888889"
                y2="2.16666667"
                id="Line"
                transform="translate(0.888889, 1.500000) rotate(-90.000000) translate(-0.888889, -1.500000) "
              ></line>
              <line
                x1="3.88888889"
                y1="0.833333333"
                x2="3.88888889"
                y2="2.16666667"
                id="Line-Copy"
                transform="translate(3.888889, 1.500000) rotate(-90.000000) translate(-3.888889, -1.500000) "
              ></line>
            </g>
            <g
              id="Group-4-Copy-3"
              transform="translate(127.000000, 57.000000)"
              stroke="#0775E2"
              stroke-linecap="square"
            >
              <line x1="1.5" y1="0.25" x2="1.5" y2="1.75" id="Line"></line>
              <line x1="1.5" y1="2.25" x2="1.5" y2="3.75" id="Line-Copy"></line>
              <line
                x1="0.888888889"
                y1="0.833333333"
                x2="0.888888889"
                y2="2.16666667"
                id="Line"
                transform="translate(0.888889, 1.500000) rotate(-90.000000) translate(-0.888889, -1.500000) "
              ></line>
              <line
                x1="3.88888889"
                y1="0.833333333"
                x2="3.88888889"
                y2="2.16666667"
                id="Line-Copy"
                transform="translate(3.888889, 1.500000) rotate(-90.000000) translate(-3.888889, -1.500000) "
              ></line>
            </g>
            <g
              id="Group-4-Copy-2"
              transform="translate(120.000000, 87.000000)"
              stroke="#0775E2"
              stroke-linecap="square"
            >
              <line x1="0.5" y1="0.25" x2="0.5" y2="1.75" id="Line"></line>
              <line x1="0.5" y1="2.25" x2="0.5" y2="3.75" id="Line-Copy"></line>
              <g
                id="Group-3"
                transform="translate(2.500000, 0.500000) rotate(-90.000000) translate(-2.500000, -0.500000) translate(2.000000, -2.000000)"
              >
                <line
                  x1="0.5"
                  y1="0.222222222"
                  x2="0.5"
                  y2="1.55555556"
                  id="Line"
                ></line>
                <line
                  x1="0.5"
                  y1="3.22222222"
                  x2="0.5"
                  y2="4.55555556"
                  id="Line-Copy"
                ></line>
              </g>
            </g>
            <g
              id="Group-5"
              transform="translate(63.000000, 69.500000) rotate(-180.000000) translate(-63.000000, -69.500000) translate(11.000000, 17.000000)"
              stroke="#0775E2"
            >
              <circle id="Oval-3" cx="84" cy="3" r="2"></circle>
              <circle id="Oval-3-Copy-2" cx="86" cy="59" r="2"></circle>
              <circle id="Oval-3-Copy-6" cx="4" cy="103" r="2"></circle>
              <circle id="Oval-3-Copy" cx="88" cy="11" r="1"></circle>
              <circle id="Oval-3-Copy-9" cx="37" cy="1" r="1"></circle>
              <circle id="Oval-3-Copy-8" cx="14" cy="97" r="1"></circle>
              <circle id="Oval-3-Copy-3" cx="77.5" cy="62.5" r="1"></circle>
              <circle id="Oval-3-Copy-7" cx="0.5" cy="90.5" r="1"></circle>
              <circle id="Oval-3-Copy-4" cx="77.5" cy="23.5" r="1"></circle>
              <circle id="Oval-3-Copy-4" cx="83.5" cy="38.5" r="1"></circle>
              <circle id="Oval-3-Copy-10" cx="43.5" cy="7.5" r="1"></circle>
              <circle id="Oval-3-Copy-5" cx="103.5" cy="23.5" r="1"></circle>
            </g>
            <g id="Group-2" transform="translate(0.153600, 14.945578)">
              <path
                d="M38.9816542,67.1047147 L47.7091502,99.605846 C47.8523805,100.139235 48.4008886,100.455521 48.9342773,100.31229 C49.1434499,100.256121 49.328733,100.133561 49.4622638,99.9630391 L126.8464,1.14182411 L126.8464,1.14182411 L38.9816542,67.1047147 Z"
                id="Path-14"
                fill="#79E5B8"
              ></path>
              <g id="Path-13">
                <path
                  d="M46.6100722,69.808005 L47.7505779,99.3915664 C47.7718537,99.9434411 48.2364842,100.373577 48.7883589,100.352301 C49.0767991,100.341181 49.3463645,100.205964 49.5277473,99.9814166 L71.3464003,72.9704374 L71.3464003,72.9704374 L46.6100722,69.808005 Z"
                  fill="black"
                  fill-opacity="1"
                  filter="url(#ready-filter-2)"
                ></path>
                <path
                  d="M46.6100722,69.808005 L47.7505779,99.3915664 C47.7718537,99.9434411 48.2364842,100.373577 48.7883589,100.352301 C49.0767991,100.341181 49.3463645,100.205964 49.5277473,99.9814166 L71.3464003,72.9704374 L71.3464003,72.9704374 L46.6100722,69.808005 Z"
                  fill="#26C281"
                ></path>
              </g>
              <g id="Path-12">
                <path
                  d="M94.5026323,85.1410117 L125.792934,1.30442177 L125.792934,1.30442177 L46.6100722,69.808005 L91.9443861,86.3208919 C92.9764511,86.6968185 94.1185565,86.1700719 94.5026323,85.1410117 Z"
                  fill="black"
                  fill-opacity="1"
                  filter="url(#ready-filter-4)"
                ></path>
                <path
                  d="M94.5026323,85.1410117 L125.792934,1.30442177 L125.792934,1.30442177 L46.6100722,69.808005 L91.9443861,86.3208919 C92.9764511,86.6968185 94.1185565,86.1700719 94.5026323,85.1410117 Z"
                  fill="#FFFFFF"
                ></path>
              </g>
              <g id="Path-15">
                <path
                  d="M38.9816542,67.1047147 L2.40903343,52.4270106 C1.89648538,52.2213095 1.64773679,51.6390535 1.8534379,51.1265055 C1.95497331,50.8735084 2.15539581,50.6729305 2.40831409,50.571199 L127.068623,0.428987968 L127.068623,0.428987968 L38.9816542,67.1047147 Z"
                  fill="black"
                  fill-opacity="1"
                  filter="url(#ready-filter-6)"
                ></path>
                <path
                  d="M38.9816542,67.1047147 L2.40903343,52.4270106 C1.89648538,52.2213095 1.64773679,51.6390535 1.8534379,51.1265055 C1.95497331,50.8735084 2.15539581,50.6729305 2.40831409,50.571199 L127.068623,0.428987968 L127.068623,0.428987968 L38.9816542,67.1047147 Z"
                  fill="#FFFFFF"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="search-empty-icon" viewBox="0 0 176 176">
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group" transform="translate(26.535714, 23.000000)">
        <path
          d="M89.2410714,97.1964286 L120.151786,97.1964286 C123.465494,97.1964286 126.151786,99.8827201 126.151786,103.196429 L126.151786,115.116071 C126.151786,118.42978 123.465494,121.116071 120.151786,121.116071 L68.2410714,121.116071 L68.2410714,121.116071 L68.2410714,118.196429 C68.2410714,106.598449 77.6430917,97.1964286 89.2410714,97.1964286 Z"
          id="Mint"
          fill="#A4EBD5"
          transform="translate(97.196429, 109.156250) rotate(52.000000) translate(-97.196429, -109.156250) "
        ></path>
        <path
          d="M50.9642857,102 C68.4545567,102 83.8680949,93.1084498 92.9312761,79.5989736 C93.2458364,79.1300935 91.2816586,76.8692313 91.5807408,76.3894043 C96.4056534,68.6486456 101.464286,61.2930653 101.464286,51.5 C101.464286,23.6096201 78.8546656,1 50.9642857,1 C23.0739058,1 0.464285714,23.6096201 0.464285714,51.5 C0.464285714,79.3903799 23.0739058,102 50.9642857,102 Z"
          id="Mint"
          fill="#A4EBD5"
        ></path>
        <path
          d="M67.9464286,89.6428571 L121.410714,89.6428571 C124.724423,89.6428571 127.410714,92.3291486 127.410714,95.6428571 L127.410714,103.785714 C127.410714,107.099423 124.724423,109.785714 121.410714,109.785714 L67.9464286,109.785714 C64.6327201,109.785714 61.9464286,107.099423 61.9464286,103.785714 L61.9464286,95.6428571 C61.9464286,92.3291486 64.6327201,89.6428571 67.9464286,89.6428571 Z"
          id="White-Shadow"
          fill="#FFFFFF"
          transform="translate(94.678571, 99.714286) rotate(52.000000) translate(-94.678571, -99.714286) "
        ></path>
        <circle
          id="Oval"
          fill="#FFFFFF"
          cx="56.4642857"
          cy="47"
          r="47"
        ></circle>
        <circle
          id="Oval"
          stroke="#384D57"
          stroke-width="3"
          fill="#FFFFFF"
          cx="57.4642857"
          cy="44"
          r="42.5"
        ></circle>
        <circle
          id="Oval"
          stroke="#384D57"
          stroke-width="3"
          fill="#FFFFFF"
          cx="57.4642857"
          cy="44"
          r="31.5"
        ></circle>
      </g>
      <path
        d="M103.848214,49 C92.7236215,49 83.7053571,57.5065898 83.7053571,68"
        id="Highlight"
        stroke="#A4EBD5"
        stroke-width="8"
        fill="#FFFFFF"
        transform="translate(93.776786, 58.500000) scale(-1, 1) translate(-93.776786, -58.500000) "
      ></path>
      <path
        d="M114.797792,96.2426336 C112.841244,98.1159263 111.104362,99.6534976 109.583777,100.857064 C107.964015,102.139129 105.502747,103.69659 102.184376,105.54499 L132.078651,144.275442 C132.095472,144.297145 132.095472,144.297145 132.11247,144.318709 C133.65491,146.267428 136.485053,146.596782 138.433771,145.054342 L143.878214,140.744984 C145.817913,139.209684 146.154627,136.396569 144.632065,134.446856 L114.797792,96.2426336 Z"
        id="Handle"
        stroke="#384D57"
        stroke-width="3"
        fill="#FFFFFF"
      ></path>
    </g>
  </symbol>

  <symbol id="filled-circle-checkmark-icon" viewBox="0 0 24 24">
    <path
      transform="translate(3.5 4)"
      fill-rule="nonzero"
      d="M7.272 9.293l4.074-4.094a.676.676 0 01.957.953l-4.538 4.561a.676.676 0 01-.944.014L4.71 8.726a.676.676 0 01.93-.98l1.631 1.547z M8.5 16a8 8 0 100-16 8 8 0 000 16z"
      fill="currentColor"
    />
  </symbol>

  <symbol id="reviews-empty-state-icon" viewBox="0 0 176 176">
    <g
      id="reviews-empty-state-Pictograms"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="reviews-empty-state-DL-I2G---Pictograms-^"
        transform="translate(-1822.000000, -925.000000)"
      ></g>
      <g id="reviews-empty-state-pictogram/feedback">
        <rect
          id="Rectangle"
          fill="#A4EBD5"
          x="26"
          y="44"
          width="128"
          height="85"
          rx="8"
        ></rect>
        <path
          d="M30,36 L137,36 C141.418278,36 145,39.581722 145,44 L145,113.209091 C145,117.627369 141.418278,121.209091 137,121.209091 L67.7148438,121.209091 L67.7148438,121.209091 L39.7851563,148.698242 L39.7851563,121.209091 L30,121.209091 C25.581722,121.209091 22,117.627369 22,113.209091 L22,44 C22,39.581722 25.581722,36 30,36 Z"
          id="Rectangle"
          fill="#FFFFFF"
        ></path>
        <path
          d="M135,37.5 C136.242641,37.5 137.367641,38.0036797 138.181981,38.8180195 C138.99632,39.6323593 139.5,40.7573593 139.5,42 L139.5,42 L139.5,110.373832 C139.5,111.616472 138.99632,112.741472 138.181981,113.555812 C137.367641,114.370152 136.242641,114.873832 135,114.873832 L135,114.873832 L71.4305518,114.873832 L46.6074219,140.303282 L46.6074219,114.873832 L28,114.873832 C26.7573593,114.873832 25.6323593,114.370152 24.8180195,113.555812 C24.0036797,112.741472 23.5,111.616472 23.5,110.373832 L23.5,110.373832 L23.5,42 C23.5,40.7573593 24.0036797,39.6323593 24.8180195,38.8180195 C25.6323593,38.0036797 26.7573593,37.5 28,37.5 L28,37.5 Z"
          id="Rectangle"
          stroke="#162D3D"
          stroke-width="3"
        ></path>
        <polygon
          id="Star-Copy-2"
          fill="#00E591"
          points="112.5 82.25 104.564899 86.4217294 106.080369 77.5858647 99.660737 71.3282706 108.53245 70.0391353 112.5 62 116.46755 70.0391353 125.339263 71.3282706 118.919631 77.5858647 120.435101 86.4217294"
        ></polygon>
        <polygon
          id="Star-Copy-3"
          fill="#00E591"
          points="81.5 82.25 73.5648991 86.4217294 75.0803685 77.5858647 68.660737 71.3282706 77.5324495 70.0391353 81.5 62 85.4675505 70.0391353 94.339263 71.3282706 87.9196315 77.5858647 89.4351009 86.4217294"
        ></polygon>
        <polygon
          id="Star-Copy-4"
          fill="#00E591"
          points="50.5 82.25 42.5648991 86.4217294 44.0803685 77.5858647 37.660737 71.3282706 46.5324495 70.0391353 50.5 62 54.4675505 70.0391353 63.339263 71.3282706 56.9196315 77.5858647 58.4351009 86.4217294"
        ></polygon>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-note-info-icon" viewBox="0 0 16 16">
    <g
      id="Messaging"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Messaging-/-x_overrides-/-Status-Information"
        transform="translate(-8.000000, -24.000000)"
      >
        <g id="icon/Message/Info16" transform="translate(8.000000, 24.000000)">
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconInformation">
            <circle id="Background" fill="#0875E2" cx="8" cy="8" r="8"></circle>
            <rect
              id="stroke"
              fill="#FFFFFF"
              x="7"
              y="7"
              width="2"
              height="6"
            ></rect>
            <rect
              id="Dot"
              fill="#FFFFFF"
              x="7"
              y="3"
              width="2"
              height="2"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="info-xlarge-icon" viewBox="0 0 64 64">
    <defs />
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <g transform="translate(4 4)">
        <circle cx="28" cy="28" r="28" fill="#0875E2" />
        <path fill="#FFF" d="M26 24h4v16h-4zM26 16h4v4h-4z" />
      </g>
    </g>
  </symbol>

  <symbol id="success-xlarge-icon" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <g transform="translate(4 4)">
        <circle cx="28" cy="28" r="28" fill="#22A971" />
        <path
          fill="#FFF"
          d="M38.76 14.67l3.27 2.45-17.86 22.82-.01-.01v.05L14 29.83l2.88-2.89 6.9 6.91z"
        />
      </g>
    </g>
  </symbol>

  <symbol id="alert-xlarge-icon" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h64v64H0z" />
      <g transform="translate(4 4)">
        <circle cx="28" cy="28" r="28" fill="#E80E51" />
        <path fill="#FFF" d="M26 16h4v16h-4zM26 36h4v4h-4z" />
      </g>
    </g>
  </symbol>

  <symbol id="i2g-note-alert-icon" viewBox="0 0 24 24">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Method-/-I2G-Money-/-ID-Required"
        transform="translate(-16.000000, -16.000000)"
      >
        <g
          id="Page-1"
          transform="translate(28.000000, 28.000000) scale(1, -1) translate(-28.000000, -28.000000) translate(16.000000, 16.000000)"
        >
          <path
            d="M12,0 C5.3724,0 0,5.3724 0,12 C0,18.6276 5.3724,24 12,24 C18.6276,24 24,18.6276 24,12 C24,5.3724 18.6276,0 12,0"
            id="Fill-1"
            fill="#E80E51"
          ></path>
          <path
            d="M11,9.80598218 C11,9.36085051 11.4477153,9 12,9 C12.5522847,9 13,9.36085051 13,9.80598218 L13,17.1940178 C13,17.6391495 12.5522847,18 12,18 C11.4477153,18 11,17.6391495 11,17.1940178 L11,9.80598218 Z"
            id="Stroke-3"
            fill="#FFFFFF"
          ></path>
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            x="11"
            y="6"
            width="2"
            height="2"
            rx="1"
          ></rect>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="verify-email-icon" viewBox="0 0 96 96">
    <g
      id="Light-/-Login-Email-Verify-Sm-Ct"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group-2" transform="translate(13.000000, 10.000000)">
        <path
          d="M7.74576271,31 L68.2542373,31 C70.8752627,31 73,33.078282 73,35.6419753 L73,73.3580247 C73,75.921718 70.8752627,78 68.2542373,78 L7.74576271,78 C5.12474915,78 3,75.921718 3,73.3580247 L3,35.6419753 C3,33.078282 5.12474915,31 7.74576271,31 Z"
          id="Clip-2"
          fill="#A4EBD5"
        ></path>
        <path
          d="M4.75862069,24 L64.2413793,24 C66.869506,24 69,26.1068824 69,28.7058824 L69,69.2941176 C69,71.8931059 66.869506,74 64.2413793,74 L4.75862069,74 C2.13050586,74 0,71.8931059 0,69.2941176 L0,28.7058824 C0,26.1068824 2.13050586,24 4.75862069,24 Z"
          id="Clip-5"
          fill="#FFFFFF"
        ></path>
        <polyline
          id="Stroke-7"
          stroke="#162D3D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="3 29 34 18 64 29"
        ></polyline>
        <g id="Email" transform="translate(9.000000, 0.000000)">
          <rect
            id="Rectangle"
            stroke="#122835"
            stroke-width="2"
            fill="#FFFFFF"
            x="1"
            y="1"
            width="46"
            height="58"
            rx="4"
          ></rect>
          <g id="iconSuccess" transform="translate(12.000000, 13.000000)">
            <circle
              id="Background"
              fill="#00E591"
              cx="12"
              cy="12"
              r="12"
            ></circle>
            <circle
              id="Background"
              stroke="#162D3D"
              stroke-width="2"
              cx="12"
              cy="12"
              r="11"
            ></circle>
            <polygon
              id="Tick"
              fill="#122835"
              points="10.1928925 14.5051562 16.6130554 6.28772247 18.0107988 7.33725305 10.3589059 17.1190136 10.3555948 17.1123185 10.3562814 17.1349796 5.99901847 12.7839298 7.23534224 11.547606"
            ></polygon>
          </g>
        </g>
        <path
          d="M5.64210526,28.7042039 L33.5,49.5601057 L33.5,49.5601057 L61.3578947,28.7042039 C62.9159386,27.537784 65.1262333,27.8529739 66.2947368,29.4082005 C66.7525114,30.0174962 67,30.7585718 67,31.5201906 L67,68.4800166 C67,70.4240506 65.4212096,72 63.4736842,72 L3.52631579,72 C1.57878565,72 0,70.4240506 0,68.4800166 L0,31.5201906 C0,29.5761577 1.57878565,28 3.52631579,28 C4.28930532,28 5.03171352,28.247232 5.64210526,28.7042039 Z"
          id="Stroke-15"
          fill="#FFFFFF"
        ></path>
        <path
          d="M61.9571997,29.5047247 C62.5155915,29.0866881 63.1908759,28.9342562 63.8312207,29.0255697 C64.4713048,29.1168461 65.0766237,29.451711 65.4952428,30.0088745 C65.8228211,30.4448796 66,30.9751677 66,31.5201906 L66,31.5201906 L66,68.4800166 C66,69.1756852 65.7173792,69.8054131 65.2606946,70.2612777 C64.8033581,70.7177928 64.1715117,71 63.4736842,71 L63.4736842,71 L3.52631579,71 C2.82848706,71 2.19664083,70.7177935 1.73930484,70.2612788 C1.28262009,69.8054142 1,69.1756857 1,68.4800166 L1,68.4800166 L1,31.5201906 C1,30.8244875 1.28264249,30.1946943 1.73935412,29.738776 C2.19668111,29.2822434 2.82850524,29 3.52631579,29 C4.07318122,29 4.6053007,29.1771891 5.0427955,29.5047211 L5.0427955,29.5047211 L33.5,50.809298 Z"
          id="Stroke-15"
          stroke="#162D3D"
          stroke-width="2"
        ></path>
      </g>
      <rect id="Rectangle" x="0" y="0" width="96" height="96"></rect>
    </g>
  </symbol>

  <symbol id="account-block-icon" viewBox="0 0 96 96">
    <g
      id="Light-/-Login-Verify-Sm"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group-2" transform="translate(2.000000, 26.000000)">
        <path
          d="M7.74576271,13 L68.2542373,13 C70.8752627,13 73,15.078282 73,17.6419753 L73,55.3580247 C73,57.921718 70.8752627,60 68.2542373,60 L7.74576271,60 C5.12474915,60 3,57.921718 3,55.3580247 L3,17.6419753 C3,15.078282 5.12474915,13 7.74576271,13 Z"
          id="Clip-2"
          fill="#A4EBD5"
        ></path>
        <path
          d="M4.75862069,6 L64.2413793,6 C66.869506,6 69,8.10688235 69,10.7058824 L69,51.2941176 C69,53.8931059 66.869506,56 64.2413793,56 L4.75862069,56 C2.13050586,56 0,53.8931059 0,51.2941176 L0,10.7058824 C0,8.10688235 2.13050586,6 4.75862069,6 Z"
          id="Clip-5"
          fill="#FFFFFF"
        ></path>
        <polyline
          id="Stroke-7"
          stroke="#162D3D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="3 11 34 0 64 11"
        ></polyline>
        <path
          d="M61.9571997,11.5047247 C62.5155915,11.0866881 63.1908759,10.9342562 63.8312207,11.0255697 C64.4713048,11.1168461 65.0766237,11.451711 65.4952428,12.0088745 C65.8228211,12.4448796 66,12.9751677 66,13.5201906 L66,13.5201906 L66,50.4800166 C66,51.1756852 65.7173792,51.8054131 65.2606946,52.2612777 C64.8033581,52.7177928 64.1715117,53 63.4736842,53 L63.4736842,53 L3.52631579,53 C2.82848706,53 2.19664083,52.7177935 1.73930484,52.2612788 C1.28262009,51.8054142 1,51.1756857 1,50.4800166 L1,50.4800166 L1,13.5201906 C1,12.8244875 1.28264249,12.1946943 1.73935412,11.738776 C2.19668111,11.2822434 2.82850524,11 3.52631579,11 C4.07318122,11 4.6053007,11.1771891 5.0427955,11.5047211 L5.0427955,11.5047211 L33.5,32.809298 Z"
          id="Stroke-15"
          stroke="#162D3D"
          stroke-width="2"
        ></path>
      </g>
      <g id="Group" transform="translate(23.000000, 13.000000)">
        <rect
          id="Rectangle"
          fill="#00E591"
          x="0"
          y="11"
          width="26"
          height="23"
          rx="3"
        ></rect>
        <rect
          id="Rectangle"
          stroke="#162D3D"
          stroke-width="2"
          x="1"
          y="12"
          width="24"
          height="21"
          rx="3"
        ></rect>
        <circle
          id="Oval-7"
          stroke="#162D3D"
          stroke-width="2"
          fill="#FFFFFF"
          cx="13"
          cy="22"
          r="3"
        ></circle>
        <path
          d="M13,1 C14.927159,1 16.6691451,1.8284465 17.9311317,3.15965117 C19.2119307,4.51070002 20,6.37826851 20,8.43878766 L20,8.43878766 L20,12 L6,12 L6,8.43878766 C6,6.37826851 6.7880693,4.51070002 8.06886829,3.15965117 C9.33085495,1.8284465 11.072841,1 13,1 Z"
          id="Oval"
          stroke="#162D3D"
          stroke-width="2"
        ></path>
      </g>
      <rect id="Rectangle" x="0" y="0" width="96" height="96"></rect>
    </g>
  </symbol>

  <symbol id="filled-circle-checkmark-icon" viewBox="0 0 24 24">
    <path
      transform="translate(3.5 4)"
      fill-rule="nonzero"
      d="M7.272 9.293l4.074-4.094a.676.676 0 01.957.953l-4.538 4.561a.676.676 0 01-.944.014L4.71 8.726a.676.676 0 01.93-.98l1.631 1.547z M8.5 16a8 8 0 100-16 8 8 0 000 16z"
      fill="currentColor"
    />
  </symbol>

  <symbol id="green-checkmark-icon" viewBox="0 0 43 42">
    <g
      id="Web"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="Web-/-Mark-1-Copy"
        transform="translate(-66.000000, -65.000000)"
        stroke="#22A971"
        stroke-width="5"
      >
        <g id="Group-2" transform="translate(66.000000, 65.000000)">
          <polyline
            id="Path-2"
            points="3.2590332 22 16.6025391 38.6630859 39.5874023 3.16894531"
          ></polyline>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="global-star-icon" viewBox="0 0 28 28">
    <g
      id="Profiles-V3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linejoin="round"
    >
      <g
        id="C1-/-Profile-/-Reviews-v3"
        transform="translate(-210.000000, -216.000000)"
        fill="#22A971"
        stroke="#22A971"
        stroke-width="2.5"
      >
        <g id="Hero" transform="translate(16.000000, 168.000000)">
          <g id="Star-40" transform="translate(106.000000, 40.000000)">
            <g
              id="icons-/-star-/-star40"
              transform="translate(86.000000, 7.000000)"
            >
              <path
                d="M16,-0.169854224 L19.5469134,11.1180926 L31.3784452,11.0032402 L21.7390264,17.8647227 L25.5044018,29.0816869 L16,22.0343694 L6.49559816,29.0816869 L10.2609736,17.8647227 L0.621554772,11.0032402 L12.4530866,11.1180926 L16,-0.169854224 Z"
                id="Star"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="job-empty-state-icon" viewBox="0 0 176 176">
    <g
      id="job-empty-state-pictogram/file"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect
        id="job-empty-state-Bounding-box"
        x="0"
        y="0"
        width="176"
        height="176"
      ></rect>
      <g id="Group-15" transform="translate(31.000000, 41.000000)">
        <rect
          id="Rectangle"
          fill="#A4EBD5"
          x="19"
          y="15"
          width="105"
          height="90"
          rx="6"
        ></rect>
        <rect
          id="Rectangle"
          fill="#FFFFFF"
          x="0"
          y="7"
          width="116"
          height="90"
          rx="8"
        ></rect>
        <rect
          id="Rectangle"
          fill="#A4EBD5"
          x="11"
          y="3"
          width="88"
          height="86"
          rx="8"
        ></rect>
        <path
          d="M41.8935078,1.5 L50.0526875,12.5947266 L105.879883,12.5947266 C107.122523,12.5947266 108.247523,13.0984062 109.061863,13.912746 C109.876203,14.7270859 110.379883,15.8520859 110.379883,17.0947266 L110.379883,17.0947266 L110.379883,87 C110.379883,88.2426407 109.876203,89.3676407 109.061863,90.1819805 C108.247523,90.9963203 107.122523,91.5 105.879883,91.5 L105.879883,91.5 L9,91.5 C7.75735931,91.5 6.63235931,90.9963203 5.81801948,90.1819805 C5.00367966,89.3676407 4.5,88.2426407 4.5,87 L4.5,87 L4.5,6 C4.5,4.75735931 5.00367966,3.63235931 5.81801948,2.81801948 C6.63235931,2.00367966 7.75735931,1.5 9,1.5 L9,1.5 L41.8935078,1.5 Z"
          id="Rectangle"
          stroke="#162D3D"
          stroke-width="3"
          fill="#FFFFFF"
        ></path>
        <rect
          id="Rectangle"
          fill="#00E591"
          x="60"
          y="21"
          width="41"
          height="13"
          rx="2"
        ></rect>
        <rect
          id="Rectangle"
          fill="#384D57"
          x="69"
          y="38"
          width="32"
          height="3"
        ></rect>
      </g>
    </g>
  </symbol>

  <symbol id="attachment-blue-icon" viewBox="0 0 84 108">
    <defs>
      <linearGradient
        x1="50%"
        y1="100%"
        x2="50%"
        y2="3.061617e-15%"
        id="linearGradient-1"
      >
        <stop stop-color="#0875E2" offset="0%"></stop>
        <stop stop-color="#0875E2" stop-opacity="0.8" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g id="Rectangle-Copy-14" transform="translate(2.000000, 2.000000)">
        <g id="Rectangle-Copy">
          <mask id="mask-3" fill="white">
            <path
              d="M4.44444444,0 L48.8888889,0 C51.3434878,-4.81114602e-15 53.3333333,1.98984556 53.3333333,4.44444444 L53.3333333,20.8888889 C53.3333333,24.5707872 56.3181017,27.5555556 60,27.5555556 L75.5555556,27.5555556 C78.0101544,27.5555556 80,29.5454011 80,32 L80,100 C80,102.454599 78.0101544,104.444444 75.5555556,104.444444 L4.44444444,104.444444 C1.98984556,104.444444 -5.87576753e-16,102.454599 0,100 L0,4.44444444 C-3.00601667e-16,1.98984556 1.98984556,-4.37275919e-16 4.44444444,0 Z"
            ></path>
          </mask>
          <path
            d="M4.44444444,0 L48.8888889,0 C51.3434878,-4.81114602e-15 53.3333333,1.98984556 53.3333333,4.44444444 L53.3333333,20.8888889 C53.3333333,24.5707872 56.3181017,27.5555556 60,27.5555556 L75.5555556,27.5555556 C78.0101544,27.5555556 80,29.5454011 80,32 L80,100 C80,102.454599 78.0101544,104.444444 75.5555556,104.444444 L4.44444444,104.444444 C1.98984556,104.444444 -5.87576753e-16,102.454599 0,100 L0,4.44444444 C-3.00601667e-16,1.98984556 1.98984556,-4.37275919e-16 4.44444444,0 Z"
            stroke="#FFFFFF"
            stroke-width="2.22222222"
            fill="url(#linearGradient-1)"
          ></path>
        </g>
        <mask id="mask-5" fill="white">
          <path
            d="M4.44444444,0 L51.4495614,0 C52.6535673,2.8057503e-15 53.8060572,0.488481299 54.6433487,1.35368254 L78.7493429,26.2632098 C79.551522,27.0921283 80,28.2004566 80,29.3539717 L80,100 C80,102.454599 78.0101544,104.444444 75.5555556,104.444444 L4.44444444,104.444444 C1.98984556,104.444444 -5.87576753e-16,102.454599 0,100 L0,4.44444444 C-3.00601667e-16,1.98984556 1.98984556,-4.37275919e-16 4.44444444,0 Z"
          ></path>
        </mask>
        <path
          d="M4.44444444,0 L51.4495614,0 C52.6535673,2.8057503e-15 53.8060572,0.488481299 54.6433487,1.35368254 L78.7493429,26.2632098 C79.551522,27.0921283 80,28.2004566 80,29.3539717 L80,100 C80,102.454599 78.0101544,104.444444 75.5555556,104.444444 L4.44444444,104.444444 C1.98984556,104.444444 -5.87576753e-16,102.454599 0,100 L0,4.44444444 C-3.00601667e-16,1.98984556 1.98984556,-4.37275919e-16 4.44444444,0 Z"
          stroke="#0875E2"
          stroke-width="2.22222222"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="invoices-empty-state-icon" viewBox="0 0 109 132">
    <g id="*Empty-state" stroke="none" stroke-width="1" fill="none">
      <g
        id="Web---Overdue-invoices---Empty-state----Modal-in-full-"
        transform="translate(-209.000000, -222.000000)"
      >
        <g id="Group" transform="translate(176.000000, 200.000000)">
          <rect id="Bounding-box" x="0" y="0" width="176" height="176"></rect>
          <g transform="translate(33.000000, 22.000000)" id="Document">
            <g
              transform="translate(54.500000, 66.500000) scale(-1, 1) translate(-54.500000, -66.500000) "
            >
              <rect
                id="Shadow"
                fill="#A4EBD5"
                transform="translate(60.000000, 70.000000) rotate(5.000000) translate(-60.000000, -70.000000) "
                x="16"
                y="11"
                width="88"
                height="118"
                rx="8"
              ></rect>
              <rect
                id="Edge"
                fill="#FFFFFF"
                x="0"
                y="0"
                width="95"
                height="120"
                rx="8"
              ></rect>
              <rect
                id="Paper"
                stroke="#162D3D"
                stroke-width="3"
                x="6.5"
                y="4.5"
                width="83"
                height="111"
                rx="6"
              ></rect>
            </g>
          </g>
          <path
            d="M97.0002679,108.385827 C83.1928464,108.385827 72,97.1929804 72,83.3860947 C72,69.5786731 83.1928464,58.3858268 97.0002679,58.3858268 C110.807154,58.3858268 122,69.5786731 122,83.3860947 C122,97.1929804 110.807154,108.385827 97.0002679,108.385827 Z"
            id="Shadow"
            fill="#A4EBD5"
          ></path>
          <path
            d="M96.5002411,104.385827 C84.0735617,104.385827 74,94.3122651 74,81.8860679 C74,69.4593885 84.0735617,59.3858268 96.5002411,59.3858268 C108.926438,59.3858268 119,69.4593885 119,81.8860679 C119,94.3122651 108.926438,104.385827 96.5002411,104.385827 Z"
            id="Edge"
            fill="#FFFFFF"
          ></path>
          <g transform="translate(70.000000, 56.000000)" id="iconSuccess">
            <g transform="translate(3.000000, 3.000000)">
              <circle
                id="Background"
                fill="#00E591"
                cx="21"
                cy="21"
                r="21"
              ></circle>
              <circle
                id="Background"
                stroke="#162D3D"
                stroke-width="3"
                cx="21"
                cy="21"
                r="21"
              ></circle>
              <polygon
                id="Tick"
                fill="#122835"
                points="17.8375619 25.3840234 29.0728469 11.0035143 31.5188978 12.8401928 18.1280853 29.9582738 18.122291 29.9465573 18.1234924 29.9862144 10.4982823 22.3718771 12.6618489 20.2083105"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="attachment-loading-icon" viewBox="0 0 24 24">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none">
      <g
        id="Web-/-Attach-Loading"
        transform="translate(-40.000000, -40.000000)"
      >
        <g id="Group-Copy-2" transform="translate(40.000000, 40.000000)">
          <path
            d="M12,0 C5.3724,0 0,5.3724 0,12 C0,18.6276 5.3724,24 12,24 C18.6276,24 24,18.6276 24,12 C24,5.3724 18.6276,0 12,0 M12,2.4 C17.2932,2.4 21.6,6.7068 21.6,12 C21.6,17.2932 17.2932,21.6 12,21.6 C6.7068,21.6 2.4,17.2932 2.4,12 C2.4,6.7068 6.7068,2.4 12,2.4"
            id="Mask"
            fill-opacity="0.1"
            fill="#162D3D"
          ></path>
          <path
            d="M12,1.2 C17.9646753,1.2 22.8,6.0353247 22.8,12 L22.8,12 L22.8,12"
            id="Path-2"
            stroke="#26C281"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="add-photo-icon" viewBox="0 0 20 17">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none">
      <g id="Group" transform="translate(-4.000000, -5.000000)">
        <g id="Colour/Jungle" transform="translate(4.000000, 5.000000)">
          <mask id="mask-2" fill="white">
            <path
              d="M12.7322263,0 C13.140283,0 13.5095418,0.238032904 13.6726207,0.606200395 L14.1848022,1.76250297 L17.4148664,1.76250297 C18.8737841,1.76250297 20.0016288,3.03614794 20.0016288,4.53474697 L20.0016288,14.227756 C20.0016288,15.726355 18.8737841,17 17.4148664,17 L2.58676243,17 C1.12784474,17 0,15.726355 0,14.227756 L0,4.53474697 C0,3.03614794 1.12784474,1.76250297 2.58676243,1.76250297 L5.81682669,1.76250297 L6.32900817,0.606200395 C6.49208708,0.238032904 6.86134585,0 7.26940258,0 L12.7322263,0 Z M12.0603469,2.01948206 L7.94128196,2.01948206 L7.42910049,3.17578464 C7.26602158,3.54395213 6.89676281,3.78198503 6.48870608,3.78198503 L2.58676243,3.78198503 C2.32849225,3.78198503 2.05176477,4.09448599 2.05176477,4.53474697 L2.05176477,14.227756 C2.05176477,14.668017 2.32849225,14.9805179 2.58676243,14.9805179 L17.4148664,14.9805179 C17.6731366,14.9805179 17.9498641,14.668017 17.9498641,14.227756 L17.9498641,4.53474697 C17.9498641,4.09448599 17.6731366,3.78198503 17.4148664,3.78198503 L13.5129228,3.78198503 C13.104866,3.78198503 12.7356073,3.54395213 12.5725284,3.17578464 L12.0603469,2.01948206 Z M10.0008657,4.74896344 C12.5504756,4.74896344 14.6173364,6.81582432 14.6173364,9.36543417 C14.6173364,11.915044 12.5504756,13.9819049 10.0008657,13.9819049 C7.45125587,13.9819049 5.38439499,11.915044 5.38439499,9.36543417 C5.38439499,6.81582432 7.45125587,4.74896344 10.0008657,4.74896344 Z M10.0008657,6.80072821 C8.58441427,6.80072821 7.43615976,7.94898272 7.43615976,9.36543417 C7.43615976,10.7818856 8.58441427,11.9301401 10.0008657,11.9301401 C11.4173172,11.9301401 12.5655717,10.7818856 12.5655717,9.36543417 C12.5655717,7.94898272 11.4173172,6.80072821 10.0008657,6.80072821 Z"
            ></path>
          </mask>
          <path
            d="M12.7322263,0 C13.140283,0 13.5095418,0.238032904 13.6726207,0.606200395 L14.1848022,1.76250297 L17.4148664,1.76250297 C18.8737841,1.76250297 20.0016288,3.03614794 20.0016288,4.53474697 L20.0016288,14.227756 C20.0016288,15.726355 18.8737841,17 17.4148664,17 L2.58676243,17 C1.12784474,17 0,15.726355 0,14.227756 L0,4.53474697 C0,3.03614794 1.12784474,1.76250297 2.58676243,1.76250297 L5.81682669,1.76250297 L6.32900817,0.606200395 C6.49208708,0.238032904 6.86134585,0 7.26940258,0 L12.7322263,0 Z M12.0603469,2.01948206 L7.94128196,2.01948206 L7.42910049,3.17578464 C7.26602158,3.54395213 6.89676281,3.78198503 6.48870608,3.78198503 L2.58676243,3.78198503 C2.32849225,3.78198503 2.05176477,4.09448599 2.05176477,4.53474697 L2.05176477,14.227756 C2.05176477,14.668017 2.32849225,14.9805179 2.58676243,14.9805179 L17.4148664,14.9805179 C17.6731366,14.9805179 17.9498641,14.668017 17.9498641,14.227756 L17.9498641,4.53474697 C17.9498641,4.09448599 17.6731366,3.78198503 17.4148664,3.78198503 L13.5129228,3.78198503 C13.104866,3.78198503 12.7356073,3.54395213 12.5725284,3.17578464 L12.0603469,2.01948206 Z M10.0008657,4.74896344 C12.5504756,4.74896344 14.6173364,6.81582432 14.6173364,9.36543417 C14.6173364,11.915044 12.5504756,13.9819049 10.0008657,13.9819049 C7.45125587,13.9819049 5.38439499,11.915044 5.38439499,9.36543417 C5.38439499,6.81582432 7.45125587,4.74896344 10.0008657,4.74896344 Z M10.0008657,6.80072821 C8.58441427,6.80072821 7.43615976,7.94898272 7.43615976,9.36543417 C7.43615976,10.7818856 8.58441427,11.9301401 10.0008657,11.9301401 C11.4173172,11.9301401 12.5655717,10.7818856 12.5655717,9.36543417 C12.5655717,7.94898272 11.4173172,6.80072821 10.0008657,6.80072821 Z"
            fill="#000000"
          ></path>
          <g id="Group" mask="url(#mask-2)">
            <g transform="translate(-4.000000, -5.000000)" id="Colour/Jungle">
              <rect
                id="Rectangle"
                fill="#0580E6"
                x="0"
                y="0"
                width="28"
                height="28"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="job-files-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Documents"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M14,2 L20,8 L20,22 L4,22 L4,2 L14,2 Z M13.171,4 L6,4 L6,20 L18,20 L18,8.829 L13.171,4 Z"
        id="Rectangle"
        fill="currentColor"
      ></path>
      <polygon
        id="Path"
        fill="currentColor"
        points="14 2 14 8 20 8 20 10 12 10 12 2"
      ></polygon>
    </g>
  </symbol>

  <symbol id="job-info-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Profile"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M11.9999237,15.8743457 C10.0040862,15.8743457 8.14621667,16.6906403 6.80659112,18.0840632 C8.20454404,19.2793157 10.0181096,20 12,20 C13.9818904,20 15.795456,19.2793157 17.1929269,18.0857169 C15.8537423,16.6904691 13.9956684,15.8743457 11.9999237,15.8743457 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,13.7139759 4.53900799,15.3020597 5.45676454,16.603992 C6.59844928,15.4497383 8.02337748,14.6170856 9.59233563,14.1930399 C8.62488803,13.4639456 8,12.304948 8,11 C8,8.790861 9.790861,7 12,7 C14.209139,7 16,8.790861 16,11 C16,12.304948 15.375112,13.4639456 14.4082464,14.1940822 C15.9760404,14.6168851 17.4010814,15.4494414 18.5424915,16.6031161 C19.460992,15.3020597 20,13.7139759 20,12 C20,7.581722 16.418278,4 12,4 Z M12,9 C10.8954305,9 10,9.8954305 10,11 C10,12.1045695 10.8954305,13 12,13 C13.1045695,13 14,12.1045695 14,11 C14,9.8954305 13.1045695,9 12,9 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
    </g>
  </symbol>

  <symbol id="job-note-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Notes"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M14,2 L14,4 L5,3.999 L5,19.999 L19,19.999 L19,8.4 L21,8.4 L21,22 L3,22 L3,2 L14,2 Z M10.0710678,12 L11.4852814,13.4142136 L9.37754593,14.1349052 L10.0710678,12 Z M18.0710678,4 L19.4852814,5.41421356 L12.4142136,12.4852814 L11,11.0710678 L18.0710678,4 Z M20.0710678,2 L21.4852814,3.41421356 L20.0710678,4.82842712 L18.6568542,3.41421356 L20.0710678,2 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
    </g>
  </symbol>

  <symbol id="trash-icon" viewBox="0 0 28 28">
    <g id="trash-Save-a-card" stroke="none" stroke-width="1" fill="none">
      <g
        id="trash-04_Pay-portal---Saved-card"
        transform="translate(-297.000000, -279.000000)"
      >
        <g
          id="trash-Design/Icon/Delete"
          transform="translate(297.000000, 279.000000)"
        >
          <g id="trash-Colour/Jungle">
            <path
              d="M7,12 C7,11.4477153 7.44771525,11 8,11 C8.55228475,11 9,11.4477153 9,12 L9,20.0480347 C9,20.7048476 9.24606432,20.9426724 10.0195923,21 L18.0003662,21 C18.7864986,21 19,20.7915881 19,20.0480347 L19,12 C19,11.4477153 19.4477153,11 20,11 C20.5522847,11 21,11.4477153 21,12 L21,20.0480347 C21,21.9071016 19.8804122,23 18.0003662,23 L9.94890011,22.9974982 C8.10033053,22.866491 7,21.8030056 7,20.0480347 L7,12 Z"
              id="trash-Path-4"
              fill="#fff"
            ></path>
            <path
              d="M12,9.02941895 L10,9.02941895 L10,8.04272461 C10,6.1404144 11.1192498,5.01267322 13.0273437,5 L15.0565294,5.00088252 C16.9176887,5.07912588 18.0166016,6.17803872 18.0166016,8.0020752 L18.0166016,9.02941895 L16.0166016,9.02941895 L16.0166016,8.0020752 C16.0166016,7.26890138 15.7807976,7.03309743 15.0145264,7 L13.033997,6.99997787 C12.2323127,7.00531181 12,7.23938704 12,8.04272461 L12,9.02941895 Z"
              id="trash-Path-5"
              fill="#fff"
            ></path>
            <rect
              id="trash-Rectangle-2"
              fill="#fff"
              x="7"
              y="8"
              width="14"
              height="2"
              rx="1"
            ></rect>
            <rect
              id="trash-Rectangle-3"
              fill="#fff"
              x="11"
              y="11"
              width="2"
              height="8"
              rx="1"
            ></rect>
            <rect
              id="trash-Rectangle-3-Copy"
              fill="#fff"
              x="15"
              y="11"
              width="2"
              height="8"
              rx="1"
            ></rect>
            <g></g>
          </g>
        </g>
      </g>
    </g>
  </symbol>
  <symbol id="image-file-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Document-Jpeg"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M22,4 L22,20 L2,20 L2,4 L22,4 Z M20,6 L4,6 L4,18 L20,18 L20,6 Z"
        id="Combined-Shape"
        fill="#162D3D"
      ></path>
      <polyline
        id="Line"
        stroke="#162D3D"
        stroke-width="2"
        points="3.04858398 17.03125 8 13 11.0153809 15.0305176 16.0131836 9.92626953 21.1008301 16.1101074"
      ></polyline>
      <rect
        id="Rectangle"
        fill="#162D3D"
        x="6"
        y="8"
        width="2"
        height="2"
      ></rect>
    </g>
  </symbol>

  <symbol id="pdf-file-icon" viewBox="0 0 24 24">
    <g
      id="icons-/-24-/-Document-PDF"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
      <path
        d="M14,2 L20,8 L20,22 L4,22 L4,2 L14,2 Z M13.171,4 L6,4 L6,20 L18,20 L18,8.829 L13.171,4 Z"
        id="Rectangle"
        fill="#162D3D"
      ></path>
      <line
        x1="9.35"
        y1="15.6"
        x2="12.15"
        y2="12.4"
        id="Line-2"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
      <line
        x1="12.15"
        y1="12.6666667"
        x2="11.1"
        y2="9"
        id="Line-2-Copy-2"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
      <line
        x1="12.15"
        y1="12.5"
        x2="14.95"
        y2="14"
        id="Line-2-Copy"
        stroke="#162D3D"
        stroke-width="2"
        stroke-linecap="square"
      ></line>
    </g>
  </symbol>

  <symbol id="invoice2go-money-icon" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
      <path fill="#FFF" d="M0 0h40v40H0z" />
      <path
        d="M32.337 9.797L6.465 20.483a.274.274 0 00-.165.258c.002.113.07.214.172.253l7.682 2.889a.254.254 0 00.246-.037l14.563-11.02a.035.035 0 01.047.007.038.038 0 01-.003.05L16.112 24.53a.277.277 0 00-.092.208v6.212c0 .116.07.22.175.258a.256.256 0 00.292-.085l3.721-4.766a.256.256 0 01.294-.084l4.747 1.787a.26.26 0 00.332-.147l7.098-17.76a.28.28 0 00-.054-.298.255.255 0 00-.287-.06"
        fill="#00DE8C"
      />
    </g>
  </symbol>

  <symbol id="paypal-icon" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
      <path fill="#FFF" d="M0 0h40v40H0z" />
      <path
        d="M13.076 6h7.8c2.196 0 4.801.071 6.544 1.608 1.164 1.027 1.775 2.663 1.634 4.42-.478 5.954-4.04 9.29-8.817 9.29H16.39c-.654 0-1.088.434-1.273 1.609l-1.073 6.827c-.07.443-.262.704-.612.736H8.627c-.533 0-.722-.408-.583-1.291l3.46-21.903C11.642 6.418 12.123 6 13.076 6"
        fill="#1B3D92"
      />
      <path
        d="M18.092 12.857h7.791c4.183 0 5.758 2.117 5.515 5.233-.401 5.137-3.507 7.977-7.626 7.977h-2.08c-.564 0-.944.373-1.098 1.388l-.892 5.888c-.058.382-.26.607-.561.634h-4.886c-.46 0-.623-.351-.503-1.113l2.984-18.89c.12-.757.533-1.117 1.356-1.117"
        fill="#00A2D3"
      />
      <path
        d="M14.857 22.595l1.362-8.62c.12-.757.534-1.118 1.357-1.118h7.79c1.29 0 2.332.201 3.15.572-.784 5.3-4.212 8.245-8.7 8.245h-3.847c-.506 0-.885.26-1.112.92"
        fill="#1B2E7F"
      />
    </g>
  </symbol>

  <symbol id="stripe-icon" viewBox="0 0 40 40">
    <g fill="none" fill-rule="evenodd">
      <path fill="#FFF" d="M0 0h40v40H0z" />
      <g fill="#6772E5" stroke-linecap="round" stroke-linejoin="round">
        <path
          d="M18.407 15.735c0-.945.8-1.315 2.09-1.315 2.141.046 4.239.58 6.134 1.564v-5.703a16.569 16.569 0 00-6.133-1.102c-4.978 0-8.32 2.56-8.32 6.84 0 6.692 9.362 5.608 9.362 8.491 0 1.128-.985 1.48-2.365 1.48-2.04 0-4.672-.829-6.738-1.931v5.77c2.127.91 4.42 1.387 6.738 1.394 5.12 0 8.647-2.481 8.647-6.837 0-7.218-9.415-5.93-9.415-8.65"
        />
        <path
          d="M18.23 15.558c0-.946.8-1.316 2.09-1.316 2.14.046 4.238.58 6.133 1.564v-5.703a16.569 16.569 0 00-6.133-1.102c-4.978 0-8.32 2.56-8.32 6.841 0 6.692 9.362 5.607 9.362 8.49 0 1.128-.985 1.48-2.365 1.48-2.04 0-4.672-.829-6.737-1.93v5.77c2.126.91 4.42 1.386 6.737 1.394 5.12 0 8.647-2.482 8.647-6.838 0-7.218-9.415-5.93-9.415-8.65"
        />
      </g>
    </g>
  </symbol>

  <symbol id="context-menu-icon" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z" />
      <circle fill="#162D3D" cx="6" cy="12" r="2" />
      <circle fill="#162D3D" cx="12" cy="12" r="2" />
      <circle fill="#162D3D" cx="18" cy="12" r="2" />
    </g>
  </symbol>

  <symbol id="account-not-linked-icon" viewBox="0 0 95 113">
    <g fill="none" fill-rule="evenodd">
      <path d="M-26-10h140v140H-26z" />
      <g transform="matrix(-1 0 0 1 86.955 7.5)">
        <rect
          fill="#CECFD5"
          transform="rotate(5 47.727 55.682)"
          x="12.727"
          y="8.75"
          width="70"
          height="93.864"
          rx="6.364"
        />
        <rect fill="#FFF" width="75.568" height="95.455" rx="6.364" />
        <rect
          stroke="#162D3D"
          stroke-width="3"
          fill="#FFF"
          x="5.477"
          y="3.886"
          width="65.409"
          height="87.682"
          rx="4.773"
        />
      </g>
      <g transform="translate(59.114 .34)">
        <circle fill="#E80E51" cx="17.5" cy="17.5" r="16.705" />
        <circle
          stroke="#162D3D"
          stroke-width="2.386"
          cx="17.5"
          cy="17.5"
          r="16.307"
        />
      </g>
      <path
        fill="#FFF"
        d="M75.023 8.295h3.182v12.728h-3.182zM75.023 24.205h3.182v3.181h-3.182z"
      />
      <g fill="#162D3D">
        <path
          d="M36.045 63.182H61.5v3.182H36.045zM36.045 45.538L48.773 42.5 61.5 45.538v3.326H36.045zM38.431 51.25h3.182v9.545h-3.182zM47.181 51.25h3.182v9.545h-3.182zM55.931 51.25h3.182v9.545h-3.182z"
        />
      </g>
    </g>
  </symbol>

  <symbol id="chevron-down-2-icon" viewBox="0 0 24 24">
    <path
      d="M12.003 14.893a.537.537 0 00.393-.17l4.535-4.647a.545.545 0 00.088-.65.517.517 0 00-.463-.264.543.543 0 00-.381.152L12 13.583 7.825 9.314a.53.53 0 00-.38-.152.517.517 0 00-.463.264.545.545 0 00-.07.275.527.527 0 00.157.381l4.535 4.64c.118.114.25.17.399.17z"
      fill="#707785"
      fill-rule="nonzero"
    />
  </symbol>

  <symbol id="account-no-transactions-icon" viewBox="0 0 87 106">
    <g transform="translate(-26 -17)" fill="none" fill-rule="evenodd">
      <path d="M0 0h140v140H0z" />
      <g transform="matrix(-1 0 0 1 112.955 17.5)">
        <rect
          fill="#A4EBD5"
          transform="rotate(5 47.727 55.682)"
          x="12.727"
          y="8.75"
          width="70"
          height="93.864"
          rx="6.364"
        />
        <rect fill="#FFF" width="75.568" height="95.455" rx="6.364" />
        <rect
          stroke="#162D3D"
          stroke-width="2.386"
          x="5.17"
          y="3.58"
          width="66.023"
          height="88.295"
          rx="4.773"
        />
      </g>
      <circle fill="#00E591" cx="62.841" cy="42.159" r="11.932" />
      <circle
        stroke="#162D3D"
        stroke-width="2.386"
        cx="62.841"
        cy="42.159"
        r="10.739"
      />
      <path
        d="M62.985 42.955V27.84c-8.347 0-15.113 6.767-15.113 15.114h15.113z"
        fill="#FFF"
      />
      <path
        d="M61.792 29.085V41.76H49.115a13.876 13.876 0 014.027-8.65 13.876 13.876 0 018.65-4.026h0z"
        stroke="#162D3D"
        stroke-width="2.386"
      />
      <path
        fill="#A4EBD5"
        d="M71.989 66.023l12.117 7.263 14.53-13.627v39.773H50.91V88.149z"
      />
      <path
        d="M96.977 58.04a1.193 1.193 0 011.808 1.554l-.08.092L84.97 74.11c-.367.386-.94.478-1.406.24l-.098-.056-10.36-6.593-21.352 21.438a1.193 1.193 0 01-1.596.085l-.091-.082a1.193 1.193 0 01-.085-1.597l.082-.09 22.029-22.116a1.193 1.193 0 011.382-.224l.104.059 10.34 6.58L96.977 58.04z"
        fill="#162D3D"
      />
    </g>
  </symbol>

  <symbol id="dotted-spinner-icon" viewBox="0 0 20 20">
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Spinner-/-Circle-Dots" fill="#23A474" fill-rule="nonzero">
        <path
          d="M4.34314575,2.64314575 C5.28202983,2.64314575 6.04314575,3.40426168 6.04314575,4.34314575 C6.04314575,5.28202983 5.28202983,6.04314575 4.34314575,6.04314575 C3.40426168,6.04314575 2.64314575,5.28202983 2.64314575,4.34314575 C2.64314575,3.40426168 3.40426168,2.64314575 4.34314575,2.64314575 Z"
          id="Dot"
          transform="translate(4.343146, 4.343146) rotate(-225.000000) translate(-4.343146, -4.343146) "
        ></path>
        <path
          d="M2,8.4 C2.8836556,8.4 3.6,9.1163444 3.6,10 C3.6,10.8836556 2.8836556,11.6 2,11.6 C1.1163444,11.6 0.4,10.8836556 0.4,10 C0.4,9.1163444 1.1163444,8.4 2,8.4 Z"
          id="Dot"
          opacity="0.949999988"
          transform="translate(2.000000, 10.000000) rotate(-270.000000) translate(-2.000000, -10.000000) "
        ></path>
        <path
          d="M4.34314575,14.1568542 C5.17157288,14.1568542 5.84314575,14.8284271 5.84314575,15.6568542 C5.84314575,16.4852814 5.17157288,17.1568542 4.34314575,17.1568542 C3.51471863,17.1568542 2.84314575,16.4852814 2.84314575,15.6568542 C2.84314575,14.8284271 3.51471863,14.1568542 4.34314575,14.1568542 Z"
          id="Dot"
          opacity="0.900000036"
          transform="translate(4.343146, 15.656854) rotate(-315.000000) translate(-4.343146, -15.656854) "
        ></path>
        <path
          d="M10,16.6 C10.7731986,16.6 11.4,17.2268014 11.4,18 C11.4,18.7731986 10.7731986,19.4 10,19.4 C9.22680135,19.4 8.6,18.7731986 8.6,18 C8.6,17.2268014 9.22680135,16.6 10,16.6 Z"
          id="Dot"
          opacity="0.849999964"
        ></path>
        <path
          d="M15.6568542,14.3568542 C16.3748244,14.3568542 16.9568542,14.9388841 16.9568542,15.6568542 C16.9568542,16.3748244 16.3748244,16.9568542 15.6568542,16.9568542 C14.9388841,16.9568542 14.3568542,16.3748244 14.3568542,15.6568542 C14.3568542,14.9388841 14.9388841,14.3568542 15.6568542,14.3568542 Z"
          id="Dot"
          opacity="0.800000012"
          transform="translate(15.656854, 15.656854) rotate(-225.000000) translate(-15.656854, -15.656854) "
        ></path>
        <path
          d="M18,8.8 C18.6627417,8.8 19.2,9.3372583 19.2,10 C19.2,10.6627417 18.6627417,11.2 18,11.2 C17.3372583,11.2 16.8,10.6627417 16.8,10 C16.8,9.3372583 17.3372583,8.8 18,8.8 Z"
          id="Dot"
          opacity="0.75"
          transform="translate(18.000000, 10.000000) rotate(-270.000000) translate(-18.000000, -10.000000) "
        ></path>
        <path
          d="M15.6568542,3.24314575 C16.2643675,3.24314575 16.7568542,3.73563253 16.7568542,4.34314575 C16.7568542,4.95065898 16.2643675,5.44314575 15.6568542,5.44314575 C15.049341,5.44314575 14.5568542,4.95065898 14.5568542,4.34314575 C14.5568542,3.73563253 15.049341,3.24314575 15.6568542,3.24314575 Z"
          id="Dot"
          opacity="0.699999988"
          transform="translate(15.656854, 4.343146) rotate(-315.000000) translate(-15.656854, -4.343146) "
        ></path>
        <path
          d="M10,0.5 C10.8284271,0.5 11.5,1.17157288 11.5,2 C11.5,2.82842712 10.8284271,3.5 10,3.5 C9.17157288,3.5 8.5,2.82842712 8.5,2 C8.5,1.17157288 9.17157288,0.5 10,0.5 Z"
          id="Dot"
        ></path>
      </g>
    </g>
  </symbol>

  <symbol id="unlink-icon" viewBox="0 0 20 18">
    <g fill="none" fill-rule="evenodd">
      <path d="M-2-3h24v24H-2z" />
      <path
        d="M15 4h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C18.88 12.61 20 10.95 20 9c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H14V8zM0 1.27l3.11 3.11A4.991 4.991 0 000 9c0 2.76 2.24 5 5 5h4v-1.9H5c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L6.73 8H6v2h2.73L11 12.27V14h1.73l4.01 4L18 16.74 1.27 0 0 1.27z"
        fill="#707785"
        fill-rule="nonzero"
      />
    </g>
  </symbol>

  <symbol id="payment-activity-icon" viewBox="0 0 69 43">
    <g transform="translate(0 2)" fill="none" fill-rule="evenodd">
      <rect
        fill="#A4EBD5"
        transform="scale(-1 1) rotate(5 0 -733.288)"
        x="2.227"
        y="4.091"
        width="61.364"
        height="32.727"
        rx="4.091"
      />
      <g transform="matrix(-1 0 0 1 74 0)">
        <rect
          id="a"
          x="6.318"
          y="0"
          width="61.364"
          height="31.909"
          rx="2.455"
          fill="#FFF"
        />
        <rect
          stroke="#FFF"
          stroke-width="1.227"
          x="5.705"
          y="-.614"
          width="62.591"
          height="33.136"
          rx="2.455"
        />
        <rect
          stroke="#162D3D"
          stroke-width="1.227"
          stroke-linejoin="square"
          x="6.932"
          y=".614"
          width="60.136"
          height="30.682"
          rx="2.455"
        />
      </g>
      <circle fill="#00E591" cx="36.591" cy="15.955" r="9.818" />
      <path
        d="M36.68 21.462v-1.085c.675-.075 1.191-.228 1.55-.459.644-.417.967-1.122.967-2.114 0-.686-.252-1.204-.755-1.555-.31-.212-.897-.44-1.762-.682v-2.718c.514.018.89.216 1.124.592.127.206.203.45.23.733h.978c-.019-.634-.226-1.144-.623-1.53-.398-.385-.967-.604-1.71-.657v-.732h-.53v.743c-.75.008-1.333.24-1.748.694-.416.455-.624.966-.624 1.533 0 .633.192 1.13.576 1.487.384.358.979.614 1.784.767v3.048c-.626-.052-1.055-.29-1.286-.71-.13-.236-.21-.608-.24-1.12h-.99c0 .642.106 1.151.318 1.528.388.697 1.124 1.081 2.21 1.152v1.085h.53zm-.543-6.001c-.414-.082-.743-.228-.987-.437-.244-.208-.366-.497-.366-.867 0-.305.103-.598.31-.878.207-.28.555-.429 1.043-.447v2.629zm.543 4.094v-2.942c.466.127.798.26.995.402.343.243.515.597.515 1.063 0 .295-.063.554-.19.778-.243.436-.683.669-1.32.699z"
        fill="#162D3D"
        fill-rule="nonzero"
      />
      <path
        d="M57.864 3.682a4.09 4.09 0 004.09 4.09h.819v16.364h-.818a4.09 4.09 0 00-4.091 4.091h0M16.136 3.682a4.09 4.09 0 01-4.09 4.09h-.819 0v16.364h.818a4.09 4.09 0 014.091 4.091h0"
        stroke="#707785"
        stroke-width="1.227"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </symbol>

  <symbol id="bank-transfer-icon" viewBox="0 0 14 14">
    <g fill="none" fill-rule="evenodd">
      <path fill="#707785" d="M0 12.082h14v1.75H0z" />
      <path
        fill="#162D3D"
        d="M0 2.005L7 0l7 2.005V4.2H0zM1.313 5.516h1.75v5.25h-1.75z"
      />
      <path fill="#162D3D" opacity=".8" d="M6.128 5.516h1.75v5.25h-1.75z" />
      <path fill="#162D3D" opacity=".75" d="M10.944 5.516h1.75v5.25h-1.75z" />
    </g>
  </symbol>

  <symbol
    id="paypal-transactions-empty-icon"
    viewBox="0 0 140 140"
    version="1.1"
  >
    <g id="Page-1" stroke="none" stroke-width="1" fill="none">
      <g id="Not-setup" transform="translate(-466.000000, -828.000000)">
        <g id="Group-2" transform="translate(466.000000, 828.000000)">
          <g id="pictogram/report">
            <rect id="Bounding-box" x="0" y="0" width="140" height="140"></rect>
            <g
              id="x_overrides/Pictograms/Document"
              transform="translate(25.250000, 17.500000)"
            >
              <g
                id="Document"
                transform="translate(44.204545, 53.000000) scale(-1, 1) translate(-44.204545, -53.000000) translate(0.704545, 0.000000)"
              >
                <rect
                  id="Shadow"
                  fill="#CFD4DE"
                  transform="translate(47.727273, 55.681818) rotate(5.000000) translate(-47.727273, -55.681818) "
                  x="12.7272727"
                  y="8.75"
                  width="70"
                  height="93.8636364"
                  rx="6.36363636"
                ></rect>
                <rect
                  id="Edge"
                  fill="#FFFFFF"
                  x="0"
                  y="0"
                  width="75.5681818"
                  height="95.4545455"
                  rx="6.36363636"
                ></rect>
                <rect
                  id="Paper"
                  stroke="#162D3D"
                  stroke-width="2.38636364"
                  x="5.17045455"
                  y="3.57954545"
                  width="66.0227273"
                  height="88.2954545"
                  rx="4.77272727"
                ></rect>
              </g>
            </g>
            <polygon
              id="Graph-under"
              fill="#CFD4DE"
              points="71.9886364 66.0227273 84.1063601 73.2864437 98.6363636 59.6590909 98.6363636 99.4318182 50.9090909 99.4318182 50.9090909 88.1494141"
            ></polygon>
            <path
              d="M96.9768373,58.0407982 C97.4312782,57.5635845 98.1865336,57.5451235 98.6637473,57.9995645 C99.1111351,58.425603 99.1553223,59.116029 98.7846502,59.59388 L98.7049809,59.6864746 L84.970432,74.1092819 C84.6034381,74.4946664 84.0298233,74.5874431 83.5638656,74.3492197 L83.4657798,74.2930915 L73.10625,67.7003409 L51.7544558,89.1375003 C51.3184724,89.5752023 50.6272278,89.6038648 50.1578262,89.2225492 L50.0670452,89.1408195 C49.6293432,88.704836 49.6006807,88.0135914 49.9819962,87.5441899 L50.063726,87.4534088 L72.09279,65.3375106 C72.4598385,64.9690152 73.0190182,64.8836566 73.4753803,65.1141068 L73.5787352,65.1729086 L83.9188636,71.7523864 L96.9768373,58.0407982 Z"
              id="Graph"
              fill="#162D3D"
            ></path>
          </g>
          <g id="Group" transform="translate(42.954545, 22.272727)">
            <g id="Group" transform="translate(11.136364, 8.909091)">
              <path
                d="M4.94669364,-2.92775905e-13 L12.5462449,-2.92775905e-13 C14.6866131,-2.92775905e-13 17.2251528,0.0695624552 18.9234565,1.56721272 C20.0578144,2.56773637 20.6531122,4.16179433 20.5155549,5.87303072 C20.0495844,11.6759111 16.5785159,14.9261434 11.9239059,14.9261434 L8.17576322,14.9261434 C7.53794409,14.9261434 7.11508274,15.3488088 6.93520011,16.493748 L5.88921592,23.1470539 C5.82141702,23.578733 5.63428422,23.8330769 5.29274236,23.8638411 L0.611287105,23.8638411 C0.0918221226,23.8638411 -0.0927633219,23.4664534 0.0430304287,22.6058384 L3.41416417,1.26250957 C3.54917412,0.407185301 4.0171041,-2.92775905e-13 4.94669364,-2.92775905e-13"
                id="Fill-1"
                fill="#1B3D92"
              ></path>
              <path
                d="M9.83412274,6.68181818 L17.4260319,6.68181818 C21.501804,6.68181818 23.0364889,8.74498182 22.7995846,11.781236 C22.4088592,16.7864016 19.3825985,19.5540076 15.3687468,19.5540076 L13.34203,19.5540076 C12.7919967,19.5540076 12.4218461,19.9176919 12.2719439,20.9060666 L11.4027071,26.6438914 C11.3462734,27.0165894 11.1503228,27.2354662 10.8558091,27.2621155 L6.09538571,27.2621155 C5.64744269,27.2621155 5.48813487,26.9193979 5.60531332,26.1771371 L8.51243609,7.77071554 C8.62883074,7.03296162 9.03229298,6.68181818 9.83412274,6.68181818"
                id="Fill-1"
                fill="#00A2D3"
              ></path>
              <path
                d="M6.68181818,16.1703918 L8.0087955,7.77057838 C8.12538609,7.0330204 8.52904428,6.68187697 9.33087405,6.68187697 L16.9227832,6.68187697 C18.1796102,6.68187697 19.1948302,6.8780235 19.9905855,7.23935636 C19.2277499,12.4040257 15.8873804,15.273526 11.5133716,15.273526 L7.76503298,15.273526 C7.27182537,15.273526 6.90324233,15.5257144 6.68181818,16.1703918"
                id="Page-1"
                fill="#1B2E7F"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="money-onboarding-icon" viewBox="0 0 69 43">
    <g transform="translate(0 2)" fill="none" fill-rule="evenodd">
      <rect
        fill="#A4EBD5"
        transform="scale(-1 1) rotate(5 0 -733.288)"
        x="2.227"
        y="4.091"
        width="61.364"
        height="32.727"
        rx="4.091"
      />
      <g transform="matrix(-1 0 0 1 74 0)">
        <rect
          id="a"
          x="6.318"
          y="0"
          width="61.364"
          height="31.909"
          rx="2.455"
          fill="#FFF"
        />
        <rect
          stroke="#FFF"
          stroke-width="1.227"
          x="5.705"
          y="-.614"
          width="62.591"
          height="33.136"
          rx="2.455"
        />
        <rect
          stroke="#162D3D"
          stroke-width="1.227"
          stroke-linejoin="square"
          x="6.932"
          y=".614"
          width="60.136"
          height="30.682"
          rx="2.455"
        />
      </g>
      <circle fill="#00E591" cx="36.591" cy="15.955" r="9.818" />
      <path
        d="M36.68 21.462v-1.085c.675-.075 1.191-.228 1.55-.459.644-.417.967-1.122.967-2.114 0-.686-.252-1.204-.755-1.555-.31-.212-.897-.44-1.762-.682v-2.718c.514.018.89.216 1.124.592.127.206.203.45.23.733h.978c-.019-.634-.226-1.144-.623-1.53-.398-.385-.967-.604-1.71-.657v-.732h-.53v.743c-.75.008-1.333.24-1.748.694-.416.455-.624.966-.624 1.533 0 .633.192 1.13.576 1.487.384.358.979.614 1.784.767v3.048c-.626-.052-1.055-.29-1.286-.71-.13-.236-.21-.608-.24-1.12h-.99c0 .642.106 1.151.318 1.528.388.697 1.124 1.081 2.21 1.152v1.085h.53zm-.543-6.001c-.414-.082-.743-.228-.987-.437-.244-.208-.366-.497-.366-.867 0-.305.103-.598.31-.878.207-.28.555-.429 1.043-.447v2.629zm.543 4.094v-2.942c.466.127.798.26.995.402.343.243.515.597.515 1.063 0 .295-.063.554-.19.778-.243.436-.683.669-1.32.699z"
        fill="#162D3D"
        fill-rule="nonzero"
      />
      <path
        d="M57.864 3.682a4.09 4.09 0 004.09 4.09h.819v16.364h-.818a4.09 4.09 0 00-4.091 4.091h0M16.136 3.682a4.09 4.09 0 01-4.09 4.09h-.819 0v16.364h.818a4.09 4.09 0 014.091 4.091h0"
        stroke="#707785"
        stroke-width="1.227"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </symbol>
</svg>
